/* eslint-disable */
/**
 * Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the definitions in this file,
 * Run `npm run generate:graphql:mp` or `npm run generate:graphql:mp:local`
 * in the terminal
 */

export type Maybe<T> = T | null | undefined
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: any
  /** An ISO 8601-encoded date */
  ISO8601Date: any
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: string
  /** Valid 24h time string in HH:MM */
  ISO8601Time: any
  /** Represents untyped JSON */
  JSON: any
}

/** Autogenerated input type of AcceptInboundBid */
export type IAcceptInboundBidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of AcceptInboundBid */
export type IAcceptInboundBidPayload = {
  __typename?: 'AcceptInboundBidPayload'
  bid?: Maybe<IBid>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of AcceptOutboundBid */
export type IAcceptOutboundBidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of AcceptOutboundBid */
export type IAcceptOutboundBidPayload = {
  __typename?: 'AcceptOutboundBidPayload'
  bid?: Maybe<IBid>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of AcceptShipment */
export type IAcceptShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of AcceptShipment */
export type IAcceptShipmentPayload = {
  __typename?: 'AcceptShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export enum IAccountingStates {
  /** Canceled */
  canceled = 'canceled',
  /** Delivered */
  delivered = 'delivered',
  /** Drafted */
  drafted = 'drafted',
  /** Open */
  open = 'open',
  /** Paid */
  paid = 'paid',
  /** Partially paid */
  partially_paid = 'partially_paid',
  /** Ready */
  ready = 'ready',
}

/** Autogenerated input type of ActivateAs2Certificate */
export type IActivateAs2CertificateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** id of the as2 certificate to be activated */
  id: Scalars['ID']
}

/** Autogenerated return type of ActivateAs2Certificate */
export type IActivateAs2CertificatePayload = {
  __typename?: 'ActivateAs2CertificatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  /** is the certificate now active? */
  success: Scalars['Boolean']
}

/** Autogenerated input type of ActivateConfigurableBuilderVersion */
export type IActivateConfigurableBuilderVersionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** the configurable builder version to update */
  id: Scalars['ID']
  /** EDI Mapper outbound config to use when building EDI */
  outboundConfigId: Scalars['ID']
}

/** Autogenerated return type of ActivateConfigurableBuilderVersion */
export type IActivateConfigurableBuilderVersionPayload = {
  __typename?: 'ActivateConfigurableBuilderVersionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configurableBuilderVersion?: Maybe<IConfigurableBuilderVersion>
  errors: Array<IError>
}

export type IActivity = {
  __typename?: 'Activity'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  metadata: Scalars['JSON']
  type: IActivityTypes
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IActivityTypes {
  /** DriverVerifiedV1 */
  DriverVerifiedV1 = 'DriverVerifiedV1',
}

/** Autogenerated input type of AddDocumentToNote */
export type IAddDocumentToNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  document: IDocumentInput
  noteId: Scalars['ID']
}

/** Autogenerated return type of AddDocumentToNote */
export type IAddDocumentToNotePayload = {
  __typename?: 'AddDocumentToNotePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  note?: Maybe<INote>
}

/** Autogenerated input type of AddReply */
export type IAddReplyInput = {
  body: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of AddReply */
export type IAddReplyPayload = {
  __typename?: 'AddReplyPayload'
  bid: IBid
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated input type of AddShipmentStop */
export type IAddShipmentStopInput = {
  appointmentInput: ICreateShipmentStopAppointmentInput
  billOfLadingReference?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  commodity: Scalars['String']
  dropTrailer?: Maybe<Scalars['Boolean']>
  ediAppointmentReasonCode?: Maybe<Scalars['String']>
  ediStatusReasonCode?: Maybe<Scalars['String']>
  facilityContactUuid?: Maybe<Scalars['ID']>
  genericCommodityId?: Maybe<Scalars['ID']>
  palletCount?: Maybe<Scalars['Int']>
  poReference?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
  shipperFacilityUuid: Scalars['ID']
  specialInstruction?: Maybe<Scalars['String']>
  stopSequence?: Maybe<Scalars['Int']>
  stopType: IShipmentStopTypes
  vendorId?: Maybe<Scalars['ID']>
  weight?: Maybe<Scalars['Int']>
}

/** Autogenerated return type of AddShipmentStop */
export type IAddShipmentStopPayload = {
  __typename?: 'AddShipmentStopPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipmentStop?: Maybe<IShipmentStop>
}

export type IAdditionalStops = {
  __typename?: 'AdditionalStops'
  city?: Maybe<Scalars['String']>
  isoCountryCode?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['ISO8601Date']>
  startTime?: Maybe<Scalars['ISO8601DateTime']>
  stateCode?: Maybe<Scalars['String']>
  stopDropTrailer?: Maybe<Scalars['Boolean']>
}

/** Autogenerated input type of AllowClaimsBilling */
export type IAllowClaimsBillingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of AllowClaimsBilling */
export type IAllowClaimsBillingPayload = {
  __typename?: 'AllowClaimsBillingPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of AllowClaimsInvoicing */
export type IAllowClaimsInvoicingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of AllowClaimsInvoicing */
export type IAllowClaimsInvoicingPayload = {
  __typename?: 'AllowClaimsInvoicingPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export type IAmPod = {
  __typename?: 'AmPod'
  ceAutoAssignmentGroup?: Maybe<IGroup>
  ceGroup?: Maybe<IGroup>
  group: IGroup
  id: Scalars['ID']
  name: Scalars['String']
  shipperApplications: IShipperApplicationConnection
}

export type IAmPodShipperApplicationsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** The connection type for AmPod. */
export type IAmPodConnection = {
  __typename?: 'AmPodConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IAmPodEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IAmPod>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IAmPodEdge = {
  __typename?: 'AmPodEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IAmPod>
}

export enum IApplicationRelationshipLevels {
  /** Primary */
  primary = 'primary',
  /** Secondary */
  secondary = 'secondary',
}

export enum IApplicationTypes {
  CarrierApplication = 'CarrierApplication',
  ShipperApplication = 'ShipperApplication',
}

export type IAppointmentConfirmationRule = {
  __typename?: 'AppointmentConfirmationRule'
  actions: Array<IAppointmentConfirmationRuleAction>
  activated: Scalars['Boolean']
  appliedOn: Array<IAppointmentConfirmationRuleAppliedOnEnum>
  conditions: Array<IAppointmentConfirmationRuleCondition>
  customActions: Array<IAppointmentConfirmationRuleAction>
  customConditions: Array<IAppointmentConfirmationRuleCondition>
  id: Scalars['ID']
  shipperApplicationId: Scalars['ID']
  uuid: Scalars['String']
}

export type IAppointmentConfirmationRuleAction = {
  __typename?: 'AppointmentConfirmationRuleAction'
  appointmentConfirmationRuleUuid: Scalars['String']
  customInstructions?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: IAppointmentConfirmationRuleActionNameEnum
}

export type IAppointmentConfirmationRuleActionInput = {
  id?: Maybe<Scalars['ID']>
  name: IAppointmentConfirmationRuleActionNameEnum
}

export enum IAppointmentConfirmationRuleActionNameEnum {
  /** Set confirmed status */
  set_confirmed_status = 'set_confirmed_status',
  /** Set edi confirmed source */
  set_edi_confirmed_source = 'set_edi_confirmed_source',
}

export enum IAppointmentConfirmationRuleAppliedOnEnum {
  /** Create */
  create = 'create',
  /** Update */
  update = 'update',
}

export type IAppointmentConfirmationRuleCondition = {
  __typename?: 'AppointmentConfirmationRuleCondition'
  appointmentConfirmationRuleUuid: Scalars['ID']
  conditionParameters?: Maybe<Array<Scalars['String']>>
  customInstructions?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isStandardized: Scalars['Boolean']
  name: IAppointmentConfirmationRuleConditionNameEnum
}

export type IAppointmentConfirmationRuleConditionInput = {
  id?: Maybe<Scalars['ID']>
  name: IAppointmentConfirmationRuleConditionNameEnum
  parameters?: Maybe<IAppointmentConfirmationRuleConditionParametersInput>
}

export enum IAppointmentConfirmationRuleConditionNameEnum {
  /** Applicable stop type */
  applicable_stop_type = 'applicable_stop_type',
  /** Appointment has start time */
  appointment_has_start_time = 'appointment_has_start_time',
  /** Appointment not dummy */
  appointment_not_dummy = 'appointment_not_dummy',
  /** Appointment type */
  appointment_type = 'appointment_type',
  /** Appointment valid */
  appointment_valid = 'appointment_valid',
  /** Appointments in chronological order */
  appointments_in_chronological_order = 'appointments_in_chronological_order',
  /** Equipment type */
  equipment_type = 'equipment_type',
  /** Shipment attribute */
  shipment_attribute = 'shipment_attribute',
  /** Shipment type */
  shipment_type = 'shipment_type',
}

export type IAppointmentConfirmationRuleConditionParametersInput = {
  stopTypes?: Maybe<Array<IShipmentStopTypes>>
}

export type IAppointmentRecommendedStartAt = {
  __typename?: 'AppointmentRecommendedStartAt'
  noTimeReasons: Array<Scalars['String']>
  recommendedStartAt?: Maybe<Scalars['ISO8601DateTime']>
}

export type IAppointmentTimeCriteria = {
  __typename?: 'AppointmentTimeCriteria'
  deliveryRangeEnd?: Maybe<Scalars['String']>
  deliveryRangeStart?: Maybe<Scalars['String']>
  id: Scalars['ID']
  pickupRangeEnd?: Maybe<Scalars['String']>
  pickupRangeStart?: Maybe<Scalars['String']>
  timezoneOverride?: Maybe<Scalars['String']>
}

/** Autogenerated input type of ApproveComplianceCoverReview */
export type IApproveComplianceCoverReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  closureReason?: Maybe<Scalars['String']>
  complianceCoverReviewId: Scalars['ID']
}

/** Autogenerated return type of ApproveComplianceCoverReview */
export type IApproveComplianceCoverReviewPayload = {
  __typename?: 'ApproveComplianceCoverReviewPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  complianceCoverReview?: Maybe<IComplianceCoverReview>
  errors: Array<IError>
}

export enum IApprovedRejectedEnum {
  approved = 'approved',
  rejected = 'rejected',
}

/** An X509 certificate which can be used to encrypt and verify AS2 messages. */
export type IAs2Certificate = {
  __typename?: 'As2Certificate'
  as2ConnectionConfig?: Maybe<IAs2ConnectionConfig>
  /** The PEM-encoded X509 certificate body. */
  body: Scalars['String']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id?: Maybe<Scalars['ID']>
  /** Is this the active certificate for the connection? (Only 1 certificate can be active at once.) */
  isActive: Scalars['Boolean']
  /** The certificate authority who issued the certificate. */
  issuer?: Maybe<Scalars['String']>
  /** The latest time the certificate is valid for. */
  notAfter?: Maybe<Scalars['ISO8601DateTime']>
  /** The earliest time the certificate is valid for. */
  notBefore?: Maybe<Scalars['ISO8601DateTime']>
  /** The party the certificate applies to. (Hostname should match the outbound url for the connection.) */
  subject?: Maybe<Scalars['String']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  /** Any errors which occurred when reading the certificate body. (Indicates an invalid body.) */
  x509ReadError?: Maybe<Scalars['String']>
}

/** Config describing a partner (shipper or carrier) server we can send and receive AS2 messages with. */
export type IAs2ConnectionConfig = {
  __typename?: 'As2ConnectionConfig'
  /** All the certificates associated with this connection. */
  as2Certificates: Array<IAs2Certificate>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  /** Used to identify the partner in incoming & outgoing messages. Assigned by the partner. */
  identifier: Scalars['String']
  /** Where we will POST outgoing AS2 messages to for this connection. */
  outboundUrl: Scalars['String']
  /** String identifiying the location of the certificate info in AWS */
  serverInfoCredentialsIdentifier: Scalars['String']
  /** Identifier to use when referring to our own AS2 server */
  transfixIdentifier: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for As2ConnectionConfig. */
export type IAs2ConnectionConfigConnection = {
  __typename?: 'As2ConnectionConfigConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IAs2ConnectionConfigEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IAs2ConnectionConfig>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IAs2ConnectionConfigEdge = {
  __typename?: 'As2ConnectionConfigEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IAs2ConnectionConfig>
}

/** Contains information on the results of an AS2 connectivity test. */
export type IAs2ConnectionConfigOutboundTestReport = {
  __typename?: 'As2ConnectionConfigOutboundTestReport'
  /** AS2 disposition. Indicates success/failure & sometimes has additional info. */
  disposition: Scalars['String']
  /** Does the disposition string indicate a successful transmission? */
  dispositionOk: Scalars['Boolean']
  /** If an error occurred in Transfix code while making the test request, a backtrace is included here. */
  errorBacktrace?: Maybe<Scalars['String']>
  /** If an error occurred in Transfix code while making the test request, the error message is included here. */
  errorMessage?: Maybe<Scalars['String']>
  /** Was the test file received successfully by the partner? */
  isSuccess: Scalars['Boolean']
  /**
   * Did the message integrity check (MIC) succeed? Meaning: Did both our side &
   * theirs calculate the same digest from the message contents?
   */
  micMatched?: Maybe<Scalars['Boolean']>
  /** Did the response from the partner acknowledge receiving the same message id (MID) we sent? */
  midMatched?: Maybe<Scalars['Boolean']>
  /** The final decrypted content of the test message we sent. */
  requestAs2MessageContent: Scalars['String']
  /**
   * The MIME type of the content we transmitted. Note this is not the MIME type of
   * the HTTP transmission - that is always binary.
   */
  requestAs2MessageContentType: Scalars['String']
  /** The filename we attached to the content we transmitted. Partners may or may not use this to name the files they receive. */
  requestAs2MessageFilename: Scalars['String']
  /** A message id we generated for the AS2 transmission we sent. */
  requestAs2MessageId: Scalars['String']
  /** The full HTTP body of the response sent back by the partner. Should be an MDN. */
  responseHttpBody?: Maybe<Scalars['String']>
  /** HTTP code the partner's server sent back to us in response to our transmission. */
  responseHttpCode?: Maybe<Scalars['String']>
  /** The HTTP headers the partner server sent back to us. */
  responseHttpHeaders: Array<Scalars['String']>
  /**
   * Was the HTTP conversation with the partner completed successfully? (Note: AS2
   * is not REST. Errors will often be returned with HTTP 200 status.)
   */
  responseHttpOk: Scalars['Boolean']
  /** Time when was the test sent to the partner server. */
  sentAt: Scalars['ISO8601DateTime']
  /**
   * Any errors which occur when verifying the S/MIME signature attached to the
   * partner's response. An error can occur if the response was not signed with the
   * private key which matches the active certificate we have for this connection config.
   */
  signatureVerificationError?: Maybe<Scalars['String']>
  /** Overall final status of the test. */
  status: IAs2TestResultStatuses
}

export enum IAs2TestResultStatuses {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  SUCCESS_WITH_WARNING = 'SUCCESS_WITH_WARNING',
}

/** Autogenerated input type of AssignFacilityVendor */
export type IAssignFacilityVendorInput = {
  addressLine2?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  facilityUuid: Scalars['ID']
  industry?: Maybe<IVendorIndustries>
  name: Scalars['String']
  shipperFacilities: Array<IShipperFacilityInput>
  vendorId?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of AssignFacilityVendor */
export type IAssignFacilityVendorPayload = {
  __typename?: 'AssignFacilityVendorPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  vendor?: Maybe<IVendor>
}

/** Autogenerated input type of AssignShipmentActiveTasks */
export type IAssignShipmentActiveTasksInput = {
  assignedToId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
  taskNamespace: ITaskNamespaces
}

/** Autogenerated return type of AssignShipmentActiveTasks */
export type IAssignShipmentActiveTasksPayload = {
  __typename?: 'AssignShipmentActiveTasksPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  tasks?: Maybe<Array<ITask>>
}

/** Autogenerated input type of AssignTrailerToShipment */
export type IAssignTrailerToShipmentInput = {
  carrierId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  number: Scalars['String']
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of AssignTrailerToShipment */
export type IAssignTrailerToShipmentPayload = {
  __typename?: 'AssignTrailerToShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  trailer?: Maybe<ITrailer>
}

export type IAssignedFacilityVendor = {
  __typename?: 'AssignedFacilityVendor'
  vendor?: Maybe<IVendor>
  vendorFacility?: Maybe<IVendorFacility>
}

/** The connection type for AssignedFacilityVendor. */
export type IAssignedFacilityVendorConnection = {
  __typename?: 'AssignedFacilityVendorConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IAssignedFacilityVendorEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IAssignedFacilityVendor>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IAssignedFacilityVendorEdge = {
  __typename?: 'AssignedFacilityVendorEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IAssignedFacilityVendor>
}

/** Objects associated with an AttachedDocument */
export type IAttachable = IFacilitySchedule | IShipment | ISourcedCarrierRate

export type IAttachedDocument = {
  __typename?: 'AttachedDocument'
  attachable: IAttachable
  createdAt: Scalars['ISO8601DateTime']
  document?: Maybe<IDownloadable>
  id: Scalars['ID']
  type: IAttachedDocumentTypes
}

export enum IAttachedDocumentTypes {
  facility_schedule_document = 'facility_schedule_document',
  invoice_attachment = 'invoice_attachment',
  /** Scale Ticket */
  scale_ticket = 'scale_ticket',
}

export type IAutoAcceptRejectRule = {
  __typename?: 'AutoAcceptRejectRule'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  description?: Maybe<Scalars['String']>
  functionName: Scalars['String']
  id: Scalars['ID']
  parameters?: Maybe<Scalars['JSON']>
  ruleType: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IAutoAppointmentSchedule = ICreatedByUser & {
  __typename?: 'AutoAppointmentSchedule'
  appointmentRequest?: Maybe<Scalars['ISO8601DateTime']>
  appointmentRequestLogUuid?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  deprecatedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  isIdeal: Scalars['Boolean']
  lastRequestedAt?: Maybe<Scalars['ISO8601DateTime']>
  requestedCount?: Maybe<Scalars['Int']>
  shipmentStop: IShipmentStop
  source: IAutoAppointmentScheduleSources
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IAutoAppointmentScheduleSources {
  /** Quick request */
  quick_request = 'quick_request',
  /** Smart appointment */
  smart_appointment = 'smart_appointment',
}

export type IAvailableTruckInput = {
  emptyAt?: Maybe<Scalars['ISO8601DateTime']>
  id?: Maybe<Scalars['ID']>
  trailerNumber?: Maybe<Scalars['String']>
  truckLocationCity: Scalars['String']
  truckLocationCountryCode?: Maybe<Scalars['String']>
  truckLocationStateCode: Scalars['String']
  truckNumber?: Maybe<Scalars['String']>
  vin?: Maybe<Scalars['String']>
}

export type IAwardOverview = {
  __typename?: 'AwardOverview'
  allInDatMax?: Maybe<Scalars['Float']>
  allInDatMin?: Maybe<Scalars['Float']>
  awardStatus?: Maybe<Scalars['String']>
  awardType?: Maybe<Scalars['String']>
  margin?: Maybe<Scalars['Float']>
  marginPctMax?: Maybe<Scalars['Float']>
  marginPctMin?: Maybe<Scalars['Float']>
  numLanes?: Maybe<Scalars['Int']>
  revenue?: Maybe<Scalars['Float']>
  volume?: Maybe<Scalars['Int']>
}

export type IBackhaulRevenueShareAgreement = {
  __typename?: 'BackhaulRevenueShareAgreement'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  endAtDate: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  name: Scalars['String']
  percentage: Scalars['Float']
  startAtDate: Scalars['ISO8601DateTime']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IBackhaulRevenueShareAgreementPartnerTypes {
  /** Shipperapplication */
  shipper_application = 'shipper_application',
}

export type IBalanceDue = {
  __typename?: 'BalanceDue'
  autoSendEdi: Scalars['Boolean']
  autoSendPdf: Scalars['Boolean']
  closedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  dueAt?: Maybe<Scalars['ISO8601DateTime']>
  ediFileDeliveredAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  name: Scalars['String']
  pdfFile?: Maybe<IDownloadable>
  pdfFileDeliveredAt?: Maybe<Scalars['ISO8601DateTime']>
  processedAt?: Maybe<Scalars['ISO8601DateTime']>
  recipientEmail?: Maybe<Scalars['String']>
  shipment: IShipment
  state: IAccountingStates
  totalAmount: Scalars['Float']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IBaseIssueResolutionStep = {
  __typename?: 'BaseIssueResolutionStep'
  description: Scalars['String']
  id: Scalars['String']
  issueResolutionStepId: Scalars['Int']
  stepSequence: Scalars['Int']
}

export type IBcaFile = {
  __typename?: 'BcaFile'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** DeprecatedAt timestamp in UTC */
  deprecatedAt?: Maybe<Scalars['ISO8601DateTime']>
  file: IDownloadable
  id: Scalars['ID']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IBid = ICreatedByUser & {
  __typename?: 'Bid'
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']>
  acceptedBy?: Maybe<IUser>
  amount: Scalars['Float']
  carrierApplication?: Maybe<ICarrierApplication>
  carrierApplicationId?: Maybe<Scalars['ID']>
  carrierAvailableTruck?: Maybe<ICarrierAvailableTruck>
  carrierContactName?: Maybe<Scalars['String']>
  carrierContactPhone?: Maybe<Scalars['String']>
  carrierContactPhoneExt?: Maybe<Scalars['String']>
  carrierContactUser?: Maybe<IUser>
  carrierContactUserId?: Maybe<Scalars['ID']>
  carrierTotalRate: Scalars['Float']
  complianceCoverReview?: Maybe<IComplianceCoverReview>
  contractLaneMatch?: Maybe<IContractLaneMatch>
  counterBid?: Maybe<IBid>
  coverNowRates?: Maybe<Array<ICoverNowRate>>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  createdBy: IUser
  createdById: Scalars['Int']
  declineReason?: Maybe<Scalars['String']>
  declinedAt?: Maybe<Scalars['ISO8601DateTime']>
  declinedBy?: Maybe<IUser>
  direction?: Maybe<Scalars['String']>
  driver?: Maybe<IUser>
  equipment: IEquipment
  id: Scalars['ID']
  latestBidApproval?: Maybe<IBidApproval>
  latestNotification?: Maybe<INotification>
  notes?: Maybe<Array<INote>>
  offerExpiresAt?: Maybe<Scalars['ISO8601DateTime']>
  parentBid?: Maybe<IBid>
  rateCoachGrade?: Maybe<IBidRateCoachGrades>
  relatedOptions: Array<IBid>
  respondees?: Maybe<Array<IUser>>
  shipment: IShipment
  shipmentId: Scalars['ID']
  shipmentRates: Array<IShipmentRate>
  source?: Maybe<ICarrierBidSourceTypes>
  sourceChannel?: Maybe<Scalars['String']>
  sourceSegment?: Maybe<Scalars['String']>
  status?: Maybe<Scalars['String']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IBidApproval = {
  __typename?: 'BidApproval'
  assignedTo?: Maybe<IUser>
  bid: IBid
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  createdBy: IUser
  id: Scalars['ID']
  state: IBidApprovalStateEnum
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy?: Maybe<IUser>
}

export enum IBidApprovalStateEnum {
  /** Approved */
  approved = 'approved',
  /** Countered */
  countered = 'countered',
  /** Declined */
  declined = 'declined',
  /** Open */
  open = 'open',
}

export enum IBidAvailabilityEnum {
  available = 'available',
  unavailable = 'unavailable',
}

/** The connection type for Bid. */
export type IBidConnection = {
  __typename?: 'BidConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IBidEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IBid>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

export type IBidCountsResponse = {
  __typename?: 'BidCountsResponse'
  all: Scalars['Int']
  available: Scalars['Int']
  notInterested: Scalars['Int']
  unavailable: Scalars['Int']
}

/** An edge in a connection. */
export type IBidEdge = {
  __typename?: 'BidEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IBid>
}

export enum IBidRateCoachGrades {
  fair = 'fair',
  good = 'good',
  poor = 'poor',
}

export type IBill = {
  __typename?: 'Bill'
  autoGeneratePdf: Scalars['Boolean']
  carrier: ICarrierApplication
  closedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  draft?: Maybe<IDraft>
  dueAt?: Maybe<Scalars['ISO8601DateTime']>
  ediFileDeliveredAt?: Maybe<Scalars['ISO8601DateTime']>
  externalId?: Maybe<Scalars['String']>
  file?: Maybe<IDownloadable>
  id: Scalars['ID']
  isPrimaryRecord: Scalars['Boolean']
  name?: Maybe<Scalars['String']>
  paidAmount?: Maybe<Scalars['Float']>
  paidAt?: Maybe<Scalars['ISO8601DateTime']>
  pdfFileDeliveredAt?: Maybe<Scalars['ISO8601DateTime']>
  processedAt?: Maybe<Scalars['ISO8601DateTime']>
  shipment: IShipment
  state: IAccountingStates
  totalAmount: Scalars['Float']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IBillCredit = {
  __typename?: 'BillCredit'
  autoSendEdi: Scalars['Boolean']
  autoSendPdf: Scalars['Boolean']
  carrier: ICarrierApplication
  closedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  dueAt?: Maybe<Scalars['ISO8601DateTime']>
  ediFileDeliveredAt?: Maybe<Scalars['ISO8601DateTime']>
  externalId: Scalars['String']
  id: Scalars['ID']
  isPrimaryRecord: Scalars['Boolean']
  name: Scalars['String']
  paidAmount: Scalars['Float']
  paidAt?: Maybe<Scalars['ISO8601DateTime']>
  pdfFile?: Maybe<IDownloadable>
  pdfFileDeliveredAt?: Maybe<Scalars['ISO8601DateTime']>
  processedAt?: Maybe<Scalars['ISO8601DateTime']>
  shipment: IShipment
  state: IAccountingStates
  totalAmount: Scalars['Float']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** Autogenerated input type of BounceCarrier */
export type IBounceCarrierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  reason: ICarrierAssignmentBounceReason
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of BounceCarrier */
export type IBounceCarrierPayload = {
  __typename?: 'BounceCarrierPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  didBounce: Scalars['Boolean']
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export type IBrokerCarrierAgreement = {
  __typename?: 'BrokerCarrierAgreement'
  id: Scalars['ID']
}

export type IBrokerPod = {
  __typename?: 'BrokerPod'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  podKey: Scalars['String']
  podName: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IBuilderLibraries {
  STUPIDEDI = 'STUPIDEDI',
  TFX12 = 'TFX12',
}

/** Autogenerated input type of BulkUpdateRfpLanesAndPrices */
export type IBulkUpdateRfpLanesAndPricesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  csv: Scalars['String']
  rfpId: Scalars['ID']
  roundNumber: Scalars['Int']
}

/** Autogenerated return type of BulkUpdateRfpLanesAndPrices */
export type IBulkUpdateRfpLanesAndPricesPayload = {
  __typename?: 'BulkUpdateRfpLanesAndPricesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
  updatedLanes?: Maybe<Array<IRequestForProposalLane>>
}

/** Autogenerated input type of CancelShipmentActiveTasks */
export type ICancelShipmentActiveTasksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
  taskNamespace: ITaskNamespaces
}

/** Autogenerated return type of CancelShipmentActiveTasks */
export type ICancelShipmentActiveTasksPayload = {
  __typename?: 'CancelShipmentActiveTasksPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  tasks?: Maybe<Array<ITask>>
}

/** Autogenerated input type of CancelShipment */
export type ICancelShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of CancelShipment */
export type ICancelShipmentPayload = {
  __typename?: 'CancelShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export type ICarrierApplication = {
  __typename?: 'CarrierApplication'
  accountingEmail?: Maybe<Scalars['String']>
  activeShipments: IShipmentConnection
  brokerCarrierAgreement?: Maybe<IBrokerCarrierAgreement>
  canBeer: Scalars['Boolean']
  carrierProfile?: Maybe<ICarrierProfile>
  carrierRelationships: Array<ICarrierRelationship>
  carrierScorecard?: Maybe<ICarrierScorecard>
  carrierSpecificInfo?: Maybe<Scalars['String']>
  carrierTrackingProviders: Array<ICarrierTrackingProvider>
  contactEmail?: Maybe<Scalars['String']>
  dbaName?: Maybe<Scalars['String']>
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  deprecatedBrokerCarrierAgreements: Array<IBcaFile>
  dotNumber?: Maybe<Scalars['String']>
  ein?: Maybe<Scalars['String']>
  entityType?: Maybe<ICarrierApplicationEntityTypes>
  factor?: Maybe<IFactor>
  fleetPlannerMotorCarrierId?: Maybe<Scalars['ID']>
  fmcsaRating?: Maybe<Scalars['String']>
  headquarter?: Maybe<ILocation>
  id: Scalars['ID']
  isCarbCompliant?: Maybe<Scalars['Boolean']>
  isDisadvantagedBusinessEntity?: Maybe<Scalars['Boolean']>
  isEldCompliant: Scalars['Boolean']
  isTrusted?: Maybe<Scalars['Boolean']>
  mcNumber?: Maybe<Scalars['String']>
  metrics?: Maybe<IMetrics>
  name?: Maybe<Scalars['String']>
  powerUnits?: Maybe<Scalars['Int']>
  primaryCarrierManager?: Maybe<IUser>
  /** The user who requested a compliance review for this carrier. */
  requestedBy?: Maybe<IUser>
  /** The shipment that triggered the compliance review for this carrier. */
  requestedForShipment?: Maybe<IShipment>
  secondaryAccountingEmail?: Maybe<Scalars['String']>
  starkLink: Scalars['String']
  state: ICarrierApplicationStates
  /** Total number of shipments for the carrier excepting certain statuses */
  totalShipments?: Maybe<Scalars['Int']>
  trailerCount?: Maybe<Scalars['Int']>
}

export type ICarrierApplicationActiveShipmentsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export enum ICarrierApplicationEntityTypes {
  /** C Corporation */
  ccorp = 'ccorp',
  /** Individual/sole proprietor or single member LLC */
  individual = 'individual',
  /** Limited Liability Company */
  llc = 'llc',
  /** Partnership */
  partnership = 'partnership',
  /** S Corporation */
  scorp = 'scorp',
  /** Trust/Estate */
  trust = 'trust',
}

export enum ICarrierApplicationStates {
  /** Active */
  activated = 'activated',
  /** App. Submitted */
  application_submitted = 'application_submitted',
  /** Cancelled */
  cancelled = 'cancelled',
  /** Conditional */
  conditional = 'conditional',
  /** Cannot Use */
  do_not_use = 'do_not_use',
  /** Expired Ins. */
  expired_insurance = 'expired_insurance',
  /** In Review */
  in_review = 'in_review',
  /** Fresh */
  new = 'new',
  /** Other */
  other = 'other',
  /** Out of Service */
  out_of_service = 'out_of_service',
  /** Pending */
  pending = 'pending',
  /** Probation */
  probation = 'probation',
}

export type ICarrierApplicationTruckNumber = {
  __typename?: 'CarrierApplicationTruckNumber'
  carrierApplicationId: Scalars['ID']
  id: Scalars['ID']
  isEldValid: Scalars['Boolean']
  keepTruckinId?: Maybe<Scalars['Int']>
  p44State: IP44TruckNumberStates
  value: Scalars['String']
}

/** The connection type for CarrierApplicationTruckNumber. */
export type ICarrierApplicationTruckNumberConnection = {
  __typename?: 'CarrierApplicationTruckNumberConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ICarrierApplicationTruckNumberEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ICarrierApplicationTruckNumber>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type ICarrierApplicationTruckNumberEdge = {
  __typename?: 'CarrierApplicationTruckNumberEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<ICarrierApplicationTruckNumber>
}

export type ICarrierAssignment = {
  __typename?: 'CarrierAssignment'
  bounceReason?: Maybe<ICarrierAssignmentBounceReason>
  bounced: Scalars['Boolean']
  bouncedAt?: Maybe<Scalars['ISO8601DateTime']>
  bouncedBy?: Maybe<IUser>
  carrierApplication: ICarrierApplication
  carrierTonu?: Maybe<ICarrierTonu>
  dispatcher?: Maybe<IUser>
  driver?: Maybe<IUser>
  id: Scalars['ID']
  rate?: Maybe<Scalars['Float']>
  shipment: IShipment
  trackingMethod?: Maybe<Scalars['String']>
  trailer?: Maybe<ITrailer>
}

export enum ICarrierAssignmentBounceReason {
  ACCEPTABLE_SWITCH = 'ACCEPTABLE_SWITCH',
  CARRIER_BREAKDOWN_ACCIDENT = 'CARRIER_BREAKDOWN_ACCIDENT',
  CARRIER_CARRIER_POOR_PLANNING = 'CARRIER_CARRIER_POOR_PLANNING',
  CARRIER_CHANGE = 'CARRIER_CHANGE',
  CARRIER_DRIVER_ISSUE = 'CARRIER_DRIVER_ISSUE',
  CARRIER_NEGLIGENCE = 'CARRIER_NEGLIGENCE',
  CARRIER_NO_CAPACITY = 'CARRIER_NO_CAPACITY',
  CARRIER_NO_DOCS = 'CARRIER_NO_DOCS',
  CARRIER_NO_OTP = 'CARRIER_NO_OTP',
  CARRIER_NO_TRACK_NO_RESPONSE = 'CARRIER_NO_TRACK_NO_RESPONSE',
  CARRIER_REJECTED_TRAILER = 'CARRIER_REJECTED_TRAILER',
  CUSTOMER_NEGLIGENCE = 'CUSTOMER_NEGLIGENCE',
  DECLINED_MANUAL_OFFER_VIA_EDI_990 = 'DECLINED_MANUAL_OFFER_VIA_EDI_990',
  DECLINED_OFFER_VIA_FMS = 'DECLINED_OFFER_VIA_FMS',
  NO_FAULT = 'NO_FAULT',
  NO_FAULT_EXTREME_WEATHER = 'NO_FAULT_EXTREME_WEATHER',
  NO_FAULT_ROAD_CLOSURE = 'NO_FAULT_ROAD_CLOSURE',
  NO_REASON_PROVIDED = 'NO_REASON_PROVIDED',
  OFFER_CHANGED = 'OFFER_CHANGED',
  OFFER_EXPIRED = 'OFFER_EXPIRED',
  SHIPPER_CHANGE = 'SHIPPER_CHANGE',
  SHIPPER_CHANGES_TO_SHIPMENT = 'SHIPPER_CHANGES_TO_SHIPMENT',
  SHIPPER_DOUBLE_TENDERED = 'SHIPPER_DOUBLE_TENDERED',
  SHIPPER_LOAD_CANCELLED = 'SHIPPER_LOAD_CANCELLED',
  SHIPPER_LOAD_NOT_READY = 'SHIPPER_LOAD_NOT_READY',
  TONU = 'TONU',
  TRANSFIX_CHANGED_LOAD_NUM = 'TRANSFIX_CHANGED_LOAD_NUM',
  TRANSFIX_LOAD_BUILT_INCORRECTLY = 'TRANSFIX_LOAD_BUILT_INCORRECTLY',
  TRANSFIX_MISCOMMUNICATION_WITH_DRIVER = 'TRANSFIX_MISCOMMUNICATION_WITH_DRIVER',
  TRANSFIX_NEGLIGENCE = 'TRANSFIX_NEGLIGENCE',
  UNCANCEL_UNTONU = 'UNCANCEL_UNTONU',
}

export type ICarrierAvailableTruck = {
  __typename?: 'CarrierAvailableTruck'
  carrierApplication: ICarrierApplication
  carrierApplicationId: Scalars['ID']
  emptyAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  isVinConfirmed: Scalars['Boolean']
  trailerNumber?: Maybe<Scalars['String']>
  truckLocation: ILocation
  truckLocationId: Scalars['ID']
  truckNumber?: Maybe<Scalars['String']>
  vin?: Maybe<Scalars['String']>
}

export enum ICarrierBidDirectionTypes {
  /** Inbound */
  inbound = 'inbound',
  /** Outbound */
  outbound = 'outbound',
}

export enum ICarrierBidSourceTypes {
  /** Alert */
  alert = 'alert',
  /** Auto */
  auto = 'auto',
  /** Covered */
  covered = 'covered',
  /** Fleet planner */
  fleet_planner = 'fleet_planner',
  /** Manual */
  manual = 'manual',
  /** Marketplace */
  marketplace = 'marketplace',
  /** Mobile */
  mobile = 'mobile',
  /** Offered */
  offered = 'offered',
  /** Push notification */
  push_notification = 'push_notification',
}

export type ICarrierCallListMatch = {
  __typename?: 'CarrierCallListMatch'
  bid?: Maybe<Scalars['Boolean']>
  carrierApplication: ICarrierApplication
  laneAlert?: Maybe<Scalars['Boolean']>
  lastLoad?: Maybe<IShipment>
  lastRan?: Maybe<Scalars['ISO8601DateTime']>
  lastRate?: Maybe<Scalars['Float']>
  metadata: ICarrierCallListMatchMetadata
  metadataCarrierContractLaneId?: Maybe<Scalars['ID']>
  metadataShipmentId?: Maybe<Scalars['ID']>
  postedTruck?: Maybe<Scalars['Boolean']>
  postsOften?: Maybe<Scalars['Boolean']>
  ranBackhaul?: Maybe<Scalars['Boolean']>
  ranBefore?: Maybe<Scalars['Boolean']>
  ranHeadhaul?: Maybe<Scalars['Boolean']>
  referenceContractLaneIds?: Maybe<Array<Scalars['ID']>>
  referenceShipmentIds?: Maybe<Array<Scalars['ID']>>
  referenceTruckIds?: Maybe<Array<Scalars['ID']>>
  reload?: Maybe<Scalars['Boolean']>
  reservedLoads?: Maybe<Scalars['Boolean']>
  searched?: Maybe<Scalars['Boolean']>
  strongestMatch: ICarrierCallListMatchStrategyEnum
  totalRan?: Maybe<Scalars['Int']>
}

export type ICarrierCallListMatchMetadata = {
  __typename?: 'CarrierCallListMatchMetadata'
  callbackExtension?: Maybe<Scalars['String']>
  callbackName?: Maybe<Scalars['String']>
  callbackPhone?: Maybe<Scalars['String']>
  comments?: Maybe<Scalars['String']>
  deliveryCityState?: Maybe<Scalars['String']>
  destinationLocations?: Maybe<Scalars['String']>
  dispatcher?: Maybe<IUser>
  equipmentType?: Maybe<Scalars['String']>
  externallyCreatedAt?: Maybe<Scalars['ISO8601DateTime']>
  lastShipmentId?: Maybe<Scalars['ID']>
  originDeadhead?: Maybe<ICarrierCallListMatchMetadataDeadhead>
  pickupCityState?: Maybe<Scalars['String']>
  /** Applicable for lane-alert strategies, takes precedence over dispatcher field */
  recipients?: Maybe<Array<IParentUser>>
}

export type ICarrierCallListMatchMetadataDeadhead = {
  __typename?: 'CarrierCallListMatchMetadataDeadhead'
  miles?: Maybe<Scalars['Float']>
}

export enum ICarrierCallListMatchStrategyEnum {
  /** Bid */
  bid = 'bid',
  /** Lane alert */
  lane_alert = 'lane_alert',
  /** Posted truck */
  posted_truck = 'posted_truck',
  /** Posts often */
  posts_often = 'posts_often',
  /** Ran backhaul */
  ran_backhaul = 'ran_backhaul',
  /** Ran before */
  ran_before = 'ran_before',
  /** Ran headhaul */
  ran_headhaul = 'ran_headhaul',
  /** Reload */
  reload = 'reload',
  /** Reserved loads */
  reserved_loads = 'reserved_loads',
  /** Searched */
  searched = 'searched',
}

export type ICarrierCallListResponse = {
  __typename?: 'CarrierCallListResponse'
  matches: Array<ICarrierCallListMatch>
  /** current page */
  pageCount: Scalars['Int']
  perPage: Scalars['Int']
  /** number of total matches */
  totalCount: Scalars['Int']
}

export enum ICarrierCallListSortEnum {
  /** Last time a load was run on this lane by carrier */
  last_ran = 'last_ran',
  /** Carrier rate of last load ran on this lane */
  last_rate = 'last_rate',
}

export type ICarrierCertification = {
  __typename?: 'CarrierCertification'
  /** The certification ID. */
  certificationId: Scalars['ID']
  /** The certification code. */
  code: Scalars['String']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** If the certification has been verified by supplier.io. */
  isVerified: Scalars['Boolean']
  /** The organization that issued the certification. */
  issuingOrganization?: Maybe<Scalars['String']>
  /** The date the certification expires. */
  renewalDate?: Maybe<Scalars['ISO8601Date']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type ICarrierContractLane = {
  __typename?: 'CarrierContractLane'
  approvedAt?: Maybe<Scalars['ISO8601DateTime']>
  approvedBy?: Maybe<IUser>
  carrierApplication: ICarrierApplication
  createdAt: Scalars['ISO8601DateTime']
  createdBy: IUser
  deliveryRadiusMiles?: Maybe<Scalars['ID']>
  deliveryTimePreference: ICarrierContractLaneDeliveryTimes
  dispatcher: IUser
  id: Scalars['ID']
  isOnlyBeer?: Maybe<Scalars['Boolean']>
  isOnlyDropTrailer?: Maybe<Scalars['Boolean']>
  isShipperExclusive?: Maybe<Scalars['Boolean']>
  pickupRadiusMiles?: Maybe<Scalars['ID']>
  pickupTimePreferences: Array<ICarrierContractLanePickupTime>
  shipperApplication?: Maybe<IShipperApplication>
  startDate?: Maybe<Scalars['String']>
  uuid: Scalars['ID']
}

export enum ICarrierContractLaneDeliveryTimes {
  /** Any */
  any = 'any',
  /** Next day */
  next_day = 'next_day',
  /** Same day */
  same_day = 'same_day',
}

export type ICarrierContractLanePickupTime = {
  __typename?: 'CarrierContractLanePickupTime'
  carrierContractLaneUuid: Scalars['ID']
  dayOfWeek: IWeekDaysEnum
  endTime?: Maybe<Scalars['String']>
  id: Scalars['ID']
  startTime?: Maybe<Scalars['String']>
}

export type ICarrierDedicatedLaneRatePreference = {
  __typename?: 'CarrierDedicatedLaneRatePreference'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  /** Whether the carrier is interested in dedicated lanes. */
  isInterestedInDedicatedLanes: Scalars['Boolean']
  /** The minimum rate per mile the carrier is willing to accept. */
  minimumRatePerMile?: Maybe<Scalars['Float']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type ICarrierEquipmentCapability = {
  __typename?: 'CarrierEquipmentCapability'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  /** Carrier capable of handling dry van freight. */
  isDryVanCapable: Scalars['Boolean']
  /** Carrier capable of handling flatbed freight. */
  isFlatbedCapable: Scalars['Boolean']
  /** Carrier capable of handling reefer freight. */
  isReeferCapable: Scalars['Boolean']
  /** Carrier only has trailers, no power units. */
  isTrailerOnly: Scalars['Boolean']
  /** Number of power units the carrier has. */
  powerUnitCount: Scalars['Int']
  /** Number of trailers the carrier has. */
  trailerCount: Scalars['Int']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type ICarrierFreightCapability = {
  __typename?: 'CarrierFreightCapability'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  /** Carrier capable of picking up drayage freight, e.g. shipping containers from ocean ports. */
  isDrayageCapable: Scalars['Boolean']
  /** Carrier capable of handling full truckloads. */
  isFtlCapable: Scalars['Boolean']
  /** Carrier capable of handling intermodal freight. */
  isIntermodalCapable: Scalars['Boolean']
  /** Carrier capable of handling less than truckloads. */
  isLtlCapable: Scalars['Boolean']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type ICarrierLoadingCapability = {
  __typename?: 'CarrierLoadingCapability'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  /** Whether the carrier is capable of drop loading. */
  isDropCapable: Scalars['Boolean']
  /** Whether the carrier is capable of carrying loads over 42,000 lbs. */
  isHeavyLoadCapable: Scalars['Boolean']
  /** Whether the carrier is capable of live loading. */
  isLiveCapable: Scalars['Boolean']
  /** Whether the carrier is only capable of carrying power units. */
  isPowerOnly: Scalars['Boolean']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum ICarrierOptionSortByEnum {
  amount = 'amount',
  counter_bid_amount = 'counter_bid_amount',
  shipper_name = 'shipper_name',
  updated_at = 'updated_at',
}

export enum ICarrierOptionViewEnum {
  all = 'all',
  cm_lead = 'cm_lead',
  default = 'default',
}

export type ICarrierProfile = {
  __typename?: 'CarrierProfile'
  /** The carrier certification details. */
  certifications: Array<ICarrierCertification>
  /** The carrier dedicated lane rate preferences. */
  dedicatedLaneRatePreference?: Maybe<ICarrierDedicatedLaneRatePreference>
  /** The carrier endorsement titles. */
  endorsements: Array<Scalars['String']>
  /** The carrier equipment capabilities. */
  equipmentCapability?: Maybe<ICarrierEquipmentCapability>
  /** The carrier excluded commodity titles. */
  excludedCommodities: Array<Scalars['String']>
  /** The carrier freight capabilities. */
  freightCapability?: Maybe<ICarrierFreightCapability>
  /** The carrier loading capabilities. */
  loadingCapability?: Maybe<ICarrierLoadingCapability>
  /** The carrier rate type preferences. */
  rateTypePreference?: Maybe<ICarrierRateTypePreference>
  /** The carrier SmartWay registration details. */
  smartWayRegistration?: Maybe<ICarrierSmartWayRegistration>
}

export type ICarrierRateTypePreference = {
  __typename?: 'CarrierRateTypePreference'
  /** Whether the carrier allows all-in rates. */
  allowsAllIn: Scalars['Boolean']
  /** Whether the carrier allows day rates. */
  allowsDayRate: Scalars['Boolean']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** Whether the carrier has a line haul fuel surcharge. */
  hasLineHaulFuelSurcharge: Scalars['Boolean']
  id?: Maybe<Scalars['ID']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum ICarrierRateTypes {
  /** Flat rate */
  flat_rate = 'flat_rate',
  /** Fuel surcharge */
  fuel_surcharge = 'fuel_surcharge',
}

export type ICarrierRelationship = {
  __typename?: 'CarrierRelationship'
  carrierApplication: ICarrierApplication
  createdAt: Scalars['ISO8601DateTime']
  createdBy: IUser
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  deletedBy?: Maybe<IUser>
  id: Scalars['ID']
  relationshipLevel: IApplicationRelationshipLevels
  relationshipType: ICarrierRelationshipTypes
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy: IUser
  user: IUser
}

export type ICarrierRelationshipInput = {
  /** Destroy this relationship if it exists. */
  destroy?: Maybe<Scalars['Boolean']>
  relationshipLevel: IApplicationRelationshipLevels
  relationshipType: ICarrierRelationshipTypes
  userId: Scalars['ID']
}

export enum ICarrierRelationshipTypes {
  /** Carrier experience representative */
  carrier_experience_representative = 'carrier_experience_representative',
  /** Carrier manager */
  carrier_manager = 'carrier_manager',
  /** Carrier sales representative */
  carrier_sales_representative = 'carrier_sales_representative',
}

export type ICarrierScorecard = {
  __typename?: 'CarrierScorecard'
  /** Number of times the carrier fell off a shipment within 24 hours of pickup */
  bounceFailure?: Maybe<Scalars['Int']>
  /** Bounce percent for carrier */
  bouncePct?: Maybe<Scalars['Float']>
  /** Bounce score of the carrier */
  bounceScore?: Maybe<Scalars['Int']>
  /** Number of times the carrier did not fall off a shipment within 24 hour of pickup */
  bounceSuccess?: Maybe<Scalars['Int']>
  /** The date of the last shipment that the carrier ran */
  lastShipmentDate?: Maybe<Scalars['ISO8601Date']>
  /** Number of stops arrived late */
  onTimeFailure?: Maybe<Scalars['Int']>
  /** On Time Percentage of the carrier */
  onTimePct: Scalars['Float']
  /** On time score for the carrier */
  onTimeScore?: Maybe<Scalars['Int']>
  /** Number of stops arrived on-time */
  onTimeSuccess?: Maybe<Scalars['Int']>
  /** Overall score for the carrier */
  overallScore?: Maybe<Scalars['Float']>
  /** If the scorecard holds stale data */
  stale?: Maybe<Scalars['Boolean']>
  /** Number of shipments not tracked */
  trackingFailure?: Maybe<Scalars['Int']>
  /** Tracking Percentage of the carrier */
  trackingPct: Scalars['Float']
  /** Tracking score for the carrier */
  trackingScore?: Maybe<Scalars['Int']>
  /** Number of shipments tracked */
  trackingSuccess?: Maybe<Scalars['Int']>
  /** Date the carrier scorecard was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>
}

export type ICarrierShipment = {
  __typename?: 'CarrierShipment'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type ICarrierSmartWayRegistration = {
  __typename?: 'CarrierSmartWayRegistration'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  /** Whether the carrier is registered with SmartWay. */
  isRegistered: Scalars['Boolean']
  /** The date the carrier's SmartWay registration expires. */
  renewalDate?: Maybe<Scalars['ISO8601Date']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum ICarrierStateEnum {
  active = 'active',
  not_active = 'not_active',
}

export type ICarrierTonu = {
  __typename?: 'CarrierTonu'
  amount: Scalars['Float']
  approvedAt?: Maybe<Scalars['ISO8601DateTime']>
  approvedBy?: Maybe<IUser>
  approvedById?: Maybe<Scalars['ID']>
  carrier: ICarrierApplication
  carrierAssignment: ICarrierAssignment
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  createdBy: IUser
  createdById: Scalars['ID']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  deletedBy?: Maybe<IUser>
  deletedById?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  isOop: Scalars['Boolean']
  oopReason?: Maybe<Scalars['String']>
  rateConfirmation?: Maybe<ICarrierTonuRateConfirmation>
  shipment: IShipment
  shipmentAccessorial?: Maybe<IShipmentAccessorial>
  shipperProofOfTonu?: Maybe<IShipperProofOfTonu>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type ICarrierTonuRateConfirmation = {
  __typename?: 'CarrierTonuRateConfirmation'
  createdAt?: Maybe<Scalars['ISO8601DateTime']>
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  document: IDownloadable
  id: Scalars['ID']
  type: Scalars['String']
}

export enum ICarrierTrackingMethods {
  /** keep_truckin */
  keep_truckin = 'keep_truckin',
  /** project_44 */
  project_44 = 'project_44',
}

export type ICarrierTrackingProvider = {
  __typename?: 'CarrierTrackingProvider'
  active: Scalars['Boolean']
  carrierApplicationId: Scalars['ID']
  id: Scalars['ID']
  p44TrackingMethod?: Maybe<IP44TrackingMethods>
  trackingMethod: ICarrierTrackingMethods
  updatedAt: Scalars['ISO8601DateTime']
  updatedById?: Maybe<Scalars['ID']>
}

export enum ICarrierUserTypes {
  /** Dispatcher */
  dispatcher = 'dispatcher',
  /** Driver */
  driver = 'driver',
  /** Owner Operator */
  owner_operator = 'owner_operator',
}

export type ICarrierWaitTimeCriteria = {
  __typename?: 'CarrierWaitTimeCriteria'
  id: Scalars['ID']
  rangeEnd?: Maybe<Scalars['String']>
  rangeStart?: Maybe<Scalars['String']>
}

/** Autogenerated input type of CloseBillCreditNow */
export type ICloseBillCreditNowInput = {
  billCreditId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of CloseBillCreditNow */
export type ICloseBillCreditNowPayload = {
  __typename?: 'CloseBillCreditNowPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of CloseBillNow */
export type ICloseBillNowInput = {
  billId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of CloseBillNow */
export type ICloseBillNowPayload = {
  __typename?: 'CloseBillNowPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of CloseInvoiceCreditNow */
export type ICloseInvoiceCreditNowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  invoiceCreditId: Scalars['ID']
  sendEdiOrPdf?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of CloseInvoiceCreditNow */
export type ICloseInvoiceCreditNowPayload = {
  __typename?: 'CloseInvoiceCreditNowPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of CloseInvoiceNow */
export type ICloseInvoiceNowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  invoiceId: Scalars['ID']
  sendEdiOrPdf?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of CloseInvoiceNow */
export type ICloseInvoiceNowPayload = {
  __typename?: 'CloseInvoiceNowPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of CloseRfp */
export type ICloseRfpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  rfpId: Scalars['ID']
}

/** Autogenerated return type of CloseRfp */
export type ICloseRfpPayload = {
  __typename?: 'CloseRfpPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

export enum ICodeStatuses {
  /** Active */
  active = 'active',
  /** Failed */
  failed = 'failed',
  /** Inactive */
  inactive = 'inactive',
  /** Pending */
  pending = 'pending',
  /** Processing */
  processing = 'processing',
  /** Used */
  used = 'used',
}

export enum ICodeTypes {
  /** Digital Card */
  digital_card = 'digital_card',
  /** Relay Code */
  relay_code = 'relay_code',
}

export type IComcheck = {
  __typename?: 'Comcheck'
  amount: Scalars['Float']
  approvedAt?: Maybe<Scalars['ISO8601DateTime']>
  approvedBy?: Maybe<IUser>
  carrierApplication: ICarrierApplication
  carrierFee: Scalars['Float']
  carrierFeePercentage: Scalars['Float']
  code?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  creator: IUser
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  deletedBy?: Maybe<IUser>
  driver: IUser
  id: Scalars['ID']
  reason: Scalars['String']
  totalAmount: Scalars['Float']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type ICommodity = {
  __typename?: 'Commodity'
  createdAt: Scalars['ISO8601DateTime']
  description: Scalars['String']
  id: Scalars['ID']
}

export type IComplianceChecklist = {
  __typename?: 'ComplianceChecklist'
  carrierApplicationId: Scalars['ID']
  fleetPlannerMotorCarrierId: Scalars['ID']
  hasW9Form: Scalars['Boolean']
  id: Scalars['ID']
}

export type IComplianceCoverReview = {
  __typename?: 'ComplianceCoverReview'
  approvedAt?: Maybe<Scalars['ISO8601DateTime']>
  carrierApplication: ICarrierApplication
  carrierApplicationId: Scalars['ID']
  closureReason?: Maybe<Scalars['String']>
  complianceRep?: Maybe<IUser>
  complianceRepId?: Maybe<Scalars['ID']>
  createdAt: Scalars['ISO8601DateTime']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  rejectedAt?: Maybe<Scalars['ISO8601DateTime']>
  shipment: IShipment
  shipmentId: Scalars['ID']
  status: IComplianceCoverReviewStatuses
}

export enum IComplianceCoverReviewStatuses {
  /** active:in_review */
  active_in_review = 'active_in_review',
  /** active:needs_review */
  active_needs_review = 'active_needs_review',
  /** approved */
  approved = 'approved',
  /** cancelled */
  cancelled = 'cancelled',
  /** rejected */
  rejected = 'rejected',
}

export type IComplianceFlag = {
  __typename?: 'ComplianceFlag'
  description: Scalars['String']
  id: Scalars['ID']
  name: Scalars['String']
}

export type IConfigGroup = {
  __typename?: 'ConfigGroup'
  configGroupMappings?: Maybe<Array<IConfigGroupMapping>>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  name: Scalars['String']
  shipperApplication?: Maybe<IShipperApplication>
  shipperApplicationId: Scalars['ID']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IConfigGroupMapping = {
  __typename?: 'ConfigGroupMapping'
  configGroup?: Maybe<IConfigGroup>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  ediMapperConfigGroupId: Scalars['ID']
  id: Scalars['ID']
  inboundEdiMapperConnectionConfig?: Maybe<IInboundConnectionConfig>
  inboundEdiMapperConnectionConfigId: Scalars['ID']
  isaSenderId: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IConfigurableBuilder = {
  __typename?: 'ConfigurableBuilder'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  ediMessageTypes?: Maybe<Array<IEdiMessage>>
  id: Scalars['ID']
  /** is the builder ready for use in production? */
  isLive: Scalars['Boolean']
  name: Scalars['String']
  transactionSet: ITransactionSetTypes
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IConfigurableBuilderTest = {
  __typename?: 'ConfigurableBuilderTest'
  accountingInvoiceId?: Maybe<Scalars['Int']>
  changedField?: Maybe<Scalars['String']>
  changedShipperStopSequence?: Maybe<Scalars['Int']>
  expectedOutput: Scalars['JSON']
  id: Scalars['ID']
  isLive: Scalars['Boolean']
  name: Scalars['String']
  notes?: Maybe<Scalars['String']>
  shipmentId?: Maybe<Scalars['Int']>
}

export type IConfigurableBuilderTestResult = {
  __typename?: 'ConfigurableBuilderTestResult'
  actualEdi?: Maybe<Scalars['String']>
  actualJson?: Maybe<Scalars['JSON']>
  diffs?: Maybe<Scalars['JSON']>
  expectedJson: Scalars['JSON']
  id: Scalars['ID']
  isLive: Scalars['Boolean']
  name: Scalars['String']
  notes?: Maybe<Scalars['String']>
  passed: Scalars['Boolean']
  status: IConfigurableBuilderTestResultStatuses
}

export enum IConfigurableBuilderTestResultStatuses {
  FAILED = 'FAILED',
  PASSED = 'PASSED',
  SKIPPED = 'SKIPPED',
}

export type IConfigurableBuilderVersion = {
  __typename?: 'ConfigurableBuilderVersion'
  builderLibrary: IBuilderLibraries
  canBuildBalanceDues: Scalars['Boolean']
  ediMapperConfigurableBuilder?: Maybe<IConfigurableBuilder>
  ediMapperConfigurableBuilderId: Scalars['ID']
  extractionTemplate: Scalars['String']
  id: Scalars['ID']
  isLive: Scalars['Boolean']
  notes?: Maybe<Scalars['String']>
  stupidediConfig?: Maybe<IStupidEdiConfigs>
  tfx12DefinitionId?: Maybe<Scalars['ID']>
  wasEverLive: Scalars['Boolean']
}

export type IConfigurableParser = {
  __typename?: 'ConfigurableParser'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  ediMessageTypes?: Maybe<Array<IEdiMessage>>
  id: Scalars['ID']
  name: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IConfirmCarrierInformationInput = {
  address: Scalars['String']
  city: Scalars['String']
  contactEmail: Scalars['String']
  contactPhone: Scalars['String']
  countryCode: Scalars['String']
  dotNumber: Scalars['String']
  legalName: Scalars['String']
  mcNumber: Scalars['String']
  postalCode: Scalars['String']
  stateCode: Scalars['String']
}

/** An inbound or outbound edi connection config. */
export type IConnectionConfig = IInboundConnectionConfig | IOutboundConnectionConfig

export enum IConnectionConfigEnvironment {
  development = 'development',
  production = 'production',
  staging = 'staging',
}

export enum IConnectionConfigTypes {
  InboundEdiMapperConnectionConfig = 'InboundEdiMapperConnectionConfig',
  OutboundEdiMapperConnectionConfig = 'OutboundEdiMapperConnectionConfig',
}

export enum IConnectionTypes {
  AS2 = 'AS2',
  FTP = 'FTP',
  SFTP_WITH_PASSWORD = 'SFTP_WITH_PASSWORD',
  SFTP_WITH_PRIVATE_KEY = 'SFTP_WITH_PRIVATE_KEY',
}

export type IContactPreference = {
  __typename?: 'ContactPreference'
  autoSmsDisabled: Scalars['Boolean']
  autoSmsDisabledReason?: Maybe<Scalars['String']>
  carrierContactInstructions?: Maybe<Scalars['String']>
}

export type IContractCriteria = {
  __typename?: 'ContractCriteria'
  awardType: Scalars['String']
  id: Scalars['ID']
}

export type IContractLaneMatch = {
  __typename?: 'ContractLaneMatch'
  bid?: Maybe<IBid>
  carrierApplication: ICarrierApplication
  carrierContractLane: ICarrierContractLane
  deliveryRadiusMiles?: Maybe<Scalars['String']>
  destinationCity?: Maybe<Scalars['String']>
  destinationStateCode?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isSameMarket: Scalars['Boolean']
  matchStrategy: IContractLaneMatchStrategies
  matchType?: Maybe<IContractLaneMatchTypes>
  offerDurationMinutes?: Maybe<Scalars['Int']>
  originCity: Scalars['String']
  originStateCode: Scalars['String']
  outcome: IContractLaneMatchOutcomes
  pickupRadiusMiles?: Maybe<Scalars['String']>
  rate?: Maybe<Scalars['Float']>
  shipment: IShipment
  skipReasons?: Maybe<Array<Scalars['String']>>
  skippedBy?: Maybe<IUser>
  waterfallOfferSequence: IWaterfallOfferSequence
  waterfallTimeLeftMinutes: Scalars['Int']
}

export enum IContractLaneMatchOutcomes {
  accepted = 'accepted',
  declined = 'declined',
  not_offered_yet = 'not_offered_yet',
  offer_expired = 'offer_expired',
  offered = 'offered',
  re_offered = 're_offered',
  skipped = 'skipped',
}

export enum IContractLaneMatchStrategies {
  /** Auto historical */
  auto_historical = 'auto_historical',
  /** Auto reloads */
  auto_reloads = 'auto_reloads',
  /** City radius */
  city_radius = 'city_radius',
  /** City states */
  city_states = 'city_states',
  /** Dat markets */
  dat_markets = 'dat_markets',
  /** Delivery radius */
  delivery_radius = 'delivery_radius',
}

export enum IContractLaneMatchTypes {
  /** Auto offer */
  auto_offer = 'auto_offer',
  /** Lane alert */
  lane_alert = 'lane_alert',
  /** Re offer */
  re_offer = 're_offer',
}

export enum IContractLaneMatchUserSkipReasons {
  /** Not interested in shipper or facility */
  carrier_not_interested_facility = 'carrier_not_interested_facility',
  /** Not interested in pickup city or delivery city */
  carrier_not_interested_lane = 'carrier_not_interested_lane',
  /** Not interested in appt times */
  carrier_not_interested_timing = 'carrier_not_interested_timing',
  /** Carrier not responding to email or call */
  carrier_not_responding = 'carrier_not_responding',
  /** No trucks available */
  no_trucks = 'no_trucks',
  /** Pickup date is too far out */
  pickup_date_too_far = 'pickup_date_too_far',
  /** Too heavy */
  too_heavy = 'too_heavy',
}

export type IConversation = {
  __typename?: 'Conversation'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  lastMessageSentAt?: Maybe<Scalars['ISO8601DateTime']>
  owner: IUser
  role?: Maybe<Scalars['String']>
  shipment?: Maybe<IShipment>
  smsMessages: Array<ISmsMessage>
  state: IConversationStates
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IConversationStates {
  /** canceled */
  canceled = 'canceled',
  /** closed */
  closed = 'closed',
  /** open */
  open = 'open',
}

export type ICoordinateInput = {
  latitude: Scalars['Float']
  longitude: Scalars['Float']
}

export type ICostControlConfig = {
  __typename?: 'CostControlConfig'
  controlOption?: Maybe<Scalars['String']>
  costStrategy?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  deliveryRegion?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isDrop?: Maybe<Scalars['Boolean']>
  pickupRegion?: Maybe<Scalars['String']>
  rangeEnd?: Maybe<Scalars['ISO8601Date']>
  rangeStart?: Maybe<Scalars['ISO8601Date']>
  ruleType?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type ICountLoadsQuotedCriteria = {
  __typename?: 'CountLoadsQuotedCriteria'
  deliveryType: Scalars['String']
  deliveryValue: Scalars['String']
  id: Scalars['ID']
  isDifferentPickupDelivery?: Maybe<Scalars['Boolean']>
  isSamePickupDelivery?: Maybe<Scalars['Boolean']>
  pickupType: Scalars['String']
  pickupValue: Scalars['String']
  rangeEnd?: Maybe<Scalars['String']>
  rangeStart?: Maybe<Scalars['String']>
}

export enum ICountries {
  /** Canada */
  CA = 'CA',
  /** Mexico */
  MX = 'MX',
  /** United States */
  US = 'US',
}

export type ICoverBid = {
  amount: Scalars['Float']
  carrierApplicationId: Scalars['ID']
  carrierAvailableTruck?: Maybe<IAvailableTruckInput>
  carrierContactName: Scalars['String']
  carrierContactPhone: Scalars['String']
  carrierContactPhoneExt?: Maybe<Scalars['String']>
  carrierContactUserId?: Maybe<Scalars['ID']>
  counterBidAmount?: Maybe<Scalars['Float']>
  driverId?: Maybe<Scalars['ID']>
}

export type ICoverNowRate = {
  __typename?: 'CoverNowRate'
  rate?: Maybe<Scalars['Float']>
  type: ICoverNowTypes
}

export enum ICoverNowTypes {
  /** Expected CoverNow value by 8am tomorrow morning */
  cover_eight_am_tomorrow = 'cover_eight_am_tomorrow',
  /** Expected CoverNow value in 4 hours time */
  cover_four_hours_from_now = 'cover_four_hours_from_now',
  /** CoverNow value for current time */
  cover_now = 'cover_now',
}

/** Autogenerated input type of CoverShipment */
export type ICoverShipmentInput = {
  bid: ICoverBid
  callBackAt?: Maybe<Scalars['ISO8601DateTime']>
  carrierContactInstructions?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  lateReason?: Maybe<Scalars['String']>
  manualEta?: Maybe<Scalars['ISO8601DateTime']>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of CoverShipment */
export type ICoverShipmentPayload = {
  __typename?: 'CoverShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of CreateAppointmentConfirmationRule */
export type ICreateAppointmentConfirmationRuleInput = {
  actions: Array<IAppointmentConfirmationRuleActionInput>
  activated: Scalars['Boolean']
  appliedOn: Array<IAppointmentConfirmationRuleAppliedOnEnum>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  conditions: Array<IAppointmentConfirmationRuleConditionInput>
  shipperApplicationId: Scalars['ID']
}

/** Autogenerated return type of CreateAppointmentConfirmationRule */
export type ICreateAppointmentConfirmationRulePayload = {
  __typename?: 'CreateAppointmentConfirmationRulePayload'
  appointmentConfirmationRule?: Maybe<IAppointmentConfirmationRule>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of CreateAs2Certificate */
export type ICreateAs2CertificateInput = {
  /** The connection config this certificate should be associated with */
  as2ConnectionConfigId: Scalars['Int']
  /** PEM-encoded certificate body */
  body: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of CreateAs2Certificate */
export type ICreateAs2CertificatePayload = {
  __typename?: 'CreateAs2CertificatePayload'
  as2Certificate?: Maybe<IAs2Certificate>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of CreateAttachedDocument */
export type ICreateAttachedDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  document: IDocumentInput
  shipmentId: Scalars['ID']
  type: IAttachedDocumentTypes
}

/** Autogenerated return type of CreateAttachedDocument */
export type ICreateAttachedDocumentPayload = {
  __typename?: 'CreateAttachedDocumentPayload'
  attachedDocument?: Maybe<IAttachedDocument>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

export type ICreateBid = {
  amount: Scalars['Float']
  carrierApplicationId?: Maybe<Scalars['ID']>
  carrierAvailableTruck?: Maybe<IAvailableTruckInput>
  carrierContactName?: Maybe<Scalars['String']>
  carrierContactPhone: Scalars['String']
  carrierContactPhoneExt?: Maybe<Scalars['String']>
  carrierContactUserId?: Maybe<Scalars['ID']>
  counterBidAmount?: Maybe<Scalars['Float']>
  createBidApproval?: Maybe<Scalars['Boolean']>
  direction: ICarrierBidDirectionTypes
  driverId?: Maybe<Scalars['ID']>
  isNotBookable?: Maybe<Scalars['Boolean']>
  note?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
  source: ICarrierBidSourceTypes
  sourceChannel?: Maybe<Scalars['String']>
  sourceSegment?: Maybe<Scalars['String']>
}

export type ICreateBidApproval = {
  bidId: Scalars['ID']
  comment?: Maybe<Scalars['String']>
}

/** Autogenerated input type of CreateBidApproval */
export type ICreateBidApprovalInput = {
  bidApproval: ICreateBidApproval
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of CreateBidApproval */
export type ICreateBidApprovalPayload = {
  __typename?: 'CreateBidApprovalPayload'
  bidApproval?: Maybe<IBidApproval>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of CreateBid */
export type ICreateBidInput = {
  bid: ICreateBid
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of CreateBid */
export type ICreateBidPayload = {
  __typename?: 'CreateBidPayload'
  bid?: Maybe<IBid>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of CreateCarrierApplicationBca */
export type ICreateCarrierApplicationBcaInput = {
  brokerCarrierSignatory: Scalars['String']
  carrierApplicationId?: Maybe<Scalars['ID']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contactEmail: Scalars['String']
  currentUserId: Scalars['ID']
  fleetPlannerMotorCarrierId?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of CreateCarrierApplicationBca */
export type ICreateCarrierApplicationBcaPayload = {
  __typename?: 'CreateCarrierApplicationBcaPayload'
  carrierApplication?: Maybe<ICarrierApplication>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of CreateCarrierApplication */
export type ICreateCarrierApplicationInput = {
  accountingEmail?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contactEmail?: Maybe<Scalars['String']>
  dbaName?: Maybe<Scalars['String']>
  dotNumber?: Maybe<Scalars['ID']>
  ein?: Maybe<Scalars['String']>
  entityType?: Maybe<ICarrierApplicationEntityTypes>
  factorId?: Maybe<Scalars['ID']>
  fleetPlannerMotorCarrierId?: Maybe<Scalars['ID']>
  headquarter?: Maybe<ILocationInput>
  isCarbCompliant?: Maybe<Scalars['Boolean']>
  isDisadvantagedBusinessEntity?: Maybe<Scalars['Boolean']>
  isEldCompliant?: Maybe<Scalars['Boolean']>
  mcNumber?: Maybe<Scalars['ID']>
  name: Scalars['String']
  secondaryAccountingEmail?: Maybe<Scalars['String']>
}

/** Autogenerated return type of CreateCarrierApplication */
export type ICreateCarrierApplicationPayload = {
  __typename?: 'CreateCarrierApplicationPayload'
  carrierApplication?: Maybe<ICarrierApplication>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of CreateCarrierUser */
export type ICreateCarrierUserInput = {
  carrierApplicationId: Scalars['ID']
  cellPhone?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  phone?: Maybe<Scalars['String']>
  phoneExt?: Maybe<Scalars['String']>
  userType: ICarrierUserTypes
}

/** Autogenerated return type of CreateCarrierUser */
export type ICreateCarrierUserPayload = {
  __typename?: 'CreateCarrierUserPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  user?: Maybe<IUser>
}

/** Autogenerated input type of CreateConfigGroup */
export type ICreateConfigGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  name: Scalars['String']
  shipperApplicationId: Scalars['ID']
}

/** Autogenerated input type of CreateConfigGroupMapping */
export type ICreateConfigGroupMappingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** config group that this mapping belongs to */
  ediMapperConfigGroupId: Scalars['ID']
  inboundEdiMapperConnectionConfigId: Scalars['ID']
  isaSenderId: Scalars['String']
}

/** Autogenerated return type of CreateConfigGroupMapping */
export type ICreateConfigGroupMappingPayload = {
  __typename?: 'CreateConfigGroupMappingPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configGroupMapping?: Maybe<IConfigGroupMapping>
  errors: Array<IError>
}

/** Autogenerated return type of CreateConfigGroup */
export type ICreateConfigGroupPayload = {
  __typename?: 'CreateConfigGroupPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configGroup?: Maybe<IConfigGroup>
  errors: Array<IError>
}

/** Autogenerated input type of CreateConfigurableBuilder */
export type ICreateConfigurableBuilderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  isLive?: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  transactionSet: ITransactionSetTypes
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
}

/** Autogenerated return type of CreateConfigurableBuilder */
export type ICreateConfigurableBuilderPayload = {
  __typename?: 'CreateConfigurableBuilderPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configurableBuilder?: Maybe<IConfigurableBuilder>
  errors: Array<IError>
}

/** Autogenerated input type of CreateConfigurableBuilderTest */
export type ICreateConfigurableBuilderTestInput = {
  accountingInvoiceId?: Maybe<Scalars['Int']>
  changedField?: Maybe<Scalars['String']>
  changedShipperStopSequence?: Maybe<Scalars['Int']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediMapperConfigurableBuilderId: Scalars['ID']
  expectedOutput: Scalars['JSON']
  isLive?: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  notes?: Maybe<Scalars['String']>
  shipmentId?: Maybe<Scalars['Int']>
}

/** Autogenerated return type of CreateConfigurableBuilderTest */
export type ICreateConfigurableBuilderTestPayload = {
  __typename?: 'CreateConfigurableBuilderTestPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configurableBuilderTest: IConfigurableBuilderTest
  errors: Array<IError>
}

/** Autogenerated input type of CreateConfigurableBuilderVersion */
export type ICreateConfigurableBuilderVersionInput = {
  builderLibrary: IBuilderLibraries
  canBuildBalanceDues?: Maybe<Scalars['Boolean']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediMapperConfigurableBuilderId: Scalars['ID']
  extractionTemplate: Scalars['String']
  stupidediConfig?: Maybe<IStupidEdiConfigs>
  tfx12DefinitionId?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of CreateConfigurableBuilderVersion */
export type ICreateConfigurableBuilderVersionPayload = {
  __typename?: 'CreateConfigurableBuilderVersionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configurableBuilderVersion?: Maybe<IConfigurableBuilderVersion>
  errors: Array<IError>
}

/** Autogenerated input type of CreateCounterBid */
export type ICreateCounterBidInput = {
  amount: Scalars['Float']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  parentBidId: Scalars['ID']
}

/** Autogenerated return type of CreateCounterBid */
export type ICreateCounterBidPayload = {
  __typename?: 'CreateCounterBidPayload'
  bid?: Maybe<IBid>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of CreateDriverLocation */
export type ICreateDriverLocationInput = {
  altitude?: Maybe<Scalars['Float']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  course?: Maybe<Scalars['Float']>
  driverId: Scalars['ID']
  horizontalAccuracy?: Maybe<Scalars['Float']>
  latitude: Scalars['Float']
  longitude: Scalars['Float']
  phoneTimestamp: Scalars['ISO8601DateTime']
  shipmentId: Scalars['ID']
  sourceType?: Maybe<Scalars['String']>
  speed?: Maybe<Scalars['Float']>
  transfixVersion?: Maybe<Scalars['String']>
  verticalAccuracy?: Maybe<Scalars['Float']>
}

/** Autogenerated return type of CreateDriverLocation */
export type ICreateDriverLocationPayload = {
  __typename?: 'CreateDriverLocationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  driverLocation?: Maybe<IDriverLocation>
  errors: Array<IError>
}

/** Autogenerated input type of CreateDriverLocations */
export type ICreateDriverLocationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  driverLocations: Array<IDriverLocationInput>
  parentUserId: Scalars['ID']
}

/** Autogenerated return type of CreateDriverLocations */
export type ICreateDriverLocationsPayload = {
  __typename?: 'CreateDriverLocationsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  keepTracking: Scalars['Boolean']
}

/** Autogenerated input type of CreateEdiChargeCode */
export type ICreateEdiChargeCodeInput = {
  chargeCode: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  lineItemTitle: ILineItemTitles
  shipperApplicationId: Scalars['ID']
  stopType: Scalars['String']
}

/** Autogenerated return type of CreateEdiChargeCode */
export type ICreateEdiChargeCodePayload = {
  __typename?: 'CreateEdiChargeCodePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediChargeCode?: Maybe<IEdiChargeCode>
  errors: Array<IError>
}

/** Autogenerated input type of CreateGroup */
export type ICreateGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  newGroup: INewGroupInput
}

/** Autogenerated return type of CreateGroup */
export type ICreateGroupPayload = {
  __typename?: 'CreateGroupPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  group?: Maybe<IGroup>
}

/** Autogenerated input type of CreateInboundAs2ConnectionConfig */
export type ICreateInboundAs2ConnectionConfigInput = {
  /** The connection config this connection will receive files from */
  as2ConnectionConfigId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  disabled: Scalars['Boolean']
  environment?: Maybe<IConnectionConfigEnvironment>
  /** only process files matching this pattern */
  filenameGlob: Scalars['String']
  /** shipper or carrier id */
  partnerApplicationId: Scalars['ID']
  partnerApplicationType: IPartnerApplicationTypes
  send997s?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of CreateInboundAs2ConnectionConfig */
export type ICreateInboundAs2ConnectionConfigPayload = {
  __typename?: 'CreateInboundAs2ConnectionConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediInboundConnectionConfig?: Maybe<IInboundConnectionConfig>
  errors: Array<IError>
}

/** Autogenerated input type of CreateInboundEdiMessage */
export type ICreateInboundEdiMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediMapperConfigurableParserId?: Maybe<Scalars['ID']>
  /** the inbound config to add the message type to */
  inboundEdiMapperConnectionConfigId: Scalars['ID']
  legacyParserClass?: Maybe<ILegacyParserClassTypes>
  transactionSet: ITransactionSetTypes
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
}

/** Autogenerated return type of CreateInboundEdiMessage */
export type ICreateInboundEdiMessagePayload = {
  __typename?: 'CreateInboundEdiMessagePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediMessageType?: Maybe<IEdiMessage>
  errors: Array<IError>
}

/** Autogenerated input type of CreateInboundFileRouterConfig */
export type ICreateInboundFileRouterConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  connectionType: IFtpConnectionTypes
  /** should config be disabled? */
  disabled: Scalars['Boolean']
  environment: IConnectionConfigEnvironment
  /** hostname */
  host: Scalars['String']
  /** directory to check for incoming files */
  pathPrefix: Scalars['String']
  /** tcp port */
  port: Scalars['Int']
  /**
   * Either an ENV variable name, or a string consisting of 'secretsmanager:'
   * followed by a secretsmanager id. This should resolve to a password or SSH
   * private key, depending on the connection type.
   */
  secretKey: Scalars['String']
  /** JSON config to get the shipper code from EDI */
  shipperCodeJson: Scalars['JSON']
  /** TMS name */
  tmsName: Scalars['String']
  /** username to use for login */
  username: Scalars['String']
}

/** Autogenerated return type of CreateInboundFileRouterConfig */
export type ICreateInboundFileRouterConfigPayload = {
  __typename?: 'CreateInboundFileRouterConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  inboundFileRouterConfig?: Maybe<IInboundFileRouterConfig>
}

/** Autogenerated input type of CreateInboundFtpConnectionConfig */
export type ICreateInboundFtpConnectionConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  connectionType: IFtpConnectionTypes
  /** should config be disabled? */
  disabled?: Maybe<Scalars['Boolean']>
  environment?: Maybe<IConnectionConfigEnvironment>
  /** only fetch files matching this pattern */
  filenameGlob?: Maybe<Scalars['String']>
  /** hostname */
  host: Scalars['String']
  /** shipper or carrier id */
  partnerApplicationId: Scalars['ID']
  partnerApplicationType: IPartnerApplicationTypes
  /** directory to check for incoming files */
  pathPrefix: Scalars['String']
  /** tcp port */
  port: Scalars['Int']
  /**
   * Either an ENV variable name, or a string consisting of 'secretsmanager:'
   * followed by a secretsmanager id. This should resolve to a password or SSH
   * private key, depending on the connection type.
   */
  secretKey: Scalars['String']
  send997s?: Maybe<Scalars['Boolean']>
  /** username to use for login */
  username: Scalars['String']
}

/** Autogenerated return type of CreateInboundFtpConnectionConfig */
export type ICreateInboundFtpConnectionConfigPayload = {
  __typename?: 'CreateInboundFtpConnectionConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediInboundConnectionConfig?: Maybe<IInboundConnectionConfig>
  errors: Array<IError>
}

/** Autogenerated input type of CreateIssueAutomationRule */
export type ICreateIssueAutomationRuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  issueAutomationRuleNodes: Array<IIssueAutomationRuleNodeInput>
  name: Scalars['String']
  ruleAction: IIssueAutomationRuleActionEnum
  shipmentIssueTypeId: Scalars['ID']
}

/** Autogenerated return type of CreateIssueAutomationRule */
export type ICreateIssueAutomationRulePayload = {
  __typename?: 'CreateIssueAutomationRulePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  issueAutomationRule?: Maybe<IIssueAutomationRule>
}

/** Autogenerated input type of CreateMiscellaneousDocument */
export type ICreateMiscellaneousDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  document: IDocumentInput
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of CreateMiscellaneousDocument */
export type ICreateMiscellaneousDocumentPayload = {
  __typename?: 'CreateMiscellaneousDocumentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of CreateMotorCarrierComplianceFlag */
export type ICreateMotorCarrierComplianceFlagInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  flagName?: Maybe<Scalars['String']>
}

/** Autogenerated return type of CreateMotorCarrierComplianceFlag */
export type ICreateMotorCarrierComplianceFlagPayload = {
  __typename?: 'CreateMotorCarrierComplianceFlagPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors?: Maybe<Array<IError>>
  motorCarrierComplianceFlag?: Maybe<IMotorCarrierComplianceFlag>
}

/** Autogenerated input type of CreateMotorCarrierInsuranceContacts */
export type ICreateMotorCarrierInsuranceContactsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  insuranceContacts: Array<IMotorCarrierInsuranceContactInput>
}

/** Autogenerated return type of CreateMotorCarrierInsuranceContacts */
export type ICreateMotorCarrierInsuranceContactsPayload = {
  __typename?: 'CreateMotorCarrierInsuranceContactsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  insuranceContacts?: Maybe<Array<IMotorCarrierInsuranceContact>>
}

/** Autogenerated input type of CreateNote */
export type ICreateNoteInput = {
  autotag?: Maybe<Array<INoteAutotagTypes>>
  body: Scalars['String']
  callBackAt?: Maybe<Scalars['ISO8601DateTime']>
  /** Callback date in MM/DD/YYYY format in Eastern Time */
  callbackDate?: Maybe<Scalars['String']>
  /** Callback time in ISO8601Time format in Eastern Time */
  callbackTime?: Maybe<Scalars['ISO8601Time']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  documents?: Maybe<Array<IDocumentInput>>
  noteableId: Scalars['ID']
  noteableType: INoteableTypes
}

/** Autogenerated return type of CreateNote */
export type ICreateNotePayload = {
  __typename?: 'CreateNotePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  note?: Maybe<INote>
}

/** Autogenerated input type of CreateOutboundAs2ConnectionConfig */
export type ICreateOutboundAs2ConnectionConfigInput = {
  /** The connection config this connection will receive files from */
  as2ConnectionConfigId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  componentSeparator?: Maybe<Scalars['String']>
  /** Used to differentiate multiple outbound configs associated with a single partner. */
  destinationOverride?: Maybe<Scalars['String']>
  disabled: Scalars['Boolean']
  elementSeparator?: Maybe<Scalars['String']>
  environment?: Maybe<IConnectionConfigEnvironment>
  expect997s?: Maybe<Scalars['Boolean']>
  groupVersionStr?: Maybe<Scalars['String']>
  gsReceiverId: Scalars['String']
  gsSenderId: Scalars['String']
  interchangeVersionStr?: Maybe<Scalars['String']>
  isaReceiverId: Scalars['String']
  isaReceiverIdQualifier: Scalars['String']
  isaSenderId: Scalars['String']
  isaSenderIdQualifier: Scalars['String']
  /** shipper or carrier id */
  partnerApplicationId: Scalars['ID']
  partnerApplicationType: IPartnerApplicationTypes
  repetitionSeparator?: Maybe<Scalars['String']>
  segmentSeparator?: Maybe<Scalars['String']>
  testIndicator: IUsageIndicators
}

/** Autogenerated return type of CreateOutboundAs2ConnectionConfig */
export type ICreateOutboundAs2ConnectionConfigPayload = {
  __typename?: 'CreateOutboundAs2ConnectionConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediOutboundConnectionConfig?: Maybe<IOutboundConnectionConfig>
  errors: Array<IError>
}

/** Autogenerated input type of CreateOutboundEdiMessage */
export type ICreateOutboundEdiMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediMapperConfigurableBuilderId?: Maybe<Scalars['ID']>
  legacyBuilderClass?: Maybe<ILegacyBuilderClassTypes>
  /** the outbound config to add the message type to */
  outboundEdiMapperConnectionConfigId: Scalars['ID']
  transactionSet: ITransactionSetTypes
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
}

/** Autogenerated return type of CreateOutboundEdiMessage */
export type ICreateOutboundEdiMessagePayload = {
  __typename?: 'CreateOutboundEdiMessagePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediMessageType?: Maybe<IEdiMessage>
  errors: Array<IError>
}

/** Autogenerated input type of CreateOutboundFiles */
export type ICreateOutboundFilesInput = {
  appointmentUpdates: Scalars['Boolean']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
  stopUpdates: Scalars['Boolean']
  transactionSet: ITransactionSetTypes
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
}

/** Autogenerated return type of CreateOutboundFiles */
export type ICreateOutboundFilesPayload = {
  __typename?: 'CreateOutboundFilesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  createOutboundFilesReport: ICreateOutboundFilesReport
  errors: Array<IError>
}

/** Contains information on the results of creating an outbound file for staging testing */
export type ICreateOutboundFilesReport = {
  __typename?: 'CreateOutboundFilesReport'
  errorBacktrace?: Maybe<Scalars['String']>
  errorMessage?: Maybe<Scalars['String']>
  /** IDs for the newly created outbound files */
  outboundRawEdiFileIds: Array<Scalars['ID']>
  /** Rogers URLs to view the files' contents */
  outboundRawEdiFileUrls: Array<Scalars['String']>
  success: Scalars['Boolean']
}

/** Autogenerated input type of CreateOutboundFtpConnectionConfig */
export type ICreateOutboundFtpConnectionConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  componentSeparator?: Maybe<Scalars['String']>
  connectionType: IFtpConnectionTypes
  /** Used to differentiate multiple outbound configs associated with a single partner. */
  destinationOverride?: Maybe<Scalars['String']>
  disabled: Scalars['Boolean']
  elementSeparator?: Maybe<Scalars['String']>
  environment?: Maybe<IConnectionConfigEnvironment>
  expect997s?: Maybe<Scalars['Boolean']>
  groupVersionStr?: Maybe<Scalars['String']>
  gsReceiverId: Scalars['String']
  gsSenderId: Scalars['String']
  /** hostname */
  host: Scalars['String']
  interchangeVersionStr?: Maybe<Scalars['String']>
  isaReceiverId: Scalars['String']
  isaReceiverIdQualifier: Scalars['String']
  isaSenderId: Scalars['String']
  isaSenderIdQualifier: Scalars['String']
  /** shipper or carrier id */
  partnerApplicationId: Scalars['ID']
  partnerApplicationType: IPartnerApplicationTypes
  /** directory to check for incoming files */
  pathPrefix: Scalars['String']
  /** tcp port */
  port: Scalars['Int']
  repetitionSeparator?: Maybe<Scalars['String']>
  /**
   * Either an ENV variable name, or a string consisting of 'secretsmanager:'
   * followed by a secretsmanager id. This should resolve to a password or SSH
   * private key, depending on the connection type.
   */
  secretKey: Scalars['String']
  segmentSeparator?: Maybe<Scalars['String']>
  testIndicator: IUsageIndicators
  /** username to use for login */
  username: Scalars['String']
}

/** Autogenerated return type of CreateOutboundFtpConnectionConfig */
export type ICreateOutboundFtpConnectionConfigPayload = {
  __typename?: 'CreateOutboundFtpConnectionConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediOutboundConnectionConfig?: Maybe<IOutboundConnectionConfig>
  errors: Array<IError>
}

/** Autogenerated input type of CreateQuickRequest */
export type ICreateQuickRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentStopId: Scalars['ID']
}

/** Autogenerated return type of CreateQuickRequest */
export type ICreateQuickRequestPayload = {
  __typename?: 'CreateQuickRequestPayload'
  autoAppointmentSchedule?: Maybe<IAutoAppointmentSchedule>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

export type ICreateRescheduleRequestInput = {
  isWorkInRequested?: Maybe<Scalars['Boolean']>
  reasonForRequest?: Maybe<Scalars['String']>
  shipmentStopId: Scalars['ID']
}

/** Autogenerated input type of CreateRescheduleRequests */
export type ICreateRescheduleRequestsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  rescheduleRequests: Array<ICreateRescheduleRequestInput>
  shipmentIssueInput?: Maybe<IWithShipmentIssueInput>
}

/** Autogenerated return type of CreateRescheduleRequests */
export type ICreateRescheduleRequestsPayload = {
  __typename?: 'CreateRescheduleRequestsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  rescheduleRequests: Array<IRescheduleRequest>
}

/** Autogenerated input type of CreateRulesAssessmentOverrides */
export type ICreateRulesAssessmentOverridesInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  rulesAssessmentOverrides: Array<IUpdateRulesAssessmentOverride>
}

/** Autogenerated return type of CreateRulesAssessmentOverrides */
export type ICreateRulesAssessmentOverridesPayload = {
  __typename?: 'CreateRulesAssessmentOverridesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors?: Maybe<Array<IError>>
  rulesAssessmentOverrides?: Maybe<Array<IRulesAssessmentOverride>>
}

/** Autogenerated input type of CreateSafetyLetter */
export type ICreateSafetyLetterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  driverRatingSummary: Scalars['String']
  fleetPlannerMotorCarrierId: Scalars['ID']
  safetyLetterSignatory: Scalars['String']
  safetyLetterSignatoryTitle: Scalars['String']
  vehicleRatingSummary: Scalars['String']
}

/** Autogenerated return type of CreateSafetyLetter */
export type ICreateSafetyLetterPayload = {
  __typename?: 'CreateSafetyLetterPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  didUpload: Scalars['Boolean']
  errors: Array<IError>
}

/** Autogenerated input type of CreateSendPushNotificationJob */
export type ICreateSendPushNotificationJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  notificationParams: IExternalPushNotificationParams
  notificationType: Scalars['String']
  parentUserId: Scalars['ID']
}

/** Autogenerated return type of CreateSendPushNotificationJob */
export type ICreateSendPushNotificationJobPayload = {
  __typename?: 'CreateSendPushNotificationJobPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of CreateShipmentAccessorial */
export type ICreateShipmentAccessorialInput = {
  amount?: Maybe<Scalars['Float']>
  autoSendSms?: Maybe<Scalars['Boolean']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  constraintAmount?: Maybe<Scalars['Float']>
  /**
   * Will create the accessorial on behalf of this user. Requires permission
   * stark.can_create_or_modify_accessorial_on_behalf. creator_id must be a parent user id
   */
  creatorId?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  document?: Maybe<IDocumentInput>
  endAt?: Maybe<Scalars['ISO8601DateTime']>
  escortServiceName?: Maybe<Scalars['String']>
  internalNotesDescription?: Maybe<Scalars['String']>
  isCustomerRequest: Scalars['Boolean']
  isOutOfPocket: Scalars['Boolean']
  lumperServiceName?: Maybe<Scalars['String']>
  name: IShipmentAccessorialNames
  oopOwnerId?: Maybe<Scalars['ID']>
  oopOwnerType?: Maybe<IShipmentIssueFollowerTypes>
  oopReason?: Maybe<Scalars['String']>
  rejectionReason?: Maybe<Scalars['String']>
  sendApprovalEmail?: Maybe<Scalars['Boolean']>
  sendNotificationEmail?: Maybe<Scalars['Boolean']>
  shipmentId: Scalars['ID']
  shipperApprovalState?: Maybe<Scalars['String']>
  shipperCharge?: Maybe<Scalars['Float']>
  shipperFacilityUuid?: Maybe<Scalars['String']>
  shipperRejectionReason?: Maybe<Scalars['String']>
  source?: Maybe<IShipmentAccessorialSources>
  startAt?: Maybe<Scalars['ISO8601DateTime']>
  state?: Maybe<Scalars['String']>
  stopId?: Maybe<Scalars['ID']>
  taxId?: Maybe<Scalars['String']>
  trailerControlRecord?: Maybe<Scalars['String']>
  useRelayPayments?: Maybe<Scalars['Boolean']>
  withComcheck: Scalars['Boolean']
}

/** Autogenerated return type of CreateShipmentAccessorial */
export type ICreateShipmentAccessorialPayload = {
  __typename?: 'CreateShipmentAccessorialPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipmentAccessorial?: Maybe<IShipmentAccessorial>
}

/** Autogenerated input type of CreateShipment */
export type ICreateShipmentInput = {
  carrierSpecialInstructions?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  disallowAutoShipperFuelComputation?: Maybe<Scalars['Boolean']>
  equipmentAttributes: Array<IShipmentEquipmentAttributeInput>
  equipmentType: IEquipmentTypes
  hasClaims?: Maybe<Scalars['Boolean']>
  hasOsd?: Maybe<Scalars['Boolean']>
  hot?: Maybe<Scalars['Boolean']>
  isBackhaul?: Maybe<Scalars['Boolean']>
  isHighRisk?: Maybe<Scalars['Boolean']>
  loadingType?: Maybe<IShipperLoadTypes>
  mustGo?: Maybe<Scalars['Boolean']>
  opsRepId: Scalars['ID']
  originalShipmentId?: Maybe<Scalars['ID']>
  shipperApplicationId: Scalars['ID']
  shipperMiles?: Maybe<Scalars['Float']>
  shipperPerMileFuelRate?: Maybe<Scalars['Float']>
  shipperRate: Scalars['Float']
  shipperRateType: IShipperRateTypes
  shipperTotalFuelSurcharge?: Maybe<Scalars['Float']>
  specialInstruction?: Maybe<Scalars['String']>
  stops: Array<ICreateShipmentStopInput>
  team?: Maybe<Scalars['Boolean']>
  totalPalletCount: Scalars['Int']
  totalWeight: Scalars['Int']
}

/** Autogenerated input type of CreateShipmentIssue */
export type ICreateShipmentIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  dueAt?: Maybe<Scalars['ISO8601DateTime']>
  owner: IShipmentIssueFollowerInput
  priority?: Maybe<Scalars['Int']>
  shipmentId: Scalars['ID']
  shipmentIssueFaultId?: Maybe<Scalars['ID']>
  shipmentIssueReasonId?: Maybe<Scalars['ID']>
  shipmentIssueTypeId: Scalars['ID']
  state: IShipmentIssueStates
  subscribers?: Maybe<Array<IShipmentIssueFollowerInput>>
  summary?: Maybe<Scalars['String']>
}

/** Autogenerated return type of CreateShipmentIssue */
export type ICreateShipmentIssuePayload = {
  __typename?: 'CreateShipmentIssuePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipmentIssue?: Maybe<IShipmentIssue>
}

/** Autogenerated return type of CreateShipment */
export type ICreateShipmentPayload = {
  __typename?: 'CreateShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export type ICreateShipmentStopAppointmentInput = {
  appointmentReference?: Maybe<Scalars['String']>
  appointmentType: IShipmentStopAppointmentTypes
  confirmationReference?: Maybe<Scalars['String']>
  /** End at date for the appointment in its local timezone. */
  endAtDate?: Maybe<Scalars['ISO8601Date']>
  /** End at time for the appointment in its local timezone. */
  endAtTime?: Maybe<Scalars['ISO8601Time']>
  isWorkIn?: Maybe<Scalars['Boolean']>
  /** Start at date for the appointment in its local timezone. */
  startAtDate?: Maybe<Scalars['ISO8601Date']>
  /** Start at time for the appointment in its local timezone. */
  startAtTime?: Maybe<Scalars['ISO8601Time']>
  status?: Maybe<IShipmentStopAppointmentStatuses>
}

export type ICreateShipmentStopInput = {
  appointmentInput: ICreateShipmentStopAppointmentInput
  billOfLadingReference?: Maybe<Scalars['String']>
  commodity: Scalars['String']
  dropTrailer?: Maybe<Scalars['Boolean']>
  ediAppointmentReasonCode?: Maybe<Scalars['String']>
  ediStatusReasonCode?: Maybe<Scalars['String']>
  facilityContactUuid?: Maybe<Scalars['ID']>
  genericCommodityId?: Maybe<Scalars['ID']>
  palletCount?: Maybe<Scalars['Int']>
  poReference?: Maybe<Scalars['String']>
  shipperFacilityUuid: Scalars['ID']
  specialInstruction?: Maybe<Scalars['String']>
  stopSequence: Scalars['Int']
  stopType: IShipmentStopTypes
  vendorId?: Maybe<Scalars['ID']>
  weight?: Maybe<Scalars['Int']>
}

export type ICreateShipperAutoAcceptRejectRuleInput = {
  chainRuleOnFalse?: Maybe<Scalars['ID']>
  chainRuleOnTrue?: Maybe<Scalars['ID']>
  createdById: Scalars['ID']
  decisionOnFalse?: Maybe<Scalars['String']>
  decisionOnTrue?: Maybe<Scalars['String']>
  functionName: Scalars['String']
  isStart?: Maybe<Scalars['Boolean']>
  parameters?: Maybe<Scalars['JSON']>
  ruleType: Scalars['String']
  shipmentType: Scalars['String']
  shipperApplicationId: Scalars['ID']
  temporaryId: Scalars['ID']
}

/** Autogenerated input type of CreateShipperFacilityLane */
export type ICreateShipperFacilityLaneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  endShipperFacilityNote?: Maybe<Scalars['String']>
  endShipperFacilityUuid: Scalars['String']
  hours?: Maybe<Array<IShipperFacilityHourValueInput>>
  startShipperFacilityNote?: Maybe<Scalars['String']>
  startShipperFacilityUuid: Scalars['String']
}

/** Autogenerated return type of CreateShipperFacilityLane */
export type ICreateShipperFacilityLanePayload = {
  __typename?: 'CreateShipperFacilityLanePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperFacilityLane?: Maybe<IShipperFacilityLane>
}

/** Autogenerated input type of CreateShipperFacilityTrailerPool */
export type ICreateShipperFacilityTrailerPoolInput = {
  carrierApplicationId?: Maybe<Scalars['ID']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipperFacilityUuid: Scalars['String']
  trailerRequirement: Scalars['Int']
}

/** Autogenerated return type of CreateShipperFacilityTrailerPool */
export type ICreateShipperFacilityTrailerPoolPayload = {
  __typename?: 'CreateShipperFacilityTrailerPoolPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  trailerPool?: Maybe<IShipperFacilityTrailerPool>
}

/** Autogenerated input type of CreateShipper */
export type ICreateShipperInput = {
  accountingEmail: Scalars['String']
  carrierInstructions?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  cohortQuarter?: Maybe<Scalars['Int']>
  cohortYear?: Maybe<Scalars['Int']>
  emailDomain: Scalars['String']
  headquarter?: Maybe<ILocationInput>
  isKeyAccount?: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  onBoarding?: Maybe<Scalars['Boolean']>
  rateType: IRateTypeTypes
  secondaryAccountingEmail: Scalars['String']
  segment?: Maybe<Scalars['String']>
  shipmentEmail: Scalars['String']
  trackingRequired?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of CreateShipper */
export type ICreateShipperPayload = {
  __typename?: 'CreateShipperPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipper?: Maybe<IShipperApplication>
}

/** Autogenerated input type of CreateSmsMessage */
export type ICreateSmsMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  conversationId?: Maybe<Scalars['ID']>
  intent?: Maybe<ISmsMessageIntents>
  message: Scalars['String']
  shipmentId?: Maybe<Scalars['ID']>
  toUserId: Scalars['ID']
}

/** Autogenerated return type of CreateSmsMessage */
export type ICreateSmsMessagePayload = {
  __typename?: 'CreateSmsMessagePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  smsMessage?: Maybe<ISmsMessage>
}

/** Autogenerated input type of CreateSourcedCarrierRate */
export type ICreateSourcedCarrierRateInput = {
  canDoWeekends?: Maybe<Scalars['Boolean']>
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  confirmed?: Maybe<Scalars['Boolean']>
  laneAgreement?: Maybe<IDocumentInput>
  maxCapacity?: Maybe<Scalars['Int']>
  minCapacity?: Maybe<Scalars['Int']>
  rate: IRateInput
  shipperRateId: Scalars['ID']
}

/** Autogenerated return type of CreateSourcedCarrierRate */
export type ICreateSourcedCarrierRatePayload = {
  __typename?: 'CreateSourcedCarrierRatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  sourcedCarrierRate?: Maybe<ISourcedCarrierRate>
}

/** Autogenerated input type of CreateSpfIntegration */
export type ICreateSpfIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  integrationType?: ISpfAvailableIntegrationTypes
  notes?: Maybe<Scalars['String']>
  providerName: ISpfAvailableProviderNames
  scac?: Maybe<Scalars['String']>
  shipperApplicationId: Scalars['ID']
  shipperSpecificKey?: Maybe<Scalars['String']>
}

/** Autogenerated return type of CreateSpfIntegration */
export type ICreateSpfIntegrationPayload = {
  __typename?: 'CreateSpfIntegrationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors?: Maybe<Array<IError>>
  spfIntegration?: Maybe<ISpfIntegration>
}

/** Autogenerated input type of CreateTrailer */
export type ICreateTrailerInput = {
  carrierId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** Trailer emptied at date in timezone of facility */
  emptiedAtDate?: Maybe<Scalars['ISO8601Date']>
  /** Trailer emptied at time in timezone of facility */
  emptiedAtTime?: Maybe<Scalars['ISO8601Time']>
  /** Trailer arrived at date in timezone of facility */
  facilityArrivedAtDate?: Maybe<Scalars['ISO8601Date']>
  /** Trailer arrived at time in timezone of facility */
  facilityArrivedAtTime?: Maybe<Scalars['ISO8601Time']>
  length?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  number: Scalars['String']
  shipmentId?: Maybe<Scalars['ID']>
  shipperFacilityUuid?: Maybe<Scalars['String']>
  state?: Maybe<ITrailerStatesEnum>
  type?: Maybe<Scalars['String']>
}

/** Autogenerated return type of CreateTrailer */
export type ICreateTrailerPayload = {
  __typename?: 'CreateTrailerPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  trailer?: Maybe<ITrailer>
}

/** Autogenerated input type of CreateVendor */
export type ICreateVendorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  industry?: Maybe<IVendorIndustries>
  name: Scalars['String']
  vendorKeywords?: Maybe<Array<ICreateVendorKeywordInput>>
}

export type ICreateVendorKeywordInput = {
  value: Scalars['String']
}

/** Autogenerated return type of CreateVendor */
export type ICreateVendorPayload = {
  __typename?: 'CreateVendorPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  vendor?: Maybe<IVendor>
}

export type ICreatedByUser = {
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
}

export type IDatBucket = {
  __typename?: 'DatBucket'
  count: Scalars['Int']
  datBucket: Scalars['Int']
}

export type IDateCriteria = {
  __typename?: 'DateCriteria'
  id: Scalars['ID']
  rangeEnd?: Maybe<Scalars['String']>
  rangeStart?: Maybe<Scalars['String']>
}

/** Autogenerated input type of DeclineBid */
export type IDeclineBidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  declineReason?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DeclineBid */
export type IDeclineBidPayload = {
  __typename?: 'DeclineBidPayload'
  bid?: Maybe<IBid>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of DeclineCarrierShipment */
export type IDeclineCarrierShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  parentUserId: Scalars['ID']
}

/** Autogenerated return type of DeclineCarrierShipment */
export type IDeclineCarrierShipmentPayload = {
  __typename?: 'DeclineCarrierShipmentPayload'
  carrierShipment?: Maybe<ICarrierShipment>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of DeleteCarrierCertification */
export type IDeleteCarrierCertificationInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  code: Scalars['String']
}

/** Autogenerated return type of DeleteCarrierCertification */
export type IDeleteCarrierCertificationPayload = {
  __typename?: 'DeleteCarrierCertificationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of DeleteEdiChargeCode */
export type IDeleteEdiChargeCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DeleteEdiChargeCode */
export type IDeleteEdiChargeCodePayload = {
  __typename?: 'DeleteEdiChargeCodePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediChargeCode?: Maybe<IEdiChargeCode>
  errors: Array<IError>
}

/** Autogenerated input type of DeleteIssueAutomationRule */
export type IDeleteIssueAutomationRuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DeleteIssueAutomationRule */
export type IDeleteIssueAutomationRulePayload = {
  __typename?: 'DeleteIssueAutomationRulePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  issueAutomationRule?: Maybe<IIssueAutomationRule>
}

/** Autogenerated input type of DeleteOutboundFiles */
export type IDeleteOutboundFilesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  outboundRawEdiFileIds: Array<Scalars['ID']>
}

/** Autogenerated return type of DeleteOutboundFiles */
export type IDeleteOutboundFilesPayload = {
  __typename?: 'DeleteOutboundFilesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  deleteOutboundFilesReport: IDeleteOutboundFilesReport
  errors: Array<IError>
}

/** Contains information on the results of deleting outbound files. */
export type IDeleteOutboundFilesReport = {
  __typename?: 'DeleteOutboundFilesReport'
  errorBacktrace?: Maybe<Scalars['String']>
  errorMessage?: Maybe<Scalars['String']>
  /** IDs for the outbound files deleted */
  outboundRawEdiFileIds: Array<Scalars['ID']>
  success: Scalars['Boolean']
}

/** Autogenerated input type of DeleteRescheduleRequest */
export type IDeleteRescheduleRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DeleteRescheduleRequest */
export type IDeleteRescheduleRequestPayload = {
  __typename?: 'DeleteRescheduleRequestPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  rescheduleRequest?: Maybe<IRescheduleRequest>
}

/** Autogenerated input type of DeleteShipmentAccessorialDocuments */
export type IDeleteShipmentAccessorialDocumentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  deleteAssetCheck: Scalars['Boolean']
  id: Scalars['ID']
}

/** Autogenerated return type of DeleteShipmentAccessorialDocuments */
export type IDeleteShipmentAccessorialDocumentsPayload = {
  __typename?: 'DeleteShipmentAccessorialDocumentsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of DeleteShipmentAccessorial */
export type IDeleteShipmentAccessorialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DeleteShipmentAccessorial */
export type IDeleteShipmentAccessorialPayload = {
  __typename?: 'DeleteShipmentAccessorialPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of DeleteShipmentStop */
export type IDeleteShipmentStopInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentStopId: Scalars['ID']
}

/** Autogenerated return type of DeleteShipmentStop */
export type IDeleteShipmentStopPayload = {
  __typename?: 'DeleteShipmentStopPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of DeleteShipperFacilityLane */
export type IDeleteShipperFacilityLaneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipperFacilityLaneId: Scalars['ID']
}

/** Autogenerated return type of DeleteShipperFacilityLane */
export type IDeleteShipperFacilityLanePayload = {
  __typename?: 'DeleteShipperFacilityLanePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of DeleteShipperFacilityTrailerPool */
export type IDeleteShipperFacilityTrailerPoolInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  trailerPoolId: Scalars['ID']
}

/** Autogenerated return type of DeleteShipperFacilityTrailerPool */
export type IDeleteShipperFacilityTrailerPoolPayload = {
  __typename?: 'DeleteShipperFacilityTrailerPoolPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of DeleteShipperFuelMatrix */
export type IDeleteShipperFuelMatrixInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  fuelMatrixId: Scalars['ID']
}

/** Autogenerated return type of DeleteShipperFuelMatrix */
export type IDeleteShipperFuelMatrixPayload = {
  __typename?: 'DeleteShipperFuelMatrixPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of DeleteShipperFuelPaddMapping */
export type IDeleteShipperFuelPaddMappingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipperFuelPaddMappingId?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of DeleteShipperFuelPaddMapping */
export type IDeleteShipperFuelPaddMappingPayload = {
  __typename?: 'DeleteShipperFuelPaddMappingPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of DeleteShipperKpiTrackingConfiguration */
export type IDeleteShipperKpiTrackingConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipperKpiTrackingConfigurationId?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of DeleteShipperKpiTrackingConfiguration */
export type IDeleteShipperKpiTrackingConfigurationPayload = {
  __typename?: 'DeleteShipperKpiTrackingConfigurationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of DeleteSourcedCarrierRate */
export type IDeleteSourcedCarrierRateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DeleteSourcedCarrierRate */
export type IDeleteSourcedCarrierRatePayload = {
  __typename?: 'DeleteSourcedCarrierRatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of DeleteSpfIntegration */
export type IDeleteSpfIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  spfIntegrationId: Scalars['ID']
}

/** Autogenerated return type of DeleteSpfIntegration */
export type IDeleteSpfIntegrationPayload = {
  __typename?: 'DeleteSpfIntegrationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of DeleteUserFilterPreference */
export type IDeleteUserFilterPreferenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DeleteUserFilterPreference */
export type IDeleteUserFilterPreferencePayload = {
  __typename?: 'DeleteUserFilterPreferencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  userFilterPreference?: Maybe<IUserFilterPreferences>
}

/** Autogenerated input type of DeleteVendor */
export type IDeleteVendorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of DeleteVendor */
export type IDeleteVendorPayload = {
  __typename?: 'DeleteVendorPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  vendor?: Maybe<IVendor>
}

export type IDigitalCardDetails = {
  __typename?: 'DigitalCardDetails'
  cardNumber?: Maybe<Scalars['String']>
  cvv?: Maybe<Scalars['String']>
  expireMonth?: Maybe<Scalars['Int']>
  expireYear?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of DispatchShipment */
export type IDispatchShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lateReason?: Maybe<Scalars['String']>
  /** ETA in timezone to first pickup stop */
  manualEtaDate: Scalars['ISO8601Date']
  /** ETA in timezone to first pickup stop */
  manualEtaTime: Scalars['ISO8601Time']
  relayedBy?: Maybe<IShipmentStopRelayedByTypes>
  relayedVia?: Maybe<IShipmentStopRelayedViaTypes>
}

/** Autogenerated return type of DispatchShipment */
export type IDispatchShipmentPayload = {
  __typename?: 'DispatchShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export type IDistanceToMarketCenterCriteria = {
  __typename?: 'DistanceToMarketCenterCriteria'
  id: Scalars['ID']
  locationType: Scalars['String']
  rangeEnd?: Maybe<Scalars['String']>
  rangeStart?: Maybe<Scalars['String']>
}

export enum IDistanceUnits {
  /** Kilometers */
  km = 'km',
  /** Miles */
  mi = 'mi',
}

export type IDocumentInput = {
  document: Scalars['String']
  documentFileName: Scalars['String']
}

/** Autogenerated input type of DownloadSftpFiles */
export type IDownloadSftpFilesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inboundConnectionConfigId: Scalars['ID']
}

/** Autogenerated return type of DownloadSftpFiles */
export type IDownloadSftpFilesPayload = {
  __typename?: 'DownloadSftpFilesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  downloadSftpFilesReport: IDownloadSftpFilesReport
  errors: Array<IError>
}

/** Contains information on the results of downloading SFTP file for staging testing. */
export type IDownloadSftpFilesReport = {
  __typename?: 'DownloadSftpFilesReport'
  /** list of downloaded SFTP file names */
  downloadedOriginalFileNames?: Maybe<Array<Scalars['String']>>
  errorBacktrace?: Maybe<Scalars['String']>
  errorMessage?: Maybe<Scalars['String']>
  /** list of inbound raw edi file IDs. */
  inboundRawEdiFileIds?: Maybe<Array<Scalars['ID']>>
  /** if an error happened, this may contain some suggestions about what the error means and how to solve it */
  possibleCauses: Array<Scalars['String']>
  success: Scalars['Boolean']
  warningMessage?: Maybe<Scalars['String']>
}

export type IDownloadable = {
  __typename?: 'Downloadable'
  name: Scalars['String']
  url?: Maybe<Scalars['String']>
}

export type IDraft = {
  __typename?: 'Draft'
  amount: Scalars['Float']
  bills?: Maybe<Array<IBill>>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  draftedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  netsuiteRecords?: Maybe<Array<INetsuiteBillPayment>>
  triumphpayDraftId: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IDriverLocation = {
  __typename?: 'DriverLocation'
  driver?: Maybe<IUser>
  driverId: Scalars['ID']
  id: Scalars['ID']
  isRecent: Scalars['Boolean']
  latitude: Scalars['Float']
  longitude: Scalars['Float']
  osTimestamp?: Maybe<Scalars['ISO8601DateTime']>
  phoneModel?: Maybe<Scalars['String']>
  phoneOs?: Maybe<Scalars['String']>
  phoneTimestamp: Scalars['ISO8601DateTime']
  sourceType: Scalars['String']
  speed?: Maybe<Scalars['Float']>
  timezone: Scalars['String']
  transfixVersion?: Maybe<Scalars['String']>
}

/** The connection type for DriverLocation. */
export type IDriverLocationConnection = {
  __typename?: 'DriverLocationConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IDriverLocationEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IDriverLocation>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IDriverLocationEdge = {
  __typename?: 'DriverLocationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IDriverLocation>
}

export type IDriverLocationInput = {
  altitude?: Maybe<Scalars['Float']>
  course?: Maybe<Scalars['Float']>
  driverId?: Maybe<Scalars['ID']>
  horizontalAccuracy?: Maybe<Scalars['Float']>
  latitude: Scalars['Float']
  longitude: Scalars['Float']
  osTimestamp?: Maybe<Scalars['ISO8601DateTime']>
  phoneModel?: Maybe<Scalars['String']>
  phoneOs?: Maybe<Scalars['String']>
  phoneTimestamp: Scalars['ISO8601DateTime']
  shipmentId?: Maybe<Scalars['ID']>
  sourceType?: Maybe<Scalars['String']>
  speed?: Maybe<Scalars['Float']>
  transfixVersion?: Maybe<Scalars['String']>
  verticalAccuracy?: Maybe<Scalars['Float']>
}

export type IEdiChargeCode = {
  __typename?: 'EdiChargeCode'
  chargeCode?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  lineItemTitle: ILineItemTitles
  shipperApplicationId: Scalars['ID']
  stopType: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IEdiMessage = {
  __typename?: 'EdiMessage'
  configurableBuilder?: Maybe<IConfigurableBuilder>
  configurableParser?: Maybe<IConfigurableParser>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  ediMapperConfigGroup?: Maybe<IConfigGroup>
  ediMapperConfigGroupId?: Maybe<Scalars['ID']>
  ediMapperConfigurableBuilderId?: Maybe<Scalars['ID']>
  ediMapperConfigurableParserId?: Maybe<Scalars['ID']>
  ediMapperConnectionConfig?: Maybe<IConnectionConfig>
  id: Scalars['ID']
  legacyBuilderClass?: Maybe<ILegacyBuilderClassTypes>
  legacyParserClass?: Maybe<ILegacyParserClassTypes>
  transactionSet: ITransactionSetTypes
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for EdiMessage. */
export type IEdiMessageConnection = {
  __typename?: 'EdiMessageConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IEdiMessageEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IEdiMessage>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IEdiMessageEdge = {
  __typename?: 'EdiMessageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IEdiMessage>
}

export type IEdiMetadata = {
  __typename?: 'EdiMetadata'
  changedField?: Maybe<Scalars['String']>
  shipperStopSequence?: Maybe<Scalars['Int']>
  stopType?: Maybe<IShipmentStopTypes>
  subtype?: Maybe<Scalars['String']>
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
  value?: Maybe<Scalars['String']>
}

export type IEdiReasonCode = {
  __typename?: 'EdiReasonCode'
  reasonCode: Scalars['String']
  reasonText: Scalars['String']
}

export type IEdiShipmentExtraData = {
  __typename?: 'EdiShipmentExtraData'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  otherShipperShipmentIdentifiers?: Maybe<Array<IOtherShipperShipmentIdentifiers>>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IEditGroupInput = {
  email?: Maybe<Scalars['String']>
  id: Scalars['ID']
  instructions?: Maybe<Scalars['String']>
  key?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
}

/** Autogenerated input type of EditVendor */
export type IEditVendorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  industry?: Maybe<IVendorIndustries>
  name: Scalars['String']
}

/** Autogenerated input type of EditVendorKeywords */
export type IEditVendorKeywordsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  keywords: Array<IUpdateVendorKeywordInput>
}

/** Autogenerated return type of EditVendorKeywords */
export type IEditVendorKeywordsPayload = {
  __typename?: 'EditVendorKeywordsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  vendor?: Maybe<IVendor>
}

/** Autogenerated return type of EditVendor */
export type IEditVendorPayload = {
  __typename?: 'EditVendorPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  vendor?: Maybe<IVendor>
}

export type IEldTruckNumber = {
  __typename?: 'EldTruckNumber'
  keepTruckinValidated: Scalars['Boolean']
  project44Validated: Scalars['Boolean']
  value: Scalars['String']
}

export type IEquipment = {
  __typename?: 'Equipment'
  id: Scalars['ID']
  key: IEquipmentTypes
  name: Scalars['String']
  parent?: Maybe<IEquipment>
  parentKey?: Maybe<IEquipmentTypes>
  parentName?: Maybe<Scalars['String']>
}

export type IEquipmentAttribute = {
  __typename?: 'EquipmentAttribute'
  attributeOptions?: Maybe<Scalars['String']>
  attributeOptionsPlaceholder?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  defaultValue?: Maybe<Scalars['String']>
  displayGroup?: Maybe<IEquipmentAttributeDisplayGroup>
  id: Scalars['ID']
  inputType: Scalars['String']
  key: Scalars['String']
  label: Scalars['String']
  position?: Maybe<Scalars['Int']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IEquipmentAttributeDisplayGroup = {
  __typename?: 'EquipmentAttributeDisplayGroup'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  key: Scalars['String']
  label: Scalars['String']
  position?: Maybe<Scalars['Int']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IEquipmentAttributeTypes {
  can_reefer = 'can_reefer',
  chains = 'chains',
  coil_rack = 'coil_rack',
  door_type = 'door_type',
  downloadable_report = 'downloadable_report',
  fixed_temp_control = 'fixed_temp_control',
  floor_type = 'floor_type',
  flow = 'flow',
  food_grade = 'food_grade',
  lift_gate = 'lift_gate',
  load_bars = 'load_bars',
  load_locks = 'load_locks',
  max_temp_control = 'max_temp_control',
  min_temp_control = 'min_temp_control',
  not_older_than = 'not_older_than',
  pallet_jack = 'pallet_jack',
  precool = 'precool',
  ratchet_straps = 'ratchet_straps',
  roof_type = 'roof_type',
  specialized_description_details = 'specialized_description_details',
  straps = 'straps',
  tarp = 'tarp',
  temp_control_type = 'temp_control_type',
  tracks = 'tracks',
  wall_type = 'wall_type',
}

export enum IEquipmentTypes {
  _20_van = '_20_van',
  _40_van = '_40_van',
  _48_flatbed = '_48_flatbed',
  _48_reefer = '_48_reefer',
  _48_van = '_48_van',
  _53_flatbed = '_53_flatbed',
  _53_reefer = '_53_reefer',
  _53_van = '_53_van',
  double_drop = 'double_drop',
  dry_van = 'dry_van',
  ice_cream_trailer = 'ice_cream_trailer',
  lift_gate = 'lift_gate',
  open_deck = 'open_deck',
  plate_trailer = 'plate_trailer',
  power_unit = 'power_unit',
  reefer = 'reefer',
  space_saver_reefer = 'space_saver_reefer',
  specialized = 'specialized',
  stepdeck = 'stepdeck',
  vented_van = 'vented_van',
}

export type IError = {
  __typename?: 'Error'
  key: Scalars['String']
  message: Scalars['String']
}

export type IEtaObject = {
  __typename?: 'EtaObject'
  drivingDistance: Scalars['Float']
  eta: Scalars['ISO8601DateTime']
  lastPingLatitude: Scalars['Float']
  lastPingLongitude: Scalars['Float']
  onTime: Scalars['Boolean']
  shipmentId: Scalars['ID']
}

/** Autogenerated input type of ExportShipperRateCarrierCallList */
export type IExportShipperRateCarrierCallListInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  destinationRadiusMiles?: Maybe<Scalars['Int']>
  originRadiusMiles?: Maybe<Scalars['Int']>
  shipperRateId: Scalars['ID']
}

/** Autogenerated return type of ExportShipperRateCarrierCallList */
export type IExportShipperRateCarrierCallListPayload = {
  __typename?: 'ExportShipperRateCarrierCallListPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Params for a push notification job */
export type IExternalPushNotificationParams = {
  savedLaneLoadMatch?: Maybe<ISavedLaneLoadMatch>
}

export enum IFacilitiesSortEnum {
  /** facility_name */
  facility_name = 'facility_name',
  /** location */
  location = 'location',
  /** shipments */
  shipments = 'shipments',
  /** trailer_pools */
  trailer_pools = 'trailer_pools',
}

export type IFacility = {
  __typename?: 'Facility'
  /** All associated facility contacts */
  contacts: Array<IFacilityContact>
  /** Delivery Appointment Type */
  deliveryAppointmentType?: Maybe<IFacilityAppointmentTypeEnum>
  facilityType?: Maybe<IFacilityTypes>
  id: Scalars['ID']
  /** Facility location information */
  location: ILocation
  /** Facilities merged into this facility if applicable */
  mergedFacilities: Array<IFacility>
  metadata?: Maybe<IFacilityMetadata>
  name: Scalars['String']
  /** All associated notes */
  notes: Array<INote>
  onHoldStops: Array<IShipmentStop>
  /** Pickup Appointment Type */
  pickupAppointmentType?: Maybe<IFacilityAppointmentTypeEnum>
  /** Facility this facility was merged into if applicable */
  primaryFacility?: Maybe<IFacility>
  primaryFacilityUuidSetAt?: Maybe<Scalars['ISO8601DateTime']>
  primaryFacilityUuidSetBy?: Maybe<IUser>
  /** Relay Payments Network Status */
  relayPaymentsNetworkStatus?: Maybe<Scalars['String']>
  reviewStatus: IFacilityReviewStatuses
  reviewStatusSetAt?: Maybe<Scalars['ISO8601DateTime']>
  reviewStatusSetBy?: Maybe<IUser>
  schedule?: Maybe<IFacilitySchedule>
  /** Schedule Hours associated with this facility */
  scheduleHours: Array<IFacilityScheduleHour>
  /** Shipper facilities associated with this facility */
  shipperFacilities?: Maybe<Array<IShipperFacility>>
  shouldAutoEmail: Scalars['Boolean']
  uuid: Scalars['ID']
  /** VendorFacility records associated with this facility */
  vendorFacilities?: Maybe<Array<IVendorFacility>>
}

export type IFacilityShipperFacilitiesArgs = {
  shipperApplicationId?: Maybe<Scalars['ID']>
  uuids?: Maybe<Array<Scalars['ID']>>
}

export enum IFacilityAppointmentTypeEnum {
  /** By appointment */
  by_appointment = 'by_appointment',
  /** Fcfs */
  fcfs = 'fcfs',
  /** Notification window */
  notification_window = 'notification_window',
}

export enum IFacilityClasses {
  Facility = 'Facility',
  ShipperFacility = 'ShipperFacility',
  VendorFacility = 'VendorFacility',
  VendorShipperFacility = 'VendorShipperFacility',
}

/** The connection type for Facility. */
export type IFacilityConnection = {
  __typename?: 'FacilityConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IFacilityEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IFacility>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

export type IFacilityContact = {
  __typename?: 'FacilityContact'
  canScheduleFor?: Maybe<Scalars['String']>
  /** All active associated FacilityContactMethods */
  contactMethods: Array<IFacilityContactMethod>
  contactRoles?: Maybe<Array<Scalars['String']>>
  contactType: Scalars['String']
  email?: Maybe<Scalars['String']>
  facilityUuid?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  phoneExtension?: Maybe<Scalars['String']>
  shipperFacilityUuid?: Maybe<Scalars['ID']>
  website?: Maybe<Scalars['String']>
}

export type IFacilityContactMethod = {
  __typename?: 'FacilityContactMethod'
  contactMethod: IFacilityContactMethodTypes
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  metadata?: Maybe<Scalars['JSON']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  value: Scalars['String']
  vendor?: Maybe<IVendor>
}

export enum IFacilityContactMethodTypes {
  /** Cell phone */
  cell_phone = 'cell_phone',
  /** Email */
  email = 'email',
  /** Phone */
  phone = 'phone',
}

/** An edge in a connection. */
export type IFacilityEdge = {
  __typename?: 'FacilityEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IFacility>
}

export type IFacilityIdentifier = {
  __typename?: 'FacilityIdentifier'
  ediLocationCode?: Maybe<Scalars['String']>
  ediLocationName?: Maybe<Scalars['String']>
  ediLocationType?: Maybe<Scalars['String']>
  facilityCode?: Maybe<Scalars['String']>
  id: Scalars['ID']
  shipperFacility: IShipperFacility
  vendorShipperFacilityUuid?: Maybe<Scalars['ID']>
}

export type IFacilityIdentifierInput = {
  editLocationCode?: Maybe<Scalars['String']>
  facilityCode?: Maybe<Scalars['String']>
  id: Scalars['ID']
  vendorShipperFacilityUuid?: Maybe<Scalars['ID']>
}

export type IFacilityMetadata = {
  __typename?: 'FacilityMetadata'
  addressLine2?: Maybe<Scalars['String']>
  arrivalInstructions?: Maybe<Scalars['String']>
  equipments?: Maybe<Array<IEquipment>>
  requirements?: Maybe<Array<IFacilityRequirements>>
  safetyRequirements?: Maybe<Scalars['String']>
  services?: Maybe<Array<IFacilityServices>>
}

export type IFacilityMetadataInput = {
  addressLine2?: Maybe<Scalars['String']>
  facilityUuid?: Maybe<Scalars['ID']>
  shipperFacilityUuid?: Maybe<Scalars['ID']>
  uuid?: Maybe<Scalars['ID']>
  vendorFacilityUuid?: Maybe<Scalars['ID']>
  vendorShipperFacilityUuid?: Maybe<Scalars['ID']>
}

export enum IFacilityRelayPaymentsNetworkStatus {
  in_network = 'in_network',
  out_of_network = 'out_of_network',
  unknown = 'unknown',
}

export enum IFacilityRequirements {
  /** Driver unload */
  driver_unload = 'driver_unload',
  /** Twic card */
  twic_card = 'twic_card',
}

export enum IFacilityReviewStatuses {
  merged_to_primary = 'merged_to_primary',
  needs_address_review = 'needs_address_review',
  not_reviewed = 'not_reviewed',
  primary = 'primary',
  retained_as_duplicate = 'retained_as_duplicate',
}

export type IFacilitySchedule = {
  __typename?: 'FacilitySchedule'
  documents?: Maybe<Array<IAttachedDocument>>
  rules: Array<IFacilityScheduleRule>
  schedulingNotes?: Maybe<Scalars['String']>
  sop?: Maybe<Scalars['String']>
}

export type IFacilityScheduleHour = {
  __typename?: 'FacilityScheduleHour'
  closed: Scalars['Boolean']
  day: Scalars['String']
  endTime?: Maybe<Scalars['String']>
  id: Scalars['ID']
  startTime?: Maybe<Scalars['String']>
  stopType: Scalars['String']
  unloadType: Scalars['String']
}

export type IFacilityScheduleHourInput = {
  closed?: Maybe<Scalars['Boolean']>
  day: IWeekDaysEnum
  endTime?: Maybe<Scalars['ISO8601Time']>
  startTime?: Maybe<Scalars['ISO8601Time']>
}

export type IFacilityScheduleRule = {
  __typename?: 'FacilityScheduleRule'
  appointmentType?: Maybe<IShipmentStopAppointmentTypes>
  autoScheduling: Scalars['Boolean']
  procedureRequirements?: Maybe<IFacilityScheduleRulesProcedureRequirementsTypes>
  quickRequest: Scalars['Boolean']
  schedulingMethod?: Maybe<IFacilityScheduleRulesSchedulingMethodsTypes>
  stopType: IShipmentStopTypes
  tmsNotes?: Maybe<Scalars['String']>
  tmsUrl?: Maybe<Scalars['String']>
  unloadType: IFacilityScheduleRulesUnloadTypes
  workInsAllowed: Scalars['Boolean']
}

export enum IFacilityScheduleRulesProcedureRequirementsTypes {
  /** Approval */
  APPROVAL = 'APPROVAL',
  /** Notification */
  NOTIFICATION = 'NOTIFICATION',
  /** No contact */
  NO_CONTACT = 'NO_CONTACT',
}

export enum IFacilityScheduleRulesSchedulingMethodsTypes {
  CONTACT = 'CONTACT',
  TMS = 'TMS',
}

export enum IFacilityScheduleRulesUnloadTypes {
  /** Drop */
  DROP = 'DROP',
  /** Live */
  LIVE = 'LIVE',
}

export enum IFacilityServices {
  /** Drivers lounge */
  drivers_lounge = 'drivers_lounge',
  /** Escort service */
  escort_service = 'escort_service',
  /** Freezer blast */
  freezer_blast = 'freezer_blast',
  /** Lumper service */
  lumper_service = 'lumper_service',
  /** Overnight parking */
  overnight_parking = 'overnight_parking',
  /** Pallet jack */
  pallet_jack = 'pallet_jack',
  /** Scale on site */
  scale_on_site = 'scale_on_site',
}

export enum IFacilityTypes {
  crossdock = 'crossdock',
  retail = 'retail',
  warehouse = 'warehouse',
}

export type IFacilityUuidTypeInput = {
  facilityClass: IFacilityClasses
  uuid: Scalars['ID']
}

export type IFacilityWithErrorsAndNotices = {
  __typename?: 'FacilityWithErrorsAndNotices'
  errors?: Maybe<Array<IError>>
  facility?: Maybe<IFacility>
  notices?: Maybe<Array<IError>>
}

export type IFactor = {
  __typename?: 'Factor'
  address?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  contactEmail?: Maybe<Scalars['String']>
  contactPhone?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  createdBy?: Maybe<IUser>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for Factor. */
export type IFactorConnection = {
  __typename?: 'FactorConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IFactorEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IFactor>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IFactorEdge = {
  __typename?: 'FactorEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IFactor>
}

/** Abbreviation/code for a region that makes up one part of a federation. */
export enum IFederatedStateCodes {
  AB = 'AB',
  AGS = 'AGS',
  AGU = 'AGU',
  AK = 'AK',
  AL = 'AL',
  AOL = 'AOL',
  AR = 'AR',
  AZ = 'AZ',
  BC = 'BC',
  BCN = 'BCN',
  BCS = 'BCS',
  CA = 'CA',
  CAM = 'CAM',
  CHH = 'CHH',
  CHIH = 'CHIH',
  CHIS = 'CHIS',
  CHP = 'CHP',
  CMX = 'CMX',
  CO = 'CO',
  COA = 'COA',
  COAH = 'COAH',
  COL = 'COL',
  CT = 'CT',
  DC = 'DC',
  DE = 'DE',
  DF = 'DF',
  DGO = 'DGO',
  DUR = 'DUR',
  FL = 'FL',
  GA = 'GA',
  GRO = 'GRO',
  GTO = 'GTO',
  GUA = 'GUA',
  HGO = 'HGO',
  HI = 'HI',
  HID = 'HID',
  IA = 'IA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  JAL = 'JAL',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  MA = 'MA',
  MB = 'MB',
  MD = 'MD',
  ME = 'ME',
  MEX = 'MEX',
  MI = 'MI',
  MIC = 'MIC',
  MICH = 'MICH',
  MN = 'MN',
  MO = 'MO',
  MOR = 'MOR',
  MS = 'MS',
  MT = 'MT',
  NAY = 'NAY',
  NB = 'NB',
  NC = 'NC',
  ND = 'ND',
  NE = 'NE',
  NH = 'NH',
  NJ = 'NJ',
  NL = 'NL',
  NLE = 'NLE',
  NM = 'NM',
  NS = 'NS',
  NV = 'NV',
  NY = 'NY',
  OAX = 'OAX',
  OH = 'OH',
  OK = 'OK',
  ON = 'ON',
  OR = 'OR',
  PA = 'PA',
  PE = 'PE',
  PUE = 'PUE',
  QC = 'QC',
  QRO = 'QRO',
  QROO = 'QROO',
  QUE = 'QUE',
  RI = 'RI',
  ROO = 'ROO',
  SC = 'SC',
  SD = 'SD',
  SIN = 'SIN',
  SK = 'SK',
  SLP = 'SLP',
  SON = 'SON',
  TAB = 'TAB',
  TAL = 'TAL',
  TAM = 'TAM',
  TAMPS = 'TAMPS',
  TLAX = 'TLAX',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VA = 'VA',
  VER = 'VER',
  VT = 'VT',
  WA = 'WA',
  WI = 'WI',
  WV = 'WV',
  WY = 'WY',
  YUC = 'YUC',
  ZAC = 'ZAC',
}

/** Objects associated with user filter preferences */
export type IFilterPreferences =
  | ILatestUserAvailabilitiesFilterPreferences
  | IShipmentIssueFilterPreferences
  | ITaskedShipmentFilterPreferences

/** An output type to return the same data than ShipmentIssueFollowerInput for User Filter Preferences */
export type IFilterPreferencesShipmentIssueFollowerOutput = {
  __typename?: 'FilterPreferencesShipmentIssueFollowerOutput'
  followerId: Scalars['ID']
  followerType: IShipmentIssueFollowerTypes
}

export type IFmsSmsMessage = {
  __typename?: 'FmsSmsMessage'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  fromPhone: Scalars['String']
  id: Scalars['ID']
  message: Scalars['String']
  /** The user corresponding with to_phone */
  recipient?: Maybe<IUser>
  sendError?: Maybe<Scalars['String']>
  sentAt?: Maybe<Scalars['ISO8601DateTime']>
  toPhone: Scalars['String']
  twilioMessageSid?: Maybe<Scalars['String']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** Contains information on the results of an FTP connectivity test. */
export type IFtpConnectionConfigTestReport = {
  __typename?: 'FtpConnectionConfigTestReport'
  errorBacktrace?: Maybe<Scalars['String']>
  errorMessage?: Maybe<Scalars['String']>
  /** if an error happened, when during the test did it occur? */
  errorWhen?: Maybe<Scalars['String']>
  /** a list of files currently found on the s/ftp server. */
  fileList: Array<Scalars['String']>
  /** if an error happened, this may contain some suggestions about what the error means and how to solve it */
  possibleCauses: Array<Scalars['String']>
  success: Scalars['Boolean']
}

export enum IFtpConnectionTypes {
  FTP = 'FTP',
  SFTP_WITH_PASSWORD = 'SFTP_WITH_PASSWORD',
  SFTP_WITH_PRIVATE_KEY = 'SFTP_WITH_PRIVATE_KEY',
}

export type IFuelSurchargeCalculation = {
  __typename?: 'FuelSurchargeCalculation'
  calculatedFuelCost?: Maybe<Scalars['Float']>
  fuelMileage?: Maybe<Scalars['Float']>
  fuelMileageType?: Maybe<Scalars['String']>
  fuelRpm?: Maybe<Scalars['Float']>
  fuelRpmType?: Maybe<Scalars['String']>
}

/** Autogenerated input type of GenerateDetentionLink */
export type IGenerateDetentionLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of GenerateDetentionLink */
export type IGenerateDetentionLinkPayload = {
  __typename?: 'GenerateDetentionLinkPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  url?: Maybe<Scalars['String']>
}

/** GeocoderHelper Response */
export type IGeocoding = {
  __typename?: 'Geocoding'
  address?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  coordinates: Array<Scalars['Float']>
  country?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  id: Scalars['ID']
  latitude: Scalars['Float']
  longitude: Scalars['Float']
  postalCode?: Maybe<Scalars['String']>
  resultType?: Maybe<Scalars['String']>
  shortString?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
}

export enum IGeocodingAllowedCountryEnum {
  /** CA */
  CA = 'CA',
  /** MX */
  MX = 'MX',
  /** US */
  US = 'US',
}

export enum IGeocodingResultTypeEnum {
  /** Address */
  Address = 'Address',
  /** City */
  City = 'City',
  /** Country */
  Country = 'Country',
  /** None */
  None = 'None',
  /** Poi */
  POI = 'POI',
  /** Postalcode */
  PostalCode = 'PostalCode',
  /** State */
  State = 'State',
}

export type IGeographicCriteria = {
  __typename?: 'GeographicCriteria'
  criteriaType: Scalars['String']
  id: Scalars['ID']
  isInbound: Scalars['Boolean']
  spotBiddingRuleId?: Maybe<Scalars['ID']>
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>
  value: Scalars['String']
}

/** Autogenerated input type of GetConfigurableBuilderWarnings */
export type IGetConfigurableBuilderWarningsInput = {
  /** Id of configurable builder to check */
  builderId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** Id of outbound config to check */
  outboundConfigId: Scalars['ID']
}

/** Autogenerated return type of GetConfigurableBuilderWarnings */
export type IGetConfigurableBuilderWarningsPayload = {
  __typename?: 'GetConfigurableBuilderWarningsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  warnings: Array<Scalars['String']>
}

/** Autogenerated input type of GetInboundSftpFiles */
export type IGetInboundSftpFilesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inboundConnectionConfigId: Scalars['ID']
}

/** Autogenerated return type of GetInboundSftpFiles */
export type IGetInboundSftpFilesPayload = {
  __typename?: 'GetInboundSftpFilesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  inboundSftpFilesReport: IGetInboundSftpFilesReport
}

/** Contains information on the results of listing SFTP files for E2E. */
export type IGetInboundSftpFilesReport = {
  __typename?: 'GetInboundSftpFilesReport'
  errorBacktrace?: Maybe<Scalars['String']>
  errorMessage?: Maybe<Scalars['String']>
  /** a list of files currently found on the s/ftp server. */
  inboundRawEdiFiles: Array<Scalars['String']>
  /** if an error happened, this may contain some suggestions about what the error means and how to solve it */
  possibleCauses: Array<Scalars['String']>
  success: Scalars['Boolean']
}

/** Autogenerated input type of GetSerializedJson */
export type IGetSerializedJsonInput = {
  accountingInvoiceId?: Maybe<Scalars['Int']>
  changedField?: Maybe<Scalars['String']>
  changedShipperStopSequence?: Maybe<Scalars['Int']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId?: Maybe<Scalars['Int']>
  /** message type of builder being tested */
  transactionSet?: Maybe<ITransactionSetTypes>
  /** message subytype of builder being tested */
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
}

/** Autogenerated return type of GetSerializedJson */
export type IGetSerializedJsonPayload = {
  __typename?: 'GetSerializedJsonPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  serializedJson?: Maybe<Scalars['JSON']>
}

export type IGroup = {
  __typename?: 'Group'
  email?: Maybe<Scalars['String']>
  id: Scalars['ID']
  instructions?: Maybe<Scalars['String']>
  isBookingRegion: Scalars['Boolean']
  key: Scalars['String']
  members: Array<IUser>
  name: Scalars['String']
  shippers: Array<IShipperApplication>
}

/** The connection type for Group. */
export type IGroupConnection = {
  __typename?: 'GroupConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IGroupEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IGroup>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IGroupEdge = {
  __typename?: 'GroupEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IGroup>
}

export type IHighwayAddress = {
  __typename?: 'HighwayAddress'
  city?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  id?: Maybe<Scalars['ID']>
  isType: Scalars['String']
  postalCode?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
  street1?: Maybe<Scalars['String']>
  street2?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type IHighwayCarrier = {
  __typename?: 'HighwayCarrier'
  addresses: Array<IHighwayAddress>
  brokerAuthority?: Maybe<Scalars['String']>
  contacts: Array<IHighwayContact>
  continuousAuthorityGrantDate?: Maybe<Scalars['ISO8601Date']>
  createdAt: Scalars['ISO8601DateTime']
  dbaName?: Maybe<Scalars['String']>
  dotNumber?: Maybe<Scalars['Int']>
  driverOosInspections?: Maybe<Scalars['Int']>
  ein?: Maybe<Scalars['String']>
  fatalCrashes?: Maybe<Scalars['Int']>
  fmcsaContactPhone?: Maybe<Scalars['String']>
  highwayId: Scalars['ID']
  id: Scalars['ID']
  injuryCrashes?: Maybe<Scalars['Int']>
  insurancePolicies: Array<IHighwayInsurancePolicy>
  isMonitored: Scalars['Boolean']
  legalName: Scalars['String']
  mcNumber?: Maybe<Scalars['Int']>
  motorCarrierId: Scalars['ID']
  operatingStatus?: Maybe<Scalars['String']>
  rulesAssessmentPass: Scalars['Boolean']
  rulesAssessments: Array<IHighwayRulesAssessment>
  safetyRating?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
  vehicleOosInspections?: Maybe<Scalars['Int']>
  vehicles: IHighwayVehicleConnection
}

export type IHighwayCarrierVehiclesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  type?: Maybe<IHighwayVehicleTypes>
}

export type IHighwayContact = {
  __typename?: 'HighwayContact'
  createdAt: Scalars['ISO8601DateTime']
  emailAddress?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  isType?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type IHighwayInsuranceCertificate = {
  __typename?: 'HighwayInsuranceCertificate'
  contentType?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  filename?: Maybe<Scalars['String']>
  id: Scalars['ID']
  signedUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
  url?: Maybe<Scalars['String']>
}

export type IHighwayInsurancePolicy = {
  __typename?: 'HighwayInsurancePolicy'
  actualCashValue?: Maybe<Scalars['Boolean']>
  anyAuto?: Maybe<Scalars['Boolean']>
  cancellationDate?: Maybe<Scalars['ISO8601Date']>
  coverageLimit?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  effectiveDate?: Maybe<Scalars['ISO8601Date']>
  expirationDate?: Maybe<Scalars['ISO8601Date']>
  hiredAutos?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['ID']>
  insuranceCertificate?: Maybe<IHighwayInsuranceCertificate>
  insurer?: Maybe<IHighwayInsurer>
  isRefrigerationBreakdownIncluded?: Maybe<Scalars['Boolean']>
  isType?: Maybe<Scalars['String']>
  nonOwnedAutos?: Maybe<Scalars['Boolean']>
  ownedAutos?: Maybe<Scalars['Boolean']>
  policyNumber?: Maybe<Scalars['String']>
  scheduledAutos?: Maybe<Scalars['Boolean']>
  status?: Maybe<Scalars['String']>
  statutoryLimits?: Maybe<Scalars['Boolean']>
  transfixFlags?: Maybe<ITransfixHighwayInsurancePolicyFlag>
  updatedAt: Scalars['ISO8601DateTime']
}

export type IHighwayInsurer = {
  __typename?: 'HighwayInsurer'
  city?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  naic: Scalars['String']
  name?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  shortName?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  street1?: Maybe<Scalars['String']>
  street2?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
  website?: Maybe<Scalars['String']>
}

export type IHighwayRulesAssessment = {
  __typename?: 'HighwayRulesAssessment'
  classificationName: Scalars['String']
  createdAt: Scalars['ISO8601DateTime']
  id?: Maybe<Scalars['ID']>
  override?: Maybe<IRulesAssessmentOverride>
  overrides: Scalars['JSON']
  result: Scalars['String']
  ruleName: Scalars['String']
  updatedAt: Scalars['ISO8601DateTime']
}

export type IHighwayVehicle = {
  __typename?: 'HighwayVehicle'
  cabType?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  isType?: Maybe<Scalars['String']>
  licensePlateNumber?: Maybe<Scalars['String']>
  licensePlateState?: Maybe<Scalars['String']>
  make?: Maybe<Scalars['String']>
  model?: Maybe<Scalars['String']>
  modelYear?: Maybe<Scalars['Int']>
  powerUnitType?: Maybe<Scalars['String']>
  trailerType?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
  vin?: Maybe<Scalars['String']>
  weightClass?: Maybe<Scalars['String']>
}

/** The connection type for HighwayVehicle. */
export type IHighwayVehicleConnection = {
  __typename?: 'HighwayVehicleConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IHighwayVehicleEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IHighwayVehicle>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IHighwayVehicleEdge = {
  __typename?: 'HighwayVehicleEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IHighwayVehicle>
}

export enum IHighwayVehicleTypes {
  power_unit = 'power_unit',
  trailer = 'trailer',
}

/** Autogenerated input type of HoldShipment */
export type IHoldShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of HoldShipment */
export type IHoldShipmentPayload = {
  __typename?: 'HoldShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export type IInboundConnectionConfig = {
  __typename?: 'InboundConnectionConfig'
  as2ConnectionConfig?: Maybe<IAs2ConnectionConfig>
  configGroupMappings?: Maybe<Array<IConfigGroupMapping>>
  connectionType: IConnectionTypes
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  disabled: Scalars['Boolean']
  ediMessageTypes?: Maybe<Array<IEdiMessage>>
  environment: IConnectionConfigEnvironment
  filenameGlob?: Maybe<Scalars['String']>
  host?: Maybe<Scalars['String']>
  id: Scalars['ID']
  partnerApplication?: Maybe<IPartnerApplication>
  partnerApplicationId: Scalars['ID']
  partnerApplicationType: IPartnerApplicationTypes
  pathPrefix?: Maybe<Scalars['String']>
  port?: Maybe<Scalars['Int']>
  secretKey?: Maybe<Scalars['String']>
  send997s: Scalars['Boolean']
  shipperId?: Maybe<Scalars['ID']>
  tmsName?: Maybe<Scalars['String']>
  username?: Maybe<Scalars['String']>
}

/** The connection type for InboundConnectionConfig. */
export type IInboundConnectionConfigConnection = {
  __typename?: 'InboundConnectionConfigConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IInboundConnectionConfigEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IInboundConnectionConfig>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IInboundConnectionConfigEdge = {
  __typename?: 'InboundConnectionConfigEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IInboundConnectionConfig>
}

export type IInboundFileRouterConfig = {
  __typename?: 'InboundFileRouterConfig'
  connectionType: IConnectionTypes
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  disabled: Scalars['Boolean']
  environment: IConnectionConfigEnvironment
  host: Scalars['String']
  id: Scalars['ID']
  pathPrefix: Scalars['String']
  port: Scalars['Int']
  secretKey: Scalars['String']
  /** Config use to fetch shipper code from an EDI file */
  shipperCodeJson: Scalars['JSON']
  tmsName?: Maybe<Scalars['String']>
  username: Scalars['String']
}

export type IInsuranceCompliance = {
  __typename?: 'InsuranceCompliance'
  carrierAttr: Scalars['String']
  shipperRequirement: Scalars['String']
  valid: Scalars['Boolean']
}

export type IInsuranceComplianceMatch = {
  __typename?: 'InsuranceComplianceMatch'
  complianceCoverReview?: Maybe<IComplianceCoverReview>
  meetsRequirements: Scalars['Boolean']
  requirementsMatchResults: Array<IInsuranceCompliance>
}

export type IInvoice = {
  __typename?: 'Invoice'
  autoSendEdi: Scalars['Boolean']
  autoSendPdf: Scalars['Boolean']
  closedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  dueAt?: Maybe<Scalars['ISO8601DateTime']>
  ediFileDeliveredAt?: Maybe<Scalars['ISO8601DateTime']>
  file?: Maybe<IDownloadable>
  id: Scalars['ID']
  isPrimaryRecord: Scalars['Boolean']
  lineItems: Array<IInvoiceLineItem>
  name: Scalars['String']
  netsuiteInvoice?: Maybe<INetsuiteInvoice>
  paidAmount: Scalars['Float']
  pdfFileDeliveredAt?: Maybe<Scalars['ISO8601DateTime']>
  processedAt?: Maybe<Scalars['ISO8601DateTime']>
  readyToDeliverAt?: Maybe<Scalars['ISO8601DateTime']>
  shipment: IShipment
  shipper: IShipperApplication
  state: IAccountingStates
  totalAmount: Scalars['Float']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IInvoiceCredit = {
  __typename?: 'InvoiceCredit'
  autoSendEdi: Scalars['Boolean']
  autoSendPdf: Scalars['Boolean']
  closedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  dueAt?: Maybe<Scalars['ISO8601DateTime']>
  ediFileDeliveredAt?: Maybe<Scalars['ISO8601DateTime']>
  file?: Maybe<IDownloadable>
  id: Scalars['ID']
  isPrimaryRecord: Scalars['Boolean']
  name: Scalars['String']
  netsuiteInvoiceCredit?: Maybe<INetsuiteInvoiceCredit>
  paidAmount: Scalars['Float']
  pdfFileDeliveredAt?: Maybe<Scalars['ISO8601DateTime']>
  processedAt?: Maybe<Scalars['ISO8601DateTime']>
  shipment: IShipment
  shipper: IShipperApplication
  state: IAccountingStates
  totalAmount: Scalars['Float']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IInvoiceLineItem = {
  __typename?: 'InvoiceLineItem'
  amount: Scalars['Float']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  invoice: IInvoice
  shipment: IShipment
  title: Scalars['String']
  type: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IIssueAutomationRule = {
  __typename?: 'IssueAutomationRule'
  createdAt: Scalars['ISO8601DateTime']
  createdBy: IUser
  deprecatedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  issueAutomationRuleNodes: Array<IIssueAutomationRuleNode>
  name: Scalars['String']
  ruleAction: IIssueAutomationRuleActionEnum
  shipmentIssueType: IShipmentIssueType
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy: IUser
}

export enum IIssueAutomationRuleActionEnum {
  /** Create */
  create = 'create',
  /** Resolve */
  resolve = 'resolve',
}

/** The connection type for IssueAutomationRule. */
export type IIssueAutomationRuleConnection = {
  __typename?: 'IssueAutomationRuleConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IIssueAutomationRuleEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IIssueAutomationRule>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IIssueAutomationRuleEdge = {
  __typename?: 'IssueAutomationRuleEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IIssueAutomationRule>
}

export type IIssueAutomationRuleNode = {
  __typename?: 'IssueAutomationRuleNode'
  createdAt: Scalars['ISO8601DateTime']
  createdBy: IUser
  deprecatedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  issueAutomationRuleId: Scalars['ID']
  nodeType: IIssueAutomationRuleNodeTypeEnum
  parameters: IIssueAutomationRuleNodeParameters
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy: IUser
}

export type IIssueAutomationRuleNodeInput = {
  id?: Maybe<Scalars['ID']>
  nodeType: IIssueAutomationRuleNodeTypeEnum
  parameters: IIssueAutomationRuleNodeParametersInput
}

/** issue automation node parameters saved as JSON in DB */
export type IIssueAutomationRuleNodeParameters =
  | IIssueAutomationRuleNodeShipmentEventParameters
  | IIssueAutomationRuleNodeShipmentInformationParameters
  | IIssueAutomationRuleNodeShipmentStateParameters
  | IIssueAutomationRuleNodeTimeWindowParameters

export type IIssueAutomationRuleNodeParametersInput = {
  shipmentEventFields?: Maybe<Array<IIssueAutomationRuleNodeShipmentEventFieldTypeEnum>>
  shipmentEventOperator?: Maybe<IIssueAutomationRuleNodeShipmentEventOperatorTypeEnum>
  shipmentInformationFields?: Maybe<Array<IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum>>
  shipmentInformationOperator?: Maybe<IIssueAutomationRuleNodeShipmentInformationOperatorTypeEnum>
  shipmentStates?: Maybe<Array<IShipmentStates>>
  timeWindowField?: Maybe<IIssueAutomationRuleNodeTimeWindowFieldTypeEnum>
  timeWindowOperator?: Maybe<IIssueAutomationRuleNodeTimeWindowOperatorTypeEnum>
  timeWindowSeconds?: Maybe<Scalars['Int']>
}

export enum IIssueAutomationRuleNodeShipmentEventFieldTypeEnum {
  /** Is same day shipment */
  is_same_day_shipment = 'is_same_day_shipment',
}

export enum IIssueAutomationRuleNodeShipmentEventOperatorTypeEnum {
  /** Is true */
  is_true = 'is_true',
}

export type IIssueAutomationRuleNodeShipmentEventParameters = {
  __typename?: 'IssueAutomationRuleNodeShipmentEventParameters'
  shipmentEventFields: Array<IIssueAutomationRuleNodeShipmentEventFieldTypeEnum>
  shipmentEventOperator: IIssueAutomationRuleNodeShipmentEventOperatorTypeEnum
}

export enum IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum {
  /** Is carrier assigned */
  is_carrier_assigned = 'is_carrier_assigned',
  /** Is carrier billed */
  is_carrier_billed = 'is_carrier_billed',
  /** Is driver assigned */
  is_driver_assigned = 'is_driver_assigned',
  /** Is high risk shipment */
  is_high_risk_shipment = 'is_high_risk_shipment',
  /** Is pod approved */
  is_pod_approved = 'is_pod_approved',
  /** Is same day shipment */
  is_same_day_shipment = 'is_same_day_shipment',
  /** Is shipment reefer */
  is_shipment_reefer = 'is_shipment_reefer',
  /** Is shipment reefer temperatures present */
  is_shipment_reefer_temperatures_present = 'is_shipment_reefer_temperatures_present',
  /** Is shipment stop drop trailer */
  is_shipment_stop_drop_trailer = 'is_shipment_stop_drop_trailer',
  /** Is shipment tracking */
  is_shipment_tracking = 'is_shipment_tracking',
  /** Is shipment trailer number present */
  is_shipment_trailer_number_present = 'is_shipment_trailer_number_present',
  /** Is shipper l1 tracking required */
  is_shipper_l1_tracking_required = 'is_shipper_l1_tracking_required',
}

export enum IIssueAutomationRuleNodeShipmentInformationOperatorTypeEnum {
  /** Is not true */
  is_not_true = 'is_not_true',
  /** Is true */
  is_true = 'is_true',
}

export type IIssueAutomationRuleNodeShipmentInformationParameters = {
  __typename?: 'IssueAutomationRuleNodeShipmentInformationParameters'
  shipmentInformationFields: Array<IIssueAutomationRuleNodeShipmentInformationFieldTypeEnum>
  shipmentInformationOperator: IIssueAutomationRuleNodeShipmentInformationOperatorTypeEnum
}

export type IIssueAutomationRuleNodeShipmentStateParameters = {
  __typename?: 'IssueAutomationRuleNodeShipmentStateParameters'
  shipmentStates: Array<IShipmentStates>
}

export enum IIssueAutomationRuleNodeTimeWindowFieldTypeEnum {
  /** Delivery appointment start at */
  delivery_appointment_start_at = 'delivery_appointment_start_at',
  /** Pickup appointment start at */
  pickup_appointment_start_at = 'pickup_appointment_start_at',
  /** Scheduling task due at */
  scheduling_task_due_at = 'scheduling_task_due_at',
  /** Tracking task due at */
  tracking_task_due_at = 'tracking_task_due_at',
}

export enum IIssueAutomationRuleNodeTimeWindowOperatorTypeEnum {
  /** Is after */
  is_after = 'is_after',
  /** Is before */
  is_before = 'is_before',
}

export type IIssueAutomationRuleNodeTimeWindowParameters = {
  __typename?: 'IssueAutomationRuleNodeTimeWindowParameters'
  timeWindowField: IIssueAutomationRuleNodeTimeWindowFieldTypeEnum
  timeWindowOperator: IIssueAutomationRuleNodeTimeWindowOperatorTypeEnum
  timeWindowSeconds: Scalars['Int']
}

export enum IIssueAutomationRuleNodeTypeEnum {
  /** Shipment event */
  shipment_event = 'shipment_event',
  /** Shipment information */
  shipment_information = 'shipment_information',
  /** Shipment status */
  shipment_status = 'shipment_status',
  /** Time window */
  time_window = 'time_window',
}

export type IIssueResolutionStep = {
  __typename?: 'IssueResolutionStep'
  completed?: Maybe<Scalars['Boolean']>
  completedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** @deprecated Replaced by completedById */
  completedBy?: Maybe<Scalars['String']>
  completedById?: Maybe<Scalars['Int']>
  description: Scalars['String']
  id: Scalars['String']
  issueResolutionStepId: Scalars['Int']
  stepSequence: Scalars['Int']
}

export type IIssueResolutionStepInput = {
  completed: Scalars['Boolean']
  id: Scalars['ID']
}

export type ILaneCarrierMatch = {
  __typename?: 'LaneCarrierMatch'
  carrierApplicationId: Scalars['ID']
  hasAvailableTruck?: Maybe<Scalars['Boolean']>
  hasBackhaulBidHistory?: Maybe<Scalars['Boolean']>
  hasBackhaulHistory?: Maybe<Scalars['Boolean']>
  hasBidHistory?: Maybe<Scalars['Boolean']>
  hasCustomerHistory?: Maybe<Scalars['Boolean']>
  hasExactLaneHistory?: Maybe<Scalars['Boolean']>
  hasHeadhaulHistory?: Maybe<Scalars['Boolean']>
  hasHqNearOrigin?: Maybe<Scalars['Boolean']>
  hasLaneAlert?: Maybe<Scalars['Boolean']>
  hasLaneRadiusHistory?: Maybe<Scalars['Boolean']>
  hasLaneSearchHistory?: Maybe<Scalars['Boolean']>
  hasReloads?: Maybe<Scalars['Boolean']>
  hasReservedLane?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  laneMatchTriggerId: Scalars['ID']
  lastRan?: Maybe<Scalars['ISO8601DateTime']>
  lastRate?: Maybe<Scalars['Float']>
  metadata?: Maybe<ICarrierCallListMatchMetadata>
  referenceShipmentIds?: Maybe<Array<Scalars['ID']>>
  referenceTruckIds?: Maybe<Array<Scalars['ID']>>
  shipment: IShipment
  strongestMatch?: Maybe<ILaneCarrierMatchListFilterEnum>
  totalRan?: Maybe<Scalars['Int']>
}

/** The connection type for LaneCarrierMatch. */
export type ILaneCarrierMatchConnection = {
  __typename?: 'LaneCarrierMatchConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ILaneCarrierMatchEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ILaneCarrierMatch>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type ILaneCarrierMatchEdge = {
  __typename?: 'LaneCarrierMatchEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<ILaneCarrierMatch>
}

export enum ILaneCarrierMatchListFilterEnum {
  /** Lane alert */
  lane_alert = 'lane_alert',
  /** Ran backhaul */
  ran_backhaul = 'ran_backhaul',
  /** Ran before */
  ran_before = 'ran_before',
  /** Ran headhaul */
  ran_headhaul = 'ran_headhaul',
  /** Reload */
  reload = 'reload',
  /** Reserved loads */
  reserved_loads = 'reserved_loads',
}

export type ILaneGeographicCriteria = {
  __typename?: 'LaneGeographicCriteria'
  deliveryType: Scalars['String']
  deliveryValue: Scalars['String']
  id: Scalars['ID']
  pickupType: Scalars['String']
  pickupValue: Scalars['String']
}

export type ILaneHistory = {
  __typename?: 'LaneHistory'
  lastRan?: Maybe<Scalars['ISO8601DateTime']>
  lastRate?: Maybe<Scalars['Float']>
  totalRan?: Maybe<Scalars['Int']>
}

export type ILaneMarketInsights = {
  __typename?: 'LaneMarketInsights'
  deliveryMarketInsight?: Maybe<IMarketInsight>
  pickupMarketInsight?: Maybe<IMarketInsight>
}

export type ILaneTierCriteria = {
  __typename?: 'LaneTierCriteria'
  id: Scalars['ID']
  tier: Scalars['String']
}

export type ILatestUserAvailabilitiesFilterPreferences = {
  __typename?: 'LatestUserAvailabilitiesFilterPreferences'
  /** Only include users in passed group IDs. Can be used in combination with `inNoOpsGroup` */
  groupIds?: Maybe<Array<Scalars['ID']>>
  /** Filters by users who are in no ops group. Can be used in conjunction with `groupIds` */
  inNoOpsGroup?: Maybe<Scalars['Boolean']>
  isAvailable?: Maybe<Scalars['Boolean']>
  /** Filter by user first/last name match */
  name?: Maybe<Scalars['String']>
  types?: Maybe<Array<IUserAvailabilityTypes>>
  userIds?: Maybe<Array<Scalars['ID']>>
}

export type ILatestUserAvailabilitiesFilterPreferencesInput = {
  groupIds?: Maybe<Array<Scalars['ID']>>
  inNoOpsGroup?: Maybe<Scalars['Boolean']>
  isAvailable?: Maybe<Scalars['Boolean']>
  name?: Maybe<Scalars['String']>
  types?: Maybe<Array<IUserAvailabilityTypes>>
  userIds?: Maybe<Array<Scalars['ID']>>
}

export enum ILegacyBuilderClassTypes {
  Edi_Mapper_Builder_Abbott_StatusMessage214 = 'Edi_Mapper_Builder_Abbott_StatusMessage214',
  Edi_Mapper_Builder_Agco_StatusMessage214 = 'Edi_Mapper_Builder_Agco_StatusMessage214',
  Edi_Mapper_Builder_AmericanFreight_ResponseToLoadTender990 = 'Edi_Mapper_Builder_AmericanFreight_ResponseToLoadTender990',
  Edi_Mapper_Builder_AnheuserBusch_ResponseToLoadTender990 = 'Edi_Mapper_Builder_AnheuserBusch_ResponseToLoadTender990',
  Edi_Mapper_Builder_AnheuserBusch_StatusMessage214 = 'Edi_Mapper_Builder_AnheuserBusch_StatusMessage214',
  Edi_Mapper_Builder_BJ_Invoice210 = 'Edi_Mapper_Builder_BJ_Invoice210',
  Edi_Mapper_Builder_BJ_ResponseToLoadTender990 = 'Edi_Mapper_Builder_BJ_ResponseToLoadTender990',
  Edi_Mapper_Builder_BJ_ScheduledTracking214 = 'Edi_Mapper_Builder_BJ_ScheduledTracking214',
  Edi_Mapper_Builder_BJ_StatusMessage214 = 'Edi_Mapper_Builder_BJ_StatusMessage214',
  Edi_Mapper_Builder_Banyan_StatusMessage214 = 'Edi_Mapper_Builder_Banyan_StatusMessage214',
  Edi_Mapper_Builder_Base = 'Edi_Mapper_Builder_Base',
  Edi_Mapper_Builder_Bumblebeefoods_Invoice210 = 'Edi_Mapper_Builder_Bumblebeefoods_Invoice210',
  Edi_Mapper_Builder_Bumblebeefoods_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Bumblebeefoods_ResponseToLoadTender990',
  Edi_Mapper_Builder_Bumblebeefoods_ScheduledTracking214 = 'Edi_Mapper_Builder_Bumblebeefoods_ScheduledTracking214',
  Edi_Mapper_Builder_Bumblebeefoods_StatusMessage214 = 'Edi_Mapper_Builder_Bumblebeefoods_StatusMessage214',
  Edi_Mapper_Builder_Burlington_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Burlington_ResponseToLoadTender990',
  Edi_Mapper_Builder_CNG_Invoice210 = 'Edi_Mapper_Builder_CNG_Invoice210',
  Edi_Mapper_Builder_CNG_ResponseToLoadTender990 = 'Edi_Mapper_Builder_CNG_ResponseToLoadTender990',
  Edi_Mapper_Builder_CNG_StatusMessage214 = 'Edi_Mapper_Builder_CNG_StatusMessage214',
  Edi_Mapper_Builder_Carrier_LoadTender204 = 'Edi_Mapper_Builder_Carrier_LoadTender204',
  Edi_Mapper_Builder_CharterComm_ResponseToLoadTender990 = 'Edi_Mapper_Builder_CharterComm_ResponseToLoadTender990',
  Edi_Mapper_Builder_CharterComm_ScheduledTracking214 = 'Edi_Mapper_Builder_CharterComm_ScheduledTracking214',
  Edi_Mapper_Builder_CharterComm_StatusMessage214 = 'Edi_Mapper_Builder_CharterComm_StatusMessage214',
  Edi_Mapper_Builder_Chep_Invoice210 = 'Edi_Mapper_Builder_Chep_Invoice210',
  Edi_Mapper_Builder_Chep_Invoice210BlueYonder = 'Edi_Mapper_Builder_Chep_Invoice210BlueYonder',
  Edi_Mapper_Builder_Chep_StatusMessage214 = 'Edi_Mapper_Builder_Chep_StatusMessage214',
  Edi_Mapper_Builder_Chep_StatusMessage214BlueYonder = 'Edi_Mapper_Builder_Chep_StatusMessage214BlueYonder',
  Edi_Mapper_Builder_Colgate_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Colgate_ResponseToLoadTender990',
  Edi_Mapper_Builder_Costco_Invoice210 = 'Edi_Mapper_Builder_Costco_Invoice210',
  Edi_Mapper_Builder_Costco_OTM_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Costco_OTM_ResponseToLoadTender990',
  Edi_Mapper_Builder_Costco_OTM_StatusMessage214 = 'Edi_Mapper_Builder_Costco_OTM_StatusMessage214',
  Edi_Mapper_Builder_Costco_ScheduledTracking214 = 'Edi_Mapper_Builder_Costco_ScheduledTracking214',
  Edi_Mapper_Builder_Costco_StatusMessage214 = 'Edi_Mapper_Builder_Costco_StatusMessage214',
  Edi_Mapper_Builder_Dole_Invoice210 = 'Edi_Mapper_Builder_Dole_Invoice210',
  Edi_Mapper_Builder_Ecopax_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Ecopax_ResponseToLoadTender990',
  Edi_Mapper_Builder_Ecopax_StatusMessage214 = 'Edi_Mapper_Builder_Ecopax_StatusMessage214',
  Edi_Mapper_Builder_FiveBelow_Invoice210 = 'Edi_Mapper_Builder_FiveBelow_Invoice210',
  Edi_Mapper_Builder_FloorDecor_ManualResponseToLoadTender990 = 'Edi_Mapper_Builder_FloorDecor_ManualResponseToLoadTender990',
  Edi_Mapper_Builder_FloorDecor_ManualStatusMessage214 = 'Edi_Mapper_Builder_FloorDecor_ManualStatusMessage214',
  Edi_Mapper_Builder_FunctionalAcknowledgement997 = 'Edi_Mapper_Builder_FunctionalAcknowledgement997',
  Edi_Mapper_Builder_GE_Invoice210 = 'Edi_Mapper_Builder_GE_Invoice210',
  Edi_Mapper_Builder_GE_ResponseToLoadTender990 = 'Edi_Mapper_Builder_GE_ResponseToLoadTender990',
  Edi_Mapper_Builder_Gnc_Invoice210 = 'Edi_Mapper_Builder_Gnc_Invoice210',
  Edi_Mapper_Builder_Gojo_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Gojo_ResponseToLoadTender990',
  Edi_Mapper_Builder_GraphicPackaging_BookingStatusMessage214 = 'Edi_Mapper_Builder_GraphicPackaging_BookingStatusMessage214',
  Edi_Mapper_Builder_GraphicPackaging_Invoice210 = 'Edi_Mapper_Builder_GraphicPackaging_Invoice210',
  Edi_Mapper_Builder_GraphicPackaging_ScheduledTracking214 = 'Edi_Mapper_Builder_GraphicPackaging_ScheduledTracking214',
  Edi_Mapper_Builder_GraphicPackaging_StatusMessage214 = 'Edi_Mapper_Builder_GraphicPackaging_StatusMessage214',
  Edi_Mapper_Builder_Greif_StatusMessage214 = 'Edi_Mapper_Builder_Greif_StatusMessage214',
  Edi_Mapper_Builder_Henkel_Invoice210 = 'Edi_Mapper_Builder_Henkel_Invoice210',
  Edi_Mapper_Builder_Henkel_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Henkel_ResponseToLoadTender990',
  Edi_Mapper_Builder_Henkel_StatusMessage214 = 'Edi_Mapper_Builder_Henkel_StatusMessage214',
  Edi_Mapper_Builder_Huhtamaki_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Huhtamaki_ResponseToLoadTender990',
  Edi_Mapper_Builder_KbxOrderful_Invoice210 = 'Edi_Mapper_Builder_KbxOrderful_Invoice210',
  Edi_Mapper_Builder_KbxOrderful_ResponseToLoadTender990 = 'Edi_Mapper_Builder_KbxOrderful_ResponseToLoadTender990',
  Edi_Mapper_Builder_KbxOrderful_ScheduledTracking214 = 'Edi_Mapper_Builder_KbxOrderful_ScheduledTracking214',
  Edi_Mapper_Builder_KbxOrderful_StatusMessage214 = 'Edi_Mapper_Builder_KbxOrderful_StatusMessage214',
  Edi_Mapper_Builder_Kbx_Invoice210 = 'Edi_Mapper_Builder_Kbx_Invoice210',
  Edi_Mapper_Builder_Kbx_StatusMessage214 = 'Edi_Mapper_Builder_Kbx_StatusMessage214',
  Edi_Mapper_Builder_Kbx_StatusMessageTracking214 = 'Edi_Mapper_Builder_Kbx_StatusMessageTracking214',
  Edi_Mapper_Builder_KraftHeinz_Invoice210 = 'Edi_Mapper_Builder_KraftHeinz_Invoice210',
  Edi_Mapper_Builder_KraftHeinz_ResponseToLoadTender990 = 'Edi_Mapper_Builder_KraftHeinz_ResponseToLoadTender990',
  Edi_Mapper_Builder_KraftHeinz_StatusMessage214 = 'Edi_Mapper_Builder_KraftHeinz_StatusMessage214',
  Edi_Mapper_Builder_LG_Invoice210 = 'Edi_Mapper_Builder_LG_Invoice210',
  Edi_Mapper_Builder_LG_ResponseToLoadTender990 = 'Edi_Mapper_Builder_LG_ResponseToLoadTender990',
  Edi_Mapper_Builder_LG_ScheduledTracking214 = 'Edi_Mapper_Builder_LG_ScheduledTracking214',
  Edi_Mapper_Builder_LG_StatusMessage214 = 'Edi_Mapper_Builder_LG_StatusMessage214',
  Edi_Mapper_Builder_LG_TrueRateActualRateStatusMessage214 = 'Edi_Mapper_Builder_LG_TrueRateActualRateStatusMessage214',
  Edi_Mapper_Builder_Manhattan_Invoice210 = 'Edi_Mapper_Builder_Manhattan_Invoice210',
  Edi_Mapper_Builder_Manhattan_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Manhattan_ResponseToLoadTender990',
  Edi_Mapper_Builder_Manhattan_ScheduledTracking214 = 'Edi_Mapper_Builder_Manhattan_ScheduledTracking214',
  Edi_Mapper_Builder_Manhattan_StatusMessage214 = 'Edi_Mapper_Builder_Manhattan_StatusMessage214',
  Edi_Mapper_Builder_ManualBase = 'Edi_Mapper_Builder_ManualBase',
  Edi_Mapper_Builder_ManualInvoice210 = 'Edi_Mapper_Builder_ManualInvoice210',
  Edi_Mapper_Builder_ManualShipmentStatus214 = 'Edi_Mapper_Builder_ManualShipmentStatus214',
  Edi_Mapper_Builder_Molson_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Molson_ResponseToLoadTender990',
  Edi_Mapper_Builder_Molson_StatusMessage214 = 'Edi_Mapper_Builder_Molson_StatusMessage214',
  Edi_Mapper_Builder_Mondelez_Invoice210 = 'Edi_Mapper_Builder_Mondelez_Invoice210',
  Edi_Mapper_Builder_Mondelez_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Mondelez_ResponseToLoadTender990',
  Edi_Mapper_Builder_Mondelez_StatusMessage214 = 'Edi_Mapper_Builder_Mondelez_StatusMessage214',
  Edi_Mapper_Builder_Mtd_Invoice210 = 'Edi_Mapper_Builder_Mtd_Invoice210',
  Edi_Mapper_Builder_Mtd_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Mtd_ResponseToLoadTender990',
  Edi_Mapper_Builder_Mtd_StatusMessage214 = 'Edi_Mapper_Builder_Mtd_StatusMessage214',
  Edi_Mapper_Builder_NestleUsa_Invoice210 = 'Edi_Mapper_Builder_NestleUsa_Invoice210',
  Edi_Mapper_Builder_NestleUsa_ResponseToLoadTender990 = 'Edi_Mapper_Builder_NestleUsa_ResponseToLoadTender990',
  Edi_Mapper_Builder_NestleUsa_StatusMessage214 = 'Edi_Mapper_Builder_NestleUsa_StatusMessage214',
  Edi_Mapper_Builder_Nestle_Invoice210 = 'Edi_Mapper_Builder_Nestle_Invoice210',
  Edi_Mapper_Builder_Niagara_Invoice210 = 'Edi_Mapper_Builder_Niagara_Invoice210',
  Edi_Mapper_Builder_Niagara_StatusMessage214 = 'Edi_Mapper_Builder_Niagara_StatusMessage214',
  Edi_Mapper_Builder_Novolex_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Novolex_ResponseToLoadTender990',
  Edi_Mapper_Builder_OfficeDepot_Invoice210 = 'Edi_Mapper_Builder_OfficeDepot_Invoice210',
  Edi_Mapper_Builder_Omnimax_ScheduledTracking214 = 'Edi_Mapper_Builder_Omnimax_ScheduledTracking214',
  Edi_Mapper_Builder_Omnimax_StatusMessage214 = 'Edi_Mapper_Builder_Omnimax_StatusMessage214',
  Edi_Mapper_Builder_PG_Invoice210 = 'Edi_Mapper_Builder_PG_Invoice210',
  Edi_Mapper_Builder_PG_ResponseToLoadTender990 = 'Edi_Mapper_Builder_PG_ResponseToLoadTender990',
  Edi_Mapper_Builder_PG_StatusMessage214 = 'Edi_Mapper_Builder_PG_StatusMessage214',
  Edi_Mapper_Builder_Peloton_Invoice210 = 'Edi_Mapper_Builder_Peloton_Invoice210',
  Edi_Mapper_Builder_Peloton_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Peloton_ResponseToLoadTender990',
  Edi_Mapper_Builder_Peloton_ScheduledTracking214 = 'Edi_Mapper_Builder_Peloton_ScheduledTracking214',
  Edi_Mapper_Builder_Peloton_StatusMessage214 = 'Edi_Mapper_Builder_Peloton_StatusMessage214',
  Edi_Mapper_Builder_Printpack_Invoice210 = 'Edi_Mapper_Builder_Printpack_Invoice210',
  Edi_Mapper_Builder_Printpack_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Printpack_ResponseToLoadTender990',
  Edi_Mapper_Builder_Printpack_StatusMessage214 = 'Edi_Mapper_Builder_Printpack_StatusMessage214',
  Edi_Mapper_Builder_Ravago_Invoice210 = 'Edi_Mapper_Builder_Ravago_Invoice210',
  Edi_Mapper_Builder_Ravago_StatusMessage214 = 'Edi_Mapper_Builder_Ravago_StatusMessage214',
  Edi_Mapper_Builder_RedClassic_ResponseToLoadTender990 = 'Edi_Mapper_Builder_RedClassic_ResponseToLoadTender990',
  Edi_Mapper_Builder_RedClassic_StatusMessage214 = 'Edi_Mapper_Builder_RedClassic_StatusMessage214',
  Edi_Mapper_Builder_ResponseToLoadTender990 = 'Edi_Mapper_Builder_ResponseToLoadTender990',
  Edi_Mapper_Builder_Shaw_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Shaw_ResponseToLoadTender990',
  Edi_Mapper_Builder_Shaw_ScheduledTracking214 = 'Edi_Mapper_Builder_Shaw_ScheduledTracking214',
  Edi_Mapper_Builder_Shaw_StatusMessage214 = 'Edi_Mapper_Builder_Shaw_StatusMessage214',
  Edi_Mapper_Builder_Staples_Invoice210 = 'Edi_Mapper_Builder_Staples_Invoice210',
  Edi_Mapper_Builder_Staples_StatusMessage214 = 'Edi_Mapper_Builder_Staples_StatusMessage214',
  Edi_Mapper_Builder_Syncada_CampbellSoup_Invoice210 = 'Edi_Mapper_Builder_Syncada_CampbellSoup_Invoice210',
  Edi_Mapper_Builder_Syncada_Invoice210 = 'Edi_Mapper_Builder_Syncada_Invoice210',
  Edi_Mapper_Builder_Syncada_Meritor_Invoice210 = 'Edi_Mapper_Builder_Syncada_Meritor_Invoice210',
  Edi_Mapper_Builder_TMC_Invoice210 = 'Edi_Mapper_Builder_TMC_Invoice210',
  Edi_Mapper_Builder_TMC_ResponseToLoadTender990 = 'Edi_Mapper_Builder_TMC_ResponseToLoadTender990',
  Edi_Mapper_Builder_TMC_ScheduledTracking214 = 'Edi_Mapper_Builder_TMC_ScheduledTracking214',
  Edi_Mapper_Builder_TMC_StatusMessage214 = 'Edi_Mapper_Builder_TMC_StatusMessage214',
  Edi_Mapper_Builder_Target_Dedicated_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Target_Dedicated_ResponseToLoadTender990',
  Edi_Mapper_Builder_Target_Dedicated_ResponseToLoadTender990Nrcl = 'Edi_Mapper_Builder_Target_Dedicated_ResponseToLoadTender990Nrcl',
  Edi_Mapper_Builder_Target_Dedicated_StatusMessage214 = 'Edi_Mapper_Builder_Target_Dedicated_StatusMessage214',
  Edi_Mapper_Builder_Target_Invoice210 = 'Edi_Mapper_Builder_Target_Invoice210',
  Edi_Mapper_Builder_Target_ManualResponseToLoadTender990 = 'Edi_Mapper_Builder_Target_ManualResponseToLoadTender990',
  Edi_Mapper_Builder_Target_ManualShipmentStatus214 = 'Edi_Mapper_Builder_Target_ManualShipmentStatus214',
  Edi_Mapper_Builder_Target_Ratelinx_ManualScheduledStatus214 = 'Edi_Mapper_Builder_Target_Ratelinx_ManualScheduledStatus214',
  Edi_Mapper_Builder_Target_Ratelinx_ManualShipmentStatus214 = 'Edi_Mapper_Builder_Target_Ratelinx_ManualShipmentStatus214',
  Edi_Mapper_Builder_Target_ResponseToLoadTender990Calcartage = 'Edi_Mapper_Builder_Target_ResponseToLoadTender990Calcartage',
  Edi_Mapper_Builder_Tbc_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Tbc_ResponseToLoadTender990',
  Edi_Mapper_Builder_Tbc_ScheduledTracking214 = 'Edi_Mapper_Builder_Tbc_ScheduledTracking214',
  Edi_Mapper_Builder_Tbc_StatusMessage214 = 'Edi_Mapper_Builder_Tbc_StatusMessage214',
  Edi_Mapper_Builder_TraegerGrills_ResponseToLoadTender990 = 'Edi_Mapper_Builder_TraegerGrills_ResponseToLoadTender990',
  Edi_Mapper_Builder_TransplaceX12_Invoice210 = 'Edi_Mapper_Builder_TransplaceX12_Invoice210',
  Edi_Mapper_Builder_TransplaceX12_ResponseToLoadTender990 = 'Edi_Mapper_Builder_TransplaceX12_ResponseToLoadTender990',
  Edi_Mapper_Builder_TransplaceX12_StatusMessage214 = 'Edi_Mapper_Builder_TransplaceX12_StatusMessage214',
  Edi_Mapper_Builder_Transplace_Invoice210 = 'Edi_Mapper_Builder_Transplace_Invoice210',
  Edi_Mapper_Builder_Transplace_ScheduledTracking214 = 'Edi_Mapper_Builder_Transplace_ScheduledTracking214',
  Edi_Mapper_Builder_Transplace_StatusMessage214 = 'Edi_Mapper_Builder_Transplace_StatusMessage214',
  Edi_Mapper_Builder_Unilever_ManualResponseToLoadTender990 = 'Edi_Mapper_Builder_Unilever_ManualResponseToLoadTender990',
  Edi_Mapper_Builder_Unilever_ManualResponseToSpotTender990 = 'Edi_Mapper_Builder_Unilever_ManualResponseToSpotTender990',
  Edi_Mapper_Builder_Unilever_ManualShipmentStatus214 = 'Edi_Mapper_Builder_Unilever_ManualShipmentStatus214',
  Edi_Mapper_Builder_Unilever_Transplace_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Unilever_Transplace_ResponseToLoadTender990',
  Edi_Mapper_Builder_Unilever_Transplace_StatusMessage214 = 'Edi_Mapper_Builder_Unilever_Transplace_StatusMessage214',
  Edi_Mapper_Builder_Upfield_Invoice210 = 'Edi_Mapper_Builder_Upfield_Invoice210',
  Edi_Mapper_Builder_Volvo_Invoice210 = 'Edi_Mapper_Builder_Volvo_Invoice210',
  Edi_Mapper_Builder_Walmart_Invoice210 = 'Edi_Mapper_Builder_Walmart_Invoice210',
  Edi_Mapper_Builder_Walmart_LegacyInvoice210 = 'Edi_Mapper_Builder_Walmart_LegacyInvoice210',
  Edi_Mapper_Builder_Walmart_ResponseToLoadTender990 = 'Edi_Mapper_Builder_Walmart_ResponseToLoadTender990',
  Edi_Mapper_Builder_Walmart_ScheduledTracking214 = 'Edi_Mapper_Builder_Walmart_ScheduledTracking214',
  Edi_Mapper_Builder_Walmart_StatusMessage214 = 'Edi_Mapper_Builder_Walmart_StatusMessage214',
  Edi_Mapper_Builder_Wayfair_Invoice210 = 'Edi_Mapper_Builder_Wayfair_Invoice210',
}

export enum ILegacyParserClassTypes {
  Edi_Mapper_Parser_Abbott204 = 'Edi_Mapper_Parser_Abbott204',
  Edi_Mapper_Parser_Academy204 = 'Edi_Mapper_Parser_Academy204',
  Edi_Mapper_Parser_Agco204 = 'Edi_Mapper_Parser_Agco204',
  Edi_Mapper_Parser_AnheuserBusch204 = 'Edi_Mapper_Parser_AnheuserBusch204',
  Edi_Mapper_Parser_BJ204 = 'Edi_Mapper_Parser_BJ204',
  Edi_Mapper_Parser_Bumblebeefoods204 = 'Edi_Mapper_Parser_Bumblebeefoods204',
  Edi_Mapper_Parser_Burlington204 = 'Edi_Mapper_Parser_Burlington204',
  Edi_Mapper_Parser_CNG204 = 'Edi_Mapper_Parser_CNG204',
  Edi_Mapper_Parser_Carrier214 = 'Edi_Mapper_Parser_Carrier214',
  Edi_Mapper_Parser_Carrier990 = 'Edi_Mapper_Parser_Carrier990',
  Edi_Mapper_Parser_CharterComm204 = 'Edi_Mapper_Parser_CharterComm204',
  Edi_Mapper_Parser_Chep204 = 'Edi_Mapper_Parser_Chep204',
  Edi_Mapper_Parser_ChepBlueYonder204 = 'Edi_Mapper_Parser_ChepBlueYonder204',
  Edi_Mapper_Parser_Costco204 = 'Edi_Mapper_Parser_Costco204',
  Edi_Mapper_Parser_Costco824 = 'Edi_Mapper_Parser_Costco824',
  Edi_Mapper_Parser_CostcoOTM204 = 'Edi_Mapper_Parser_CostcoOTM204',
  Edi_Mapper_Parser_Ecopax204 = 'Edi_Mapper_Parser_Ecopax204',
  Edi_Mapper_Parser_FloorDecor204 = 'Edi_Mapper_Parser_FloorDecor204',
  Edi_Mapper_Parser_GE204 = 'Edi_Mapper_Parser_GE204',
  Edi_Mapper_Parser_GraphicPackaging204 = 'Edi_Mapper_Parser_GraphicPackaging204',
  Edi_Mapper_Parser_Greif204 = 'Edi_Mapper_Parser_Greif204',
  Edi_Mapper_Parser_Henkel204 = 'Edi_Mapper_Parser_Henkel204',
  Edi_Mapper_Parser_Kbx204 = 'Edi_Mapper_Parser_Kbx204',
  Edi_Mapper_Parser_KbxOrderful204 = 'Edi_Mapper_Parser_KbxOrderful204',
  Edi_Mapper_Parser_KraftHeinz204 = 'Edi_Mapper_Parser_KraftHeinz204',
  Edi_Mapper_Parser_Lg204 = 'Edi_Mapper_Parser_Lg204',
  Edi_Mapper_Parser_Manhattan204 = 'Edi_Mapper_Parser_Manhattan204',
  Edi_Mapper_Parser_Manual204 = 'Edi_Mapper_Parser_Manual204',
  Edi_Mapper_Parser_ManualStaples204 = 'Edi_Mapper_Parser_ManualStaples204',
  Edi_Mapper_Parser_ManualUnilever204 = 'Edi_Mapper_Parser_ManualUnilever204',
  Edi_Mapper_Parser_Molson204 = 'Edi_Mapper_Parser_Molson204',
  Edi_Mapper_Parser_Mondelez204 = 'Edi_Mapper_Parser_Mondelez204',
  Edi_Mapper_Parser_Mtd204 = 'Edi_Mapper_Parser_Mtd204',
  Edi_Mapper_Parser_NestleUsa204 = 'Edi_Mapper_Parser_NestleUsa204',
  Edi_Mapper_Parser_Niagara204 = 'Edi_Mapper_Parser_Niagara204',
  Edi_Mapper_Parser_Omnimax204 = 'Edi_Mapper_Parser_Omnimax204',
  Edi_Mapper_Parser_Peloton204 = 'Edi_Mapper_Parser_Peloton204',
  Edi_Mapper_Parser_Pg204 = 'Edi_Mapper_Parser_Pg204',
  Edi_Mapper_Parser_Printpack204 = 'Edi_Mapper_Parser_Printpack204',
  Edi_Mapper_Parser_Ravago204 = 'Edi_Mapper_Parser_Ravago204',
  Edi_Mapper_Parser_RedClassic204 = 'Edi_Mapper_Parser_RedClassic204',
  Edi_Mapper_Parser_Shaw204 = 'Edi_Mapper_Parser_Shaw204',
  Edi_Mapper_Parser_Shipper997 = 'Edi_Mapper_Parser_Shipper997',
  Edi_Mapper_Parser_Stupidedi204 = 'Edi_Mapper_Parser_Stupidedi204',
  Edi_Mapper_Parser_TMC204 = 'Edi_Mapper_Parser_TMC204',
  Edi_Mapper_Parser_Target204 = 'Edi_Mapper_Parser_Target204',
  Edi_Mapper_Parser_TargetCalcartage204 = 'Edi_Mapper_Parser_TargetCalcartage204',
  Edi_Mapper_Parser_TargetDedicated204 = 'Edi_Mapper_Parser_TargetDedicated204',
  Edi_Mapper_Parser_TargetNrcl204 = 'Edi_Mapper_Parser_TargetNrcl204',
  Edi_Mapper_Parser_Tbc204 = 'Edi_Mapper_Parser_Tbc204',
  Edi_Mapper_Parser_TextMessage864 = 'Edi_Mapper_Parser_TextMessage864',
  Edi_Mapper_Parser_Transplace204 = 'Edi_Mapper_Parser_Transplace204',
  Edi_Mapper_Parser_TransplaceX12204 = 'Edi_Mapper_Parser_TransplaceX12204',
  Edi_Mapper_Parser_UnileverTransplace204 = 'Edi_Mapper_Parser_UnileverTransplace204',
  Edi_Mapper_Parser_Walmart204 = 'Edi_Mapper_Parser_Walmart204',
  Edi_Mapper_Parser_Walmart824 = 'Edi_Mapper_Parser_Walmart824',
}

export enum ILineItemTitles {
  /** Bridge Toll */
  bridge_toll = 'bridge_toll',
  /** Circuity Fee */
  circuity_fee = 'circuity_fee',
  /** Cross Dock */
  cross_dock = 'cross_dock',
  /** Deadhead Mileage */
  deadhead_mileage = 'deadhead_mileage',
  /** Deduction Fee */
  deduction_fee = 'deduction_fee',
  /** Detention Fee */
  detention_fee = 'detention_fee',
  /** Driver Assist */
  driver_assist = 'driver_assist',
  /** Driver Loading/Unloading */
  driver_loading_unloading = 'driver_loading_unloading',
  /** ES-Escort Service Fee */
  es_escort_service_fee = 'es_escort_service_fee',
  /** Flat Rate */
  flat_rate = 'flat_rate',
  /** Fuel Surcharge */
  fuel_surcharge = 'fuel_surcharge',
  /** Keep from Freezing */
  keep_from_freezing = 'keep_from_freezing',
  /** Layover Fee */
  layover_fee = 'layover_fee',
  /** Line Haul Rate */
  line_haul_rate = 'line_haul_rate',
  /** Lumper Charge */
  lumper_charge = 'lumper_charge',
  /** Miscellaneous */
  miscellaneous = 'miscellaneous',
  /** OTP/OTD Late Fee */
  otp_otd_late_fee = 'otp_otd_late_fee',
  /** Out of Route Miles Fee */
  out_of_route_miles_fee = 'out_of_route_miles_fee',
  /** Preloading Charge */
  preloading_charge = 'preloading_charge',
  /** Reconsignment Fee */
  reconsignment_fee = 'reconsignment_fee',
  /** Redelivery / Refused Goods */
  redelivery___refused_goods = 'redelivery___refused_goods',
  /** Restack */
  restack = 'restack',
  /** Returned Load */
  returned_load = 'returned_load',
  /** Stop-off Charge */
  stop_off_charge = 'stop_off_charge',
  /** Storage Fee */
  storage_fee = 'storage_fee',
  /** Team Driver */
  team_driver = 'team_driver',
  /** Tier 1 */
  tier_1 = 'tier_1',
  /** TONU */
  tonu = 'tonu',
  /** Trailer Detention Fee */
  trailer_detention_fee = 'trailer_detention_fee',
  /** Truck Ordered Not Used Charge */
  truck_ordered_not_used_charge = 'truck_ordered_not_used_charge',
  /** Up Charge */
  up_charge = 'up_charge',
}

export type ILink = {
  __typename?: 'Link'
  id: Scalars['ID']
  title: Scalars['String']
  url: Scalars['String']
}

export type ILinkInput = {
  title: Scalars['String']
  url: Scalars['String']
}

export type IListPrice = {
  __typename?: 'ListPrice'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  price: Scalars['Float']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum ILoadBoardNames {
  DAT_CONNEXION = 'DAT_CONNEXION',
  TRUCKER_TOOLS = 'TRUCKER_TOOLS',
}

export type ILoadBoardPost = {
  __typename?: 'LoadBoardPost'
  boardName: ILoadBoardNames
  commentsOne?: Maybe<Scalars['String']>
  commentsTwo?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  destinationCity?: Maybe<Scalars['String']>
  destinationStateCode?: Maybe<Scalars['String']>
  equipmentType?: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** False if the DAT rate is $0 or missing */
  includeListRate: Scalars['Boolean']
  originCity?: Maybe<Scalars['String']>
  originStateCode?: Maybe<Scalars['String']>
  pickupDate?: Maybe<Scalars['ISO8601DateTime']>
  postersReferenceId?: Maybe<Scalars['ID']>
  rate?: Maybe<Scalars['Float']>
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy: IUser
}

export type ILocation = {
  __typename?: 'Location'
  address?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  contactEmail?: Maybe<Scalars['String']>
  contactName?: Maybe<Scalars['String']>
  contactPhone?: Maybe<Scalars['String']>
  contactPhoneExt?: Maybe<Scalars['String']>
  countryCode: ICountries
  countryName: Scalars['String']
  id: Scalars['ID']
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  region?: Maybe<IShipmentStopRegionTypes>
  stateCode: Scalars['String']
  stateName: Scalars['String']
  timezone?: Maybe<Scalars['String']>
  zipcode?: Maybe<Scalars['String']>
}

/** Input to filter result(s) by location. Only one of `regions` or `city`/`state_code` is required for LocationFilterInput. */
export type ILocationFilterInput = {
  city?: Maybe<Scalars['String']>
  /**
   * Search by postal codes of the DAT market for `city`/`state_code` pair. This
   * argument will be ignored if `regions` is provided.
   */
  isDatMarketSearch?: Maybe<Scalars['Boolean']>
  /**
   * Radius of area around specified `city`/`state_code` pair. This argument will
   * be ignored if `regions` is provided or `is_dat_market_search` is `true`.
   */
  radius?: Maybe<IRadiusInput>
  regions?: Maybe<Array<IShipmentStopRegionTypes>>
  stateCode?: Maybe<IFederatedStateCodes>
}

export type ILocationInput = {
  address?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  contactEmail?: Maybe<Scalars['String']>
  contactName?: Maybe<Scalars['String']>
  contactPhone?: Maybe<Scalars['String']>
  contactPhoneExt?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  stateCode?: Maybe<Scalars['String']>
  stateName?: Maybe<Scalars['String']>
  zipcode?: Maybe<Scalars['String']>
}

/** Autogenerated input type of ManagePod */
export type IManagePodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  pod?: Maybe<IDocumentInput>
  /** Required if rejecting a POD */
  podRejectionReason?: Maybe<Scalars['String']>
  /** Source of where a POD was uploaded */
  podSourceName?: Maybe<Scalars['String']>
  podStatus?: Maybe<IApprovedRejectedEnum>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of ManagePod */
export type IManagePodPayload = {
  __typename?: 'ManagePodPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export type IMapboxFeature = {
  __typename?: 'MapboxFeature'
  boundingBox?: Maybe<Array<Scalars['Float']>>
  center?: Maybe<Array<Scalars['Float']>>
  context?: Maybe<Array<IMapboxFeatureContext>>
  geometry?: Maybe<IMapboxFeatureGeometry>
  id: Scalars['String']
  placeName?: Maybe<Scalars['String']>
  placeType?: Maybe<Array<Scalars['String']>>
  properties?: Maybe<IMapboxFeatureProperty>
  relevance?: Maybe<Scalars['Int']>
  text?: Maybe<Scalars['String']>
  type: Scalars['String']
}

export type IMapboxFeatureContext = {
  __typename?: 'MapboxFeatureContext'
  countryCode?: Maybe<Scalars['String']>
  countryName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  wikidata?: Maybe<Scalars['String']>
}

export type IMapboxFeatureGeometry = {
  __typename?: 'MapboxFeatureGeometry'
  coordinates?: Maybe<Array<Scalars['Float']>>
  type?: Maybe<Scalars['String']>
}

export type IMapboxFeatureProperty = {
  __typename?: 'MapboxFeatureProperty'
  shortCode?: Maybe<Scalars['String']>
  wikidata?: Maybe<Scalars['String']>
}

/** Autogenerated input type of MarkAllRead */
export type IMarkAllReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of MarkAllRead */
export type IMarkAllReadPayload = {
  __typename?: 'MarkAllReadPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  notifications?: Maybe<Array<INotification>>
}

/** Autogenerated input type of MarkAsRead */
export type IMarkAsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of MarkAsRead */
export type IMarkAsReadPayload = {
  __typename?: 'MarkAsReadPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  notifications?: Maybe<Array<INotification>>
}

/** Autogenerated input type of MarkCarrierTonu */
export type IMarkCarrierTonuInput = {
  carrierAssignmentId: Scalars['ID']
  carrierFee?: Maybe<Scalars['Float']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  internalNotesDescription?: Maybe<Scalars['String']>
  isApproved?: Maybe<Scalars['Boolean']>
  isCustomerRequest?: Maybe<Scalars['Boolean']>
  isOutOfPocket?: Maybe<Scalars['Boolean']>
  outOfPocketReason?: Maybe<Scalars['String']>
  proofOfTonu?: Maybe<IDocumentInput>
  shipmentId: Scalars['ID']
  shipperApprovalState?: Maybe<Scalars['String']>
  shipperFee?: Maybe<Scalars['Float']>
  shipperRejectionReason?: Maybe<Scalars['String']>
}

/** Autogenerated return type of MarkCarrierTonu */
export type IMarkCarrierTonuPayload = {
  __typename?: 'MarkCarrierTonuPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of MarkFacilityPrimary */
export type IMarkFacilityPrimaryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  facilityUuid: Scalars['ID']
}

/** Autogenerated return type of MarkFacilityPrimary */
export type IMarkFacilityPrimaryPayload = {
  __typename?: 'MarkFacilityPrimaryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  facility?: Maybe<IFacility>
}

/** Autogenerated input type of MarkFullTonu */
export type IMarkFullTonuInput = {
  carrierFee?: Maybe<Scalars['Float']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  internalNotesDescription?: Maybe<Scalars['String']>
  isCustomerRequest?: Maybe<Scalars['Boolean']>
  isOutOfPocket?: Maybe<Scalars['Boolean']>
  outOfPocketReason?: Maybe<Scalars['String']>
  proofOfTonu?: Maybe<IDocumentInput>
  shipmentId: Scalars['ID']
  shipperApprovalState?: Maybe<Scalars['String']>
  shipperFee?: Maybe<Scalars['Float']>
  shipperRejectionReason?: Maybe<Scalars['String']>
}

/** Autogenerated return type of MarkFullTonu */
export type IMarkFullTonuPayload = {
  __typename?: 'MarkFullTonuPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of MarkShipmentRolled */
export type IMarkShipmentRolledInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  rescheduleReason: IRolledRescheduleReasons
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of MarkShipmentRolled */
export type IMarkShipmentRolledPayload = {
  __typename?: 'MarkShipmentRolledPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export type IMarket = {
  __typename?: 'Market'
  cityState: Scalars['String']
}

export type IMarketInsight = {
  __typename?: 'MarketInsight'
  changeLastFourteenDays: Scalars['Float']
  changeLastSevenDays: Scalars['Float']
  changeLastThirtyDays: Scalars['Float']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  datCityState: Scalars['String']
  id: Scalars['ID']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IMarketInsightEquipmentKeyTypes {
  /** Dry van */
  dry_van = 'dry_van',
}

export type IMatchedFacilities = {
  __typename?: 'MatchedFacilities'
  allUuids?: Maybe<Array<Scalars['ID']>>
  bestMatch?: Maybe<IFacility>
  otherMatches?: Maybe<Array<IFacility>>
  totalCount: Scalars['Int']
}

export type IMatchedVendorKeyword = {
  __typename?: 'MatchedVendorKeyword'
  keyword?: Maybe<IVendorKeyword>
  vendor?: Maybe<IVendor>
}

export type IMeasurement = {
  __typename?: 'Measurement'
  /** Miles to point */
  miles?: Maybe<Scalars['Float']>
  /** Estimated seconds to point */
  seconds?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of MergeFacilitiesToPrimary */
export type IMergeFacilitiesToPrimaryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  facilitiesToMergeUuid: Array<Scalars['ID']>
  primaryFacilityUuid: Scalars['ID']
}

/** Autogenerated return type of MergeFacilitiesToPrimary */
export type IMergeFacilitiesToPrimaryPayload = {
  __typename?: 'MergeFacilitiesToPrimaryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  mergedFacilities?: Maybe<Array<IFacilityWithErrorsAndNotices>>
  primaryFacility?: Maybe<IFacility>
}

/** Autogenerated input type of MergeFacilityToPrimary */
export type IMergeFacilityToPrimaryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  facilityToMergeUuid: Scalars['ID']
  primaryFacilityUuid: Scalars['ID']
}

/** Autogenerated return type of MergeFacilityToPrimary */
export type IMergeFacilityToPrimaryPayload = {
  __typename?: 'MergeFacilityToPrimaryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  mergedFacility?: Maybe<IFacility>
  notices: Array<IError>
  primaryFacility?: Maybe<IFacility>
}

export type IMergedFacility = {
  __typename?: 'MergedFacility'
  contacts: Array<IRecordMergeFacilityContactsField>
  facility: IFacility
  facilityType: IRecordMergeFacilityTypeField
  hours: IRecordMergeFacilityScheduleHours
  identifiers: IRecordMergeFacilityIdentifiersField
  isHighRisk: IRecordMergeBooleanField
  location: IRecordMergeFacilityLocationField
  metadata?: Maybe<IRecordMergeFacilityMetadataField>
  name: IRecordMergeStringField
  note: IRecordMergeStringField
  numberOfDocks: IRecordMergeIntField
  schedule?: Maybe<IRecordMergeFacilityScheduleField>
  shipperApplication?: Maybe<IShipperApplication>
  shipperFacility?: Maybe<IShipperFacility>
  vendor?: Maybe<IVendor>
  vendorFacility?: Maybe<IVendorFacility>
  vendorShipperFacility?: Maybe<IVendorShipperFacility>
}

/** The connection type for MergedFacility. */
export type IMergedFacilityConnection = {
  __typename?: 'MergedFacilityConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IMergedFacilityEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IMergedFacility>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IMergedFacilityEdge = {
  __typename?: 'MergedFacilityEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IMergedFacility>
}

export type IMetrics = {
  __typename?: 'Metrics'
  /** Bounce Percentage of the last 30 calendar days */
  bouncePercentage?: Maybe<Scalars['Int']>
  /** On Time Delivery Percentage of the last 30 calendar days */
  otdPercentage?: Maybe<Scalars['Int']>
  /** On Time Pickup Percentage of the last 30 calendar days */
  otpPercentage?: Maybe<Scalars['Int']>
  /** Shipment Delivered in the last 30 calendar days */
  shipmentCount?: Maybe<Scalars['Int']>
}

export type IMileageCriteria = {
  __typename?: 'MileageCriteria'
  id: Scalars['ID']
  rangeEnd?: Maybe<Scalars['String']>
  rangeStart?: Maybe<Scalars['String']>
}

export type IMotorCarrierComplianceFlag = {
  __typename?: 'MotorCarrierComplianceFlag'
  /** Motor carrier associated with the assessment */
  carrierApplication: ICarrierApplication
  complianceFlag: IComplianceFlag
  deprecatedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
}

export type IMotorCarrierInsuranceContact = {
  __typename?: 'MotorCarrierInsuranceContact'
  /** The ID of the associated carrier application. */
  carrierApplicationId: Scalars['ID']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** DeletedAt timestamp in UTC */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** Contact email of the insurance agent */
  email: Scalars['String']
  /** Full name of the insurance agent */
  fullName: Scalars['String']
  /** The motor carrier insurance contacts table primary key identifier. */
  id: Scalars['ID']
  /** Insurance documents attached to this contact */
  insuranceDocuments?: Maybe<Array<Scalars['JSON']>>
  /** Name of the insurance organizations/company */
  organizationName: Scalars['String']
  /** Contact phone number of the insurance agent */
  phoneNumber: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IMotorCarrierInsuranceContactInput = {
  carrierApplicationId: Scalars['ID']
  email: Scalars['String']
  fullName: Scalars['String']
  insuranceDocuments?: Maybe<Array<IDocumentInput>>
  organizationName: Scalars['String']
  phoneNumber: Scalars['String']
}

export type IMotorCarrierTransfixRule = {
  __typename?: 'MotorCarrierTransfixRule'
  /** Primary key identifier */
  id: Scalars['ID']
  /** Key reference from source */
  key: Scalars['String']
  /** Name of the rule */
  name: Scalars['String']
}

export type IMotorCarrierTransfixRulesAssessment = {
  __typename?: 'MotorCarrierTransfixRulesAssessment'
  /** Motor carrier associated with the assessment */
  carrierApplication: ICarrierApplication
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** Primary key identifier */
  id: Scalars['ID']
  /** Any overrides present for this relationship */
  override?: Maybe<IRulesAssessmentOverride>
  /** The result of the rule evaluation */
  result: Scalars['String']
  /** Motor carrier transfix rule associated with this record */
  rule: IMotorCarrierTransfixRule
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** Item in a list of motor carrier ids */
export type IMotorCarriersInput = {
  dotNumber?: Maybe<Scalars['ID']>
  mcNumber?: Maybe<Scalars['ID']>
}

export type IMultiStopLegDatObjects = {
  __typename?: 'MultiStopLegDatObjects'
  deliveryPostalCode?: Maybe<Scalars['String']>
  estimatedAllInTotal?: Maybe<Scalars['Float']>
  miles?: Maybe<Scalars['Float']>
  pickupPostalCode?: Maybe<Scalars['String']>
}

export type IMutation = {
  __typename?: 'Mutation'
  acceptInboundBid?: Maybe<IAcceptInboundBidPayload>
  acceptOutboundBid?: Maybe<IAcceptOutboundBidPayload>
  acceptShipment?: Maybe<IAcceptShipmentPayload>
  /** Activate an existing certificate. Only 1 certificate can be active for each connection. */
  activateAs2Certificate?: Maybe<IActivateAs2CertificatePayload>
  /** Make an existing builder version live */
  activateConfigurableBuilderVersion?: Maybe<IActivateConfigurableBuilderVersionPayload>
  addDocumentToNote?: Maybe<IAddDocumentToNotePayload>
  addReply?: Maybe<IAddReplyPayload>
  addShipmentStop?: Maybe<IAddShipmentStopPayload>
  allowClaimsBilling?: Maybe<IAllowClaimsBillingPayload>
  allowClaimsInvoicing?: Maybe<IAllowClaimsInvoicingPayload>
  approveComplianceCoverReview?: Maybe<IApproveComplianceCoverReviewPayload>
  assignFacilityVendor?: Maybe<IAssignFacilityVendorPayload>
  /** Assigns all active tasks for passed namespace and shipment to the passed `assignedToId` user */
  assignShipmentActiveTasks?: Maybe<IAssignShipmentActiveTasksPayload>
  assignTrailerToShipment?: Maybe<IAssignTrailerToShipmentPayload>
  bounceCarrier?: Maybe<IBounceCarrierPayload>
  bulkUpdateRfpLanesAndPrices?: Maybe<IBulkUpdateRfpLanesAndPricesPayload>
  cancelShipment?: Maybe<ICancelShipmentPayload>
  cancelShipmentActiveTasks?: Maybe<ICancelShipmentActiveTasksPayload>
  closeBillCreditNow?: Maybe<ICloseBillCreditNowPayload>
  closeBillNow?: Maybe<ICloseBillNowPayload>
  closeInvoiceCreditNow?: Maybe<ICloseInvoiceCreditNowPayload>
  closeInvoiceNow?: Maybe<ICloseInvoiceNowPayload>
  closeRfp?: Maybe<ICloseRfpPayload>
  coverShipment?: Maybe<ICoverShipmentPayload>
  createAppointmentConfirmationRule?: Maybe<ICreateAppointmentConfirmationRulePayload>
  /** Create a new AS2 certificate for a connection. */
  createAs2Certificate?: Maybe<ICreateAs2CertificatePayload>
  createAttachedDocument?: Maybe<ICreateAttachedDocumentPayload>
  createBid?: Maybe<ICreateBidPayload>
  createBidApproval?: Maybe<ICreateBidApprovalPayload>
  createCarrierApplication?: Maybe<ICreateCarrierApplicationPayload>
  createCarrierApplicationBca?: Maybe<ICreateCarrierApplicationBcaPayload>
  createCarrierUser?: Maybe<ICreateCarrierUserPayload>
  /**
   * Create a new config group. This is one of two pieces needed to help route
   * outbound messages based on the ISA Sender ID we get from a shipper.
   */
  createConfigGroup?: Maybe<ICreateConfigGroupPayload>
  /**
   * Create a new config group mapping. This will tell us which config group to
   * associate with and which inbound connection config and ISA sender ID to use
   */
  createConfigGroupMapping?: Maybe<ICreateConfigGroupMappingPayload>
  /** Creates a new builder */
  createConfigurableBuilder?: Maybe<ICreateConfigurableBuilderPayload>
  /** Creates a new test for a configurable builder */
  createConfigurableBuilderTest?: Maybe<ICreateConfigurableBuilderTestPayload>
  /** Creates a new version of a builder */
  createConfigurableBuilderVersion?: Maybe<ICreateConfigurableBuilderVersionPayload>
  createCounterBid?: Maybe<ICreateCounterBidPayload>
  createDriverLocation?: Maybe<ICreateDriverLocationPayload>
  createDriverLocations?: Maybe<ICreateDriverLocationsPayload>
  createEdiChargeCode?: Maybe<ICreateEdiChargeCodePayload>
  /** Create a new AS2 inbound connection config. */
  createEdiInboundAs2ConnectionConfig?: Maybe<ICreateInboundAs2ConnectionConfigPayload>
  /** Create a new FTP or SFTP inbound connection config. */
  createEdiInboundFtpConnectionConfig?: Maybe<ICreateInboundFtpConnectionConfigPayload>
  /** Create a new AS2 outbound connection config. */
  createEdiOutboundAs2ConnectionConfig?: Maybe<ICreateOutboundAs2ConnectionConfigPayload>
  /** Create a new FTP or SFTP outbound connection config. */
  createEdiOutboundFtpConnectionConfig?: Maybe<ICreateOutboundFtpConnectionConfigPayload>
  createGroup?: Maybe<ICreateGroupPayload>
  /**
   * Create a new inbound edi message type. This means Transfix is able to receive
   * this message type from the given inbound config.
   */
  createInboundEdiMessageType?: Maybe<ICreateInboundEdiMessagePayload>
  /** Create a new inbound file router config. */
  createInboundFileRouterConfig?: Maybe<ICreateInboundFileRouterConfigPayload>
  createIssueAutomationRule?: Maybe<ICreateIssueAutomationRulePayload>
  createMiscellaneousDocument?: Maybe<ICreateMiscellaneousDocumentPayload>
  createMotorCarrierComplianceFlag?: Maybe<ICreateMotorCarrierComplianceFlagPayload>
  createMotorCarrierInsuranceContacts?: Maybe<ICreateMotorCarrierInsuranceContactsPayload>
  createNote?: Maybe<ICreateNotePayload>
  /**
   * Create a new outbound edi message type. This means Transfix is able to send a
   * given message type to a given outbound config.
   */
  createOutboundEdiMessageType?: Maybe<ICreateOutboundEdiMessagePayload>
  createQuickRequest?: Maybe<ICreateQuickRequestPayload>
  createRescheduleRequests?: Maybe<ICreateRescheduleRequestsPayload>
  createRulesAssessmentOverrides?: Maybe<ICreateRulesAssessmentOverridesPayload>
  createSafetyLetter?: Maybe<ICreateSafetyLetterPayload>
  createSendPushNotificationJob?: Maybe<ICreateSendPushNotificationJobPayload>
  createShipment?: Maybe<ICreateShipmentPayload>
  createShipmentAccessorial?: Maybe<ICreateShipmentAccessorialPayload>
  createShipmentIssue?: Maybe<ICreateShipmentIssuePayload>
  createShipper?: Maybe<ICreateShipperPayload>
  createShipperAutoAcceptRejectRules?: Maybe<IUpsertShipperAutoAcceptRejectConfigurationPayload>
  createShipperFacilityLane?: Maybe<ICreateShipperFacilityLanePayload>
  createShipperFacilityTrailerPool?: Maybe<ICreateShipperFacilityTrailerPoolPayload>
  createSmsMessage?: Maybe<ICreateSmsMessagePayload>
  createSourcedCarrierRate?: Maybe<ICreateSourcedCarrierRatePayload>
  createSpfIntegration?: Maybe<ICreateSpfIntegrationPayload>
  createTrailer?: Maybe<ICreateTrailerPayload>
  createVendor?: Maybe<ICreateVendorPayload>
  declineBid?: Maybe<IDeclineBidPayload>
  declineCarrierShipment?: Maybe<IDeclineCarrierShipmentPayload>
  deleteCarrierCertification?: Maybe<IDeleteCarrierCertificationPayload>
  deleteEdiChargeCode?: Maybe<IDeleteEdiChargeCodePayload>
  deleteIssueAutomationRule?: Maybe<IDeleteIssueAutomationRulePayload>
  deleteRescheduleRequest?: Maybe<IDeleteRescheduleRequestPayload>
  deleteShipmentAccessorial?: Maybe<IDeleteShipmentAccessorialPayload>
  deleteShipmentAccessorialDocuments?: Maybe<IDeleteShipmentAccessorialDocumentsPayload>
  deleteShipmentStop?: Maybe<IDeleteShipmentStopPayload>
  deleteShipperFacilityLane?: Maybe<IDeleteShipperFacilityLanePayload>
  deleteShipperFacilityTrailerPool?: Maybe<IDeleteShipperFacilityTrailerPoolPayload>
  deleteShipperFuelMatrix?: Maybe<IDeleteShipperFuelMatrixPayload>
  deleteShipperFuelPaddMapping?: Maybe<IDeleteShipperFuelPaddMappingPayload>
  deleteShipperKpiTrackingConfiguration?: Maybe<IDeleteShipperKpiTrackingConfigurationPayload>
  deleteSourcedCarrierRate?: Maybe<IDeleteSourcedCarrierRatePayload>
  deleteSpfIntegration?: Maybe<IDeleteSpfIntegrationPayload>
  deleteUserFilterPreference?: Maybe<IDeleteUserFilterPreferencePayload>
  deleteVendor?: Maybe<IDeleteVendorPayload>
  dispatchShipment?: Maybe<IDispatchShipmentPayload>
  editVendor?: Maybe<IEditVendorPayload>
  editVendorKeywords?: Maybe<IEditVendorKeywordsPayload>
  exportShipperRateCarrierCallList?: Maybe<IExportShipperRateCarrierCallListPayload>
  generateDetentionLink?: Maybe<IGenerateDetentionLinkPayload>
  /** get associated warnings for a configurable builder */
  getConfigurableBuilderWarnings?: Maybe<IGetConfigurableBuilderWarningsPayload>
  /** get serialized json data to use for testing a new builder */
  getSerializedJson?: Maybe<IGetSerializedJsonPayload>
  holdShipment?: Maybe<IHoldShipmentPayload>
  /**
   * Mutation to upload, approve, and reject POD on a shipment.
   *         These actions can be performed simultaneously or separately
   */
  managePod?: Maybe<IManagePodPayload>
  markAllRead?: Maybe<IMarkAllReadPayload>
  markAsRead?: Maybe<IMarkAsReadPayload>
  markCarrierTonu?: Maybe<IMarkCarrierTonuPayload>
  markFacilityPrimary?: Maybe<IMarkFacilityPrimaryPayload>
  markFullTonu?: Maybe<IMarkFullTonuPayload>
  markShipmentRolled?: Maybe<IMarkShipmentRolledPayload>
  mergeFacilitiesToPrimary?: Maybe<IMergeFacilitiesToPrimaryPayload>
  mergeFacilityToPrimary?: Maybe<IMergeFacilityToPrimaryPayload>
  offerShipment?: Maybe<IOfferShipmentPayload>
  reOfferWaterfallToCarrier?: Maybe<IReOfferWaterfallPayload>
  reactivateDeclinedBid?: Maybe<IReactivateDeclinedBidPayload>
  rearrangeShipmentStops?: Maybe<IRearrangeShipmentStopsPayload>
  refreshHighwayData?: Maybe<IRefreshHighwayDataPayload>
  regenerateInvoice?: Maybe<IRegenerateInvoicePayload>
  /** Mutation to rejected an approved POD on a shipment. */
  rejectApprovedPod?: Maybe<IRejectApprovedPodPayload>
  rejectComplianceCoverReview?: Maybe<IRejectComplianceCoverReviewPayload>
  removeCarrierTonu?: Maybe<IRemoveCarrierTonuPayload>
  /** Explicitly move a shipment back into the assigned state from dispatched */
  removeDispatch?: Maybe<IRemoveDispatchPayload>
  /** Remove TONU status when shipment is in TONU status and all bills and invoices are open */
  removeTonu?: Maybe<IRemoveTonuPayload>
  reprintInvoice?: Maybe<IReprintInvoicePayload>
  reprintRateConfirmation?: Maybe<IReprintRateConfirmationPayload>
  requestCarrierApproval?: Maybe<IRequestCarrierApprovalPayload>
  resend214?: Maybe<IResend214Payload>
  /** given a csv of invoices, trigger all of them to be resent */
  resendInvoices?: Maybe<IResendInvoicesPayload>
  resetShipmentWaterfall?: Maybe<IResetShipmentWaterfallPayload>
  reviewFacilityAddress?: Maybe<IReviewFacilityAddressPayload>
  revokeCarrierTonuApproval?: Maybe<IRevokeCarrierTonuApprovalPayload>
  rfpExportData?: Maybe<IRfpExportDataPayload>
  rfpImportLanesData?: Maybe<IRfpImportLanesDataPayload>
  /** test builder that is under development */
  runConfigurableBuilder?: Maybe<IRunConfigurableBuilderPayload>
  /** test builder using tests existing in db */
  runConfigurableBuilderTests?: Maybe<IRunConfigurableBuilderTestsPayload>
  /** Soft deletes parent and child users */
  selfDeleteParentUser?: Maybe<ISelfDeleteParentUserPayload>
  sendShipmentOfferToCarrier?: Maybe<ISendShipmentOfferToCarrierPayload>
  /** send sms for given a relay_payments_code to the driver */
  sendSmsRelayPayments?: Maybe<ISendSmsRelayPaymentsPayload>
  /** Create or delete carrier/transfix-user relationships. */
  setCarrierRelationships?: Maybe<ISetCarrierRelationshipsPayload>
  setLatestUserAvailabilitiesFilterPreferences?: Maybe<
    ISetLatestUserAvailabilitiesFilterPreferencePayload
  >
  setNotifiedEscalatedShipmentIssues?: Maybe<ISetNotifiedEscalatedShipmentIssuesPayload>
  setShipmentIssuesFilterPreferences?: Maybe<ISetShipmentIssuesFilterPreferencePayload>
  setShipmentTaskCap?: Maybe<ISetShipmentTaskCapPayload>
  setShipperAppointmentPreference?: Maybe<ISetShipperAppointmentPreferencePayload>
  /** Set Transfix team details for shipper. */
  setShipperRelationships?: Maybe<ISetShipperRelationshipsPayload>
  setShipperTenderAppointmentConfiguration?: Maybe<ISetShipperTenderAppointmentConfigurationPayload>
  setTaskedShipmentFilterPreferences?: Maybe<ISetTaskedShipmentFilterPreferencePayload>
  shipperApproveShipmentAccessorial?: Maybe<IShipperApproveShipmentAccessorialPayload>
  shipperRejectShipmentAccessorial?: Maybe<IShipperRejectShipmentAccessorialPayload>
  signRateConfirmation?: Maybe<ISignRateConfirmationPayload>
  skipShipmentWaterfallCarrier?: Maybe<ISkipShipmentWaterfallCarrierPayload>
  snoozeShipmentActiveTasks?: Maybe<ISnoozeShipmentActiveTasksPayload>
  /** soft deletes a relay_payments_code record */
  softDeleteRelayPaymentsCode?: Maybe<ISoftDeleteRelayPaymentsCodePayload>
  /** create files for staging testing */
  stagingTestingCreateOutboundFiles?: Maybe<ICreateOutboundFilesPayload>
  /** delete unneeded outbound files */
  stagingTestingDeleteOutboundFiles?: Maybe<IDeleteOutboundFilesPayload>
  /** Download Inbound SFTP file for Staging Env */
  stagingTestingDownloadSftpFiles?: Maybe<IDownloadSftpFilesPayload>
  /** List Inbound SFTP files for Staging Env */
  stagingTestingGetInboundSftpFiles?: Maybe<IGetInboundSftpFilesPayload>
  /** staging testing upload files */
  stagingTestingUploadOutboundFiles?: Maybe<IUploadOutboundFilesPayload>
  startPhoneCall?: Maybe<IStartPhoneCallPayload>
  syncBillWithTriumphpay?: Maybe<ISyncBillWithTriumphpayPayload>
  /** Update carrier data with data from Highway */
  syncHighwayDataIntoCarrier?: Maybe<ISyncHighwayDataIntoCarrierPayload>
  tenderShipment?: Maybe<ITenderShipmentPayload>
  /** send a test file to the partner's AS2 server and verify that the connection is set up correctly. */
  testAs2ConnectionConfigOutbound?: Maybe<ITestAs2ConnectionConfigOutboundPayload>
  /** test connecting to partner's s/ftp server. */
  testFtpConnectionConfig?: Maybe<ITestFtpConnectionConfigPayload>
  /** Unassigns all active tasks for passed namespace for shipments that were assigned automatically */
  unassignAllShipmentActiveTasks?: Maybe<IUnassignAllShipmentActiveTasksPayload>
  unassignFacilityVendor?: Maybe<IUnassignFacilityVendorPayload>
  unassignTrailerFromShipment?: Maybe<IUnassignTrailerFromShipmentPayload>
  /** Move a shipment in canceled state to on_hold and bounce carrier if present */
  uncancelShipment?: Maybe<IUncancelShipmentPayload>
  undeliverShipment?: Maybe<IUndeliverShipmentPayload>
  unmarkFacilityPrimary?: Maybe<IUnmarkFacilityPrimaryPayload>
  unmarkShipmentRolled?: Maybe<IUnmarkShipmentRolledPayload>
  unsnoozeShipmentActiveTasks?: Maybe<IUnsnoozeShipmentActiveTasksPayload>
  /** Update an existing AS2 certificate. Note: There is a separate mutation to make the certificate active. */
  updateAs2Certificate?: Maybe<IUpdateAs2CertificatePayload>
  updateAssignedFacilityVendor?: Maybe<IUpdateAssignedFacilityVendorPayload>
  updateBid?: Maybe<IUpdateBidPayload>
  updateBidApprovalState?: Maybe<IUpdateBidApprovalStatePayload>
  updateCarrierApplicationState?: Maybe<IUpdateCarrierApplicationStatePayload>
  updateCarrierAssignment?: Maybe<IUpdateCarrierAssignmentPayload>
  updateCarrierCertification?: Maybe<IUpdateCarrierCertificationPayload>
  updateCarrierCompanyInformation?: Maybe<IUpdateCarrierCompanyInformationPayload>
  updateCarrierDedicatedLaneRatePreference?: Maybe<IUpdateCarrierDedicatedLaneRatePreferencePayload>
  updateCarrierEndorsements?: Maybe<IUpdateCarrierEndorsementsPayload>
  updateCarrierEquipmentCapability?: Maybe<IUpdateCarrierEquipmentCapabilityPayload>
  updateCarrierExcludedCommodities?: Maybe<IUpdateCarrierExcludedCommoditiesPayload>
  updateCarrierFreightCapability?: Maybe<IUpdateCarrierFreightCapabilityPayload>
  updateCarrierHeadquater?: Maybe<IUpdateHeadquarterPayload>
  updateCarrierLoadingCapability?: Maybe<IUpdateCarrierLoadingCapabilityPayload>
  updateCarrierRateTypePreference?: Maybe<IUpdateCarrierRateTypePreferencePayload>
  updateCarrierSmartWayRegistration?: Maybe<IUpdateCarrierSmartWayRegistrationPayload>
  updateCarrierTonu?: Maybe<IUpdateCarrierTonuPayload>
  /** Update an existing config group */
  updateConfigGroup?: Maybe<IUpdateConfigGroupPayload>
  /** Update an existing config group mapping */
  updateConfigGroupMapping?: Maybe<IUpdateConfigGroupMappingPayload>
  /** Update an existing builder */
  updateConfigurableBuilder?: Maybe<IUpdateConfigurableBuilderPayload>
  /** Update an existing test for a builder */
  updateConfigurableBuilderTest?: Maybe<IUpdateConfigurableBuilderTestPayload>
  /** Update an existing builder version */
  updateConfigurableBuilderVersion?: Maybe<IUpdateConfigurableBuilderVersionPayload>
  updateDispatcher?: Maybe<IUpdateDispatcherPayload>
  updateDriver?: Maybe<IUpdateDriverPayload>
  updateEdiChargeCode?: Maybe<IUpdateEdiChargeCodePayload>
  /** Update an existing AS2 inbound connection config. */
  updateEdiInboundAs2ConnectionConfig?: Maybe<IUpdateInboundAs2ConnectionConfigPayload>
  /** Create a new FTP or SFTP inbound connection config. */
  updateEdiInboundFtpConnectionConfig?: Maybe<IUpdateInboundFtpConnectionConfigPayload>
  /** Update an existing AS2 outbound connection config. */
  updateEdiOutboundAs2ConnectionConfig?: Maybe<IUpdateOutboundAs2ConnectionConfigPayload>
  /** Create a new FTP or SFTP outbound connection config. */
  updateEdiOutboundFtpConnectionConfig?: Maybe<IUpdateOutboundFtpConnectionConfigPayload>
  updateGlobalRfpStrategies?: Maybe<IUpdateGlobalRfpStrategiesPayload>
  updateGroup?: Maybe<IUpdateGroupPayload>
  /** Update an existing inbound edi message type. */
  updateInboundEdiMessageType?: Maybe<IUpdateInboundEdiMessagePayload>
  /** Update an inbound file router config. */
  updateInboundFileRouterConfig?: Maybe<IUpdateInboundFileRouterConfigPayload>
  updateIssueAutomationRule?: Maybe<IUpdateIssueAutomationRulePayload>
  updateLocalRfpStrategies?: Maybe<IUpdateLocalRfpStrategiesPayload>
  updateNormFile?: Maybe<IUpdateNormFilePayload>
  updateNormFileGeneratorRowStatuses?: Maybe<IUpdateNormFileGeneratorRowStatusesPayload>
  updateNote?: Maybe<IUpdateNotePayload>
  /** Update an existing outbound edi message type. */
  updateOutboundEdiMessageType?: Maybe<IUpdateOutboundEdiMessagePayload>
  updatePriceRequestQuote?: Maybe<IUpdatePriceRequestQuotePayload>
  /** Updates a shipment's proof of TONU for an already-marked full TONU */
  updateProofOfTonu?: Maybe<IUpdateProofOfTonuPayload>
  updateRates?: Maybe<IUpdateRatesPayload>
  updateRfpLaneData?: Maybe<IUpdateRfpLaneDataPayload>
  updateRfpLanesAndPrices?: Maybe<IUpdateRfpLanesAndPricesPayload>
  updateScraperJobConfigurations?: Maybe<IUpdateScraperJobConfigurationsPayload>
  updateShipment?: Maybe<IUpdateShipmentPayload>
  updateShipmentAccessorial?: Maybe<IUpdateShipmentAccessorialPayload>
  updateShipmentCmTarget?: Maybe<IUpdateShipmentCmTargetPayload>
  updateShipmentContactPreference?: Maybe<IUpdateShipmentContactPreferencePayload>
  updateShipmentContactPreferenceCarrierContactInstructions?: Maybe<
    IUpdateShipmentContactPreferenceCarrierContactInstructionsPayload
  >
  updateShipmentEquipment?: Maybe<IUpdateShipmentEquipmentPayload>
  updateShipmentIssue?: Maybe<IUpdateShipmentIssuePayload>
  updateShipmentListPrice?: Maybe<IUpdateShipmentListPricePayload>
  updateShipmentOpsRep?: Maybe<IUpdateShipmentOpsRepPayload>
  updateShipmentStop?: Maybe<IUpdateShipmentStopPayload>
  updateShipmentStopManualEta?: Maybe<IUpdateShipmentStopManualEtaPayload>
  updateShipmentStops?: Maybe<IUpdateShipmentStopsPayload>
  /** Update the arrival/departure times of one/many shipment stops on a single shipment */
  updateShipmentStopsArrivalDeparture?: Maybe<IUpdateShipmentStopsArrivalDeparturePayload>
  /** Update an existing shipper application edi config. */
  updateShipperApplicationEdiConfig?: Maybe<IUpdateShipperApplicationEdiConfigPayload>
  updateShipperApplicationTracking?: Maybe<IUpdateShipperApplicationTrackingPayload>
  updateShipperBrokerPod?: Maybe<IUpdateShipperBrokerPodPayload>
  updateShipperFacilityLane?: Maybe<IUpdateShipperFacilityLanePayload>
  updateShipperFacilityTrailerPool?: Maybe<IUpdateShipperFacilityTrailerPoolPayload>
  updateShipperOnboardingEdiConfiguration?: Maybe<IUpdateShipperOnboardingEdiConfigurationPayload>
  updateShipperRate?: Maybe<IUpdateShipperRatePayload>
  updateSourcedCarrierRate?: Maybe<IUpdateSourcedCarrierRatePayload>
  updateSpfIntegration?: Maybe<IUpdateSpfIntegrationPayload>
  updateTasks?: Maybe<IUpdateTasksPayload>
  updateTrailer?: Maybe<IUpdateTrailerPayload>
  updateTransfixHighwayInsurancePolicyFlag?: Maybe<IUpdateTransfixHighwayInsurancePolicyFlagPayload>
  updateUserAvailability?: Maybe<IUpdateUserAvailabilityPayload>
  uploadAward?: Maybe<IUploadAwardPayload>
  uploadW9Form?: Maybe<IUploadW9FormPayload>
  upsertAs2ConnectionConfig?: Maybe<IUpsertAs2ConnectionConfigPayload>
  upsertFuelRateConfig?: Maybe<IUpsertFuelRateConfigPayload>
  upsertShipperAutoAcceptRejectConfiguration?: Maybe<
    IUpsertShipperAutoAcceptRejectConfigurationPayload
  >
  upsertShipperAwardEstimationConfiguration?: Maybe<
    IUpsertShipperAwardEstimationConfigurationPayload
  >
  upsertShipperContacts?: Maybe<IUpsertShipperContactsPayload>
  upsertShipperDropTrailersConfiguration?: Maybe<IUpsertShipperDropTrailersConfigurationPayload>
  upsertShipperFuelMatrix?: Maybe<IUpsertShipperFuelMatrixPayload>
  upsertShipperFuelPaddMapping?: Maybe<IUpsertShipperFuelPaddMappingPayload>
  upsertShipperKpiLinks?: Maybe<IUpsertShipperKpiLinksPayload>
  upsertShipperKpiTrackingConfiguration?: Maybe<IUpsertShipperKpiTrackingConfigurationPayload>
  upsertShipperOnboardingKpiConfiguration?: Maybe<IUpsertShipperOnboardingKpiConfigurationPayload>
  upsertShipperTrueRateConfiguration?: Maybe<IUpsertShipperTrueRateConfigurationPayload>
  verifyParentUser?: Maybe<IVerifyParentUserPayload>
}

export type IMutationAcceptInboundBidArgs = {
  input: IAcceptInboundBidInput
}

export type IMutationAcceptOutboundBidArgs = {
  input: IAcceptOutboundBidInput
}

export type IMutationAcceptShipmentArgs = {
  input: IAcceptShipmentInput
}

export type IMutationActivateAs2CertificateArgs = {
  input: IActivateAs2CertificateInput
}

export type IMutationActivateConfigurableBuilderVersionArgs = {
  input: IActivateConfigurableBuilderVersionInput
}

export type IMutationAddDocumentToNoteArgs = {
  input: IAddDocumentToNoteInput
}

export type IMutationAddReplyArgs = {
  input: IAddReplyInput
}

export type IMutationAddShipmentStopArgs = {
  input: IAddShipmentStopInput
}

export type IMutationAllowClaimsBillingArgs = {
  input: IAllowClaimsBillingInput
}

export type IMutationAllowClaimsInvoicingArgs = {
  input: IAllowClaimsInvoicingInput
}

export type IMutationApproveComplianceCoverReviewArgs = {
  input: IApproveComplianceCoverReviewInput
}

export type IMutationAssignFacilityVendorArgs = {
  input: IAssignFacilityVendorInput
}

export type IMutationAssignShipmentActiveTasksArgs = {
  input: IAssignShipmentActiveTasksInput
}

export type IMutationAssignTrailerToShipmentArgs = {
  input: IAssignTrailerToShipmentInput
}

export type IMutationBounceCarrierArgs = {
  input: IBounceCarrierInput
}

export type IMutationBulkUpdateRfpLanesAndPricesArgs = {
  input: IBulkUpdateRfpLanesAndPricesInput
}

export type IMutationCancelShipmentArgs = {
  input: ICancelShipmentInput
}

export type IMutationCancelShipmentActiveTasksArgs = {
  input: ICancelShipmentActiveTasksInput
}

export type IMutationCloseBillCreditNowArgs = {
  input: ICloseBillCreditNowInput
}

export type IMutationCloseBillNowArgs = {
  input: ICloseBillNowInput
}

export type IMutationCloseInvoiceCreditNowArgs = {
  input: ICloseInvoiceCreditNowInput
}

export type IMutationCloseInvoiceNowArgs = {
  input: ICloseInvoiceNowInput
}

export type IMutationCloseRfpArgs = {
  input: ICloseRfpInput
}

export type IMutationCoverShipmentArgs = {
  input: ICoverShipmentInput
}

export type IMutationCreateAppointmentConfirmationRuleArgs = {
  input: ICreateAppointmentConfirmationRuleInput
}

export type IMutationCreateAs2CertificateArgs = {
  input: ICreateAs2CertificateInput
}

export type IMutationCreateAttachedDocumentArgs = {
  input: ICreateAttachedDocumentInput
}

export type IMutationCreateBidArgs = {
  input: ICreateBidInput
}

export type IMutationCreateBidApprovalArgs = {
  input: ICreateBidApprovalInput
}

export type IMutationCreateCarrierApplicationArgs = {
  input: ICreateCarrierApplicationInput
}

export type IMutationCreateCarrierApplicationBcaArgs = {
  input: ICreateCarrierApplicationBcaInput
}

export type IMutationCreateCarrierUserArgs = {
  input: ICreateCarrierUserInput
}

export type IMutationCreateConfigGroupArgs = {
  input: ICreateConfigGroupInput
}

export type IMutationCreateConfigGroupMappingArgs = {
  input: ICreateConfigGroupMappingInput
}

export type IMutationCreateConfigurableBuilderArgs = {
  input: ICreateConfigurableBuilderInput
}

export type IMutationCreateConfigurableBuilderTestArgs = {
  input: ICreateConfigurableBuilderTestInput
}

export type IMutationCreateConfigurableBuilderVersionArgs = {
  input: ICreateConfigurableBuilderVersionInput
}

export type IMutationCreateCounterBidArgs = {
  input: ICreateCounterBidInput
}

export type IMutationCreateDriverLocationArgs = {
  input: ICreateDriverLocationInput
}

export type IMutationCreateDriverLocationsArgs = {
  input: ICreateDriverLocationsInput
}

export type IMutationCreateEdiChargeCodeArgs = {
  input: ICreateEdiChargeCodeInput
}

export type IMutationCreateEdiInboundAs2ConnectionConfigArgs = {
  input: ICreateInboundAs2ConnectionConfigInput
}

export type IMutationCreateEdiInboundFtpConnectionConfigArgs = {
  input: ICreateInboundFtpConnectionConfigInput
}

export type IMutationCreateEdiOutboundAs2ConnectionConfigArgs = {
  input: ICreateOutboundAs2ConnectionConfigInput
}

export type IMutationCreateEdiOutboundFtpConnectionConfigArgs = {
  input: ICreateOutboundFtpConnectionConfigInput
}

export type IMutationCreateGroupArgs = {
  input: ICreateGroupInput
}

export type IMutationCreateInboundEdiMessageTypeArgs = {
  input: ICreateInboundEdiMessageInput
}

export type IMutationCreateInboundFileRouterConfigArgs = {
  input: ICreateInboundFileRouterConfigInput
}

export type IMutationCreateIssueAutomationRuleArgs = {
  input: ICreateIssueAutomationRuleInput
}

export type IMutationCreateMiscellaneousDocumentArgs = {
  input: ICreateMiscellaneousDocumentInput
}

export type IMutationCreateMotorCarrierComplianceFlagArgs = {
  input: ICreateMotorCarrierComplianceFlagInput
}

export type IMutationCreateMotorCarrierInsuranceContactsArgs = {
  input: ICreateMotorCarrierInsuranceContactsInput
}

export type IMutationCreateNoteArgs = {
  input: ICreateNoteInput
}

export type IMutationCreateOutboundEdiMessageTypeArgs = {
  input: ICreateOutboundEdiMessageInput
}

export type IMutationCreateQuickRequestArgs = {
  input: ICreateQuickRequestInput
}

export type IMutationCreateRescheduleRequestsArgs = {
  input: ICreateRescheduleRequestsInput
}

export type IMutationCreateRulesAssessmentOverridesArgs = {
  input: ICreateRulesAssessmentOverridesInput
}

export type IMutationCreateSafetyLetterArgs = {
  input: ICreateSafetyLetterInput
}

export type IMutationCreateSendPushNotificationJobArgs = {
  input: ICreateSendPushNotificationJobInput
}

export type IMutationCreateShipmentArgs = {
  input: ICreateShipmentInput
}

export type IMutationCreateShipmentAccessorialArgs = {
  input: ICreateShipmentAccessorialInput
}

export type IMutationCreateShipmentIssueArgs = {
  input: ICreateShipmentIssueInput
}

export type IMutationCreateShipperArgs = {
  input: ICreateShipperInput
}

export type IMutationCreateShipperAutoAcceptRejectRulesArgs = {
  input: IUpsertShipperAutoAcceptRejectConfigurationInput
}

export type IMutationCreateShipperFacilityLaneArgs = {
  input: ICreateShipperFacilityLaneInput
}

export type IMutationCreateShipperFacilityTrailerPoolArgs = {
  input: ICreateShipperFacilityTrailerPoolInput
}

export type IMutationCreateSmsMessageArgs = {
  input: ICreateSmsMessageInput
}

export type IMutationCreateSourcedCarrierRateArgs = {
  input: ICreateSourcedCarrierRateInput
}

export type IMutationCreateSpfIntegrationArgs = {
  input: ICreateSpfIntegrationInput
}

export type IMutationCreateTrailerArgs = {
  input: ICreateTrailerInput
}

export type IMutationCreateVendorArgs = {
  input: ICreateVendorInput
}

export type IMutationDeclineBidArgs = {
  input: IDeclineBidInput
}

export type IMutationDeclineCarrierShipmentArgs = {
  input: IDeclineCarrierShipmentInput
}

export type IMutationDeleteCarrierCertificationArgs = {
  input: IDeleteCarrierCertificationInput
}

export type IMutationDeleteEdiChargeCodeArgs = {
  input: IDeleteEdiChargeCodeInput
}

export type IMutationDeleteIssueAutomationRuleArgs = {
  input: IDeleteIssueAutomationRuleInput
}

export type IMutationDeleteRescheduleRequestArgs = {
  input: IDeleteRescheduleRequestInput
}

export type IMutationDeleteShipmentAccessorialArgs = {
  input: IDeleteShipmentAccessorialInput
}

export type IMutationDeleteShipmentAccessorialDocumentsArgs = {
  input: IDeleteShipmentAccessorialDocumentsInput
}

export type IMutationDeleteShipmentStopArgs = {
  input: IDeleteShipmentStopInput
}

export type IMutationDeleteShipperFacilityLaneArgs = {
  input: IDeleteShipperFacilityLaneInput
}

export type IMutationDeleteShipperFacilityTrailerPoolArgs = {
  input: IDeleteShipperFacilityTrailerPoolInput
}

export type IMutationDeleteShipperFuelMatrixArgs = {
  input: IDeleteShipperFuelMatrixInput
}

export type IMutationDeleteShipperFuelPaddMappingArgs = {
  input: IDeleteShipperFuelPaddMappingInput
}

export type IMutationDeleteShipperKpiTrackingConfigurationArgs = {
  input: IDeleteShipperKpiTrackingConfigurationInput
}

export type IMutationDeleteSourcedCarrierRateArgs = {
  input: IDeleteSourcedCarrierRateInput
}

export type IMutationDeleteSpfIntegrationArgs = {
  input: IDeleteSpfIntegrationInput
}

export type IMutationDeleteUserFilterPreferenceArgs = {
  input: IDeleteUserFilterPreferenceInput
}

export type IMutationDeleteVendorArgs = {
  input: IDeleteVendorInput
}

export type IMutationDispatchShipmentArgs = {
  input: IDispatchShipmentInput
}

export type IMutationEditVendorArgs = {
  input: IEditVendorInput
}

export type IMutationEditVendorKeywordsArgs = {
  input: IEditVendorKeywordsInput
}

export type IMutationExportShipperRateCarrierCallListArgs = {
  input: IExportShipperRateCarrierCallListInput
}

export type IMutationGenerateDetentionLinkArgs = {
  input: IGenerateDetentionLinkInput
}

export type IMutationGetConfigurableBuilderWarningsArgs = {
  input: IGetConfigurableBuilderWarningsInput
}

export type IMutationGetSerializedJsonArgs = {
  input: IGetSerializedJsonInput
}

export type IMutationHoldShipmentArgs = {
  input: IHoldShipmentInput
}

export type IMutationManagePodArgs = {
  input: IManagePodInput
}

export type IMutationMarkAllReadArgs = {
  input: IMarkAllReadInput
}

export type IMutationMarkAsReadArgs = {
  input: IMarkAsReadInput
}

export type IMutationMarkCarrierTonuArgs = {
  input: IMarkCarrierTonuInput
}

export type IMutationMarkFacilityPrimaryArgs = {
  input: IMarkFacilityPrimaryInput
}

export type IMutationMarkFullTonuArgs = {
  input: IMarkFullTonuInput
}

export type IMutationMarkShipmentRolledArgs = {
  input: IMarkShipmentRolledInput
}

export type IMutationMergeFacilitiesToPrimaryArgs = {
  input: IMergeFacilitiesToPrimaryInput
}

export type IMutationMergeFacilityToPrimaryArgs = {
  input: IMergeFacilityToPrimaryInput
}

export type IMutationOfferShipmentArgs = {
  input: IOfferShipmentInput
}

export type IMutationReOfferWaterfallToCarrierArgs = {
  input: IReOfferWaterfallInput
}

export type IMutationReactivateDeclinedBidArgs = {
  input: IReactivateDeclinedBidInput
}

export type IMutationRearrangeShipmentStopsArgs = {
  input: IRearrangeShipmentStopsInput
}

export type IMutationRefreshHighwayDataArgs = {
  input: IRefreshHighwayDataInput
}

export type IMutationRegenerateInvoiceArgs = {
  input: IRegenerateInvoiceInput
}

export type IMutationRejectApprovedPodArgs = {
  input: IRejectApprovedPodInput
}

export type IMutationRejectComplianceCoverReviewArgs = {
  input: IRejectComplianceCoverReviewInput
}

export type IMutationRemoveCarrierTonuArgs = {
  input: IRemoveCarrierTonuInput
}

export type IMutationRemoveDispatchArgs = {
  input: IRemoveDispatchInput
}

export type IMutationRemoveTonuArgs = {
  input: IRemoveTonuInput
}

export type IMutationReprintInvoiceArgs = {
  input: IReprintInvoiceInput
}

export type IMutationReprintRateConfirmationArgs = {
  input: IReprintRateConfirmationInput
}

export type IMutationRequestCarrierApprovalArgs = {
  input: IRequestCarrierApprovalInput
}

export type IMutationResend214Args = {
  input: IResend214Input
}

export type IMutationResendInvoicesArgs = {
  input: IResendInvoicesInput
}

export type IMutationResetShipmentWaterfallArgs = {
  input: IResetShipmentWaterfallInput
}

export type IMutationReviewFacilityAddressArgs = {
  input: IReviewFacilityAddressInput
}

export type IMutationRevokeCarrierTonuApprovalArgs = {
  input: IRevokeCarrierTonuApprovalInput
}

export type IMutationRfpExportDataArgs = {
  input: IRfpExportDataInput
}

export type IMutationRfpImportLanesDataArgs = {
  input: IRfpImportLanesDataInput
}

export type IMutationRunConfigurableBuilderArgs = {
  input: IRunConfigurableBuilderInput
}

export type IMutationRunConfigurableBuilderTestsArgs = {
  input: IRunConfigurableBuilderTestsInput
}

export type IMutationSelfDeleteParentUserArgs = {
  input: ISelfDeleteParentUserInput
}

export type IMutationSendShipmentOfferToCarrierArgs = {
  input: ISendShipmentOfferToCarrierInput
}

export type IMutationSendSmsRelayPaymentsArgs = {
  input: ISendSmsRelayPaymentsInput
}

export type IMutationSetCarrierRelationshipsArgs = {
  input: ISetCarrierRelationshipsInput
}

export type IMutationSetLatestUserAvailabilitiesFilterPreferencesArgs = {
  input: ISetLatestUserAvailabilitiesFilterPreferenceInput
}

export type IMutationSetNotifiedEscalatedShipmentIssuesArgs = {
  input: ISetNotifiedEscalatedShipmentIssuesInput
}

export type IMutationSetShipmentIssuesFilterPreferencesArgs = {
  input: ISetShipmentIssuesFilterPreferenceInput
}

export type IMutationSetShipmentTaskCapArgs = {
  input: ISetShipmentTaskCapInput
}

export type IMutationSetShipperAppointmentPreferenceArgs = {
  input: ISetShipperAppointmentPreferenceInput
}

export type IMutationSetShipperRelationshipsArgs = {
  input: ISetShipperRelationshipsInput
}

export type IMutationSetShipperTenderAppointmentConfigurationArgs = {
  input: ISetShipperTenderAppointmentConfigurationInput
}

export type IMutationSetTaskedShipmentFilterPreferencesArgs = {
  input: ISetTaskedShipmentFilterPreferenceInput
}

export type IMutationShipperApproveShipmentAccessorialArgs = {
  input: IShipperApproveShipmentAccessorialInput
}

export type IMutationShipperRejectShipmentAccessorialArgs = {
  input: IShipperRejectShipmentAccessorialInput
}

export type IMutationSignRateConfirmationArgs = {
  input: ISignRateConfirmationInput
}

export type IMutationSkipShipmentWaterfallCarrierArgs = {
  input: ISkipShipmentWaterfallCarrierInput
}

export type IMutationSnoozeShipmentActiveTasksArgs = {
  input: ISnoozeShipmentActiveTasksInput
}

export type IMutationSoftDeleteRelayPaymentsCodeArgs = {
  input: ISoftDeleteRelayPaymentsCodeInput
}

export type IMutationStagingTestingCreateOutboundFilesArgs = {
  input: ICreateOutboundFilesInput
}

export type IMutationStagingTestingDeleteOutboundFilesArgs = {
  input: IDeleteOutboundFilesInput
}

export type IMutationStagingTestingDownloadSftpFilesArgs = {
  input: IDownloadSftpFilesInput
}

export type IMutationStagingTestingGetInboundSftpFilesArgs = {
  input: IGetInboundSftpFilesInput
}

export type IMutationStagingTestingUploadOutboundFilesArgs = {
  input: IUploadOutboundFilesInput
}

export type IMutationStartPhoneCallArgs = {
  input: IStartPhoneCallInput
}

export type IMutationSyncBillWithTriumphpayArgs = {
  input: ISyncBillWithTriumphpayInput
}

export type IMutationSyncHighwayDataIntoCarrierArgs = {
  input: ISyncHighwayDataIntoCarrierInput
}

export type IMutationTenderShipmentArgs = {
  input: ITenderShipmentInput
}

export type IMutationTestAs2ConnectionConfigOutboundArgs = {
  input: ITestAs2ConnectionConfigOutboundInput
}

export type IMutationTestFtpConnectionConfigArgs = {
  input: ITestFtpConnectionConfigInput
}

export type IMutationUnassignAllShipmentActiveTasksArgs = {
  input: IUnassignAllShipmentActiveTasksInput
}

export type IMutationUnassignFacilityVendorArgs = {
  input: IUnassignFacilityVendorInput
}

export type IMutationUnassignTrailerFromShipmentArgs = {
  input: IUnassignTrailerFromShipmentInput
}

export type IMutationUncancelShipmentArgs = {
  input: IUncancelShipmentInput
}

export type IMutationUndeliverShipmentArgs = {
  input: IUndeliverShipmentInput
}

export type IMutationUnmarkFacilityPrimaryArgs = {
  input: IUnmarkFacilityPrimaryInput
}

export type IMutationUnmarkShipmentRolledArgs = {
  input: IUnmarkShipmentRolledInput
}

export type IMutationUnsnoozeShipmentActiveTasksArgs = {
  input: IUnsnoozeShipmentActiveTasksInput
}

export type IMutationUpdateAs2CertificateArgs = {
  input: IUpdateAs2CertificateInput
}

export type IMutationUpdateAssignedFacilityVendorArgs = {
  input: IUpdateAssignedFacilityVendorInput
}

export type IMutationUpdateBidArgs = {
  input: IUpdateBidInput
}

export type IMutationUpdateBidApprovalStateArgs = {
  input: IUpdateBidApprovalStateInput
}

export type IMutationUpdateCarrierApplicationStateArgs = {
  input: IUpdateCarrierApplicationStateInput
}

export type IMutationUpdateCarrierAssignmentArgs = {
  input: IUpdateCarrierAssignmentInput
}

export type IMutationUpdateCarrierCertificationArgs = {
  input: IUpdateCarrierCertificationInput
}

export type IMutationUpdateCarrierCompanyInformationArgs = {
  input: IUpdateCarrierCompanyInformationInput
}

export type IMutationUpdateCarrierDedicatedLaneRatePreferenceArgs = {
  input: IUpdateCarrierDedicatedLaneRatePreferenceInput
}

export type IMutationUpdateCarrierEndorsementsArgs = {
  input: IUpdateCarrierEndorsementsInput
}

export type IMutationUpdateCarrierEquipmentCapabilityArgs = {
  input: IUpdateCarrierEquipmentCapabilityInput
}

export type IMutationUpdateCarrierExcludedCommoditiesArgs = {
  input: IUpdateCarrierExcludedCommoditiesInput
}

export type IMutationUpdateCarrierFreightCapabilityArgs = {
  input: IUpdateCarrierFreightCapabilityInput
}

export type IMutationUpdateCarrierHeadquaterArgs = {
  input: IUpdateHeadquarterInput
}

export type IMutationUpdateCarrierLoadingCapabilityArgs = {
  input: IUpdateCarrierLoadingCapabilityInput
}

export type IMutationUpdateCarrierRateTypePreferenceArgs = {
  input: IUpdateCarrierRateTypePreferenceInput
}

export type IMutationUpdateCarrierSmartWayRegistrationArgs = {
  input: IUpdateCarrierSmartWayRegistrationInput
}

export type IMutationUpdateCarrierTonuArgs = {
  input: IUpdateCarrierTonuInput
}

export type IMutationUpdateConfigGroupArgs = {
  input: IUpdateConfigGroupInput
}

export type IMutationUpdateConfigGroupMappingArgs = {
  input: IUpdateConfigGroupMappingInput
}

export type IMutationUpdateConfigurableBuilderArgs = {
  input: IUpdateConfigurableBuilderInput
}

export type IMutationUpdateConfigurableBuilderTestArgs = {
  input: IUpdateConfigurableBuilderTestInput
}

export type IMutationUpdateConfigurableBuilderVersionArgs = {
  input: IUpdateConfigurableBuilderVersionInput
}

export type IMutationUpdateDispatcherArgs = {
  input: IUpdateDispatcherInput
}

export type IMutationUpdateDriverArgs = {
  input: IUpdateDriverInput
}

export type IMutationUpdateEdiChargeCodeArgs = {
  input: IUpdateEdiChargeCodeInput
}

export type IMutationUpdateEdiInboundAs2ConnectionConfigArgs = {
  input: IUpdateInboundAs2ConnectionConfigInput
}

export type IMutationUpdateEdiInboundFtpConnectionConfigArgs = {
  input: IUpdateInboundFtpConnectionConfigInput
}

export type IMutationUpdateEdiOutboundAs2ConnectionConfigArgs = {
  input: IUpdateOutboundAs2ConnectionConfigInput
}

export type IMutationUpdateEdiOutboundFtpConnectionConfigArgs = {
  input: IUpdateOutboundFtpConnectionConfigInput
}

export type IMutationUpdateGlobalRfpStrategiesArgs = {
  input: IUpdateGlobalRfpStrategiesInput
}

export type IMutationUpdateGroupArgs = {
  input: IUpdateGroupInput
}

export type IMutationUpdateInboundEdiMessageTypeArgs = {
  input: IUpdateInboundEdiMessageInput
}

export type IMutationUpdateInboundFileRouterConfigArgs = {
  input: IUpdateInboundFileRouterConfigInput
}

export type IMutationUpdateIssueAutomationRuleArgs = {
  input: IUpdateIssueAutomationRuleInput
}

export type IMutationUpdateLocalRfpStrategiesArgs = {
  input: IUpdateLocalRfpStrategiesInput
}

export type IMutationUpdateNormFileArgs = {
  input: IUpdateNormFileInput
}

export type IMutationUpdateNormFileGeneratorRowStatusesArgs = {
  input: IUpdateNormFileGeneratorRowStatusesInput
}

export type IMutationUpdateNoteArgs = {
  input: IUpdateNoteInput
}

export type IMutationUpdateOutboundEdiMessageTypeArgs = {
  input: IUpdateOutboundEdiMessageInput
}

export type IMutationUpdatePriceRequestQuoteArgs = {
  input: IUpdatePriceRequestQuoteInput
}

export type IMutationUpdateProofOfTonuArgs = {
  input: IUpdateProofOfTonuInput
}

export type IMutationUpdateRatesArgs = {
  input: IUpdateRatesInput
}

export type IMutationUpdateRfpLaneDataArgs = {
  input: IUpdateRfpLaneDataInput
}

export type IMutationUpdateRfpLanesAndPricesArgs = {
  input: IUpdateRfpLanesAndPricesInput
}

export type IMutationUpdateScraperJobConfigurationsArgs = {
  input: IUpdateScraperJobConfigurationsInput
}

export type IMutationUpdateShipmentArgs = {
  input: IUpdateShipmentInput
}

export type IMutationUpdateShipmentAccessorialArgs = {
  input: IUpdateShipmentAccessorialInput
}

export type IMutationUpdateShipmentCmTargetArgs = {
  input: IUpdateShipmentCmTargetInput
}

export type IMutationUpdateShipmentContactPreferenceArgs = {
  input: IUpdateShipmentContactPreferenceInput
}

export type IMutationUpdateShipmentContactPreferenceCarrierContactInstructionsArgs = {
  input: IUpdateShipmentContactPreferenceCarrierContactInstructionsInput
}

export type IMutationUpdateShipmentEquipmentArgs = {
  input: IUpdateShipmentEquipmentInput
}

export type IMutationUpdateShipmentIssueArgs = {
  input: IUpdateShipmentIssueInput
}

export type IMutationUpdateShipmentListPriceArgs = {
  input: IUpdateShipmentListPriceInput
}

export type IMutationUpdateShipmentOpsRepArgs = {
  input: IUpdateShipmentOpsRepInput
}

export type IMutationUpdateShipmentStopArgs = {
  input: IUpdateShipmentStopInput
}

export type IMutationUpdateShipmentStopManualEtaArgs = {
  input: IUpdateShipmentStopManualEtaInput
}

export type IMutationUpdateShipmentStopsArgs = {
  input: IUpdateShipmentStopsInput
}

export type IMutationUpdateShipmentStopsArrivalDepartureArgs = {
  input: IUpdateShipmentStopsArrivalDepartureInput
}

export type IMutationUpdateShipperApplicationEdiConfigArgs = {
  input: IUpdateShipperApplicationEdiConfigInput
}

export type IMutationUpdateShipperApplicationTrackingArgs = {
  input: IUpdateShipperApplicationTrackingInput
}

export type IMutationUpdateShipperBrokerPodArgs = {
  input: IUpdateShipperBrokerPodInput
}

export type IMutationUpdateShipperFacilityLaneArgs = {
  input: IUpdateShipperFacilityLaneInput
}

export type IMutationUpdateShipperFacilityTrailerPoolArgs = {
  input: IUpdateShipperFacilityTrailerPoolInput
}

export type IMutationUpdateShipperOnboardingEdiConfigurationArgs = {
  input: IUpdateShipperOnboardingEdiConfigurationInput
}

export type IMutationUpdateShipperRateArgs = {
  input: IUpdateShipperRateInput
}

export type IMutationUpdateSourcedCarrierRateArgs = {
  input: IUpdateSourcedCarrierRateInput
}

export type IMutationUpdateSpfIntegrationArgs = {
  input: IUpdateSpfIntegrationInput
}

export type IMutationUpdateTasksArgs = {
  input: IUpdateTasksInput
}

export type IMutationUpdateTrailerArgs = {
  input: IUpdateTrailerInput
}

export type IMutationUpdateTransfixHighwayInsurancePolicyFlagArgs = {
  input: IUpdateTransfixHighwayInsurancePolicyFlagInput
}

export type IMutationUpdateUserAvailabilityArgs = {
  input: IUpdateUserAvailabilityInput
}

export type IMutationUploadAwardArgs = {
  input: IUploadAwardInput
}

export type IMutationUploadW9FormArgs = {
  input: IUploadW9FormInput
}

export type IMutationUpsertAs2ConnectionConfigArgs = {
  input: IUpsertAs2ConnectionConfigInput
}

export type IMutationUpsertFuelRateConfigArgs = {
  input: IUpsertFuelRateConfigInput
}

export type IMutationUpsertShipperAutoAcceptRejectConfigurationArgs = {
  input: IUpsertShipperAutoAcceptRejectConfigurationInput
}

export type IMutationUpsertShipperAwardEstimationConfigurationArgs = {
  input: IUpsertShipperAwardEstimationConfigurationInput
}

export type IMutationUpsertShipperContactsArgs = {
  input: IUpsertShipperContactsInput
}

export type IMutationUpsertShipperDropTrailersConfigurationArgs = {
  input: IUpsertShipperDropTrailersConfigurationInput
}

export type IMutationUpsertShipperFuelMatrixArgs = {
  input: IUpsertShipperFuelMatrixInput
}

export type IMutationUpsertShipperFuelPaddMappingArgs = {
  input: IUpsertShipperFuelPaddMappingInput
}

export type IMutationUpsertShipperKpiLinksArgs = {
  input: IUpsertShipperKpiLinksInput
}

export type IMutationUpsertShipperKpiTrackingConfigurationArgs = {
  input: IUpsertShipperKpiTrackingConfigurationInput
}

export type IMutationUpsertShipperOnboardingKpiConfigurationArgs = {
  input: IUpsertShipperOnboardingKpiConfigurationInput
}

export type IMutationUpsertShipperTrueRateConfigurationArgs = {
  input: IUpsertShipperTrueRateConfigurationInput
}

export type IMutationVerifyParentUserArgs = {
  input: IVerifyParentUserInput
}

export type INetsuiteBillPayment = {
  __typename?: 'NetsuiteBillPayment'
  carrier: ICarrierApplication
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  draft: IDraft
  entryId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastSyncAt?: Maybe<Scalars['ISO8601DateTime']>
  netsuiteId?: Maybe<Scalars['String']>
  tranDate?: Maybe<Scalars['ISO8601DateTime']>
  tranId?: Maybe<Scalars['String']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type INetsuiteInvoice = {
  __typename?: 'NetsuiteInvoice'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  dueDate?: Maybe<Scalars['ISO8601DateTime']>
  entryId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastSyncAt?: Maybe<Scalars['ISO8601DateTime']>
  memo?: Maybe<Scalars['String']>
  netsuiteEntityId?: Maybe<Scalars['String']>
  netsuiteId?: Maybe<Scalars['String']>
  params?: Maybe<Scalars['String']>
  shipment: IShipment
  tranDate?: Maybe<Scalars['ISO8601DateTime']>
  tranId?: Maybe<Scalars['String']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type INetsuiteInvoiceCredit = {
  __typename?: 'NetsuiteInvoiceCredit'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  dueDate?: Maybe<Scalars['ISO8601DateTime']>
  entryId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastSyncAt?: Maybe<Scalars['ISO8601DateTime']>
  memo?: Maybe<Scalars['String']>
  netsuiteEntityId?: Maybe<Scalars['String']>
  netsuiteId?: Maybe<Scalars['String']>
  params?: Maybe<Scalars['String']>
  shipment: IShipment
  tranDate?: Maybe<Scalars['ISO8601DateTime']>
  tranId?: Maybe<Scalars['String']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** [member_ids] is a collection of user ids to create group memberships */
export type INewGroupInput = {
  email?: Maybe<Scalars['String']>
  instructions?: Maybe<Scalars['String']>
  key: Scalars['String']
  memberIds?: Maybe<Array<Scalars['ID']>>
  name: Scalars['String']
}

export type INormFileGeneratorRowStatus = {
  __typename?: 'NormFileGeneratorRowStatus'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  deliveryCity?: Maybe<Scalars['String']>
  deliveryState?: Maybe<Scalars['String']>
  deliveryZip?: Maybe<Scalars['String']>
  id: Scalars['ID']
  laneId?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['JSON']>
  normFileGeneratorStatus?: Maybe<INormFileGeneratorStatus>
  normFileGeneratorStatusId?: Maybe<Scalars['ID']>
  output?: Maybe<Scalars['JSON']>
  pickupCity?: Maybe<Scalars['String']>
  pickupState?: Maybe<Scalars['String']>
  pickupZip?: Maybe<Scalars['String']>
  rfpLaneErrors?: Maybe<Array<IRfpLaneError>>
  status: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type INormFileGeneratorStatus = ICreatedByUser & {
  __typename?: 'NormFileGeneratorStatus'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  googleSheetsUrl: Scalars['String']
  id: Scalars['ID']
  metadata?: Maybe<Scalars['JSON']>
  requestForProposalId: Scalars['ID']
  status: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type INote = ICreatedByUser & {
  __typename?: 'Note'
  body: Scalars['String']
  callBackAt?: Maybe<Scalars['ISO8601DateTime']>
  calledBackAt?: Maybe<Scalars['ISO8601DateTime']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  documents: Array<IDownloadable>
  id: Scalars['ID']
  noteable: INoteable
  noteableId: Scalars['ID']
  noteableType: INoteableTypes
  notification?: Maybe<Array<INotification>>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum INoteAutotagTypes {
  accounting = 'accounting',
  am = 'am',
  booking_team = 'booking_team',
  ce_rep = 'ce_rep',
  claims = 'claims',
  creator = 'creator',
  ops_rep = 'ops_rep',
  pod = 'pod',
  shipper = 'shipper',
  tracking_pod = 'tracking_pod',
}

export enum INoteTypes {
  customer_bumblebee = 'customer_bumblebee',
  five9 = 'five9',
  human = 'human',
  ima_bot = 'ima_bot',
  phone = 'phone',
  scheduling = 'scheduling',
}

/** Objects which may have notes assigned to them */
export type INoteable =
  | IBid
  | IRequestForProposalLane
  | IRequestForProposalLaneFeedback
  | IRequestForProposalStrategy
  | IShipment
  | IShipmentIssue
  | IShipperRate

export enum INoteableTypes {
  Bid = 'Bid',
  RequestForProposalLane = 'RequestForProposalLane',
  RequestForProposalLaneFeedback = 'RequestForProposalLaneFeedback',
  RequestForProposalStrategy = 'RequestForProposalStrategy',
  Shipment = 'Shipment',
  ShipmentIssue = 'ShipmentIssue',
  ShipperRate = 'ShipperRate',
}

/** Internal Transfix Notifications that are viewable by Transfix employees only. Available only under Rogers */
export type INotification = ICreatedByUser & {
  __typename?: 'Notification'
  /** Body of the notification. This value depends on the notifiable type */
  body: Scalars['String']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  /** Notification primary key */
  id: Scalars['ID']
  /** JSON metadata object with a structure that depends on the notifiable type */
  metadata?: Maybe<Scalars['String']>
  /** Notifiable ID */
  notifiableId: Scalars['String']
  /** Notifiable class name */
  notifiableType: Scalars['String']
  parentUsersNotifications: Array<IParentUserNotification>
  /** Timestamp indicating when the notification was marked as read by the user */
  readAt?: Maybe<Scalars['ISO8601DateTime']>
  /** Title of the notification */
  title: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  /** Valid Rogers URL */
  url: Scalars['String']
}

export type INotifiedEscalatedShipmentIssueInput = {
  escalated?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  notified?: Maybe<Scalars['Boolean']>
}

/** Autogenerated input type of OfferShipment */
export type IOfferShipmentInput = {
  carrierApplicationId: Scalars['ID']
  carrierContactInstructions?: Maybe<Scalars['String']>
  carrierRate: Scalars['Float']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  dispatcherId: Scalars['ID']
  driverId?: Maybe<Scalars['ID']>
  shipmentId: Scalars['ID']
  trailerNumber?: Maybe<Scalars['String']>
  truckNumber?: Maybe<Scalars['String']>
  vin?: Maybe<Scalars['String']>
}

/** Autogenerated return type of OfferShipment */
export type IOfferShipmentPayload = {
  __typename?: 'OfferShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Offered shipments filters */
export enum IOfferedShipmentsFilter {
  /** all */
  all = 'all',
  /** current */
  current = 'current',
  /** past */
  past = 'past',
}

export enum IOnTimeDeliveryMeasures {
  /** Appt time local */
  appt_time_local = 'appt_time_local',
  /** Date range */
  date_range = 'date_range',
  /** Original tender del date */
  original_tender_del_date = 'original_tender_del_date',
}

export enum IOnTimePickUpMeasures {
  /** Appt time local */
  appt_time_local = 'appt_time_local',
  /** Date range */
  date_range = 'date_range',
  /** Original tender pu date */
  original_tender_pu_date = 'original_tender_pu_date',
}

/** Basic Carrier info needed for onboarding. */
export type IOnboardingCarrier = {
  __typename?: 'OnboardingCarrier'
  addresses?: Maybe<Array<IHighwayAddress>>
  carrierApplicationId?: Maybe<Scalars['ID']>
  contacts?: Maybe<Array<IHighwayContact>>
  continuousAuthorityGrantDate?: Maybe<Scalars['ISO8601Date']>
  dbaName?: Maybe<Scalars['String']>
  dotNumber: Scalars['Int']
  ein?: Maybe<Scalars['String']>
  highwayId?: Maybe<Scalars['ID']>
  /** ID will be null if motor carrier does not exist in Transfix's system. */
  id?: Maybe<Scalars['ID']>
  legalName: Scalars['String']
  mcNumber?: Maybe<Scalars['Int']>
  rulesAssessmentPass?: Maybe<Scalars['Boolean']>
  rulesAssessments?: Maybe<Array<IHighwayRulesAssessment>>
  safetyRating?: Maybe<Scalars['String']>
}

export type IOopAccessorialOwner = {
  __typename?: 'OopAccessorialOwner'
  firstName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  lastName?: Maybe<Scalars['String']>
}

export type IOtherShipperShipmentIdentifiers = {
  __typename?: 'OtherShipperShipmentIdentifiers'
  id?: Maybe<Scalars['ID']>
  idType?: Maybe<Scalars['String']>
}

export type IOutboundConnectionConfig = {
  __typename?: 'OutboundConnectionConfig'
  as2ConnectionConfig?: Maybe<IAs2ConnectionConfig>
  componentSeparator: Scalars['String']
  connectionType: IConnectionTypes
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** Used to differentiate multiple outbound configs associated with a single partner. */
  destinationOverride?: Maybe<Scalars['String']>
  disabled: Scalars['Boolean']
  ediMessageTypes?: Maybe<Array<IEdiMessage>>
  elementSeparator: Scalars['String']
  environment: IConnectionConfigEnvironment
  expect997s: Scalars['Boolean']
  groupVersionStr: Scalars['String']
  gsReceiverId?: Maybe<Scalars['String']>
  gsSenderId?: Maybe<Scalars['String']>
  host?: Maybe<Scalars['String']>
  id: Scalars['ID']
  interchangeVersionStr: Scalars['String']
  /** ISA receiver id */
  isaReceiverId: Scalars['String']
  isaReceiverIdQualifier?: Maybe<Scalars['String']>
  isaSenderId?: Maybe<Scalars['String']>
  isaSenderIdQualifier?: Maybe<Scalars['String']>
  partnerApplication?: Maybe<IPartnerApplication>
  partnerApplicationId: Scalars['ID']
  partnerApplicationType: IPartnerApplicationTypes
  pathPrefix?: Maybe<Scalars['String']>
  port?: Maybe<Scalars['Int']>
  repetitionSeparator: Scalars['String']
  secretKey?: Maybe<Scalars['String']>
  segmentSeparator: Scalars['String']
  shipperId?: Maybe<Scalars['ID']>
  testIndicator: IUsageIndicators
  tmsName?: Maybe<Scalars['String']>
  username?: Maybe<Scalars['String']>
}

/** The connection type for OutboundConnectionConfig. */
export type IOutboundConnectionConfigConnection = {
  __typename?: 'OutboundConnectionConfigConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IOutboundConnectionConfigEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IOutboundConnectionConfig>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IOutboundConnectionConfigEdge = {
  __typename?: 'OutboundConnectionConfigEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IOutboundConnectionConfig>
}

export type IOutboundRawEdiFile = {
  __typename?: 'OutboundRawEdiFile'
  acknowledgedByInboundFileId?: Maybe<Scalars['ID']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  ediMessageType: Scalars['String']
  ediMetadata?: Maybe<IEdiMetadata>
  extension: Scalars['String']
  groupControlNumber: Scalars['String']
  id: Scalars['ID']
  interchangeControlNumber: Scalars['String']
  outboundConnectionConfig: IOutboundConnectionConfig
  outboundConnectionConfigId: Scalars['ID']
  partnerApplicationId: Scalars['ID']
  partnerApplicationType: IPartnerApplicationTypes
  receiverId: Scalars['String']
  remotePath?: Maybe<Scalars['String']>
  rogersFileDetailUrl: Scalars['String']
  s3Key: Scalars['String']
  shipmentId: Scalars['ID']
  shipperId: Scalars['ID']
  shipperShipmentReference: Scalars['String']
  submitterId: Scalars['String']
  /** UploadedAt timestamp in UTC */
  uploadedAt?: Maybe<Scalars['ISO8601DateTime']>
}

export enum IP44TrackingMethods {
  /** api */
  api = 'api',
  /** eld */
  eld = 'eld',
  /** mobile */
  mobile = 'mobile',
}

export enum IP44TruckNumberStates {
  invalid = 'invalid',
  unvalidated = 'unvalidated',
  valid = 'valid',
}

/** Information about pagination in a connection. */
export type IPageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>
}

export enum IParentEquipmentTypes {
  dry_van = 'dry_van',
  open_deck = 'open_deck',
  reefer = 'reefer',
}

export type IParentUser = {
  __typename?: 'ParentUser'
  cellPhone?: Maybe<Scalars['String']>
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  deletedById?: Maybe<Scalars['ID']>
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  fullName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastName?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  phoneExt?: Maybe<Scalars['String']>
}

/** Link between Notification and the ParentUsers who should receive them */
export type IParentUserNotification = {
  __typename?: 'ParentUserNotification'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** Notification primary key */
  id: Scalars['ID']
  parentUser: IParentUser
  /** Timestamp indicating when the notification was marked as read by the user */
  readAt?: Maybe<Scalars['ISO8601DateTime']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** A shipper or a carrier. (Mainly for EDI integrations.) */
export type IPartnerApplication = ICarrierApplication | IShipperApplication

export enum IPartnerApplicationTypes {
  CarrierApplication = 'CarrierApplication',
  ShipperApplication = 'ShipperApplication',
}

export enum IPaymentTermsTypes {
  /** Net terms */
  net_terms = 'net_terms',
  /** Pre pay */
  pre_pay = 'pre_pay',
}

export type IPhoneCall = {
  __typename?: 'PhoneCall'
  agentEmail?: Maybe<Scalars['String']>
  agentName?: Maybe<Scalars['String']>
  callNotes?: Maybe<Scalars['String']>
  campaignName?: Maybe<Scalars['String']>
  campaignType?: Maybe<Scalars['String']>
  disposition?: Maybe<Scalars['String']>
  endedAt?: Maybe<Scalars['ISO8601DateTime']>
  fromPhoneNumber: Scalars['String']
  fromUser?: Maybe<IUser>
  id: Scalars['ID']
  startedAt?: Maybe<Scalars['ISO8601DateTime']>
  toPhoneNumber: Scalars['String']
  toUser?: Maybe<IUser>
}

/** The connection type for PhoneCall. */
export type IPhoneCallConnection = {
  __typename?: 'PhoneCallConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IPhoneCallEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IPhoneCall>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IPhoneCallEdge = {
  __typename?: 'PhoneCallEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IPhoneCall>
}

export type IPickupBetMarket = {
  __typename?: 'PickupBetMarket'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  equipmentId?: Maybe<Scalars['Int']>
  id: Scalars['ID']
  isDrop?: Maybe<Scalars['Boolean']>
  market?: Maybe<IMarket>
  marketId: Scalars['Int']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IPreferredTrackingMethods {
  /** fms_mobile */
  fms_mobile = 'fms_mobile',
  /** keep_truckin */
  keep_truckin = 'keep_truckin',
  /** mobile */
  mobile = 'mobile',
  /** project_44 */
  project_44 = 'project_44',
}

export type IPriceRequest = {
  __typename?: 'PriceRequest'
  additionalStops?: Maybe<Scalars['Int']>
  createdAt?: Maybe<Scalars['ISO8601DateTime']>
  customerQuote?: Maybe<Scalars['Float']>
  customerQuoteType?: Maybe<Scalars['String']>
  deliveryCity?: Maybe<Scalars['String']>
  deliveryDropTrailer?: Maybe<Scalars['Boolean']>
  deliveryStartDate?: Maybe<Scalars['ISO8601Date']>
  deliveryStartTime?: Maybe<Scalars['ISO8601DateTime']>
  deliveryStateCode?: Maybe<Scalars['String']>
  deliveryZipcode?: Maybe<Scalars['String']>
  equipmentId?: Maybe<Scalars['Int']>
  externalId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isDoNotBidApplied?: Maybe<Scalars['Boolean']>
  isDrop?: Maybe<Scalars['Boolean']>
  isTestQuote?: Maybe<Scalars['Boolean']>
  pickupCity?: Maybe<Scalars['String']>
  pickupDropTrailer?: Maybe<Scalars['Boolean']>
  pickupStartDate?: Maybe<Scalars['ISO8601Date']>
  pickupStartTime?: Maybe<Scalars['ISO8601DateTime']>
  pickupStateCode?: Maybe<Scalars['String']>
  pickupZipcode?: Maybe<Scalars['String']>
  premiums?: Maybe<IPriceRequestPremium>
  pricingResponse?: Maybe<IPricingResponse>
  requestedBy?: Maybe<IUser>
  shipperApplication?: Maybe<IShipperApplication>
  shipperApplicationId?: Maybe<Scalars['ID']>
  shipperMiles?: Maybe<Scalars['Float']>
  source?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>
}

export type IPriceRequestAppliedRules = {
  __typename?: 'PriceRequestAppliedRules'
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  priceRequestAppliedRulesMetadata?: Maybe<IPriceRequestAppliedRulesMetadata>
  priceRequestId: Scalars['ID']
  updatedAt: Scalars['ISO8601DateTime']
}

export type IPriceRequestAppliedRulesMetadata = {
  __typename?: 'PriceRequestAppliedRulesMetadata'
  additionalStops?: Maybe<Array<IAdditionalStops>>
  adjustedCostBasis?: Maybe<Scalars['Float']>
  adjustedCostBasisWithExtraPremiums?: Maybe<Scalars['Float']>
  appliedCostControlConfig?: Maybe<ICostControlConfig>
  appliedCustomRules?: Maybe<Array<Scalars['String']>>
  appliedSpotBiddingRules?: Maybe<Array<ISpotBiddingRule>>
  appliedStrikePriceRules?: Maybe<Array<ISpotBiddingRule>>
  benchmarkRate?: Maybe<Scalars['Float']>
  datType?: Maybe<Scalars['String']>
  dataScienceExtraPremiums?: Maybe<Scalars['Float']>
  dsCostPremiumPct?: Maybe<Scalars['Float']>
  dsPremiumImpactOnBaseline?: Maybe<Scalars['Float']>
  finalManualCostAdjustmentPercent?: Maybe<Scalars['Float']>
  fuelSurchargeCalculation?: Maybe<IFuelSurchargeCalculation>
  isDoNotBid?: Maybe<Scalars['Boolean']>
  multiStopBucketUsed?: Maybe<Scalars['String']>
  multiStopLegDatObjects?: Maybe<Array<IMultiStopLegDatObjects>>
  strategyChosen?: Maybe<Scalars['String']>
}

/** The connection type for PriceRequest. */
export type IPriceRequestConnection = {
  __typename?: 'PriceRequestConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IPriceRequestEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IPriceRequest>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IPriceRequestEdge = {
  __typename?: 'PriceRequestEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IPriceRequest>
}

export type IPriceRequestPremium = {
  __typename?: 'PriceRequestPremium'
  commodity?: Maybe<Scalars['String']>
  quoteWithFuel?: Maybe<Scalars['Float']>
  quoteWithoutFuel?: Maybe<Scalars['Float']>
}

export type IPricingDistMarketCenterThreshold = ICreatedByUser & {
  __typename?: 'PricingDistMarketCenterThreshold'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  delivery?: Maybe<Scalars['BigInt']>
  id: Scalars['ID']
  pickup?: Maybe<Scalars['BigInt']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IPricingLengthOfHaul = ICreatedByUser & {
  __typename?: 'PricingLengthOfHaul'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  lengthEnd?: Maybe<Scalars['BigInt']>
  lengthStart?: Maybe<Scalars['BigInt']>
  name: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IPricingResponse = {
  __typename?: 'PricingResponse'
  datMiles?: Maybe<Scalars['Float']>
  datRate?: Maybe<Scalars['Float']>
  highDatRate?: Maybe<Scalars['Float']>
  lowDatRate?: Maybe<Scalars['Float']>
  tcm25?: Maybe<Scalars['Float']>
  tcm40?: Maybe<Scalars['Float']>
  tcm50?: Maybe<Scalars['Float']>
  tcm75?: Maybe<Scalars['Float']>
}

export enum IPricingTypes {
  /** Fixed */
  fixed = 'fixed',
  /** Variable */
  variable = 'variable',
}

export type IPricingVolumeGroup = ICreatedByUser & {
  __typename?: 'PricingVolumeGroup'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  groupEnd?: Maybe<Scalars['BigInt']>
  groupStart?: Maybe<Scalars['BigInt']>
  id: Scalars['ID']
  name: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IProofOfTonu = {
  __typename?: 'ProofOfTonu'
  createdAt: Scalars['ISO8601DateTime']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  document: IDownloadable
  id: Scalars['ID']
  shipment: IShipment
  type: Scalars['String']
}

export type IProximalHourCriteria = {
  __typename?: 'ProximalHourCriteria'
  dayOrHour?: Maybe<Scalars['String']>
  id: Scalars['ID']
  rangeEnd?: Maybe<Scalars['String']>
  rangeStart?: Maybe<Scalars['String']>
}

export type IQuery = {
  __typename?: 'Query'
  accessorials: Array<IShipmentAccessorial>
  /** Gets all revenue share agreements. When a partner is specified, it scopes down to the requested partner */
  activeBackhaulRevenueShareAgreements: Array<IBackhaulRevenueShareAgreement>
  amPods: IAmPodConnection
  appointmentRecommendedStartAtTime: IAppointmentRecommendedStartAt
  /** Returns metadata from the supplied certificate body. */
  as2CertificateMetadata?: Maybe<IAs2Certificate>
  /** Exact AS2 connection config with matching id */
  as2ConnectionConfig?: Maybe<IAs2ConnectionConfig>
  /** List of AS2 connection configs. Limited to a max of 50 returned configs per call */
  as2ConnectionConfigs: IAs2ConnectionConfigConnection
  /** Gets all attached documents for a given shipment */
  attachedDocuments: Array<IAttachedDocument>
  autoAcceptRejectRules: Array<IAutoAcceptRejectRule>
  /** Gets all balance dues for a given shipment */
  balanceDues: Array<IBalanceDue>
  bid: IBid
  /** A count of various bid availabilities */
  bidCounts: IBidCountsResponse
  bids: Array<IBid>
  /** Gets all bill credits for a given shipment or carrier */
  billCredits: Array<IBillCredit>
  /** Gets all bills for a given shipment */
  bills: Array<IBill>
  /** Gets all broker pods */
  brokerPods: Array<IBrokerPod>
  /** Exact carrier with the matching id */
  carrierApplication?: Maybe<ICarrierApplication>
  carrierApplicationUsers: Array<IUser>
  carrierCallListForShipment: ICarrierCallListResponse
  carrierComplianceMatch: IInsuranceComplianceMatch
  carrierTonus: Array<ICarrierTonu>
  carrierTrackingProviders: Array<ICarrierTrackingProvider>
  comchecks: Array<IComcheck>
  commodities: Array<ICommodity>
  complianceChecklist?: Maybe<IComplianceChecklist>
  /** Exact config group mapping with matching id */
  configGroupMapping?: Maybe<IConfigGroupMapping>
  /** A collection of config group mappings for a connection config */
  configGroupMappings: Array<IConfigGroupMapping>
  /** Exact configurable builder with matching id */
  configurableBuilder?: Maybe<IConfigurableBuilder>
  /** Exact builder test with matching id */
  configurableBuilderTest?: Maybe<IConfigurableBuilderTest>
  /** Exact configurable builder id */
  configurableBuilderTests?: Maybe<Array<IConfigurableBuilderTest>>
  /** Exact configurable builder version with matching id */
  configurableBuilderVersion?: Maybe<IConfigurableBuilderVersion>
  /** A collection of all versions for a configurable builder */
  configurableBuilderVersions?: Maybe<Array<IConfigurableBuilderVersion>>
  /** A collection of configurable builders */
  configurableBuilders: Array<IConfigurableBuilder>
  /** Exact configurable parser with matching id */
  configurableParser?: Maybe<IConfigurableParser>
  /** A collection of configurable parsers */
  configurableParsers: Array<IConfigurableParser>
  /** The shipment that is most relevant to a given driver's tracking status */
  currentShipmentForUser?: Maybe<IShipment>
  /** Gets the relay payments digital card's details */
  digitalCardDetails?: Maybe<IDigitalCardDetails>
  driverLocations: IDriverLocationConnection
  driverVerified?: Maybe<IActivity>
  drivingDistance: IMeasurement
  drivingDistanceFromLatestLocation: IMeasurement
  /** Edi Charge Codes for a given shipper */
  ediChargeCodes?: Maybe<Array<IEdiChargeCode>>
  /** Exact edi connection config with matching id */
  ediInboundConnectionConfig?: Maybe<IInboundConnectionConfig>
  /** A collection of inbound configs */
  ediInboundConnectionConfigs: IInboundConnectionConfigConnection
  /** Exact edi inbound file router config with matching id */
  ediInboundFileRouterConfig?: Maybe<IInboundFileRouterConfig>
  /** A collection of edi inbound file router configs */
  ediInboundFileRouterConfigs?: Maybe<Array<IInboundFileRouterConfig>>
  /**
   * Given a shipper facility UUID, returns any other shipper facilities on the
   * shipper that have at least one matching EDI location code as the passed
   * shipper facility
   */
  ediMatchingFacilities: Array<IFacility>
  /** Exact edi message type with matching id */
  ediMessageType?: Maybe<IEdiMessage>
  /** A collection of message types */
  ediMessageTypes: IEdiMessageConnection
  /** Exact edi connection config with matching id */
  ediOutboundConnectionConfig?: Maybe<IOutboundConnectionConfig>
  /** A collection of outbound configs */
  ediOutboundConnectionConfigs: IOutboundConnectionConfigConnection
  /** list of transaction sets and subtypes */
  ediTransactionSetsWithSubtypes: Array<ITransactionSetWithSubtype>
  equipmentAttributes: Array<IEquipmentAttribute>
  equipments: Array<IEquipment>
  exportShipmentCarrierCallList: Scalars['Boolean']
  facilities: Array<IFacility>
  facility?: Maybe<IFacility>
  facilityRelayPaymentsNetworkStatus?: Maybe<IFacilityRelayPaymentsNetworkStatus>
  /** Exact carrier with the matching DOT number */
  findCarrierApplicationByDotNumber?: Maybe<ICarrierApplication>
  /** Exact carrier with the matching Fleet Planner Motor Carrier ID */
  findCarrierApplicationByFleetPlannerMotorCarrierId?: Maybe<ICarrierApplication>
  /** Exact carrier with the matching MC number */
  findCarrierApplicationByMcNumber?: Maybe<ICarrierApplication>
  /** Find a Motor Carrier for onboarding by providing an MC or DOT number. */
  findOnboardingCarrier?: Maybe<IOnboardingCarrier>
  geocodingSearch: Array<IGeocoding>
  /** The sum of distances between the set of stops */
  getCalculatedMiles: Scalars['Int']
  getEtaFor?: Maybe<Array<IEtaObject>>
  group?: Maybe<IGroup>
  groups: IGroupConnection
  /** Exact highway carrier with the matching carrier_application_id */
  highwayCarrier?: Maybe<IHighwayCarrier>
  /** Insurance agent contacts for the carrier */
  insuranceContacts: Array<IMotorCarrierInsuranceContact>
  /** Gets all invoice credits for a given shipment */
  invoiceCredits: Array<IInvoiceCredit>
  /** Gets all invoices for a given shipment */
  invoices: Array<IInvoice>
  issueAutomationRule?: Maybe<IIssueAutomationRule>
  issueAutomationRulesByIssueType: IIssueAutomationRuleConnection
  /** The carrier's history for a given lane */
  laneHistory?: Maybe<ILaneHistory>
  laneMarketInsights: ILaneMarketInsights
  latestUserAvailabilitiesByType: IUserAvailabilityConnection
  mapboxFeatures: Array<IMapboxFeature>
  marketRate?: Maybe<Scalars['Float']>
  matchFacilities?: Maybe<IMatchedFacilities>
  mergedFacilities: Array<IMergedFacility>
  /** Return all MotorCarrierComplianceFlag records related to the passed carrier application id */
  motorCarrierComplianceFlags?: Maybe<Array<IMotorCarrierComplianceFlag>>
  /** MotorCarrierTransfixRulesAssessments for the matched carrier_application_id */
  motorCarrierTransfixRulesAssessments?: Maybe<Array<IMotorCarrierTransfixRulesAssessment>>
  /**
   * Shipments with active tasks in a given namespace. If not passed
   * `taskNamespaces` argument all known namespaces are returned. Only returns
   * shipments between On Hold (inclusive) and Delivered (exclusive) states
   */
  namespacedActivelyTaskedShipments: ITaskedShipmentConnection
  nearbyPickupShipments: IShipmentConnection
  nearbyReloadShipments: IShipmentConnection
  normFileGeneatorStatus: INormFileGeneratorStatus
  normFileGeneratorStatuses: Array<INormFileGeneratorStatus>
  notifications: Array<INotification>
  offeredShipments: Array<IBid>
  paginatedBids: IBidConnection
  paginatedFacilities: IFacilityConnection
  paginatedShipmentIssues: IShipmentIssueConnection
  paginatedShipperFacilities: IShipperFacilityConnection
  /** Search for phone calls. Limited to a max of 50 returned phone calls per call */
  phoneCalls: IPhoneCallConnection
  priceRequestAppliedRules?: Maybe<IPriceRequestAppliedRules>
  priceRequestId: IPriceRequest
  priceRequests: IPriceRequestConnection
  referenceDimensions?: Maybe<IReferenceDimensions>
  /** Gets the relay payments relay code's details */
  relayCodeDetails?: Maybe<IRelayCodeDetails>
  /** Gets the relay payments code by its id */
  relayPaymentsCode?: Maybe<IRelayPaymentsCode>
  /** Gets all relay payments codes for a given shipment accessorial */
  relayPaymentsCodes?: Maybe<Array<IRelayPaymentsCode>>
  requestForProposalLane: IRequestForProposalLane
  requestForProposalLaneFeedback: IRequestForProposalLaneFeedback
  requestForProposalLaneFeedbackLaneIds: Array<Scalars['String']>
  requestForProposalLaneFeedbackMetadata?: Maybe<IRequestForProposalLaneFeedbackMetadata>
  requestForProposalLaneFeedbacks: IRequestForProposalLaneFeedbackConnection
  requestForProposalLaneLaneIds: Array<Scalars['String']>
  requestForProposalLanePrices: Array<IRequestForProposalLanePrice>
  requestForProposalLanes: IRequestForProposalLaneConnection
  requestForProposalMetadata?: Maybe<IRequestForProposalMetadata>
  requestForProposalStrategies: Array<IRequestForProposalStrategy>
  requestForProposalStrategy: IRequestForProposalStrategy
  requestForProposalUpdateStatus: IRequestForProposalUpdateStatus
  requestForProposals: Array<IRequestForProposal>
  rfpExportStatus?: Maybe<IRfpExportStatus>
  rfpLaneLaneIds: Array<Scalars['String']>
  rfpLanes: IRequestForProposalLaneConnection
  rfpRowStatusesWithErrors: Array<INormFileGeneratorRowStatus>
  scraperJobConfigurationHistory: IScraperJobConfigurationHistory
  scraperJobConfigurationMetadata?: Maybe<IScraperJobConfigurationMetadata>
  scraperJobConfigurations: Array<IScraperJobConfiguration>
  /** Populate truck dropdown with Connection type pagination */
  searchAllCarrierApplicationTruckNumbers: ICarrierApplicationTruckNumberConnection
  /** Value search */
  searchCarrierApplicationTruckNumbers: Array<ICarrierApplicationTruckNumber>
  /** Fuzzy search for carrier applications. Only one of `ids` or `search_term` is required. */
  searchCarrierApplications: Array<ICarrierApplication>
  /** Fuzzy search for factoring companies. */
  searchFactors: IFactorConnection
  searchKeywordsForVendor?: Maybe<Array<IVendorKeyword>>
  /** Fuzzy search for shipper applications. Limited to a max of 50 returned shippers per call */
  searchShipperApplications: IShipperApplicationConnection
  searchTags?: Maybe<Array<ITag>>
  /** Populate trailer dropdown with Connection type pagination */
  searchTrailers: ITrailerConnection
  /** returns a default maximum of 50 rows */
  searchTransfixAdminUsers: IUserConnection
  searchVendorForKeyword?: Maybe<IMatchedVendorKeyword>
  /** finds all shipper applications associated with the given vendor including the counts of their facilities */
  searchVendorShipperFacilityDetails: IVendorShipperDetailsConnection
  searchVendorsForFacility: IAssignedFacilityVendorConnection
  shipment?: Maybe<IShipment>
  shipmentActiveCeTasks: Array<ITask>
  shipmentActiveCxTasks: Array<ITask>
  shipmentCeTasks: Array<ITask>
  shipmentCxTasks: Array<ITask>
  shipmentFmsSmsMessages: Array<IFmsSmsMessage>
  shipmentIssueCategories: Array<IShipmentIssueCategory>
  shipmentIssueDefaults: IShipmentIssueDefaults
  shipmentIssueFaults: Array<IShipmentIssueFault>
  shipmentIssueReasons: Array<IShipmentIssueReason>
  shipmentIssueSuggestedOwners: Array<IShipmentIssueSuggestedOwner>
  shipmentIssueTypes: Array<IShipmentIssueType>
  shipmentIssues: Array<IShipmentIssue>
  shipmentListForCarrier: ILaneCarrierMatchConnection
  /** Pending outbound raw EDI files for this shipment */
  shipmentPendingOutboundRawEdiFiles: Array<IOutboundRawEdiFile>
  shipmentReferenceRates?: Maybe<IReferenceRates>
  shipmentRoutingGuides: IShipmentRoutingGuides
  shipmentSmsMessages: Array<ISmsMessage>
  shipmentTaskCaps: Array<IShipmentTaskCap>
  shipmentTrueRates: ITrueRates
  shipments: IShipmentConnection
  /** Exact shipper with matching id */
  shipperApplication?: Maybe<IShipperApplication>
  /** Find a ShipperApplicationEdiConfig by ID or shipper_application_id */
  shipperApplicationEdiConfig?: Maybe<IShipperApplicationEdiConfig>
  shipperAutoAcceptRejectConfiguration?: Maybe<IShipperAutoAcceptRejectConfiguration>
  shipperAutoAcceptRejectResult?: Maybe<IShipperAutoAcceptRejectResult>
  shipperAutoAcceptRejectResults: Array<IShipperAutoAcceptRejectResult>
  shipperAutoAcceptRejectRules: Array<IShipperAutoAcceptRejectRule>
  shipperAwardEstimationConfiguration?: Maybe<IShipperAwardEstimationConfiguration>
  shipperDropTrailersConfiguration?: Maybe<IShipperDropTrailersConfiguration>
  shipperFuelMatrix?: Maybe<IShipperFuelMatrix>
  shipperFuelPaddMappings?: Maybe<Array<IShipperFuelPaddMapping>>
  shipperFuelRateConfig?: Maybe<IShipperFuelRateConfig>
  shipperKpiLinks?: Maybe<Array<ILink>>
  shipperKpiTrackingConfiguration?: Maybe<IShipperKpiTrackingConfiguration>
  shipperOnboardingKpiConfiguration?: Maybe<IShipperOnboardingKpiConfiguration>
  shipperRate?: Maybe<IShipperRate>
  shipperRates: IShipperRateConnection
  shipperTenderAppointmentConfiguration?: Maybe<IShipperTenderAppointmentConfiguration>
  shipperTrueRateConfiguration?: Maybe<IShipperTrueRateConfiguration>
  shouldTrackNow: IShouldTrackNow
  sourcedCarrierRates: ISourcedCarrierRateConnection
  /** Last n created shipments by Inbound Config for staging testing */
  stagingTestingLastCreatedShipments: Array<Scalars['ID']>
  stoppedTrackingShipments: Array<Scalars['ID']>
  todos: Array<ITodo>
  trackingOverview: ITrackingOverview
  /** Get details for a specific trailer */
  trailer: ITrailer
  /** Fetch the list of merged facilities to which a carrier might assign trailers */
  trailerAssignmentMergedFacilities: IMergedFacilityConnection
  /** Gets all trailers */
  trailers: ITrailerConnection
  translate: ITranslation
  transportationManagementSystems: Array<ITransportationManagementSystem>
  user?: Maybe<IUser>
  userFilterPreferences?: Maybe<Array<IUserFilterPreferences>>
  vendor?: Maybe<IVendor>
  vendorForFacility?: Maybe<IAssignedFacilityVendor>
  vendors: IVendorConnection
  waterfallSkipReasons: Array<IWaterfallSkipReason>
  whoElseIsHere: Array<IParentUser>
}

export type IQueryAccessorialsArgs = {
  excludeCarrierTonus?: Maybe<Scalars['Boolean']>
  ids?: Maybe<Array<Scalars['ID']>>
  name?: Maybe<IShipmentAccessorialNames>
  shipmentId?: Maybe<Scalars['ID']>
  withDeleted?: Maybe<Scalars['Boolean']>
}

export type IQueryActiveBackhaulRevenueShareAgreementsArgs = {
  partnerId?: Maybe<Scalars['ID']>
  partnerType?: Maybe<IBackhaulRevenueShareAgreementPartnerTypes>
  pickupDate: Scalars['ISO8601DateTime']
}

export type IQueryAmPodsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type IQueryAppointmentRecommendedStartAtTimeArgs = {
  id: Scalars['ID']
}

export type IQueryAs2CertificateMetadataArgs = {
  body: Scalars['String']
}

export type IQueryAs2ConnectionConfigArgs = {
  id: Scalars['ID']
}

export type IQueryAs2ConnectionConfigsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  identifier?: Maybe<Scalars['String']>
  last?: Maybe<Scalars['Int']>
}

export type IQueryAttachedDocumentsArgs = {
  shipmentId: Scalars['ID']
  type: IAttachedDocumentTypes
}

export type IQueryAutoAcceptRejectRulesArgs = {
  ids?: Maybe<Array<Scalars['ID']>>
}

export type IQueryBalanceDuesArgs = {
  shipmentId: Scalars['ID']
  state?: Maybe<Array<IAccountingStates>>
}

export type IQueryBidArgs = {
  id: Scalars['ID']
}

export type IQueryBidCountsArgs = {
  shipmentId: Scalars['ID']
  sourceTypes?: Maybe<Array<ICarrierBidSourceTypes>>
}

export type IQueryBidsArgs = {
  availability?: Maybe<IBidAvailabilityEnum>
  bidApprovalStates?: Maybe<Array<IBidApprovalStateEnum>>
  brokerPodKey?: Maybe<Scalars['String']>
  carrierStates?: Maybe<Array<ICarrierStateEnum>>
  limit?: Maybe<Scalars['Int']>
  onlyAvailable?: Maybe<Scalars['Boolean']>
  page?: Maybe<Scalars['Int']>
  regions?: Maybe<Array<IShipmentStopRegionTypes>>
  shipmentId?: Maybe<Scalars['ID']>
  sortBy?: Maybe<ICarrierOptionSortByEnum>
  sortDirection?: Maybe<ISortOrderEnum>
  sourceTypes?: Maybe<Array<ICarrierBidSourceTypes>>
  view?: Maybe<ICarrierOptionViewEnum>
}

export type IQueryBillCreditsArgs = {
  carrierApplicationId?: Maybe<Scalars['ID']>
  shipmentId?: Maybe<Scalars['ID']>
  state?: Maybe<Array<IAccountingStates>>
}

export type IQueryBillsArgs = {
  shipmentId: Scalars['ID']
  state?: Maybe<Array<IAccountingStates>>
}

export type IQueryCarrierApplicationArgs = {
  id: Scalars['ID']
}

export type IQueryCarrierApplicationUsersArgs = {
  carrierApplicationId: Scalars['ID']
  limit?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  onlyActive?: Maybe<Scalars['Boolean']>
  userTypes: Array<ICarrierUserTypes>
}

export type IQueryCarrierCallListForShipmentArgs = {
  deliveryRadius?: Maybe<Scalars['Int']>
  matchTypes?: Maybe<Array<ICarrierCallListMatchStrategyEnum>>
  pageCount?: Maybe<Scalars['Int']>
  perPage?: Maybe<Scalars['Int']>
  pickupRadius?: Maybe<Scalars['Int']>
  shipmentId: Scalars['ID']
  sortField?: Maybe<ICarrierCallListSortEnum>
  sortOrder?: Maybe<ISortOrderEnum>
}

export type IQueryCarrierComplianceMatchArgs = {
  carrierApplicationId: Scalars['ID']
  shipmentId: Scalars['ID']
}

export type IQueryCarrierTonusArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryCarrierTrackingProvidersArgs = {
  id: Scalars['ID']
}

export type IQueryComchecksArgs = {
  ids?: Maybe<Array<Scalars['ID']>>
  shipmentId?: Maybe<Scalars['ID']>
  withDeleted?: Maybe<Scalars['Boolean']>
}

export type IQueryComplianceChecklistArgs = {
  carrierApplicationId?: Maybe<Scalars['ID']>
  fleetPlannerMotorCarrierId?: Maybe<Scalars['ID']>
}

export type IQueryConfigGroupMappingArgs = {
  id: Scalars['ID']
}

export type IQueryConfigGroupMappingsArgs = {
  inboundConnectionConfigId: Scalars['ID']
}

export type IQueryConfigurableBuilderArgs = {
  id: Scalars['ID']
}

export type IQueryConfigurableBuilderTestArgs = {
  id: Scalars['ID']
}

export type IQueryConfigurableBuilderTestsArgs = {
  configurableBuilderId?: Maybe<Scalars['ID']>
}

export type IQueryConfigurableBuilderVersionArgs = {
  id: Scalars['ID']
}

export type IQueryConfigurableBuilderVersionsArgs = {
  configurableBuilderId: Scalars['ID']
}

export type IQueryConfigurableBuildersArgs = {
  transactionSet?: Maybe<ITransactionSetTypes>
}

export type IQueryConfigurableParserArgs = {
  id: Scalars['ID']
}

export type IQueryCurrentShipmentForUserArgs = {
  parentUserId: Scalars['ID']
}

export type IQueryDigitalCardDetailsArgs = {
  id: Scalars['ID']
}

export type IQueryDriverLocationsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  shipmentId: Scalars['ID']
}

export type IQueryDriverVerifiedArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryDrivingDistanceArgs = {
  from: ICoordinateInput
  to: ICoordinateInput
}

export type IQueryDrivingDistanceFromLatestLocationArgs = {
  shipmentId: Scalars['ID']
  to: ICoordinateInput
}

export type IQueryEdiChargeCodesArgs = {
  lineItemTitle?: Maybe<Scalars['String']>
  shipperApplicationId: Scalars['ID']
}

export type IQueryEdiInboundConnectionConfigArgs = {
  id: Scalars['ID']
}

export type IQueryEdiInboundConnectionConfigsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  connectionTypes?: Maybe<Array<IConnectionTypes>>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  partnerApplicationId?: Maybe<Scalars['ID']>
  partnerApplicationType?: Maybe<IPartnerApplicationTypes>
}

export type IQueryEdiInboundFileRouterConfigArgs = {
  id: Scalars['ID']
}

export type IQueryEdiMatchingFacilitiesArgs = {
  shipperFacilityUuid: Scalars['ID']
}

export type IQueryEdiMessageTypeArgs = {
  id: Scalars['ID']
}

export type IQueryEdiMessageTypesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  connectionConfigIds?: Maybe<Array<Scalars['ID']>>
  connectionConfigType?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type IQueryEdiOutboundConnectionConfigArgs = {
  id: Scalars['ID']
}

export type IQueryEdiOutboundConnectionConfigsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  connectionTypes?: Maybe<Array<IConnectionTypes>>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  partnerApplicationId?: Maybe<Scalars['ID']>
  partnerApplicationType?: Maybe<IPartnerApplicationTypes>
}

export type IQueryExportShipmentCarrierCallListArgs = {
  deliveryRadius?: Maybe<Scalars['Int']>
  matchTypes?: Maybe<Array<ICarrierCallListMatchStrategyEnum>>
  pickupRadius?: Maybe<Scalars['Int']>
  shipmentId: Scalars['ID']
  sortField?: Maybe<ICarrierCallListSortEnum>
  sortOrder?: Maybe<ISortOrderEnum>
}

export type IQueryFacilitiesArgs = {
  city?: Maybe<Scalars['String']>
  countryCode?: Maybe<ICountries>
  limit?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  reviewStatus?: Maybe<Array<IFacilityReviewStatuses>>
  searchAddress?: Maybe<Scalars['Boolean']>
  searchTerm?: Maybe<Scalars['String']>
  shipperApplicationId?: Maybe<Scalars['ID']>
  shipperFacilityCode?: Maybe<Scalars['String']>
  shipperName?: Maybe<Scalars['String']>
  stateCode?: Maybe<IStates>
  uuid?: Maybe<Scalars['ID']>
  vendorName?: Maybe<Scalars['String']>
}

export type IQueryFacilityArgs = {
  id?: Maybe<Scalars['ID']>
  shipperFacilityUuid?: Maybe<Scalars['ID']>
  uuid?: Maybe<Scalars['ID']>
}

export type IQueryFacilityRelayPaymentsNetworkStatusArgs = {
  id?: Maybe<Scalars['ID']>
  stopId?: Maybe<Scalars['ID']>
}

export type IQueryFindCarrierApplicationByDotNumberArgs = {
  dotNumber: Scalars['String']
}

export type IQueryFindCarrierApplicationByFleetPlannerMotorCarrierIdArgs = {
  fleetPlannerMotorCarrierId: Scalars['ID']
}

export type IQueryFindCarrierApplicationByMcNumberArgs = {
  mcNumber: Scalars['String']
}

export type IQueryFindOnboardingCarrierArgs = {
  dotNumber?: Maybe<Scalars['Int']>
  mcNumber?: Maybe<Scalars['Int']>
}

export type IQueryGeocodingSearchArgs = {
  countries?: Maybe<Array<IGeocodingAllowedCountryEnum>>
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  resultTypes?: Maybe<Array<IGeocodingResultTypeEnum>>
  searchString?: Maybe<Scalars['String']>
}

export type IQueryGetCalculatedMilesArgs = {
  stops: Array<ILocationInput>
}

export type IQueryGetEtaForArgs = {
  shipmentIds: Array<Scalars['ID']>
}

export type IQueryGroupArgs = {
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
}

export type IQueryGroupsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
  search?: Maybe<Scalars['String']>
}

export type IQueryHighwayCarrierArgs = {
  carrierApplicationId: Scalars['ID']
}

export type IQueryInsuranceContactsArgs = {
  carrierApplicationId: Scalars['ID']
}

export type IQueryInvoiceCreditsArgs = {
  shipmentId: Scalars['ID']
  state?: Maybe<Array<IAccountingStates>>
}

export type IQueryInvoicesArgs = {
  shipmentId: Scalars['ID']
  state?: Maybe<Array<IAccountingStates>>
}

export type IQueryIssueAutomationRuleArgs = {
  id: Scalars['ID']
}

export type IQueryIssueAutomationRulesByIssueTypeArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  shipmentIssueTypeId: Scalars['ID']
}

export type IQueryLaneHistoryArgs = {
  carrierApplicationId: Scalars['ID']
  shipmentId: Scalars['ID']
}

export type IQueryLaneMarketInsightsArgs = {
  deliveryLocation: ILocationInput
  equipmentParentKey: IMarketInsightEquipmentKeyTypes
  pickupLocation: ILocationInput
}

export type IQueryLatestUserAvailabilitiesByTypeArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  groupIds?: Maybe<Array<Scalars['ID']>>
  inNoOpsGroup?: Maybe<Scalars['Boolean']>
  isAvailable?: Maybe<Scalars['Boolean']>
  last?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  types?: Maybe<Array<IUserAvailabilityTypes>>
  userIds?: Maybe<Array<Scalars['ID']>>
}

export type IQueryMapboxFeaturesArgs = {
  searchString: Scalars['String']
}

export type IQueryMarketRateArgs = {
  deliveryCity: Scalars['String']
  deliveryStateCode: Scalars['String']
  equipmentKey: ITcmEquipmentKeyTypes
  pickupCity: Scalars['String']
  pickupStateCode: Scalars['String']
  shipperApplicationId?: Maybe<Scalars['ID']>
}

export type IQueryMatchFacilitiesArgs = {
  address: Scalars['String']
  addressLine2?: Maybe<Scalars['String']>
  city: Scalars['String']
  countryCode: ICountries
  limit?: Maybe<Scalars['Int']>
  numberOfDocks?: Maybe<ICountries>
  stateCode: IStates
  zipcode: Scalars['String']
}

export type IQueryMergedFacilitiesArgs = {
  facilityUuids: Array<IFacilityUuidTypeInput>
}

export type IQueryMotorCarrierComplianceFlagsArgs = {
  carrierApplicationId: Scalars['ID']
}

export type IQueryMotorCarrierTransfixRulesAssessmentsArgs = {
  carrierApplicationId: Scalars['ID']
}

export type IQueryNamespacedActivelyTaskedShipmentsArgs = {
  after?: Maybe<Scalars['String']>
  amPodIds?: Maybe<Array<Scalars['ID']>>
  before?: Maybe<Scalars['String']>
  carrierIds?: Maybe<Array<Scalars['ID']>>
  deliveryDate?: Maybe<Scalars['ISO8601Date']>
  endDeliveryDate?: Maybe<Scalars['ISO8601Date']>
  endPickupDate?: Maybe<Scalars['ISO8601Date']>
  excludeIds?: Maybe<Array<Scalars['ID']>>
  first?: Maybe<Scalars['Int']>
  hot?: Maybe<Scalars['Boolean']>
  ids?: Maybe<Array<Scalars['ID']>>
  inNoOpsGroup?: Maybe<Scalars['Boolean']>
  last?: Maybe<Scalars['Int']>
  mustGo?: Maybe<Scalars['Boolean']>
  pickupDate?: Maybe<Scalars['ISO8601Date']>
  searchTerm?: Maybe<Scalars['String']>
  shipperGroupIds?: Maybe<Array<Scalars['ID']>>
  shipperIds?: Maybe<Array<Scalars['ID']>>
  snoozed?: Maybe<Scalars['Boolean']>
  states?: Maybe<Array<IShipmentStates>>
  taskAssignedToIds?: Maybe<Array<Scalars['ID']>>
  taskNamespaces?: Maybe<Array<ITaskNamespaces>>
  tasksPastDue?: Maybe<Scalars['Boolean']>
  tasksUnassigned?: Maybe<Scalars['Boolean']>
}

export type IQueryNearbyPickupShipmentsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  radiusInMi?: Maybe<Scalars['Int']>
  shipmentId: Scalars['ID']
}

export type IQueryNearbyReloadShipmentsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  radiusInMi?: Maybe<Scalars['Int']>
  shipmentId: Scalars['ID']
}

export type IQueryNormFileGeneatorStatusArgs = {
  id: Scalars['ID']
}

export type IQueryNotificationsArgs = {
  limit?: Maybe<Scalars['Int']>
}

export type IQueryOfferedShipmentsArgs = {
  filter: IOfferedShipmentsFilter
  parentUserId: Scalars['ID']
}

export type IQueryPaginatedBidsArgs = {
  after?: Maybe<Scalars['String']>
  availability?: Maybe<IBidAvailabilityEnum>
  before?: Maybe<Scalars['String']>
  bidApprovalStates?: Maybe<Array<IBidApprovalStateEnum>>
  brokerPodKey?: Maybe<Scalars['String']>
  carrierStates?: Maybe<Array<ICarrierStateEnum>>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  regions?: Maybe<Array<IShipmentStopRegionTypes>>
  shipmentId?: Maybe<Scalars['ID']>
  sortBy?: Maybe<ICarrierOptionSortByEnum>
  sortDirection?: Maybe<ISortOrderEnum>
  sourceTypes?: Maybe<Array<ICarrierBidSourceTypes>>
  view?: Maybe<ICarrierOptionViewEnum>
}

export type IQueryPaginatedFacilitiesArgs = {
  address?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  countryCode?: Maybe<ICountries>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  regionFilter?: Maybe<IRegionTypes>
  reviewStatus?: Maybe<Array<IFacilityReviewStatuses>>
  searchAddress?: Maybe<Scalars['Boolean']>
  searchTerm?: Maybe<Scalars['String']>
  shipperApplicationId?: Maybe<Scalars['ID']>
  shipperApplicationIds?: Maybe<Array<Scalars['ID']>>
  shipperFacilityCode?: Maybe<Scalars['String']>
  shipperFacilityUuids?: Maybe<Array<Scalars['ID']>>
  shipperName?: Maybe<Scalars['String']>
  sortBy?: Maybe<IFacilitiesSortEnum>
  sortDirection?: Maybe<ISortOrderEnum>
  stateCode?: Maybe<IStates>
  uuid?: Maybe<Scalars['ID']>
  vendorIndustry?: Maybe<IVendorIndustries>
  vendorName?: Maybe<Scalars['String']>
}

export type IQueryPaginatedShipmentIssuesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  carrierId?: Maybe<Scalars['ID']>
  carrierIds?: Maybe<Array<Scalars['ID']>>
  createdAt?: Maybe<Scalars['ISO8601Date']>
  createdAtEnd?: Maybe<Scalars['ISO8601Date']>
  createdById?: Maybe<Scalars['ID']>
  createdByIds?: Maybe<Array<Scalars['ID']>>
  deliveryDate?: Maybe<Scalars['ISO8601Date']>
  deliveryDateEnd?: Maybe<Scalars['ISO8601Date']>
  deliveryRegions?: Maybe<Array<IShipmentStopRegionTypes>>
  deliveryState?: Maybe<IStates>
  deliveryStates?: Maybe<Array<IStates>>
  facilityUuid?: Maybe<Scalars['String']>
  facilityUuids?: Maybe<Array<Scalars['String']>>
  first?: Maybe<Scalars['Int']>
  issueCategoryIds?: Maybe<Array<Scalars['ID']>>
  issueState?: Maybe<IShipmentIssueStates>
  issueStates?: Maybe<Array<IShipmentIssueStates>>
  issueTypeIds?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
  ownerId?: Maybe<Scalars['ID']>
  owners?: Maybe<Array<IShipmentIssueFollowerInput>>
  pickupDate?: Maybe<Scalars['ISO8601Date']>
  pickupDateEnd?: Maybe<Scalars['ISO8601Date']>
  pickupRegions?: Maybe<Array<IShipmentStopRegionTypes>>
  pickupState?: Maybe<IStates>
  pickupStates?: Maybe<Array<IStates>>
  podIds?: Maybe<Array<Scalars['ID']>>
  priorities?: Maybe<Array<Scalars['Int']>>
  shipmentCharacteristics?: Maybe<Array<IShipmentCharacteristicsEnum>>
  shipmentId?: Maybe<Scalars['ID']>
  shipmentIds?: Maybe<Array<Scalars['ID']>>
  shipmentStates?: Maybe<Array<IShipmentStates>>
  shipperId?: Maybe<Scalars['ID']>
  shipperIds?: Maybe<Array<Scalars['ID']>>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
  subscribedToById?: Maybe<Scalars['ID']>
  subscribedsToBy?: Maybe<Array<IShipmentIssueFollowerInput>>
  trackingLevels?: Maybe<Array<Scalars['Int']>>
  userEscalated?: Maybe<Scalars['Boolean']>
  userOwned?: Maybe<Scalars['Boolean']>
}

export type IQueryPaginatedShipperFacilitiesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  nameLocationSearch?: Maybe<Scalars['String']>
  poolsOnlyFilter?: Maybe<Scalars['Boolean']>
  regionFilter?: Maybe<IRegionTypes>
  shipperApplicationId?: Maybe<Scalars['ID']>
  sortBy?: Maybe<IFacilitiesSortEnum>
  sortDirection?: Maybe<ISortOrderEnum>
}

export type IQueryPhoneCallsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  campaignType?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  fromPhoneNumber?: Maybe<Scalars['String']>
  fromUserId?: Maybe<Scalars['ID']>
  last?: Maybe<Scalars['Int']>
  query?: Maybe<Scalars['String']>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
  toPhoneNumber?: Maybe<Scalars['String']>
  toUserId?: Maybe<Scalars['ID']>
}

export type IQueryPriceRequestAppliedRulesArgs = {
  priceRequestId: Scalars['ID']
}

export type IQueryPriceRequestIdArgs = {
  id: Scalars['ID']
}

export type IQueryPriceRequestsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  createdBy?: Maybe<Array<Scalars['String']>>
  createdDate?: Maybe<Scalars['String']>
  createdEndDate?: Maybe<Scalars['ISO8601Date']>
  createdStartDate?: Maybe<Scalars['ISO8601Date']>
  deliveryCity?: Maybe<Scalars['String']>
  deliveryPostalCode?: Maybe<Scalars['String']>
  deliveryRange?: Maybe<Scalars['Int']>
  deliveryStateCode?: Maybe<Scalars['String']>
  dropType?: Maybe<Array<Scalars['String']>>
  equipmentParentId?: Maybe<Array<Scalars['ID']>>
  externalId?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  isMultiStop?: Maybe<Scalars['Boolean']>
  isTestQuote?: Maybe<Scalars['Boolean']>
  last?: Maybe<Scalars['Int']>
  pickupCity?: Maybe<Scalars['String']>
  pickupPostalCode?: Maybe<Scalars['String']>
  pickupRange?: Maybe<Scalars['Int']>
  pickupStateCode?: Maybe<Scalars['String']>
  priceRequestId?: Maybe<Scalars['ID']>
  shipperApplicationId?: Maybe<Scalars['ID']>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
}

export type IQueryRelayCodeDetailsArgs = {
  id: Scalars['ID']
}

export type IQueryRelayPaymentsCodeArgs = {
  id: Scalars['ID']
}

export type IQueryRelayPaymentsCodesArgs = {
  codeStatus?: Maybe<Array<ICodeStatuses>>
  codeType?: Maybe<Array<ICodeTypes>>
  shipmentAccessorialId?: Maybe<Scalars['ID']>
}

export type IQueryRequestForProposalLaneArgs = {
  id: Scalars['ID']
}

export type IQueryRequestForProposalLaneFeedbackArgs = {
  id: Scalars['ID']
}

export type IQueryRequestForProposalLaneFeedbackLaneIdsArgs = {
  awardStatus?: Maybe<Array<Scalars['String']>>
  awardType?: Maybe<Array<Scalars['String']>>
  currentUser?: Maybe<Scalars['Boolean']>
  effectiveMarginDollarRange?: Maybe<IRequestForProposalPriceRange>
  effectiveMarginPctRange?: Maybe<IRequestForProposalPriceRange>
  incumbentLaneId?: Maybe<Scalars['String']>
  laneIds?: Maybe<Array<Scalars['String']>>
  requestForProposalId: Scalars['ID']
  volumeRange?: Maybe<IRequestForProposalPriceRange>
}

export type IQueryRequestForProposalLaneFeedbackMetadataArgs = {
  requestForProposalId: Scalars['ID']
}

export type IQueryRequestForProposalLaneFeedbacksArgs = {
  after?: Maybe<Scalars['String']>
  awardStatus?: Maybe<Array<Scalars['String']>>
  awardType?: Maybe<Array<Scalars['String']>>
  before?: Maybe<Scalars['String']>
  currentUser?: Maybe<Scalars['Boolean']>
  effectiveMarginDollarRange?: Maybe<IRequestForProposalPriceRange>
  effectiveMarginPctRange?: Maybe<IRequestForProposalPriceRange>
  first?: Maybe<Scalars['Int']>
  incumbentLaneId?: Maybe<Scalars['String']>
  laneIds?: Maybe<Array<Scalars['String']>>
  last?: Maybe<Scalars['Int']>
  requestForProposalId: Scalars['ID']
  volumeRange?: Maybe<IRequestForProposalPriceRange>
}

export type IQueryRequestForProposalLaneLaneIdsArgs = {
  allInDatPctRange?: Maybe<IRequestForProposalPriceRange>
  awardStatus?: Maybe<Array<Scalars['String']>>
  awardType?: Maybe<Array<Scalars['String']>>
  carrierConfidence?: Maybe<Array<Scalars['String']>>
  currentUser?: Maybe<Scalars['Boolean']>
  defenseAction?: Maybe<Array<Scalars['String']>>
  deliveryLocation?: Maybe<IRequestForProposalLocation>
  dropType?: Maybe<Array<Scalars['String']>>
  effectiveMarginDollarRange?: Maybe<IRequestForProposalPriceRange>
  effectiveMarginPctRange?: Maybe<IRequestForProposalPriceRange>
  equipMapped?: Maybe<Array<Scalars['String']>>
  extraStops?: Maybe<Array<Scalars['String']>>
  hasFeedback?: Maybe<Scalars['Boolean']>
  hasFeedbackNotes?: Maybe<Scalars['Boolean']>
  hasNotes?: Maybe<Scalars['Boolean']>
  hasPricingAdjustment?: Maybe<Scalars['Boolean']>
  hasTttOverride?: Maybe<Scalars['Boolean']>
  incumbentAwardType?: Maybe<Array<Scalars['String']>>
  incumbentLaneId?: Maybe<Scalars['String']>
  laneDeliveryLocation?: Maybe<IRequestForProposalLaneLocation>
  laneDesirability?: Maybe<Array<Scalars['String']>>
  laneIds?: Maybe<Array<Scalars['String']>>
  lanePickupLocation?: Maybe<IRequestForProposalLaneLocation>
  lengthOfHaul?: Maybe<Array<Scalars['String']>>
  liveAuditRiskLevel?: Maybe<Array<Scalars['String']>>
  marketDemandScore?: Maybe<Array<Scalars['String']>>
  pickupLocation?: Maybe<IRequestForProposalLocation>
  pricingRound: Scalars['Int']
  requestForProposalId: Scalars['ID']
  roundAuditStatus?: Maybe<Array<Scalars['String']>>
  simPathsRiskLabel?: Maybe<Array<Scalars['String']>>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
  strategies?: Maybe<Array<Scalars['String']>>
  varianceFlags?: Maybe<Array<Scalars['String']>>
  volumeRange?: Maybe<IRequestForProposalPriceRange>
  zones?: Maybe<Array<Scalars['String']>>
}

export type IQueryRequestForProposalLanePricesArgs = {
  requestForProposalLaneId: Scalars['ID']
  roundNumber: Array<Scalars['Int']>
}

export type IQueryRequestForProposalLanesArgs = {
  after?: Maybe<Scalars['String']>
  allInDatPctRange?: Maybe<IRequestForProposalPriceRange>
  awardStatus?: Maybe<Array<Scalars['String']>>
  awardType?: Maybe<Array<Scalars['String']>>
  before?: Maybe<Scalars['String']>
  carrierConfidence?: Maybe<Array<Scalars['String']>>
  currentUser?: Maybe<Scalars['Boolean']>
  defenseAction?: Maybe<Array<Scalars['String']>>
  deliveryLocation?: Maybe<IRequestForProposalLocation>
  dropType?: Maybe<Array<Scalars['String']>>
  effectiveMarginDollarRange?: Maybe<IRequestForProposalPriceRange>
  effectiveMarginPctRange?: Maybe<IRequestForProposalPriceRange>
  equipMapped?: Maybe<Array<Scalars['String']>>
  extraStops?: Maybe<Array<Scalars['String']>>
  first?: Maybe<Scalars['Int']>
  hasFeedback?: Maybe<Scalars['Boolean']>
  hasFeedbackNotes?: Maybe<Scalars['Boolean']>
  hasNotes?: Maybe<Scalars['Boolean']>
  hasPricingAdjustment?: Maybe<Scalars['Boolean']>
  hasTttOverride?: Maybe<Scalars['Boolean']>
  incumbentAwardType?: Maybe<Array<Scalars['String']>>
  incumbentLaneId?: Maybe<Scalars['String']>
  laneDeliveryLocation?: Maybe<IRequestForProposalLaneLocation>
  laneDesirability?: Maybe<Array<Scalars['String']>>
  laneIds?: Maybe<Array<Scalars['String']>>
  lanePickupLocation?: Maybe<IRequestForProposalLaneLocation>
  last?: Maybe<Scalars['Int']>
  lengthOfHaul?: Maybe<Array<Scalars['String']>>
  liveAuditRiskLevel?: Maybe<Array<Scalars['String']>>
  marketDemandScore?: Maybe<Array<Scalars['String']>>
  noErrors?: Maybe<Scalars['Boolean']>
  pickupLocation?: Maybe<IRequestForProposalLocation>
  pricingRound: Scalars['Int']
  requestForProposalId: Scalars['ID']
  roundAuditStatus?: Maybe<Array<Scalars['String']>>
  simPathsRiskLabel?: Maybe<Array<Scalars['String']>>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
  strategies?: Maybe<Array<Scalars['String']>>
  varianceFlags?: Maybe<Array<Scalars['String']>>
  volumeRange?: Maybe<IRequestForProposalPriceRange>
  zones?: Maybe<Array<Scalars['String']>>
}

export type IQueryRequestForProposalMetadataArgs = {
  pricingRound: Scalars['Int']
  requestForProposalId: Scalars['ID']
}

export type IQueryRequestForProposalStrategiesArgs = {
  name?: Maybe<Scalars['String']>
  rfpId?: Maybe<Scalars['ID']>
}

export type IQueryRequestForProposalStrategyArgs = {
  id: Scalars['ID']
}

export type IQueryRequestForProposalUpdateStatusArgs = {
  requestForProposalId: Scalars['ID']
}

export type IQueryRequestForProposalsArgs = {
  availableRounds?: Maybe<Scalars['Boolean']>
  ids?: Maybe<Array<Scalars['ID']>>
}

export type IQueryRfpExportStatusArgs = {
  requestForProposalId: Scalars['ID']
}

export type IQueryRfpLaneLaneIdsArgs = {
  filters?: Maybe<IRfpLaneFilters>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
}

export type IQueryRfpLanesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filters?: Maybe<IRfpLaneFilters>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
}

export type IQueryRfpRowStatusesWithErrorsArgs = {
  rfpId: Scalars['ID']
}

export type IQueryScraperJobConfigurationHistoryArgs = {
  jobUuid: Scalars['ID']
}

export type IQueryScraperJobConfigurationsArgs = {
  shipperName?: Maybe<Array<Scalars['String']>>
  tmsName?: Maybe<Array<Scalars['String']>>
}

export type IQuerySearchAllCarrierApplicationTruckNumbersArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  carrierApplicationId: Scalars['ID']
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  searchTerm: Scalars['String']
}

export type IQuerySearchCarrierApplicationTruckNumbersArgs = {
  carrierApplicationId: Scalars['ID']
  searchTerm: Scalars['String']
}

export type IQuerySearchCarrierApplicationsArgs = {
  ids?: Maybe<Array<Scalars['ID']>>
  includeDeleted?: Maybe<Scalars['Boolean']>
  limit?: Maybe<Scalars['Int']>
  searchTerm?: Maybe<Scalars['String']>
}

export type IQuerySearchFactorsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  searchTerm: Scalars['String']
}

export type IQuerySearchKeywordsForVendorArgs = {
  id: Scalars['ID']
}

export type IQuerySearchShipperApplicationsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
  searchTerm?: Maybe<Scalars['String']>
  state?: Maybe<IShipperApplicationStates>
}

export type IQuerySearchTagsArgs = {
  domain: ITaggableDomainsEnum
  taggableIds?: Maybe<Array<Scalars['ID']>>
  taggableType?: Maybe<ITaggableTypesEnum>
  variants?: Maybe<Array<ITaggableVariantsEnum>>
}

export type IQuerySearchTrailersArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  carrierId: Scalars['ID']
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  searchTerm: Scalars['String']
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
  states?: Maybe<Array<Scalars['String']>>
}

export type IQuerySearchTransfixAdminUsersArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  ids?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
  searchTerm?: Maybe<Scalars['String']>
}

export type IQuerySearchVendorForKeywordArgs = {
  value: Scalars['String']
}

export type IQuerySearchVendorShipperFacilityDetailsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  vendorId: Scalars['ID']
}

export type IQuerySearchVendorsForFacilityArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  facilityUuid: Scalars['ID']
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
}

export type IQueryShipmentArgs = {
  id: Scalars['ID']
}

export type IQueryShipmentActiveCeTasksArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryShipmentActiveCxTasksArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryShipmentCeTasksArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryShipmentCxTasksArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryShipmentFmsSmsMessagesArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryShipmentIssueDefaultsArgs = {
  shipmentId: Scalars['ID']
  shipmentIssueTypeId: Scalars['ID']
}

export type IQueryShipmentIssueSuggestedOwnersArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryShipmentIssueTypesArgs = {
  withDeleted?: Maybe<Scalars['Boolean']>
}

export type IQueryShipmentIssuesArgs = {
  ids?: Maybe<Array<Scalars['ID']>>
  shipmentId?: Maybe<Scalars['ID']>
}

export type IQueryShipmentListForCarrierArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  carrierId: Scalars['ID']
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  matchTypes?: Maybe<Array<ILaneCarrierMatchListFilterEnum>>
}

export type IQueryShipmentPendingOutboundRawEdiFilesArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryShipmentReferenceRatesArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryShipmentRoutingGuidesArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryShipmentSmsMessagesArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryShipmentTrueRatesArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryShipmentsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  carrierApplicationIds?: Maybe<Array<Scalars['ID']>>
  carrierAssignedAfter?: Maybe<Scalars['ISO8601DateTime']>
  carrierAssignedBefore?: Maybe<Scalars['ISO8601DateTime']>
  deliveryCity?: Maybe<Scalars['String']>
  deliveryDates?: Maybe<Array<Scalars['ISO8601Date']>>
  deliveryMiles?: Maybe<Scalars['Int']>
  deliveryStateCode?: Maybe<Scalars['String']>
  dropTrailer?: Maybe<Scalars['Boolean']>
  first?: Maybe<Scalars['Int']>
  hasClaims?: Maybe<Scalars['Boolean']>
  hasTrailer?: Maybe<Scalars['Boolean']>
  ids?: Maybe<Array<Scalars['ID']>>
  last?: Maybe<Scalars['Int']>
  managedByTransfix?: Maybe<Scalars['Boolean']>
  noAppointmentTime?: Maybe<Scalars['Boolean']>
  pickupCity?: Maybe<Scalars['String']>
  pickupDates?: Maybe<Array<Scalars['ISO8601Date']>>
  pickupMiles?: Maybe<Scalars['Int']>
  pickupStateCode?: Maybe<Scalars['String']>
  query?: Maybe<Scalars['String']>
  sameDaySpot?: Maybe<Scalars['Boolean']>
  shipperApplicationIds?: Maybe<Array<Scalars['ID']>>
  shipperFacilityUuids?: Maybe<Array<Scalars['ID']>>
  shipperRateId?: Maybe<Scalars['ID']>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
  state?: Maybe<Array<IShipmentStates>>
  unconfirmedAppointment?: Maybe<Scalars['Boolean']>
}

export type IQueryShipperApplicationArgs = {
  id: Scalars['ID']
}

export type IQueryShipperApplicationEdiConfigArgs = {
  id?: Maybe<Scalars['ID']>
  shipperApplicationId?: Maybe<Scalars['ID']>
}

export type IQueryShipperAutoAcceptRejectConfigurationArgs = {
  isActive?: Maybe<Scalars['Boolean']>
  shipmentType: Scalars['String']
  shipperApplicationId: Scalars['ID']
}

export type IQueryShipperAutoAcceptRejectResultArgs = {
  isFinal?: Maybe<Scalars['Boolean']>
  shipmentId: Scalars['ID']
}

export type IQueryShipperAutoAcceptRejectResultsArgs = {
  isFinal?: Maybe<Scalars['Boolean']>
  shipmentId: Scalars['ID']
}

export type IQueryShipperAutoAcceptRejectRulesArgs = {
  configurationId?: Maybe<Scalars['ID']>
  isActive?: Maybe<Scalars['Boolean']>
  shipmentType?: Maybe<Scalars['String']>
  shipperApplicationId?: Maybe<Scalars['ID']>
}

export type IQueryShipperAwardEstimationConfigurationArgs = {
  shipperApplicationId: Scalars['ID']
}

export type IQueryShipperDropTrailersConfigurationArgs = {
  shipperApplicationId: Scalars['ID']
}

export type IQueryShipperFuelMatrixArgs = {
  shipperApplicationId: Scalars['ID']
}

export type IQueryShipperFuelPaddMappingsArgs = {
  shipperApplicationId: Scalars['ID']
}

export type IQueryShipperFuelRateConfigArgs = {
  shipperApplicationId: Scalars['ID']
}

export type IQueryShipperKpiLinksArgs = {
  linkType?: Maybe<IShipperLinkTypes>
  shipperApplicationId: Scalars['ID']
}

export type IQueryShipperKpiTrackingConfigurationArgs = {
  shipperApplicationId: Scalars['ID']
}

export type IQueryShipperOnboardingKpiConfigurationArgs = {
  shipperApplicationId: Scalars['ID']
}

export type IQueryShipperRateArgs = {
  id: Scalars['ID']
}

export type IQueryShipperRatesArgs = {
  after?: Maybe<Scalars['String']>
  awardType?: Maybe<IShipperRateAwardTypeEnum>
  before?: Maybe<Scalars['String']>
  carrierApplicationIds?: Maybe<Array<Scalars['ID']>>
  carrierSalesRepIds?: Maybe<Array<Scalars['ID']>>
  deliveryLocation?: Maybe<ILocationFilterInput>
  dropTypes?: Maybe<Array<IFacilityScheduleRulesUnloadTypes>>
  equipmentIds?: Maybe<Array<Scalars['ID']>>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  pickupLocation?: Maybe<ILocationFilterInput>
  shipperApplicationIds?: Maybe<Array<Scalars['ID']>>
  shipperRateId?: Maybe<Scalars['ID']>
  shouldSource?: Maybe<Scalars['Boolean']>
  sortBy?: Maybe<IShipperRatesSortByEnum>
  sortDirection?: Maybe<ISortOrderEnum>
  sourceStatuses?: Maybe<Array<IShipperRateSourceStatusEnum>>
}

export type IQueryShipperTenderAppointmentConfigurationArgs = {
  shipperApplicationId: Scalars['ID']
}

export type IQueryShipperTrueRateConfigurationArgs = {
  shipperApplicationId: Scalars['ID']
}

export type IQueryShouldTrackNowArgs = {
  parentUserId: Scalars['ID']
}

export type IQuerySourcedCarrierRatesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  carrierApplicationIds?: Maybe<Array<Scalars['ID']>>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  shipperRateIds?: Maybe<Array<Scalars['ID']>>
}

export type IQueryStagingTestingLastCreatedShipmentsArgs = {
  inboundConnectionConfigId: Scalars['ID']
  top?: Scalars['Int']
}

export type IQueryTodosArgs = {
  carriers: Array<IMotorCarriersInput>
}

export type IQueryTrackingOverviewArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryTrailerArgs = {
  trailerId?: Maybe<Scalars['ID']>
  trailerNumber?: Maybe<Scalars['String']>
}

export type IQueryTrailerAssignmentMergedFacilitiesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  dotNumber: Scalars['ID']
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  mcNumber: Scalars['ID']
  searchTerm?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
}

export type IQueryTrailersArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  carrierIds?: Maybe<Array<Scalars['ID']>>
  deliveryDate?: Maybe<Scalars['ISO8601Date']>
  first?: Maybe<Scalars['Int']>
  isShipmentDrop?: Maybe<Scalars['Boolean']>
  last?: Maybe<Scalars['Int']>
  numbers?: Maybe<Array<Scalars['String']>>
  pickupDate?: Maybe<Scalars['ISO8601Date']>
  shipmentIds?: Maybe<Array<Scalars['ID']>>
  shipmentStates?: Maybe<Array<IShipmentStates>>
  shipperFacilityUuids?: Maybe<Array<Scalars['String']>>
  shipperIds?: Maybe<Array<Scalars['ID']>>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
  states?: Maybe<Array<Scalars['String']>>
}

export type IQueryTranslateArgs = {
  fromLanguage?: Maybe<Scalars['String']>
  text: Scalars['String']
  toLanguage?: Maybe<Scalars['String']>
}

export type IQueryUserArgs = {
  id: Scalars['ID']
}

export type IQueryUserFilterPreferencesArgs = {
  filterType?: Maybe<IUserFilterTypes>
}

export type IQueryVendorArgs = {
  id: Scalars['ID']
}

export type IQueryVendorForFacilityArgs = {
  facilityUuid: Scalars['ID']
  id: Scalars['ID']
}

export type IQueryVendorsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  facilityUuid?: Maybe<Scalars['ID']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  shipperFacilityUuid?: Maybe<Scalars['ID']>
}

export type IQueryWhoElseIsHereArgs = {
  currentUrl: Scalars['String']
}

export type IRadiusInput = {
  unit?: Maybe<IDistanceUnits>
  value: Scalars['Int']
}

export type IRate = ICreatedByUser & {
  __typename?: 'Rate'
  amount: Scalars['Float']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  id: Scalars['ID']
  rateTypeKey: IRateTypeKeyTypes
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IRateConfirmationAgreement = {
  __typename?: 'RateConfirmationAgreement'
  carrierSignature?: Maybe<Scalars['String']>
  carrierSignedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  signedBy: IUser
}

export type IRateInput = {
  amount: Scalars['Float']
  typeKey: IRateTypeKeyTypes
}

export enum IRateTypeKeyTypes {
  btf_auto_fuel_rpm = 'btf_auto_fuel_rpm',
  bulk_update_shipper_per_mile_fuel_rate = 'bulk_update_shipper_per_mile_fuel_rate',
  contract_all_in = 'contract_all_in',
  contract_fuel_all = 'contract_fuel_all',
  contract_fuel_rpm = 'contract_fuel_rpm',
  contract_linehaul = 'contract_linehaul',
  contract_min = 'contract_min',
  contract_rpm = 'contract_rpm',
  cover_now = 'cover_now',
  cover_now_at_booking_time = 'cover_now_at_booking_time',
  /** DAT */
  dat_rate = 'dat_rate',
  edi_tender_create = 'edi_tender_create',
  edi_tender_update = 'edi_tender_update',
  email_scraper = 'email_scraper',
  fuel_schedule_auto_fuel_rpm = 'fuel_schedule_auto_fuel_rpm',
  justransform = 'justransform',
  manual_stark = 'manual_stark',
  manual_stark_script = 'manual_stark_script',
  manual_stark_shipper_per_mile_fuel_rate = 'manual_stark_shipper_per_mile_fuel_rate',
  manual_stark_shipper_total_fuel_rate = 'manual_stark_shipper_total_fuel_rate',
  matched_spot_bid = 'matched_spot_bid',
  rfp_lane_carrier_all_in = 'rfp_lane_carrier_all_in',
  rfp_lane_carrier_line_haul_flat = 'rfp_lane_carrier_line_haul_flat',
  rfp_lane_carrier_line_haul_rpm = 'rfp_lane_carrier_line_haul_rpm',
  rfp_lane_carrier_min_charge = 'rfp_lane_carrier_min_charge',
  synthetic_rate = 'synthetic_rate',
  transfix_account_manager_target = 'transfix_account_manager_target',
  /** CMT */
  transfix_carrier_manager_target = 'transfix_carrier_manager_target',
  transfix_cost_manual_override = 'transfix_cost_manual_override',
  transfix_cost_prediction_30th_percentile = 'transfix_cost_prediction_30th_percentile',
  transfix_cost_prediction_40th_percentile = 'transfix_cost_prediction_40th_percentile',
  transfix_cost_prediction_65th_percentile = 'transfix_cost_prediction_65th_percentile',
  transfix_cost_prediction_90th_percentile = 'transfix_cost_prediction_90th_percentile',
  transfix_cost_prediction_bottom = 'transfix_cost_prediction_bottom',
  transfix_cost_prediction_estimate = 'transfix_cost_prediction_estimate',
  transfix_cost_prediction_top = 'transfix_cost_prediction_top',
  transfix_cost_prediction_varied_30_50 = 'transfix_cost_prediction_varied_30_50',
  transfix_strategic_buy_rate = 'transfix_strategic_buy_rate',
  transfix_tms = 'transfix_tms',
  true_rate_actual_margin = 'true_rate_actual_margin',
  true_rate_actual_rate = 'true_rate_actual_rate',
  true_rate_actual_rate_total_linehaul = 'true_rate_actual_rate_total_linehaul',
  true_rate_e2open_linehaul_rate = 'true_rate_e2open_linehaul_rate',
  true_rate_market_estimate_linehaul_rate = 'true_rate_market_estimate_linehaul_rate',
  true_rate_market_estimate_margin = 'true_rate_market_estimate_margin',
  true_rate_market_estimate_rate = 'true_rate_market_estimate_rate',
  true_rate_market_estimate_total_fuel = 'true_rate_market_estimate_total_fuel',
  true_rate_market_rate_total_linehaul = 'true_rate_market_rate_total_linehaul',
  web_scraper = 'web_scraper',
}

export enum IRateTypeTypes {
  /** per_miles */
  per_miles = 'per_miles',
  /** total */
  total = 'total',
}

/** Autogenerated input type of ReOfferWaterfall */
export type IReOfferWaterfallInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of ReOfferWaterfall */
export type IReOfferWaterfallPayload = {
  __typename?: 'ReOfferWaterfallPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contractLaneMatch?: Maybe<IContractLaneMatch>
  errors: Array<IError>
}

/** Autogenerated input type of ReactivateDeclinedBid */
export type IReactivateDeclinedBidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of ReactivateDeclinedBid */
export type IReactivateDeclinedBidPayload = {
  __typename?: 'ReactivateDeclinedBidPayload'
  bid?: Maybe<IBid>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

export enum IReadOnlyRescheduleReasons {
  /** Predicted Appt (+-1) */
  _predicted_appt____1_ = '_predicted_appt____1_',
  /** Acceptable Adjustment */
  acceptable_adjustment = 'acceptable_adjustment',
  /** Carrier Failure: Dishonesty */
  carrier_failure__dishonesty = 'carrier_failure__dishonesty',
  /** Carrier Failure: Poor Planning */
  carrier_failure__poor_planning = 'carrier_failure__poor_planning',
  /** Carrier Issue: Driver Issue */
  carrier_issue__driver_issue = 'carrier_issue__driver_issue',
  /** Carrier Issue: Driving Delays */
  carrier_issue__driving_delays = 'carrier_issue__driving_delays',
  /** Carrier Issue: Mechanical */
  carrier_issue__mechanical = 'carrier_issue__mechanical',
  /** Carrier Issue: Previous Shipment */
  carrier_issue__previous_shipment = 'carrier_issue__previous_shipment',
  /** Carrier Issue: Rejected trailer */
  carrier_issue__rejected_trailer = 'carrier_issue__rejected_trailer',
  /** Customer Issue: Clerical Error/Inaccurate Info */
  customer_issue__clerical_error_inaccurate_info = 'customer_issue__clerical_error_inaccurate_info',
  /** Customer Issue: Customer Requested Change */
  customer_issue__customer_requested_change = 'customer_issue__customer_requested_change',
  /** Customer Issue: EDI Incorrect Info */
  customer_issue__edi_incorrect_info = 'customer_issue__edi_incorrect_info',
  /** Customer Issue: Receiving Facility */
  customer_issue__receiving_facility = 'customer_issue__receiving_facility',
  /** Customer Issue: Shipping Facility */
  customer_issue__shipping_facility = 'customer_issue__shipping_facility',
  /** EDI Normal Adjustment */
  edi_normal_adjustment = 'edi_normal_adjustment',
  /** First Appointment */
  first_appointment = 'first_appointment',
  /** No Fault: First Appointment */
  no_fault__first_appointment = 'no_fault__first_appointment',
  /** No Fault: Smoothing */
  no_fault__smoothing = 'no_fault__smoothing',
  /** No Fault: Weather/AOG/Holiday/Road Closure */
  no_fault__weather_aog_holiday_road_closure = 'no_fault__weather_aog_holiday_road_closure',
  /** Normal Adjustment */
  normal_adjustment = 'normal_adjustment',
  /** Predicted Appt Inaccurate */
  predicted_appt_inaccurate = 'predicted_appt_inaccurate',
  /** Predicted Appt Request */
  predicted_appt_request = 'predicted_appt_request',
  /** Smoothing */
  smoothing = 'smoothing',
  /** Suggested Appointment */
  suggested_appointment = 'suggested_appointment',
  /** TF Issue: Acceptable Transit Adjustment */
  tf_issue__acceptable_transit_adjustment = 'tf_issue__acceptable_transit_adjustment',
  /** TF Issue: Booking/Capacity */
  tf_issue__booking_capacity = 'tf_issue__booking_capacity',
  /** TF Issue: Clerical Error/Inaccurate Info */
  tf_issue__clerical_error_inaccurate_info = 'tf_issue__clerical_error_inaccurate_info',
  /** TF Issue: CM Booking/Capacity */
  tf_issue__cm_booking_capacity = 'tf_issue__cm_booking_capacity',
  /** TF Issue: CM Faulted */
  tf_issue__cm_faulted = 'tf_issue__cm_faulted',
  /** TF Issue: Loss Prevention */
  tf_issue__loss_prevention = 'tf_issue__loss_prevention',
  /** TF Issue: Pricing */
  tf_issue__pricing = 'tf_issue__pricing',
  /** TF Issue: Smoothing */
  tf_issue__smoothing = 'tf_issue__smoothing',
  /** TF Issue: Tracking/Tracing */
  tf_issue__tracking_tracing = 'tf_issue__tracking_tracing',
  /** TF Issue: Weather/AOG/Holiday/Road Closures */
  tf_issue__weather_aog_holiday_road_closures = 'tf_issue__weather_aog_holiday_road_closures',
  /** TMS Shipment Reschedule */
  tms_shipment_reschedule = 'tms_shipment_reschedule',
  /** Weather/AOG/Holiday/Road Closures */
  weather_aog_holiday_road_closures = 'weather_aog_holiday_road_closures',
}

/** Autogenerated input type of RearrangeShipmentStops */
export type IRearrangeShipmentStopsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** Desired sequence of all delivery stops */
  deliveryStopsSequence?: Maybe<Array<IShipmentStopSequenceInput>>
  /** Desired sequence of all pickup stops */
  pickupStopsSequence?: Maybe<Array<IShipmentStopSequenceInput>>
}

/** Autogenerated return type of RearrangeShipmentStops */
export type IRearrangeShipmentStopsPayload = {
  __typename?: 'RearrangeShipmentStopsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export type IRecordMergeAttachedDocumentsField = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeAttachedDocumentsField'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value?: Maybe<Array<IAttachedDocument>>
}

export type IRecordMergeBooleanField = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeBooleanField'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value?: Maybe<Scalars['Boolean']>
}

export type IRecordMergeCountryField = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeCountryField'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value: ICountries
}

export type IRecordMergeEquipmentsField = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeEquipmentsField'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value?: Maybe<Array<IEquipment>>
}

export type IRecordMergeFacilityContactsField = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeFacilityContactsField'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value?: Maybe<Array<IFacilityContact>>
}

export type IRecordMergeFacilityIdentifiersField = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeFacilityIdentifiersField'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value: Array<IFacilityIdentifier>
}

export type IRecordMergeFacilityLocationField = {
  __typename?: 'RecordMergeFacilityLocationField'
  address: IRecordMergeStringField
  addressLine2: IRecordMergeStringField
  city: IRecordMergeStringField
  countryCode: IRecordMergeCountryField
  latitude: IRecordMergeFloatField
  longitude: IRecordMergeFloatField
  stateCode: IRecordMergeStateCodeField
  zipcode: IRecordMergeStringField
}

export type IRecordMergeFacilityMetadataField = {
  __typename?: 'RecordMergeFacilityMetadataField'
  arrivalInstructions: IRecordMergeStringField
  equipments: IRecordMergeEquipmentsField
  requirements: IRecordMergeFacilityRequirements
  safetyRequirements: IRecordMergeStringField
  services: IRecordMergeFacilityServices
}

export type IRecordMergeFacilityRequirements = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeFacilityRequirements'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value?: Maybe<Array<IFacilityRequirements>>
}

export type IRecordMergeFacilityScheduleField = {
  __typename?: 'RecordMergeFacilityScheduleField'
  documents: IRecordMergeAttachedDocumentsField
  rules: IRecordMergeFacilityScheduleRulesField
  schedulingNotes: IRecordMergeStringField
  sop: IRecordMergeStringField
}

export type IRecordMergeFacilityScheduleHours = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeFacilityScheduleHours'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value?: Maybe<Array<IFacilityScheduleHour>>
}

export type IRecordMergeFacilityScheduleRulesField = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeFacilityScheduleRulesField'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value: Array<IFacilityScheduleRule>
}

export type IRecordMergeFacilityServices = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeFacilityServices'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value?: Maybe<Array<IFacilityServices>>
}

export type IRecordMergeFacilityTypeField = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeFacilityTypeField'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value?: Maybe<IFacilityTypes>
}

export type IRecordMergeFieldInterface = {
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
}

export type IRecordMergeFloatField = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeFloatField'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value?: Maybe<Scalars['Float']>
}

export type IRecordMergeIntField = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeIntField'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value?: Maybe<Scalars['Int']>
}

export type IRecordMergeStateCodeField = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeStateCodeField'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value: IStates
}

export enum IRecordMergeStrategies {
  base = 'base',
  combine = 'combine',
  override = 'override',
}

export type IRecordMergeStringField = IRecordMergeFieldInterface & {
  __typename?: 'RecordMergeStringField'
  mergeStrategy?: Maybe<IRecordMergeStrategies>
  overridden?: Maybe<Scalars['Boolean']>
  recordId: Scalars['ID']
  value?: Maybe<Scalars['String']>
}

export type IReferenceDimensions = {
  __typename?: 'ReferenceDimensions'
  pickupBetMarkets?: Maybe<Array<IPickupBetMarket>>
  pricingDistMarketCenterThresholds?: Maybe<Array<IPricingDistMarketCenterThreshold>>
  pricingLengthOfHauls?: Maybe<Array<IPricingLengthOfHaul>>
  pricingVolumeGroups?: Maybe<Array<IPricingVolumeGroup>>
}

export type IReferenceRate = {
  __typename?: 'ReferenceRate'
  amount?: Maybe<Scalars['Float']>
  createdAt?: Maybe<Scalars['ISO8601DateTime']>
}

export type IReferenceRates = {
  __typename?: 'ReferenceRates'
  coverNow?: Maybe<IReferenceRate>
  tcm25?: Maybe<IReferenceRate>
  tcm75?: Maybe<IReferenceRate>
}

/** Autogenerated input type of RefreshHighwayData */
export type IRefreshHighwayDataInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of RefreshHighwayData */
export type IRefreshHighwayDataPayload = {
  __typename?: 'RefreshHighwayDataPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors?: Maybe<Array<IError>>
  success: Scalars['Boolean']
}

/** Autogenerated input type of RegenerateInvoice */
export type IRegenerateInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of RegenerateInvoice */
export type IRegenerateInvoicePayload = {
  __typename?: 'RegenerateInvoicePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

export enum IRegionTypes {
  /** Coastal */
  C = 'C',
  /** Midwest */
  MW = 'MW',
  /** Northeast */
  N = 'N',
  /** South */
  S = 'S',
  /** Southeast */
  SE = 'SE',
  /** West */
  W = 'W',
}

/** Autogenerated input type of RejectApprovedPOD */
export type IRejectApprovedPodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  rejectionReason: Scalars['String']
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of RejectApprovedPOD */
export type IRejectApprovedPodPayload = {
  __typename?: 'RejectApprovedPODPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of RejectComplianceCoverReview */
export type IRejectComplianceCoverReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  closureReason?: Maybe<Scalars['String']>
  complianceCoverReviewId: Scalars['ID']
}

/** Autogenerated return type of RejectComplianceCoverReview */
export type IRejectComplianceCoverReviewPayload = {
  __typename?: 'RejectComplianceCoverReviewPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  complianceCoverReview?: Maybe<IComplianceCoverReview>
  errors: Array<IError>
}

export type IRelayCodeDetails = {
  __typename?: 'RelayCodeDetails'
  code?: Maybe<Scalars['String']>
}

export type IRelayPaymentsCode = {
  __typename?: 'RelayPaymentsCode'
  amountUsed?: Maybe<Scalars['Float']>
  autoSendSms: Scalars['Boolean']
  carrier: ICarrierApplication
  chargeRecordedAt?: Maybe<Scalars['ISO8601DateTime']>
  codeStatus: ICodeStatuses
  codeType?: Maybe<ICodeTypes>
  constraintAmount: Scalars['Float']
  constraintDeadline?: Maybe<Scalars['ISO8601DateTime']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  creator: IUser
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  driver: IUser
  id: Scalars['ID']
  lastSmsSentAt?: Maybe<Scalars['ISO8601DateTime']>
  relayPaymentsChargeId?: Maybe<Scalars['ID']>
  relayPaymentsId?: Maybe<Scalars['ID']>
  shipment: IShipment
  shipmentAccessorial: IShipmentAccessorial
  shipmentStop?: Maybe<IShipmentStop>
  shipperFacility: IShipperFacility
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** Autogenerated input type of RemoveCarrierTonu */
export type IRemoveCarrierTonuInput = {
  carrierTonuId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of RemoveCarrierTonu */
export type IRemoveCarrierTonuPayload = {
  __typename?: 'RemoveCarrierTonuPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of RemoveDispatch */
export type IRemoveDispatchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of RemoveDispatch */
export type IRemoveDispatchPayload = {
  __typename?: 'RemoveDispatchPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of RemoveTonu */
export type IRemoveTonuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of RemoveTonu */
export type IRemoveTonuPayload = {
  __typename?: 'RemoveTonuPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export type IRemovedPodFile = {
  __typename?: 'RemovedPodFile'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  file: IDownloadable
  id: Scalars['ID']
  rejectedReason?: Maybe<Scalars['String']>
  shipment: IShipment
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** Autogenerated input type of ReprintInvoice */
export type IReprintInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of ReprintInvoice */
export type IReprintInvoicePayload = {
  __typename?: 'ReprintInvoicePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  invoice?: Maybe<IInvoice>
}

/** Autogenerated input type of ReprintRateConfirmation */
export type IReprintRateConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of ReprintRateConfirmation */
export type IReprintRateConfirmationPayload = {
  __typename?: 'ReprintRateConfirmationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of RequestCarrierApproval */
export type IRequestCarrierApprovalInput = {
  carrierApplicationId: Scalars['ID']
  /** Fields to set on the carrier's application. */
  carrierInformation?: Maybe<IConfirmCarrierInformationInput>
  /** The ID of the dispatcher or owner-operator to be emailed. */
  carrierUserId?: Maybe<Scalars['ID']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** The ID of the shipment associated with this request. */
  shipmentId?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of RequestCarrierApproval */
export type IRequestCarrierApprovalPayload = {
  __typename?: 'RequestCarrierApprovalPayload'
  carrierApplication?: Maybe<ICarrierApplication>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

export type IRequestForProposal = {
  __typename?: 'RequestForProposal'
  auditWorkspace: Scalars['Boolean']
  availableRounds?: Maybe<Scalars['Int']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  googleSheetsUrl?: Maybe<Scalars['String']>
  id: Scalars['ID']
  pricingRound?: Maybe<Scalars['Int']>
  pricingWorkspace: Scalars['Boolean']
  requestForProposalType?: Maybe<Scalars['String']>
  salesforceRfpId?: Maybe<Scalars['String']>
  salesforceRfpTitle?: Maybe<Scalars['String']>
  shipperApplication?: Maybe<IShipperApplication>
  shipperApplicationId?: Maybe<Scalars['ID']>
  source?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IRequestForProposalEnhancedDatHistoricRates = {
  __typename?: 'RequestForProposalEnhancedDatHistoricRates'
  confidenceLevel?: Maybe<Scalars['Int']>
  estimatedAllInTotal?: Maybe<Scalars['Float']>
  estimatedLinehaulRate?: Maybe<Scalars['Float']>
  estimatedLinehaulTotal?: Maybe<Scalars['Float']>
  highAllInTotal?: Maybe<Scalars['Float']>
  highLinehaulRate?: Maybe<Scalars['Float']>
  highLinehaulTotal?: Maybe<Scalars['Float']>
  lowAllInTotal?: Maybe<Scalars['Float']>
  lowLinehaulRate?: Maybe<Scalars['Float']>
  lowLinehaulTotal?: Maybe<Scalars['Float']>
  when?: Maybe<IRequestForProposalWhen>
}

export type IRequestForProposalLane = {
  __typename?: 'RequestForProposalLane'
  altLaneId?: Maybe<Scalars['String']>
  altLaneIds?: Maybe<Array<Scalars['String']>>
  annualVolume?: Maybe<Scalars['Float']>
  auditStatus?: Maybe<Scalars['String']>
  auditor?: Maybe<IUser>
  auditorId?: Maybe<Scalars['ID']>
  averageStopCount?: Maybe<Scalars['Float']>
  awardedLane?: Maybe<Scalars['String']>
  betLaneRate?: Maybe<Scalars['Float']>
  bundleId?: Maybe<Scalars['Int']>
  calculatedMiles?: Maybe<Scalars['Float']>
  carrierConfidence?: Maybe<Scalars['String']>
  clpBh?: Maybe<Scalars['Float']>
  clpHh?: Maybe<Scalars['Float']>
  comments?: Maybe<Scalars['String']>
  concatLanes?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  currentLaneBh?: Maybe<Scalars['Float']>
  currentLaneHh?: Maybe<Scalars['Float']>
  customerVendorName?: Maybe<Scalars['String']>
  datMiles?: Maybe<Scalars['Float']>
  deliveryCity?: Maybe<Scalars['String']>
  deliveryDistToMarketCenter?: Maybe<Scalars['Float']>
  deliveryDistToMarketCenterGeocoderSource?: Maybe<Scalars['String']>
  deliveryDropTrailer?: Maybe<Scalars['Boolean']>
  deliveryIsoCountryCode?: Maybe<Scalars['String']>
  deliveryLocationFlag?: Maybe<Scalars['Boolean']>
  deliveryMarket?: Maybe<Scalars['Int']>
  deliveryMarketRank?: Maybe<Scalars['Int']>
  deliveryPostalCode?: Maybe<Scalars['String']>
  deliveryPostalCode3?: Maybe<Scalars['String']>
  deliveryRegion?: Maybe<Scalars['String']>
  deliveryState?: Maybe<Scalars['String']>
  deliveryStateCode?: Maybe<Scalars['String']>
  deliveryZip?: Maybe<Scalars['String']>
  deliveryZip3?: Maybe<Scalars['String']>
  deliveryZone?: Maybe<Scalars['String']>
  deliveryZoneSqMileage?: Maybe<Scalars['Float']>
  deliveryZoneType?: Maybe<Scalars['String']>
  dropEligible?: Maybe<Scalars['String']>
  dropTrailer?: Maybe<Scalars['Boolean']>
  dropType?: Maybe<Scalars['String']>
  effectiveMiles?: Maybe<Scalars['Float']>
  endDate?: Maybe<Scalars['ISO8601Date']>
  enhancedDatHistoricRates?: Maybe<Array<IRequestForProposalEnhancedDatHistoricRates>>
  equipMapped?: Maybe<Scalars['String']>
  equipment?: Maybe<IEquipment>
  expansionMarketLane?: Maybe<Scalars['String']>
  forecastVersion?: Maybe<Scalars['String']>
  geocodedMiles?: Maybe<Scalars['Float']>
  geocoderSource?: Maybe<Scalars['String']>
  grossVolume?: Maybe<Scalars['Float']>
  id: Scalars['ID']
  incumbentAwardType?: Maybe<Scalars['String']>
  incumbentLaneId?: Maybe<Scalars['Int']>
  incumbentLaneRate?: Maybe<Scalars['Float']>
  incumbentLaneRateType?: Maybe<Scalars['String']>
  incumbentMatchType?: Maybe<Scalars['String']>
  isBeer?: Maybe<Scalars['Boolean']>
  isConestoga?: Maybe<Scalars['Boolean']>
  isDeliveryDropTrailerRequired?: Maybe<Scalars['Boolean']>
  isHazard?: Maybe<Scalars['Boolean']>
  isIntermodal?: Maybe<Scalars['Boolean']>
  isPickupDropTrailerRequired?: Maybe<Scalars['Boolean']>
  isTeam?: Maybe<Scalars['Boolean']>
  laneId?: Maybe<Scalars['String']>
  laneManager?: Maybe<Scalars['String']>
  laneRank?: Maybe<Scalars['String']>
  liveAuditRiskLevel?: Maybe<Scalars['String']>
  locationKillswitch?: Maybe<Scalars['Boolean']>
  mapboxMiles?: Maybe<Scalars['Float']>
  marketMarketLane?: Maybe<Scalars['String']>
  monthlyVolume?: Maybe<Scalars['Float']>
  nonRegionalNonDesirable?: Maybe<Scalars['Boolean']>
  notes: Array<INote>
  pickupCity?: Maybe<Scalars['String']>
  pickupDistToMarketCenter?: Maybe<Scalars['Float']>
  pickupDistToMarketCenterGeocoderSource?: Maybe<Scalars['String']>
  pickupDropTrailer?: Maybe<Scalars['Boolean']>
  pickupIsoCountryCode?: Maybe<Scalars['String']>
  pickupKeyMarketArea?: Maybe<Scalars['String']>
  pickupLocationFlag?: Maybe<Scalars['Boolean']>
  pickupMarket?: Maybe<Scalars['Int']>
  pickupMarketRank?: Maybe<Scalars['Int']>
  pickupPostalCode?: Maybe<Scalars['String']>
  pickupPostalCode3?: Maybe<Scalars['String']>
  pickupRegion?: Maybe<Scalars['String']>
  pickupState?: Maybe<Scalars['String']>
  pickupStateCode?: Maybe<Scalars['String']>
  pickupZip?: Maybe<Scalars['String']>
  pickupZip3?: Maybe<Scalars['String']>
  pickupZone?: Maybe<Scalars['String']>
  pickupZoneSqMileage?: Maybe<Scalars['Float']>
  pickupZoneType?: Maybe<Scalars['String']>
  previouslyDenseLaneBh?: Maybe<Scalars['String']>
  previouslyDenseLaneHh?: Maybe<Scalars['String']>
  prices?: Maybe<Array<IRequestForProposalLanePrice>>
  pricingAuditFlag?: Maybe<Scalars['String']>
  pricingAuditNotes?: Maybe<Scalars['String']>
  pricingDoNotQuote?: Maybe<Scalars['String']>
  pricingDurationMonths?: Maybe<Scalars['Int']>
  quarterlyVolume?: Maybe<Scalars['Float']>
  requestForProposal?: Maybe<IRequestForProposal>
  shipperCustomData?: Maybe<Scalars['JSON']>
  shipperDelivery?: Maybe<Scalars['Int']>
  shipperMiles?: Maybe<Scalars['Float']>
  shipperPickup?: Maybe<Scalars['Int']>
  simPathsRiskLabel?: Maybe<Scalars['String']>
  sourcedRateHh?: Maybe<Scalars['Float']>
  startDate?: Maybe<Scalars['ISO8601Date']>
  strongLane?: Maybe<Scalars['Boolean']>
  transfixLaneId?: Maybe<Scalars['Int']>
  transfixLaneKey?: Maybe<Scalars['String']>
  transfixShipperLaneId?: Maybe<Scalars['Int']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  volumeAnnual?: Maybe<Scalars['Float']>
  volumeRelevant?: Maybe<Scalars['Float']>
  weeklyVolume?: Maybe<Scalars['Float']>
}

/** The connection type for RequestForProposalLane. */
export type IRequestForProposalLaneConnection = {
  __typename?: 'RequestForProposalLaneConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IRequestForProposalLaneEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IRequestForProposalLane>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IRequestForProposalLaneEdge = {
  __typename?: 'RequestForProposalLaneEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IRequestForProposalLane>
}

export type IRequestForProposalLaneFeedback = {
  __typename?: 'RequestForProposalLaneFeedback'
  annualVolume?: Maybe<Scalars['Float']>
  awardStatus?: Maybe<Scalars['String']>
  awardType?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  fuelAtAward?: Maybe<Scalars['Float']>
  fuelRatePerMile?: Maybe<Scalars['Float']>
  grossVolume?: Maybe<Scalars['Float']>
  id: Scalars['ID']
  isFinalRound: Scalars['Boolean']
  marginAmountAtAward?: Maybe<Scalars['Float']>
  marginPercentAtAward?: Maybe<Scalars['Float']>
  minChargeLineHaul?: Maybe<Scalars['Float']>
  monthlyVolume?: Maybe<Scalars['Float']>
  notes: Array<INote>
  quarterlyVolume?: Maybe<Scalars['Float']>
  ranking?: Maybe<Scalars['Int']>
  rateAllInWithFuel?: Maybe<Scalars['Float']>
  rateLineHaul?: Maybe<Scalars['Float']>
  ratePerMile?: Maybe<Scalars['Float']>
  requestForProposalLanePrice: IRequestForProposalLanePrice
  tttAtAward?: Maybe<Scalars['Float']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  varianceAllIn?: Maybe<Scalars['Boolean']>
  varianceLinehaul?: Maybe<Scalars['Boolean']>
  varianceLinehaulRpm?: Maybe<Scalars['Boolean']>
  varianceVolume?: Maybe<Scalars['Boolean']>
  weeklyVolume?: Maybe<Scalars['Float']>
}

/** The connection type for RequestForProposalLaneFeedback. */
export type IRequestForProposalLaneFeedbackConnection = {
  __typename?: 'RequestForProposalLaneFeedbackConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IRequestForProposalLaneFeedbackEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IRequestForProposalLaneFeedback>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IRequestForProposalLaneFeedbackEdge = {
  __typename?: 'RequestForProposalLaneFeedbackEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IRequestForProposalLaneFeedback>
}

export type IRequestForProposalLaneFeedbackMetadata = {
  __typename?: 'RequestForProposalLaneFeedbackMetadata'
  acceptedBackupLanesCount?: Maybe<Scalars['Int']>
  acceptedPrimaryLanesCount?: Maybe<Scalars['Int']>
  aggregateFlagTally?: Maybe<Scalars['JSON']>
  awardOverview?: Maybe<Array<IAwardOverview>>
  datAllInBuckets?: Maybe<Array<IDatBucket>>
  datTttBuckets?: Maybe<Array<IDatBucket>>
  lanesByDropType?: Maybe<Scalars['JSON']>
  primaryAwardProgress?: Maybe<Scalars['JSON']>
  topDeliveryMarkets?: Maybe<Array<ITopMarket>>
  topPickupMarkets?: Maybe<Array<ITopMarket>>
}

export type IRequestForProposalLaneLocation = {
  groupName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  text?: Maybe<Scalars['String']>
}

export type IRequestForProposalLanePrice = {
  __typename?: 'RequestForProposalLanePrice'
  allInLessPremiums?: Maybe<Scalars['Float']>
  allInOverride?: Maybe<Scalars['Float']>
  audit?: Maybe<Scalars['Boolean']>
  auditReason?: Maybe<Scalars['String']>
  auditReviewRequired?: Maybe<Scalars['Boolean']>
  avgCasePercentile?: Maybe<Scalars['String']>
  beError?: Maybe<Scalars['String']>
  bestCasePercentile?: Maybe<Scalars['String']>
  betLane?: Maybe<Scalars['Boolean']>
  betLaneRate?: Maybe<Scalars['Boolean']>
  bhLaneNetworkLabel?: Maybe<Scalars['String']>
  blank1?: Maybe<Scalars['String']>
  blank2?: Maybe<Scalars['String']>
  blank3?: Maybe<Scalars['String']>
  blank4?: Maybe<Scalars['String']>
  blank5?: Maybe<Scalars['String']>
  blank6?: Maybe<Scalars['String']>
  blank7?: Maybe<Scalars['String']>
  blank8?: Maybe<Scalars['String']>
  blank9?: Maybe<Scalars['String']>
  blank10?: Maybe<Scalars['String']>
  boundPuMktCenter?: Maybe<Scalars['Float']>
  boundPuMktCenterBucket?: Maybe<Scalars['Float']>
  boundReferenceValue?: Maybe<Scalars['Float']>
  boundTttTcm50?: Maybe<Scalars['Float']>
  boundedRiskAdjTtt?: Maybe<Scalars['Float']>
  boundedUnadjTtt?: Maybe<Scalars['Float']>
  carrierDevSplice?: Maybe<Scalars['String']>
  carrierManagerCeilingPrice?: Maybe<Scalars['Float']>
  carrierTeamDynamicAudit?: Maybe<Scalars['Boolean']>
  costTeamFlag?: Maybe<Scalars['String']>
  costTeamStrategy?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  dat12Months?: Maybe<Scalars['Float']>
  datAnchorFlag?: Maybe<Scalars['String']>
  datDays?: Maybe<Scalars['Float']>
  datForecast?: Maybe<Scalars['Float']>
  datHighForecast?: Maybe<Scalars['Float']>
  datHighTrailing12Months?: Maybe<Scalars['Float']>
  datLowForecast?: Maybe<Scalars['Float']>
  datLowTrailing12Months?: Maybe<Scalars['Float']>
  datRate?: Maybe<Scalars['Float']>
  datTrailing12Months?: Maybe<Scalars['Float']>
  dateSubmitted?: Maybe<Scalars['ISO8601Date']>
  defenseAction?: Maybe<Scalars['String']>
  delvPremium?: Maybe<Scalars['String']>
  dollarPremium?: Maybe<Scalars['Float']>
  dollarPremiumPct?: Maybe<Scalars['Float']>
  effectiveAllIn?: Maybe<Scalars['Float']>
  effectiveAllInRelevant?: Maybe<Scalars['Float']>
  effectiveAllInRpm?: Maybe<Scalars['Float']>
  effectiveMargin?: Maybe<Scalars['Float']>
  effectiveMarginPercentage?: Maybe<Scalars['Float']>
  effectiveMarginRelevant?: Maybe<Scalars['Float']>
  effectiveP2d?: Maybe<Scalars['Float']>
  extraStops?: Maybe<Scalars['Float']>
  farFromDelvMktCenter?: Maybe<Scalars['String']>
  farFromPuMktCenter?: Maybe<Scalars['String']>
  feedback?: Maybe<IRequestForProposalLaneFeedback>
  finalMargin?: Maybe<Scalars['Float']>
  finalMarginPct?: Maybe<Scalars['Float']>
  finalPremiumPct?: Maybe<Scalars['Float']>
  focusAuditDrop?: Maybe<Scalars['String']>
  focusAuditLive?: Maybe<Scalars['String']>
  focusAuditLive2?: Maybe<Scalars['String']>
  focusAuditLiveRd2?: Maybe<Scalars['String']>
  fuelAdjustment?: Maybe<Scalars['Float']>
  fuelRpm?: Maybe<Scalars['Float']>
  fuelSurcharge?: Maybe<Scalars['Float']>
  hhLaneNetworkLabel?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isUpperBounded?: Maybe<Scalars['Boolean']>
  keyMarket?: Maybe<Scalars['Boolean']>
  keyMarketDelivery?: Maybe<Scalars['Int']>
  keyMarketPickup?: Maybe<Scalars['Int']>
  laneDesirability?: Maybe<Scalars['String']>
  linehaulOverride?: Maybe<Scalars['Float']>
  linkMap?: Maybe<Scalars['String']>
  liveAuditRiskLevel?: Maybe<Scalars['String']>
  longTermForecastVersionId?: Maybe<Scalars['Int']>
  lookerExtra?: Maybe<Scalars['String']>
  lookerLookup?: Maybe<Scalars['String']>
  lowerBound?: Maybe<Scalars['Float']>
  lowerBoundByDesirabilityMatrix?: Maybe<Scalars['Float']>
  lowerBoundProgrammatic?: Maybe<Scalars['Float']>
  lowerBoundReferenceValue?: Maybe<Scalars['Float']>
  marginAdjustment1?: Maybe<Scalars['Float']>
  marginAdjustment2?: Maybe<Scalars['Float']>
  marginAdjustment3?: Maybe<Scalars['Float']>
  marginAdjustmentDollar?: Maybe<Scalars['Float']>
  marginAvgCase?: Maybe<Scalars['Float']>
  marginAvgCaseAnnual?: Maybe<Scalars['Float']>
  marginBestCase?: Maybe<Scalars['Float']>
  marginBestCaseAnnual?: Maybe<Scalars['Float']>
  marginPct?: Maybe<Scalars['Float']>
  marginPctAvgCase?: Maybe<Scalars['Float']>
  marginPctBestCase?: Maybe<Scalars['Float']>
  marginPctProgrammatic?: Maybe<Scalars['Float']>
  marginPctWorstCase?: Maybe<Scalars['Float']>
  marginProgrammatic?: Maybe<Scalars['Float']>
  marginProgrammaticAnnual?: Maybe<Scalars['Float']>
  marginWorstCase?: Maybe<Scalars['Float']>
  marginWorstCaseAnnual?: Maybe<Scalars['Float']>
  marketDemandScore?: Maybe<Scalars['Float']>
  milesBucket?: Maybe<Scalars['String']>
  minMargin?: Maybe<Scalars['Float']>
  negMarginRisk?: Maybe<Scalars['String']>
  newBoundReferenceValue?: Maybe<Scalars['Float']>
  newDatRate?: Maybe<Scalars['Float']>
  newLowerBound?: Maybe<Scalars['Float']>
  newRiskAdjTtt?: Maybe<Scalars['Float']>
  newSimPathsRiskLabel?: Maybe<Scalars['String']>
  newTcm50?: Maybe<Scalars['Float']>
  newUnadjSimpathsTtt?: Maybe<Scalars['Float']>
  oneMoAnchor?: Maybe<Scalars['Float']>
  overrideBy?: Maybe<Scalars['String']>
  overrideTimestamp?: Maybe<Scalars['ISO8601DateTime']>
  p2dAdjustmentPct?: Maybe<Scalars['Float']>
  p2dDatR1?: Maybe<Scalars['Float']>
  p2dEligible?: Maybe<Scalars['String']>
  pctToDatBucket?: Maybe<Scalars['String']>
  preAuditTtt?: Maybe<Scalars['Float']>
  preauditBandLane?: Maybe<Scalars['Boolean']>
  preauditBandMileage?: Maybe<Scalars['String']>
  preauditBandRate?: Maybe<Scalars['Float']>
  preauditRpmLane?: Maybe<Scalars['String']>
  premiumPct?: Maybe<Scalars['Float']>
  pricingStrategyFlag?: Maybe<Scalars['String']>
  pricingTeamDynamicAudit?: Maybe<Scalars['Float']>
  puMarketNetworkLabel?: Maybe<Scalars['String']>
  puPremium?: Maybe<Scalars['String']>
  quotedTF?: Maybe<Scalars['Boolean']>
  quotedVolume?: Maybe<Scalars['Int']>
  quotedVolumeRelevant?: Maybe<Scalars['Float']>
  rateView?: Maybe<Scalars['String']>
  rawUnadjSimpathsTtt?: Maybe<Scalars['Float']>
  regionalScalar?: Maybe<Scalars['Float']>
  relevantIncumbentRate?: Maybe<Scalars['Float']>
  requestForProposalLane: IRequestForProposalLane
  riskAdjTtt?: Maybe<Scalars['Float']>
  roundAuditStatus?: Maybe<Scalars['String']>
  roundAuditorId?: Maybe<Scalars['ID']>
  roundNumber?: Maybe<Scalars['Int']>
  shortenedLowerBound?: Maybe<Scalars['Float']>
  shortenedLowerBoundByDesirabilityMatrix?: Maybe<Scalars['Float']>
  simplifiedLowerBound?: Maybe<Scalars['Float']>
  simplifiedUpperBound?: Maybe<Scalars['Float']>
  strategicPricingOverride?: Maybe<Scalars['String']>
  strategy?: Maybe<IRequestForProposalStrategy>
  strategyData?: Maybe<IRequestForProposalLanePriceStrategyData>
  tcm25?: Maybe<Scalars['Float']>
  tcm50?: Maybe<Scalars['Float']>
  tcm75?: Maybe<Scalars['Float']>
  tcmBaseProposed?: Maybe<Scalars['String']>
  tcmUsed?: Maybe<Scalars['String']>
  tfAvgCarrierCost60days?: Maybe<Scalars['Float']>
  tfAvgCarrierCostDat60days?: Maybe<Scalars['Float']>
  tfShipper60days?: Maybe<Scalars['Float']>
  tfVolume60days?: Maybe<Scalars['Float']>
  tfxhAllIn?: Maybe<Scalars['Float']>
  tfxhAllInAnnual?: Maybe<Scalars['Float']>
  tfxhAllInDat?: Maybe<Scalars['Float']>
  tfxhAllInDat12?: Maybe<Scalars['Float']>
  tfxhAllInDatForecast?: Maybe<Scalars['Float']>
  tfxhAllInDatLessPremiums?: Maybe<Scalars['Float']>
  tfxhAllInRelevant?: Maybe<Scalars['Float']>
  tfxhAllInRpm?: Maybe<Scalars['Float']>
  tfxhLinehaul?: Maybe<Scalars['Float']>
  tfxhLinehaulRpm?: Maybe<Scalars['Float']>
  topPuMarket?: Maybe<Scalars['Boolean']>
  topPuMarketEligible?: Maybe<Scalars['Boolean']>
  totalMarginAdjustment?: Maybe<Scalars['Float']>
  totalPriceAdjustment?: Maybe<Scalars['Float']>
  tttAdjustmentDollar?: Maybe<Scalars['Float']>
  tttAdjustmentPct?: Maybe<Scalars['Float']>
  tttAvgCase?: Maybe<Scalars['Float']>
  tttBestCase?: Maybe<Scalars['Float']>
  tttBoundAdjusted?: Maybe<Scalars['Float']>
  tttDrop?: Maybe<Scalars['Float']>
  tttFinal?: Maybe<Scalars['Float']>
  tttFinalDat?: Maybe<Scalars['Float']>
  tttFinalDat12Rate?: Maybe<Scalars['Float']>
  tttFinalDatRate?: Maybe<Scalars['Float']>
  tttFinalRpm?: Maybe<Scalars['Float']>
  tttForecast?: Maybe<Scalars['Float']>
  tttForecastAvgDat?: Maybe<Scalars['Float']>
  tttForecastAvgDatBound?: Maybe<Scalars['String']>
  tttForecastAvgTcm?: Maybe<Scalars['Float']>
  tttForecastAvgTcmBound?: Maybe<Scalars['String']>
  tttForecastRaw?: Maybe<Scalars['Float']>
  tttOverride?: Maybe<Scalars['Float']>
  tttProgrammatic?: Maybe<Scalars['Float']>
  tttWorstCase?: Maybe<Scalars['Float']>
  unadjSimpathsAvgTcm?: Maybe<Scalars['Float']>
  unadjSimpathsTtt?: Maybe<Scalars['Float']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  upperAndLowerBoundEndForecast?: Maybe<Scalars['Float']>
  upperAndLowerBoundValues?: Maybe<Scalars['Float']>
  upperBoundAndLowerBoundProgrammatic?: Maybe<Scalars['Float']>
  upperBoundProgrammatic?: Maybe<Scalars['Float']>
  upperBoundReferenceValue?: Maybe<Scalars['Float']>
  upperBoundShortened?: Maybe<Scalars['Float']>
  varianceShipperMileage?: Maybe<Scalars['String']>
  volumePotential?: Maybe<Scalars['String']>
  worstCasePercentile?: Maybe<Scalars['String']>
}

export type IRequestForProposalLanePriceStrategyData = {
  __typename?: 'RequestForProposalLanePriceStrategyData'
  tcm: ITcmPricingStrategy
}

export type IRequestForProposalLocation = {
  city?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
}

export type IRequestForProposalMetadata = {
  __typename?: 'RequestForProposalMetadata'
  aggregateFlagTally?: Maybe<Scalars['JSON']>
  allCities?: Maybe<Array<IRfpLaneCity>>
  allMarkets?: Maybe<Array<IRfpLaneCity>>
  allRegions?: Maybe<Array<Scalars['String']>>
  auditProgress?: Maybe<Scalars['JSON']>
  awardedOn?: Maybe<Scalars['ISO8601DateTime']>
  canStoreAward?: Maybe<Scalars['Boolean']>
  datAllInBuckets?: Maybe<Array<IDatBucket>>
  datTttBuckets?: Maybe<Array<IDatBucket>>
  lanesByDropType?: Maybe<Scalars['JSON']>
  status?: Maybe<Scalars['String']>
  statusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  syncedAt?: Maybe<Scalars['ISO8601DateTime']>
  syncedToNorm?: Maybe<Scalars['Boolean']>
  topDeliveryMarkets?: Maybe<Array<ITopMarket>>
  topPickupMarketsNew?: Maybe<Array<ITopMarket>>
}

export type IRequestForProposalPriceRange = {
  max: Scalars['Float']
  min: Scalars['Float']
}

export type IRequestForProposalStrategy = {
  __typename?: 'RequestForProposalStrategy'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  createdById: Scalars['ID']
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  notes: Array<INote>
  previousStrategyId?: Maybe<Scalars['ID']>
  requestForProposalId?: Maybe<Scalars['ID']>
  strategyMatrix?: Maybe<Scalars['JSON']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  updatedById: Scalars['ID']
}

export enum IRequestForProposalStrategyUpdateTypes {
  /** Live to p2d */
  live_to_p2d = 'live_to_p2d',
  /** P2d to live */
  p2d_to_live = 'p2d_to_live',
}

export type IRequestForProposalUpdateStatus = {
  __typename?: 'RequestForProposalUpdateStatus'
  completedAward: Scalars['Int']
  completedNormLanes?: Maybe<Scalars['Int']>
  completedUpdates: Scalars['Int']
  isNorming: Scalars['Boolean']
  isStoringAward: Scalars['Boolean']
  isUpdating: Scalars['Boolean']
  totalAward: Scalars['Int']
  totalNormLanes?: Maybe<Scalars['Int']>
  totalUpdates: Scalars['Int']
}

export type IRequestForProposalWhen = {
  __typename?: 'RequestForProposalWhen'
  month?: Maybe<Scalars['Int']>
  year?: Maybe<Scalars['Int']>
}

export enum IRescheduleReasons {
  /** Carrier Failure: Poor Planning */
  carrier_failure__poor_planning = 'carrier_failure__poor_planning',
  /** Carrier Issue: Driver Issue */
  carrier_issue__driver_issue = 'carrier_issue__driver_issue',
  /** Carrier Issue: Driving Delays */
  carrier_issue__driving_delays = 'carrier_issue__driving_delays',
  /** Carrier Issue: Mechanical */
  carrier_issue__mechanical = 'carrier_issue__mechanical',
  /** Carrier Issue: Rejected trailer */
  carrier_issue__rejected_trailer = 'carrier_issue__rejected_trailer',
  /** Customer Issue: Clerical Error/Inaccurate Info */
  customer_issue__clerical_error_inaccurate_info = 'customer_issue__clerical_error_inaccurate_info',
  /** Customer Issue: Customer Requested Change */
  customer_issue__customer_requested_change = 'customer_issue__customer_requested_change',
  /** Customer Issue: EDI Incorrect Info */
  customer_issue__edi_incorrect_info = 'customer_issue__edi_incorrect_info',
  /** Customer Issue: Receiving Facility */
  customer_issue__receiving_facility = 'customer_issue__receiving_facility',
  /** Customer Issue: Shipping Facility */
  customer_issue__shipping_facility = 'customer_issue__shipping_facility',
  /** No Fault: First Appointment */
  no_fault__first_appointment = 'no_fault__first_appointment',
  /** No Fault: Smoothing */
  no_fault__smoothing = 'no_fault__smoothing',
  /** No Fault: Weather/AOG/Holiday/Road Closure */
  no_fault__weather_aog_holiday_road_closure = 'no_fault__weather_aog_holiday_road_closure',
  /** Suggested Appointment */
  suggested_appointment = 'suggested_appointment',
  /** TF Issue: Clerical Error/Inaccurate Info */
  tf_issue__clerical_error_inaccurate_info = 'tf_issue__clerical_error_inaccurate_info',
  /** TF Issue: CM Booking/Capacity */
  tf_issue__cm_booking_capacity = 'tf_issue__cm_booking_capacity',
  /** TF Issue: Loss Prevention */
  tf_issue__loss_prevention = 'tf_issue__loss_prevention',
  /** TF Issue: Pricing */
  tf_issue__pricing = 'tf_issue__pricing',
  /** TF Issue: Tracking/Tracing */
  tf_issue__tracking_tracing = 'tf_issue__tracking_tracing',
}

export type IRescheduleRequest = ICreatedByUser & {
  __typename?: 'RescheduleRequest'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  id: Scalars['ID']
  isWorkInRequested: Scalars['Boolean']
  reasonForRequest?: Maybe<Scalars['String']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** Autogenerated input type of Resend214 */
export type IResend214Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of Resend214 */
export type IResend214Payload = {
  __typename?: 'Resend214Payload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of ResendInvoices */
export type IResendInvoicesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** name of file uploaded and to be used to store in s3 */
  filename: Scalars['String']
  /** csv containing all invoice data for resend job */
  invoiceCsv: Scalars['String']
}

/** Autogenerated return type of ResendInvoices */
export type IResendInvoicesPayload = {
  __typename?: 'ResendInvoicesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  result: Scalars['JSON']
}

/** Autogenerated input type of ResetShipmentWaterfall */
export type IResetShipmentWaterfallInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of ResetShipmentWaterfall */
export type IResetShipmentWaterfallPayload = {
  __typename?: 'ResetShipmentWaterfallPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of ReviewFacilityAddress */
export type IReviewFacilityAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  decision: IFacilityReviewStatuses
  facilityUuid: Scalars['ID']
  mergeIntoFacilityUuid?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of ReviewFacilityAddress */
export type IReviewFacilityAddressPayload = {
  __typename?: 'ReviewFacilityAddressPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  facility?: Maybe<IFacility>
}

/** Autogenerated input type of RevokeCarrierTonuApproval */
export type IRevokeCarrierTonuApprovalInput = {
  carrierTonuId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of RevokeCarrierTonuApproval */
export type IRevokeCarrierTonuApprovalPayload = {
  __typename?: 'RevokeCarrierTonuApprovalPayload'
  carrierTonu?: Maybe<ICarrierTonu>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

export type IRfpErrorCategory = {
  __typename?: 'RfpErrorCategory'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  description: Scalars['String']
  id: Scalars['ID']
  name: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IRfpErrorType = {
  __typename?: 'RfpErrorType'
  category: IRfpErrorCategory
  categoryId: Scalars['ID']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  description: Scalars['String']
  id: Scalars['ID']
  name: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** Autogenerated input type of RfpExportData */
export type IRfpExportDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  exportRfpFileName: Scalars['String']
  exportRfpVariables: Array<Scalars['String']>
  rfpId: Scalars['ID']
}

/** Autogenerated return type of RfpExportData */
export type IRfpExportDataPayload = {
  __typename?: 'RfpExportDataPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

export type IRfpExportStatus = {
  __typename?: 'RfpExportStatus'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  csvFileName?: Maybe<Scalars['String']>
  csvFileUrl?: Maybe<Scalars['String']>
  errorMessages?: Maybe<Scalars['String']>
  id: Scalars['ID']
  requestForProposalId: Scalars['ID']
  status: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** Autogenerated input type of RfpImportLanesData */
export type IRfpImportLanesDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  csv: Scalars['String']
  rfpId: Scalars['ID']
}

/** Autogenerated return type of RfpImportLanesData */
export type IRfpImportLanesDataPayload = {
  __typename?: 'RfpImportLanesDataPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

export type IRfpLaneCity = {
  __typename?: 'RfpLaneCity'
  city: Scalars['String']
  state: Scalars['String']
}

export type IRfpLaneError = {
  __typename?: 'RfpLaneError'
  createdAt: Scalars['ISO8601DateTime']
  errorMessage?: Maybe<Scalars['String']>
  id: Scalars['ID']
  rfpErrorTypeId: Scalars['ID']
  rowStatus: INormFileGeneratorRowStatus
  statusId: Scalars['ID']
  type: IRfpErrorType
}

export type IRfpLaneFeedbackUpdateInput = {
  awardStatus?: Maybe<Scalars['String']>
  tttAtAward?: Maybe<Scalars['Float']>
}

export type IRfpLaneFilters = {
  allInDatPctRange?: Maybe<IRequestForProposalPriceRange>
  awardStatus?: Maybe<Array<Scalars['String']>>
  awardType?: Maybe<Array<Scalars['String']>>
  carrierConfidence?: Maybe<Array<Scalars['String']>>
  currentUser?: Maybe<Scalars['Boolean']>
  defenseAction?: Maybe<Array<Scalars['String']>>
  deliveryLocation?: Maybe<IRequestForProposalLocation>
  dropType?: Maybe<Array<Scalars['String']>>
  effectiveMarginDollarRange?: Maybe<IRequestForProposalPriceRange>
  effectiveMarginPctRange?: Maybe<IRequestForProposalPriceRange>
  equipMapped?: Maybe<Array<Scalars['String']>>
  extraStops?: Maybe<Array<Scalars['String']>>
  hasFeedback?: Maybe<Scalars['Boolean']>
  hasFeedbackNotes?: Maybe<Scalars['Boolean']>
  hasNotes?: Maybe<Scalars['Boolean']>
  hasPricingAdjustment?: Maybe<Scalars['Boolean']>
  hasTttOverride?: Maybe<Scalars['Boolean']>
  incumbentAwardType?: Maybe<Array<Scalars['String']>>
  incumbentLaneId?: Maybe<Scalars['String']>
  laneDeliveryLocation?: Maybe<IRequestForProposalLaneLocation>
  laneDesirability?: Maybe<Array<Scalars['String']>>
  laneIds?: Maybe<Array<Scalars['String']>>
  lanePickupLocation?: Maybe<IRequestForProposalLaneLocation>
  lengthOfHaul?: Maybe<Array<Scalars['String']>>
  liveAuditRiskLevel?: Maybe<Array<Scalars['String']>>
  marketDemandScore?: Maybe<Array<Scalars['String']>>
  noErrors?: Maybe<Scalars['Boolean']>
  pickupLocation?: Maybe<IRequestForProposalLocation>
  pricingRound: Scalars['Int']
  requestForProposalId: Scalars['ID']
  roundAuditStatus?: Maybe<Array<Scalars['String']>>
  simPathsRiskLabel?: Maybe<Array<Scalars['String']>>
  strategies?: Maybe<Array<Scalars['String']>>
  varianceFlags?: Maybe<Array<Scalars['String']>>
  volumeRange?: Maybe<IRequestForProposalPriceRange>
  zones?: Maybe<Array<Scalars['String']>>
}

export type IRfpLanePriceUpdateInput = {
  allInOverride?: Maybe<Scalars['Float']>
  allInTcmValueOverride?: Maybe<Scalars['String']>
  dollarPremium?: Maybe<Scalars['Float']>
  linehaulOverride?: Maybe<Scalars['Float']>
  liveAuditRiskLevel?: Maybe<Scalars['String']>
  marginAdjustment1?: Maybe<Scalars['Float']>
  marginAdjustmentDollar?: Maybe<Scalars['Float']>
  p2dAdjustmentPct?: Maybe<Scalars['Float']>
  premiumPct?: Maybe<Scalars['Float']>
  roundAuditStatus?: Maybe<Scalars['String']>
  setAllInToTtt?: Maybe<Scalars['Boolean']>
  strategyUpdate?: Maybe<IRequestForProposalStrategyUpdateTypes>
  tcmUsed?: Maybe<Scalars['String']>
  tttAdjustmentDollar?: Maybe<Scalars['Float']>
  tttAdjustmentPct?: Maybe<Scalars['Float']>
  tttOverride?: Maybe<Scalars['Float']>
}

export type IRfpLaneUpdateInput = {
  auditStatus?: Maybe<Scalars['String']>
}

export enum IRolledRescheduleReasons {
  /** Carrier Failure: Poor Planning */
  carrier_failure__poor_planning = 'carrier_failure__poor_planning',
  /** Carrier Issue: Driver Issue */
  carrier_issue__driver_issue = 'carrier_issue__driver_issue',
  /** Carrier Issue: Driving Delays */
  carrier_issue__driving_delays = 'carrier_issue__driving_delays',
  /** Carrier Issue: Mechanical */
  carrier_issue__mechanical = 'carrier_issue__mechanical',
  /** Carrier Issue: Rejected trailer */
  carrier_issue__rejected_trailer = 'carrier_issue__rejected_trailer',
  /** TF Issue: Clerical Error/Inaccurate Info */
  tf_issue__clerical_error_inaccurate_info = 'tf_issue__clerical_error_inaccurate_info',
  /** TF Issue: CM Booking/Capacity */
  tf_issue__cm_booking_capacity = 'tf_issue__cm_booking_capacity',
  /** TF Issue: Loss Prevention */
  tf_issue__loss_prevention = 'tf_issue__loss_prevention',
  /** TF Issue: Pricing */
  tf_issue__pricing = 'tf_issue__pricing',
  /** TF Issue: Tracking/Tracing */
  tf_issue__tracking_tracing = 'tf_issue__tracking_tracing',
}

export type IRuleStartTimeCriteria = {
  __typename?: 'RuleStartTimeCriteria'
  id: Scalars['ID']
  rangeStart?: Maybe<Scalars['String']>
}

export type IRulesAssessmentOverride = {
  __typename?: 'RulesAssessmentOverride'
  deprecatedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  result: IRulesAssessmentOverrideResultEnum
  rulesAssessmentId: Scalars['ID']
  rulesAssessmentType: IRulesAssessmentOverrideTypeEnum
}

export enum IRulesAssessmentOverrideResultEnum {
  /** Fail rule */
  fail = 'fail',
  /** Pass rule */
  pass = 'pass',
}

export enum IRulesAssessmentOverrideTypeEnum {
  HighwayRule = 'HighwayRule',
  TransfixRule = 'TransfixRule',
}

/** Autogenerated input type of RunConfigurableBuilder */
export type IRunConfigurableBuilderInput = {
  accountingInvoiceId?: Maybe<Scalars['Int']>
  /** indicates if we should use tfx12 or stupedi to validate EDI */
  builderLibrary: IBuilderLibraries
  changedField?: Maybe<Scalars['String']>
  changedShipperStopSequence?: Maybe<Scalars['Int']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** extraction template used to pass into builder */
  extractionTemplate: Scalars['String']
  /** id of the related outbound config to use */
  outboundEdiMapperConnectionConfigId: Scalars['ID']
  shipmentId?: Maybe<Scalars['Int']>
  /** stupid edi config to use on builder */
  stupidediConfig?: Maybe<IStupidEdiConfigs>
  /** id of tfx12 definition to use on builder */
  tfx12DefinitionId?: Maybe<Scalars['ID']>
  /** transaction set for the builder being tested */
  transactionSet: ITransactionSetTypes
  /** transaction set subtype for the builder being tested */
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
}

/** Autogenerated return type of RunConfigurableBuilder */
export type IRunConfigurableBuilderPayload = {
  __typename?: 'RunConfigurableBuilderPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediOutput?: Maybe<Scalars['String']>
  errors: Array<IError>
  jsonOutput?: Maybe<Scalars['JSON']>
}

/** Autogenerated input type of RunConfigurableBuilderTests */
export type IRunConfigurableBuilderTestsInput = {
  /** run all tests for this configurable builder */
  builderId?: Maybe<Scalars['ID']>
  /** indicates if we should use stupiededi or tfx12 when building edi */
  builderLibrary: IBuilderLibraries
  /** run this single configurable builder test */
  builderTestId?: Maybe<Scalars['ID']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** extraction template to use in builder */
  extractionTemplate: Scalars['String']
  /** EDI Mapper outbound config to use when building EDI */
  outboundConfigId: Scalars['ID']
  /** stupidedi config name to use in builder */
  stupidediConfig?: Maybe<IStupidEdiConfigs>
  /** id of tfx12 definition to use in builder */
  tfx12DefinitionId?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of RunConfigurableBuilderTests */
export type IRunConfigurableBuilderTestsPayload = {
  __typename?: 'RunConfigurableBuilderTestsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configurableBuilderTestResults?: Maybe<Array<IConfigurableBuilderTestResult>>
  errors: Array<IError>
}

/** Params for a saved lane load match push notification job */
export type ISavedLaneLoadMatch = {
  carrierName?: Maybe<Scalars['String']>
  deliveryLocation?: Maybe<Scalars['String']>
  pickupLocation: Scalars['String']
  shipmentId: Scalars['ID']
  sourceType?: Maybe<Scalars['String']>
}

export type IScraperJobConfiguration = {
  __typename?: 'ScraperJobConfiguration'
  comment?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  demoMode: Scalars['Boolean']
  deprecatedAt?: Maybe<Scalars['ISO8601DateTime']>
  description: Scalars['String']
  elementsWaitingTime?: Maybe<Scalars['Int']>
  id: Scalars['ID']
  isEnabled: Scalars['Boolean']
  jobQueueName?: Maybe<Scalars['String']>
  jobSubtype?: Maybe<Scalars['String']>
  jobType: Scalars['String']
  jobUuid: Scalars['String']
  scraperJobExecutionCurrentExecution?: Maybe<IScraperJobExecutionHistory>
  scraperJobExecutionLastExecution?: Maybe<IScraperJobExecutionHistory>
  shipperApplication: IShipperApplication
  shipperApplicationId: Scalars['ID']
  tmsName: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy: IUser
  updatedById: Scalars['ID']
}

export type IScraperJobConfigurationAndHistory = {
  __typename?: 'ScraperJobConfigurationAndHistory'
  updatedScraperJobConfiguration?: Maybe<IScraperJobConfiguration>
  updatedScraperJobConfigurationHistory?: Maybe<IScraperJobConfigurationHistory>
}

export type IScraperJobConfigurationHistory = {
  __typename?: 'ScraperJobConfigurationHistory'
  scraperConfigurationHistory: Array<IScraperJobConfigurationHistoryItem>
}

export type IScraperJobConfigurationHistoryItem = {
  __typename?: 'ScraperJobConfigurationHistoryItem'
  desc: Scalars['String']
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy: IUser
}

export type IScraperJobConfigurationMetadata = {
  __typename?: 'ScraperJobConfigurationMetadata'
  shipperNames: Array<Scalars['String']>
  tmsNames: Array<Scalars['String']>
}

export type IScraperJobExecutionHistory = {
  __typename?: 'ScraperJobExecutionHistory'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  endedAt?: Maybe<Scalars['ISO8601DateTime']>
  errorMessage?: Maybe<Scalars['String']>
  errorType?: Maybe<Scalars['String']>
  id: Scalars['ID']
  result?: Maybe<Scalars['String']>
  scraperJobConfigurationId: Scalars['ID']
  startedAt: Scalars['ISO8601DateTime']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** Autogenerated input type of SelfDeleteParentUser */
export type ISelfDeleteParentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  parentUserId: Scalars['ID']
}

/** Autogenerated return type of SelfDeleteParentUser */
export type ISelfDeleteParentUserPayload = {
  __typename?: 'SelfDeleteParentUserPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  parentUser?: Maybe<IParentUser>
}

/** Autogenerated input type of SendShipmentOfferToCarrier */
export type ISendShipmentOfferToCarrierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of SendShipmentOfferToCarrier */
export type ISendShipmentOfferToCarrierPayload = {
  __typename?: 'SendShipmentOfferToCarrierPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of SendSmsRelayPayments */
export type ISendSmsRelayPaymentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** the relay_payments_code record id to send sms */
  relayPaymentsCodeId: Scalars['ID']
}

/** Autogenerated return type of SendSmsRelayPayments */
export type ISendSmsRelayPaymentsPayload = {
  __typename?: 'SendSmsRelayPaymentsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  result: Scalars['Boolean']
}

/** Autogenerated input type of SetCarrierRelationships */
export type ISetCarrierRelationshipsInput = {
  carrierApplicationId: Scalars['ID']
  carrierRelationships: Array<ICarrierRelationshipInput>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of SetCarrierRelationships */
export type ISetCarrierRelationshipsPayload = {
  __typename?: 'SetCarrierRelationshipsPayload'
  carrierApplication?: Maybe<ICarrierApplication>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of SetLatestUserAvailabilitiesFilterPreference */
export type ISetLatestUserAvailabilitiesFilterPreferenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  filterName: Scalars['String']
  filters: ILatestUserAvailabilitiesFilterPreferencesInput
}

/** Autogenerated return type of SetLatestUserAvailabilitiesFilterPreference */
export type ISetLatestUserAvailabilitiesFilterPreferencePayload = {
  __typename?: 'SetLatestUserAvailabilitiesFilterPreferencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  filterName: Scalars['String']
  latestUserAvailabilitiesFilters: ILatestUserAvailabilitiesFilterPreferences
}

/** Autogenerated input type of SetNotifiedEscalatedShipmentIssues */
export type ISetNotifiedEscalatedShipmentIssuesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentIssues: Array<INotifiedEscalatedShipmentIssueInput>
}

/** Autogenerated return type of SetNotifiedEscalatedShipmentIssues */
export type ISetNotifiedEscalatedShipmentIssuesPayload = {
  __typename?: 'SetNotifiedEscalatedShipmentIssuesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of SetShipmentIssuesFilterPreference */
export type ISetShipmentIssuesFilterPreferenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  filterName: Scalars['String']
  filters: IShipmentIssueFilterPreferencesInput
}

/** Autogenerated return type of SetShipmentIssuesFilterPreference */
export type ISetShipmentIssuesFilterPreferencePayload = {
  __typename?: 'SetShipmentIssuesFilterPreferencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  filterName: Scalars['String']
  shipmentIssueFilters: IShipmentIssueFilterPreferences
}

/** Autogenerated input type of SetShipmentTaskCap */
export type ISetShipmentTaskCapInput = {
  cap: Scalars['Int']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  taskNamespace: ITaskNamespaces
}

/** Autogenerated return type of SetShipmentTaskCap */
export type ISetShipmentTaskCapPayload = {
  __typename?: 'SetShipmentTaskCapPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipmentTaskCap?: Maybe<IShipmentTaskCap>
}

/** Autogenerated input type of SetShipperAppointmentPreference */
export type ISetShipperAppointmentPreferenceInput = {
  allowAutotender: Scalars['Boolean']
  beginBeforeAfter?: Maybe<IShipperBeginBeforeAfter>
  beginDate?: Maybe<IShipperBeginDateOptions>
  beginDays?: Maybe<Scalars['Int']>
  beginEnabled: Scalars['Boolean']
  bufferStopType?: Maybe<IShipperBufferStopTypes>
  bufferTimeMin?: Maybe<Scalars['Int']>
  buffersEnabled: Scalars['Boolean']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  deliveryAutoScheduleEnabled: Scalars['Boolean']
  orderEnabled: Scalars['Boolean']
  orderStopType?: Maybe<IShipmentStopTypes>
  pickupAutoScheduleEnabled: Scalars['Boolean']
  schedulingInstructions?: Maybe<Scalars['String']>
  shipperApplicationId: Scalars['ID']
}

/** Autogenerated return type of SetShipperAppointmentPreference */
export type ISetShipperAppointmentPreferencePayload = {
  __typename?: 'SetShipperAppointmentPreferencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperAppointmentPreference?: Maybe<IShipperAppointmentPreference>
}

/** Autogenerated input type of SetShipperRelationships */
export type ISetShipperRelationshipsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  opsCustomerEmail?: Maybe<Scalars['String']>
  podId?: Maybe<Scalars['ID']>
  shipperApplicationId: Scalars['ID']
  shipperRelationships: Array<IShipperRelationshipInput>
}

/** Autogenerated return type of SetShipperRelationships */
export type ISetShipperRelationshipsPayload = {
  __typename?: 'SetShipperRelationshipsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperApplication?: Maybe<IShipperApplication>
}

/** Autogenerated input type of SetShipperTenderAppointmentConfiguration */
export type ISetShipperTenderAppointmentConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipperApplicationId: Scalars['ID']
  shipperTenderAppointmentConfiguration: IShipperTenderAppointmentConfigurationInput
}

/** Autogenerated return type of SetShipperTenderAppointmentConfiguration */
export type ISetShipperTenderAppointmentConfigurationPayload = {
  __typename?: 'SetShipperTenderAppointmentConfigurationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  tenderAppointmentConfiguration?: Maybe<IShipperTenderAppointmentConfiguration>
}

/** Autogenerated input type of SetTaskedShipmentFilterPreference */
export type ISetTaskedShipmentFilterPreferenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  filterName: Scalars['String']
  filters: ITaskedShipmentFilterPreferencesInput
}

/** Autogenerated return type of SetTaskedShipmentFilterPreference */
export type ISetTaskedShipmentFilterPreferencePayload = {
  __typename?: 'SetTaskedShipmentFilterPreferencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  filterName: Scalars['String']
  taskedShipmentFilters: ITaskedShipmentFilterPreferences
}

export type ISetUserAvailabilityInput = {
  delete?: Maybe<Scalars['Boolean']>
  isAvailable: Scalars['Boolean']
  type?: Maybe<IUserAvailabilityTypes>
  userId: Scalars['ID']
}

export type IShipment = {
  __typename?: 'Shipment'
  /** All non-deleted accessorials on this shipment */
  accessorials: Array<IShipmentAccessorial>
  activeCarrierAssignment?: Maybe<ICarrierAssignment>
  /** All active CE tasks on this shipment */
  activeCeTasks: Array<ITask>
  /** All active CX tasks on this shipment */
  activeCxTasks: Array<ITask>
  allCarrierAssignments: Array<ICarrierAssignment>
  backhaulRevenueShareAgreement?: Maybe<IBackhaulRevenueShareAgreement>
  backhaulRevenueShareAgreementId?: Maybe<Scalars['ID']>
  bolReferences: Array<Scalars['String']>
  bouncedCarrierAssignments: Array<ICarrierAssignment>
  btfUpdateExpected: Scalars['Boolean']
  calculatedMiles?: Maybe<Scalars['Float']>
  canCancel: Scalars['Boolean']
  canceledAt?: Maybe<Scalars['ISO8601DateTime']>
  canceledBy?: Maybe<IUser>
  carrierApplication?: Maybe<ICarrierApplication>
  carrierApplicationId?: Maybe<Scalars['ID']>
  carrierCancelationFee?: Maybe<Scalars['Float']>
  /** Sum of all known carrier charges, less any comcheck payments */
  carrierGrandTotal: Scalars['Float']
  /** Always the sum of carrier rate and carrier fuel rate, regardless of TONU status */
  carrierLineHaulAndFuelRate?: Maybe<Scalars['Float']>
  /** AKA Ops Rep */
  carrierManager?: Maybe<IUser>
  carrierPaymentTerms: Scalars['Int']
  carrierPaymentTermsType: IPaymentTermsTypes
  carrierPerMileFuelRate?: Maybe<Scalars['Float']>
  carrierRate?: Maybe<Scalars['Float']>
  carrierRateType?: Maybe<ICarrierRateTypes>
  carrierSpecialInstructions?: Maybe<Scalars['String']>
  carrierTotalAccessorialRate?: Maybe<Scalars['Float']>
  /** Total carrier rate for carrier TONUs */
  carrierTotalCarrierTonuRate?: Maybe<Scalars['Float']>
  carrierTotalCharges: Scalars['Float']
  carrierTotalFuelRate?: Maybe<Scalars['Float']>
  /** @deprecated Use carrierTotalCharges instead */
  carrierTotalRate?: Maybe<Scalars['Float']>
  /** All CE tasks on this shipment */
  ceTasks: Array<ITask>
  characteristics: IShipmentCharacteristics
  cmTarget?: Maybe<Scalars['Float']>
  comchecks: Array<IComcheck>
  commissionTierBands?: Maybe<IShipmentCommissionTierBands>
  contactPreferences: IContactPreference
  coveredBid?: Maybe<IBid>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  creator: IUser
  currentCeRep?: Maybe<IUser>
  currentCxTask?: Maybe<ITask>
  /** Get index of the current stop (based on the "next destination") */
  currentStopIndex: Scalars['Int']
  cxRep?: Maybe<IUser>
  /** All CX tasks on this shipment */
  cxTasks: Array<ITask>
  datMarketRate?: Maybe<IShipmentRate>
  declaredValue?: Maybe<Scalars['Float']>
  deliveries: Array<IShipmentStop>
  disallowAutoShipperFuelComputation: Scalars['Boolean']
  dispatchedAt?: Maybe<Scalars['ISO8601DateTime']>
  dispatcher?: Maybe<IUser>
  driver?: Maybe<IUser>
  driverLocations: IDriverLocationConnection
  ediShipmentExtraData?: Maybe<IEdiShipmentExtraData>
  equipment: IEquipment
  equipmentAttributes: Array<IShipmentEquipmentAttribute>
  equipmentId: Scalars['ID']
  firstPickup: IShipmentStop
  hasClaims: Scalars['Boolean']
  hasOsd: Scalars['Boolean']
  id: Scalars['ID']
  isBackhaul: Scalars['Boolean']
  isBtfRequired: Scalars['Boolean']
  isListedInCarrierApp: Scalars['Boolean']
  isRelayPaymentsEnabled: Scalars['Boolean']
  isTonu: Scalars['Boolean']
  issueSuggestedOwners: Array<IShipmentIssueSuggestedOwner>
  issues: Array<IShipmentIssue>
  lastAction?: Maybe<IShipmentAction>
  lastDelivery: IShipmentStop
  lastOpsNote?: Maybe<INote>
  lastPickup: IShipmentStop
  latestListPrice?: Maybe<IListPrice>
  /** Old accounting bill document that precedes the Bill type */
  legacyBill?: Maybe<IDownloadable>
  /** Old accounting main or accessorial invoice documents that precede the Invoice type */
  legacyInvoices: Array<IDownloadable>
  links: IShipmentLinks
  listRate?: Maybe<Scalars['Float']>
  loadBoardPosts: Array<ILoadBoardPost>
  loadingType?: Maybe<IShipperLoadTypes>
  miscellaneousDocument?: Maybe<IDownloadable>
  miscellaneousDocumentUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  notMarketableReasons: IShipmentNotMarketableReasons
  notes: Array<INote>
  optionGradeTiers?: Maybe<IShipmentOptionGrade>
  originalShipmentId?: Maybe<Scalars['ID']>
  pickups: Array<IShipmentStop>
  poReferences: Array<Scalars['String']>
  pod?: Maybe<IDownloadable>
  podApproved: Scalars['Boolean']
  podSyncedWithHubtran: Scalars['Boolean']
  podUploadedAt?: Maybe<Scalars['ISO8601DateTime']>
  pricingType?: Maybe<IPricingTypes>
  proofOfTonu?: Maybe<IProofOfTonu>
  rateConfirmation?: Maybe<IDownloadable>
  rateConfirmationAgreement?: Maybe<IRateConfirmationAgreement>
  readyToBillAt?: Maybe<Scalars['ISO8601DateTime']>
  readyToInvoiceAt?: Maybe<Scalars['ISO8601DateTime']>
  recentStats: IShipmentRecentStats
  removedPods: Array<IRemovedPodFile>
  shipmentIssueIds: Array<Scalars['ID']>
  shipperApplication: IShipperApplication
  shipperApplicationId: Scalars['ID']
  shipperCancelationFee?: Maybe<Scalars['Float']>
  shipperFuelRate?: Maybe<IShipmentRate>
  /** Sum of all known shipper charges */
  shipperGrandTotal: Scalars['Float']
  shipperInsuranceRequirement: IShipperInsuranceRequirement
  /** Always the sum of shipper rate and shipper fuel rate, regardless of TONU status */
  shipperLineHaulAndFuelRate: Scalars['Float']
  shipperMiles?: Maybe<Scalars['Float']>
  shipperPaymentTerms: Scalars['Int']
  shipperPaymentTermsType?: Maybe<IPaymentTermsTypes>
  shipperPerMileFuelRate?: Maybe<Scalars['Float']>
  shipperRate?: Maybe<Scalars['Float']>
  shipperRateConfirmedAt?: Maybe<Scalars['ISO8601DateTime']>
  shipperRateConfirmedBy?: Maybe<IUser>
  shipperRateSources?: Maybe<Array<IShipmentShipperRateSource>>
  shipperRateType?: Maybe<IShipperRateTypes>
  shipperShipmentReference?: Maybe<Scalars['String']>
  shipperTotalAccessorialRate?: Maybe<Scalars['Float']>
  /** Total shipper rate for carrier TONUs */
  shipperTotalCarrierTonuRate?: Maybe<Scalars['Float']>
  shipperTotalCharges: Scalars['Float']
  shipperTotalFuelRate?: Maybe<Scalars['Float']>
  /** @deprecated Use shipperTotalCharges instead */
  shipperTotalRate?: Maybe<Scalars['Float']>
  shipperTrackingSegment?: Maybe<IShipperTrackingSegment>
  similarPosts: Array<ILoadBoardPost>
  smsMessages: Array<ISmsMessage>
  source: Scalars['String']
  specialInstruction?: Maybe<Scalars['String']>
  state: IShipmentStates
  statusDetails: IShipmentStatus
  stops: Array<IShipmentStop>
  strategicBuyRate?: Maybe<Scalars['Float']>
  suggestedCounterAmount?: Maybe<Scalars['Float']>
  targetMarginRate?: Maybe<Scalars['Float']>
  team: Scalars['Boolean']
  tmsShipmentPublicUuid?: Maybe<Scalars['ID']>
  /** Total amount billed to the carrier. Does not include carrier TONU bills. */
  totalBillableAmount: Scalars['Float']
  /** Total amount invoiced to the shipper. */
  totalInvoiceableAmount: Scalars['Float']
  totalPalletCount?: Maybe<Scalars['Int']>
  totalWeight?: Maybe<Scalars['Int']>
  trackingOverview: ITrackingOverview
  trackingSummary: ITrackingSummary
  trailerNumber?: Maybe<Scalars['String']>
  trailerNumberRequired: Scalars['Boolean']
  truckNumber?: Maybe<Scalars['String']>
  truckNumberRequired: Scalars['Boolean']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  vin?: Maybe<Scalars['String']>
  vinVerified?: Maybe<Scalars['Boolean']>
}

export type IShipmentCarrierTotalAccessorialRateArgs = {
  excludeCarrierTonus?: Maybe<Scalars['Boolean']>
}

export type IShipmentDriverLocationsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type IShipmentIssuesArgs = {
  states?: Maybe<Array<IShipmentIssueStates>>
}

export type IShipmentNotesArgs = {
  includeIssueNotes?: Maybe<Scalars['Boolean']>
  noteType?: Maybe<INoteTypes>
}

export type IShipmentRecentStatsArgs = {
  sinceMinutes?: Maybe<Scalars['Int']>
}

export type IShipmentShipperTotalAccessorialRateArgs = {
  excludeCarrierTonus?: Maybe<Scalars['Boolean']>
}

export type IShipmentAccessorial = {
  __typename?: 'ShipmentAccessorial'
  additionalInfo?: Maybe<Scalars['JSON']>
  approvedAt?: Maybe<Scalars['ISO8601DateTime']>
  approvedBy?: Maybe<IUser>
  approvedById?: Maybe<Scalars['ID']>
  carrierAmount: Scalars['Float']
  carrierApprovalStateUpdatedAt?: Maybe<Scalars['String']>
  carrierApprovalStateUpdatedBy?: Maybe<IUser>
  carrierState: IShipmentAccessorialCarrierStates
  comcheck?: Maybe<IComcheck>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  createdBy: IUser
  createdById: Scalars['ID']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  deletedBy?: Maybe<IUser>
  deletedById?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  endDateTime?: Maybe<Scalars['String']>
  escortServiceName?: Maybe<Scalars['String']>
  file?: Maybe<IDownloadable>
  id: Scalars['ID']
  inactiveRelayPaymentsCodes?: Maybe<Array<IRelayPaymentsCode>>
  isCustomerRequest: Scalars['Boolean']
  isOutOfPocket: Scalars['Boolean']
  location?: Maybe<ILocation>
  lumperServiceName?: Maybe<Scalars['String']>
  name: IShipmentAccessorialNames
  oopOwner?: Maybe<IOopAccessorialOwner>
  /** Out of Pocket Owner ID */
  oopOwnerId?: Maybe<Scalars['ID']>
  oopOwnerType?: Maybe<IShipmentIssueFollowerTypes>
  oopReason?: Maybe<Scalars['String']>
  rejectionReason?: Maybe<Scalars['String']>
  relayPaymentsCode?: Maybe<IRelayPaymentsCode>
  shipmentStop?: Maybe<IShipmentStop>
  shipperAmount: Scalars['Float']
  shipperApprovalState?: Maybe<Scalars['String']>
  shipperApprovalStateUpdatedAt?: Maybe<Scalars['String']>
  shipperApprovalStateUpdatedBy?: Maybe<IUser>
  shipperFacility?: Maybe<IShipperFacility>
  shipperRejectionReason?: Maybe<Scalars['String']>
  source?: Maybe<IShipmentAccessorialSources>
  startDateTime?: Maybe<Scalars['String']>
  taxId?: Maybe<Scalars['String']>
  trailerControlRecord?: Maybe<Scalars['String']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy: IUser
  updatedById: Scalars['ID']
}

export enum IShipmentAccessorialCarrierStates {
  approved = 'approved',
  pending = 'pending',
  rejected = 'rejected',
}

export enum IShipmentAccessorialNames {
  /** Bridge Toll */
  bridge_toll = 'bridge_toll',
  /** Circuity Fee */
  circuity_fee = 'circuity_fee',
  /** Cross Dock */
  cross_dock = 'cross_dock',
  /** Deadhead Mileage */
  deadhead_mileage = 'deadhead_mileage',
  /** Deduction Fee */
  deduction_fee = 'deduction_fee',
  /** Detention Fee */
  detention_fee = 'detention_fee',
  /** Driver Assist */
  driver_assist = 'driver_assist',
  /** Driver Loading/Unloading */
  driver_loading_unloading = 'driver_loading_unloading',
  /** Driver Not Tracking Fee */
  driver_not_tracking_fee = 'driver_not_tracking_fee',
  /** ES-Escort Service Fee */
  es_escort_service_fee = 'es_escort_service_fee',
  /** Escort Fee */
  escort_fee = 'escort_fee',
  /** Financial Reconciliation (For AR/AP Use Only) */
  financial_reconciliation__for_ar_ap_use_only_ = 'financial_reconciliation__for_ar_ap_use_only_',
  /** Flat Rate */
  flat_rate = 'flat_rate',
  /** Insurance Claims */
  insurance_claims = 'insurance_claims',
  /** Keep from Freezing */
  keep_from_freezing = 'keep_from_freezing',
  /** Late Fee */
  late_fee = 'late_fee',
  /** Layover Fee */
  layover_fee = 'layover_fee',
  /** Lumper Charge */
  lumper_charge = 'lumper_charge',
  /** Miscellaneous */
  miscellaneous = 'miscellaneous',
  /** OTP/OTD Late Fee */
  otp_otd_late_fee = 'otp_otd_late_fee',
  /** Out of Route Miles Fee */
  out_of_route_miles_fee = 'out_of_route_miles_fee',
  /** Preloading Charge */
  preloading_charge = 'preloading_charge',
  /** Reconsignment Fee */
  reconsignment_fee = 'reconsignment_fee',
  /** Redelivery / Refused Goods */
  redelivery___refused_goods = 'redelivery___refused_goods',
  /** Restack */
  restack = 'restack',
  /** Returned Load */
  returned_load = 'returned_load',
  /** Stop-off Charge */
  stop_off_charge = 'stop_off_charge',
  /** Storage Fee */
  storage_fee = 'storage_fee',
  /** Team Driver */
  team_driver = 'team_driver',
  /** Tier 1 */
  tier_1 = 'tier_1',
  /** TONU */
  tonu = 'tonu',
  /** Trailer Detention Fee */
  trailer_detention_fee = 'trailer_detention_fee',
  /** Up Charge */
  up_charge = 'up_charge',
}

export enum IShipmentAccessorialSources {
  /** Edi */
  edi = 'edi',
  /** Fleet planner */
  fleet_planner = 'fleet_planner',
  /** Mobile */
  mobile = 'mobile',
  /** Scraper */
  scraper = 'scraper',
  /** Stark link generated */
  stark_link_generated = 'stark_link_generated',
  /** Stark manually added */
  stark_manually_added = 'stark_manually_added',
}

export type IShipmentAction = {
  __typename?: 'ShipmentAction'
  at?: Maybe<Scalars['ISO8601DateTime']>
  snippet?: Maybe<Scalars['String']>
  type: IShipmentActionTypes
  updatedBy?: Maybe<IUser>
}

export enum IShipmentActionTypes {
  Callback = 'Callback',
  Note = 'Note',
  ShipmentDelivery = 'ShipmentDelivery',
  ShipmentPickup = 'ShipmentPickup',
  ShipmentStateTransition = 'ShipmentStateTransition',
}

export type IShipmentCharacteristics = {
  __typename?: 'ShipmentCharacteristics'
  backhaulEligible: Scalars['Boolean']
  bounceCount: Scalars['Int']
  fraudValidation: Scalars['Boolean']
  haltClaimsBilling: Scalars['Boolean']
  haltClaimsInvoicing: Scalars['Boolean']
  hasDropTrailerStops: Scalars['Boolean']
  hazmat: Scalars['Boolean']
  hot: Scalars['Boolean']
  isHighRisk: Scalars['Boolean']
  mustGo: Scalars['Boolean']
  rolloverCount: Scalars['Int']
  sameDaySpot: Scalars['Boolean']
  trueRatePlus: Scalars['Boolean']
}

export enum IShipmentCharacteristicsEnum {
  /** Backhaul */
  backhaul = 'backhaul',
  /** Drop trailer */
  drop_trailer = 'drop_trailer',
  /** Hot */
  hot = 'hot',
  /** Must go */
  must_go = 'must_go',
  /** Rolled */
  rolled = 'rolled',
}

/** Bands which determine commission incentive tiers for booking a shipment. */
export type IShipmentCommissionTierBands = {
  __typename?: 'ShipmentCommissionTierBands'
  tier1Max: Scalars['Float']
  tier2Max: Scalars['Float']
  tier3Max: Scalars['Float']
}

/** The connection type for Shipment. */
export type IShipmentConnection = {
  __typename?: 'ShipmentConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IShipmentEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IShipment>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IShipmentEdge = {
  __typename?: 'ShipmentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IShipment>
}

export type IShipmentEquipmentAttribute = {
  __typename?: 'ShipmentEquipmentAttribute'
  attributeValue: Scalars['String']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  parent: IEquipmentAttribute
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IShipmentEquipmentAttributeInput = {
  type: IEquipmentAttributeTypes
  value: Scalars['String']
}

export type IShipmentIssue = ICreatedByUser & {
  __typename?: 'ShipmentIssue'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  dueAt?: Maybe<Scalars['ISO8601DateTime']>
  escalateAt?: Maybe<Scalars['ISO8601DateTime']>
  escalated: Scalars['Boolean']
  fault?: Maybe<IShipmentIssueFault>
  id: Scalars['ID']
  issueResolutionSteps?: Maybe<Array<IIssueResolutionStep>>
  issueStateTransitions: Array<IShipmentIssueStateTransition>
  notes: Array<INote>
  notified: Scalars['Boolean']
  notifyAt?: Maybe<Scalars['ISO8601DateTime']>
  owner: IShipmentIssueFollower
  priority?: Maybe<Scalars['Int']>
  reason?: Maybe<IShipmentIssueReason>
  shipment: IShipment
  shouldEscalate: Scalars['Boolean']
  shouldNotify: Scalars['Boolean']
  state: IShipmentIssueStates
  stepsToResolve?: Maybe<Array<Scalars['String']>>
  subscribers: Array<IShipmentIssueFollower>
  suggestedOwners: Array<IShipmentIssueSuggestedOwner>
  summary?: Maybe<Scalars['String']>
  type: IShipmentIssueType
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  updater: IUser
}

export type IShipmentIssueCategory = {
  __typename?: 'ShipmentIssueCategory'
  id: Scalars['ID']
  name: Scalars['String']
}

/** The connection type for ShipmentIssue. */
export type IShipmentIssueConnection = {
  __typename?: 'ShipmentIssueConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IShipmentIssueEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IShipmentIssue>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

export type IShipmentIssueDefaults = {
  __typename?: 'ShipmentIssueDefaults'
  defaultOwner?: Maybe<IShipmentIssueFollower>
  defaultPriority?: Maybe<Scalars['Int']>
  defaultSubscribers: Array<IShipmentIssueFollower>
  slaDuration?: Maybe<Scalars['Int']>
}

/** An edge in a connection. */
export type IShipmentIssueEdge = {
  __typename?: 'ShipmentIssueEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IShipmentIssue>
}

export type IShipmentIssueFault = {
  __typename?: 'ShipmentIssueFault'
  fault: Scalars['String']
  id: Scalars['ID']
}

export type IShipmentIssueFilterPreferences = {
  __typename?: 'ShipmentIssueFilterPreferences'
  /** @deprecated Use carrier_ids instead */
  carrierId?: Maybe<Scalars['ID']>
  carrierIds?: Maybe<Array<Scalars['ID']>>
  createdAt?: Maybe<Scalars['ISO8601Date']>
  createdAtEnd?: Maybe<Scalars['ISO8601Date']>
  /** @deprecated Use created_by_ids instead */
  createdById?: Maybe<Scalars['ID']>
  createdByIds?: Maybe<Array<Scalars['ID']>>
  deliveryDate?: Maybe<Scalars['ISO8601Date']>
  deliveryDateEnd?: Maybe<Scalars['ISO8601Date']>
  deliveryRegions?: Maybe<Array<IShipmentStopRegionTypes>>
  /** @deprecated Use delivery_states instead */
  deliveryState?: Maybe<IStates>
  deliveryStates?: Maybe<Array<IStates>>
  /** @deprecated Use facility_uuids instead */
  facilityUuid?: Maybe<Scalars['String']>
  facilityUuids?: Maybe<Array<Scalars['String']>>
  issueCategoryIds?: Maybe<Array<Scalars['ID']>>
  /** @deprecated Use issue_states */
  issueState?: Maybe<IShipmentIssueStates>
  issueStates?: Maybe<Array<IShipmentIssueStates>>
  issueTypeIds?: Maybe<Array<Scalars['ID']>>
  /** @deprecated Use owners instead */
  ownerId?: Maybe<Scalars['ID']>
  owners?: Maybe<Array<IFilterPreferencesShipmentIssueFollowerOutput>>
  pickupDate?: Maybe<Scalars['ISO8601Date']>
  pickupDateEnd?: Maybe<Scalars['ISO8601Date']>
  pickupRegions?: Maybe<Array<IShipmentStopRegionTypes>>
  /** @deprecated Use pickup_states instead */
  pickupState?: Maybe<IStates>
  pickupStates?: Maybe<Array<IStates>>
  podIds?: Maybe<Array<Scalars['ID']>>
  priorities?: Maybe<Array<Scalars['Int']>>
  shipmentCharacteristics?: Maybe<Array<IShipmentCharacteristicsEnum>>
  /** @deprecated Use shipment_ids instead */
  shipmentId?: Maybe<Scalars['ID']>
  shipmentIds?: Maybe<Array<Scalars['ID']>>
  shipmentStates?: Maybe<Array<IShipmentStates>>
  /** @deprecated Use shipper_ids instead */
  shipperId?: Maybe<Scalars['ID']>
  shipperIds?: Maybe<Array<Scalars['ID']>>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
  /** @deprecated Use subscribeds_to_by */
  subscribedToById?: Maybe<Scalars['ID']>
  subscribedsToBy?: Maybe<Array<IFilterPreferencesShipmentIssueFollowerOutput>>
  trackingLevels?: Maybe<Array<Scalars['Int']>>
  userEscalated?: Maybe<Scalars['Boolean']>
  userOwned?: Maybe<Scalars['Boolean']>
}

export type IShipmentIssueFilterPreferencesInput = {
  carrierId?: Maybe<Scalars['ID']>
  carrierIds?: Maybe<Array<Scalars['ID']>>
  createdAt?: Maybe<Scalars['ISO8601Date']>
  createdAtEnd?: Maybe<Scalars['ISO8601Date']>
  createdById?: Maybe<Scalars['ID']>
  createdByIds?: Maybe<Array<Scalars['ID']>>
  deliveryDate?: Maybe<Scalars['ISO8601Date']>
  deliveryDateEnd?: Maybe<Scalars['ISO8601Date']>
  deliveryRegions?: Maybe<Array<IShipmentStopRegionTypes>>
  deliveryState?: Maybe<IStates>
  deliveryStates?: Maybe<Array<IStates>>
  facilityUuid?: Maybe<Scalars['String']>
  facilityUuids?: Maybe<Array<Scalars['String']>>
  issueCategoryIds?: Maybe<Array<Scalars['ID']>>
  issueState?: Maybe<IShipmentIssueStates>
  issueStates?: Maybe<Array<IShipmentIssueStates>>
  issueTypeIds?: Maybe<Array<Scalars['ID']>>
  ownerId?: Maybe<Scalars['ID']>
  owners?: Maybe<Array<IShipmentIssueFollowerInput>>
  pickupDate?: Maybe<Scalars['ISO8601Date']>
  pickupDateEnd?: Maybe<Scalars['ISO8601Date']>
  pickupRegions?: Maybe<Array<IShipmentStopRegionTypes>>
  pickupState?: Maybe<IStates>
  pickupStates?: Maybe<Array<IStates>>
  podIds?: Maybe<Array<Scalars['ID']>>
  priorities?: Maybe<Array<Scalars['Int']>>
  shipmentCharacteristics?: Maybe<Array<IShipmentCharacteristicsEnum>>
  shipmentId?: Maybe<Scalars['ID']>
  shipmentIds?: Maybe<Array<Scalars['ID']>>
  shipmentStates?: Maybe<Array<IShipmentStates>>
  shipperId?: Maybe<Scalars['ID']>
  shipperIds?: Maybe<Array<Scalars['ID']>>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
  subscribedToById?: Maybe<Scalars['ID']>
  subscribedsToBy?: Maybe<Array<IShipmentIssueFollowerInput>>
  trackingLevels?: Maybe<Array<Scalars['Int']>>
  userEscalated?: Maybe<Scalars['Boolean']>
  userOwned?: Maybe<Scalars['Boolean']>
}

/** Shared type for shipment issue owners and subscribers */
export type IShipmentIssueFollower = {
  __typename?: 'ShipmentIssueFollower'
  email?: Maybe<Scalars['String']>
  firstName: Scalars['String']
  followerId: Scalars['ID']
  followerType: IShipmentIssueFollowerTypes
  lastName?: Maybe<Scalars['String']>
  nickname?: Maybe<Scalars['String']>
}

export type IShipmentIssueFollowerInput = {
  followerId: Scalars['ID']
  followerType: IShipmentIssueFollowerTypes
}

export enum IShipmentIssueFollowerTypes {
  Group = 'Group',
  User = 'User',
}

export type IShipmentIssueReason = {
  __typename?: 'ShipmentIssueReason'
  id: Scalars['ID']
  reason: Scalars['String']
}

export type IShipmentIssueStateTransition = ICreatedByUser & {
  __typename?: 'ShipmentIssueStateTransition'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  id: Scalars['ID']
  state: IShipmentIssueStates
  /** UpdatedAt timestamp in UTC */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>
}

export enum IShipmentIssueStates {
  /** Awaiting response */
  awaiting_response = 'awaiting_response',
  /** In progress */
  in_progress = 'in_progress',
  /** Pending */
  pending = 'pending',
  /** Resolved */
  resolved = 'resolved',
}

export type IShipmentIssueSuggestedOwner = {
  __typename?: 'ShipmentIssueSuggestedOwner'
  owner?: Maybe<IShipmentIssueFollower>
  role: Scalars['String']
}

export type IShipmentIssueType = {
  __typename?: 'ShipmentIssueType'
  canManuallyResolve: Scalars['Boolean']
  category?: Maybe<IShipmentIssueCategory>
  categoryId?: Maybe<Scalars['ID']>
  deletable: Scalars['Boolean']
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  issueResolutionSteps?: Maybe<Array<IBaseIssueResolutionStep>>
  name: Scalars['String']
  priority?: Maybe<Scalars['Int']>
  slaBasedOn: IShipmentIssueTypeSlaBasedOn
  slaDuration: Scalars['Int']
  slaDurationText: Scalars['String']
  stepsToResolve?: Maybe<Array<Scalars['String']>>
}

export enum IShipmentIssueTypeSlaBasedOn {
  /** SLA starts from issue creation */
  issue_creation = 'issue_creation',
  /** SLA starts from the next appointment start time */
  next_appointment_start = 'next_appointment_start',
}

export type IShipmentLinks = {
  __typename?: 'ShipmentLinks'
  starkCopyFmsShipmentUrl: Scalars['String']
}

export type IShipmentNotMarketableReasons = {
  __typename?: 'ShipmentNotMarketableReasons'
  base: Array<Scalars['String']>
  loadBoards: Array<Scalars['String']>
  marketplace: Array<Scalars['String']>
}

/** Demarcates poor, fair, or good bid amounts relative to the shipment's carrier manager target rate */
export type IShipmentOptionGrade = {
  __typename?: 'ShipmentOptionGrade'
  /** The maximum amount considered fair for the brokerage, any amount above this is considered poor */
  maxFairBidAmount: Scalars['Float']
  /** The maximum amount considered good for the brokerage; any amount lower than this is considered good */
  maxGoodBidAmount: Scalars['Float']
}

export type IShipmentRate = {
  __typename?: 'ShipmentRate'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  rate: IRate
  rateTypeKey: IRateTypeKeyTypes
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IShipmentRecentStats = {
  __typename?: 'ShipmentRecentStats'
  issuesCount: Scalars['Int']
  notesCount: Scalars['Int']
  smsMessagesCount: Scalars['Int']
}

export type IShipmentRoutingGuides = {
  __typename?: 'ShipmentRoutingGuides'
  contractLaneMatches?: Maybe<Array<IContractLaneMatch>>
  waterfallStatus?: Maybe<IWaterfallStatusTypes>
}

export type IShipmentShipperRateSource = {
  __typename?: 'ShipmentShipperRateSource'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  difference: Scalars['String']
  id: Scalars['ID']
  rate: IRate
  rateTypeKey: IRateTypeKeyTypes
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IShipmentStates {
  /** Alerted */
  alerted = 'alerted',
  /** Arrived for Delivery */
  arrived_for_delivery = 'arrived_for_delivery',
  /** Arrived for Pick Up */
  arrived_for_pickup = 'arrived_for_pickup',
  /** Assigned */
  assigned = 'assigned',
  /** Canceled */
  canceled = 'canceled',
  /** Completed */
  completed = 'completed',
  /** Covered */
  covered = 'covered',
  /** Delivered */
  delivered = 'delivered',
  /** Dispatched */
  dispatched = 'dispatched',
  /** Documents Received */
  documents_received = 'documents_received',
  /** E-Submitted */
  e_submitted = 'e_submitted',
  /** In Transit */
  in_transit = 'in_transit',
  /** Invoice Sent */
  invoice_sent = 'invoice_sent',
  /** Offered */
  offered = 'offered',
  /** On Hold */
  on_hold = 'on_hold',
  /** POD Rejected */
  pod_rejected = 'pod_rejected',
  /** Quoted */
  quoted = 'quoted',
  /** Submitted */
  submitted = 'submitted',
  /** Tendered */
  tendered = 'tendered',
  /** TONU */
  truck_ordered_not_used = 'truck_ordered_not_used',
  /** Waterfall Offered */
  waterfall_offered = 'waterfall_offered',
}

export type IShipmentStatus = {
  __typename?: 'ShipmentStatus'
  /** Detailed state of shipment (includes custom transit statuses) */
  detailedState: Scalars['String']
  pickupStatus: Scalars['String']
}

export type IShipmentStop = {
  __typename?: 'ShipmentStop'
  activeCeTasks: Array<ITask>
  address?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  /** The current active appointment on this stop */
  appointment: IShipmentStopAppointment
  /** Set of all appointment records that have ever been associated with this stop */
  appointmentsWithDeprecated: IShipmentStopAppointmentConnection
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']>
  arrivedAtRelayedBy?: Maybe<IUser>
  arrivedAtRelayedVia?: Maybe<Scalars['String']>
  arrivedAtUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  arrivedAtUpdatedBy?: Maybe<IUser>
  autoAppointmentSchedule?: Maybe<IAutoAppointmentSchedule>
  billOfLadingReference?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  commodity: Scalars['String']
  companyName?: Maybe<Scalars['String']>
  dropTrailer: Scalars['Boolean']
  ediAppointmentReasonCode?: Maybe<Scalars['String']>
  ediStatusReasonCode?: Maybe<Scalars['String']>
  facility: IFacility
  facilityIdentifier?: Maybe<IFacilityIdentifier>
  genericCommodity?: Maybe<ICommodity>
  geoArrivedAt?: Maybe<Scalars['ISO8601DateTime']>
  geoLeftAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  isoCountryCode?: Maybe<Scalars['String']>
  lateReason?: Maybe<Scalars['String']>
  latitude?: Maybe<Scalars['Float']>
  leftAt?: Maybe<Scalars['ISO8601DateTime']>
  leftAtRelayedBy?: Maybe<IUser>
  leftAtRelayedVia?: Maybe<Scalars['String']>
  leftAtUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  leftAtUpdatedBy?: Maybe<IUser>
  longitude?: Maybe<Scalars['Float']>
  manualEta?: Maybe<Scalars['ISO8601DateTime']>
  manualEtaRelayedBy?: Maybe<IUser>
  manualEtaRelayedVia?: Maybe<Scalars['String']>
  manualEtaUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  manualEtaUpdatedBy?: Maybe<IUser>
  mapboxEta?: Maybe<Scalars['ISO8601DateTime']>
  mergedFacility: IMergedFacility
  miles?: Maybe<Scalars['Float']>
  note?: Maybe<Scalars['String']>
  palletCount?: Maybe<Scalars['Int']>
  poReference?: Maybe<Scalars['String']>
  project44Eta?: Maybe<Scalars['ISO8601DateTime']>
  quickRequestEligible: Scalars['Boolean']
  rescheduleRequest?: Maybe<IRescheduleRequest>
  shipment: IShipment
  shipperFacility: IShipperFacility
  smartAppointmentEligible: Scalars['Boolean']
  specialInstruction?: Maybe<Scalars['String']>
  stateCode: Scalars['String']
  stopSequence: Scalars['Int']
  stopType: IShipmentStopTypes
  trailerArrivedAt?: Maybe<Scalars['ISO8601DateTime']>
  trailerEmptiedAt?: Maybe<Scalars['ISO8601DateTime']>
  vendorShipperFacility?: Maybe<IVendorShipperFacility>
  weight?: Maybe<Scalars['Int']>
  zipcode?: Maybe<Scalars['String']>
}

export type IShipmentStopAppointmentsWithDeprecatedArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type IShipmentStopAppointment = {
  __typename?: 'ShipmentStopAppointment'
  appointmentReference?: Maybe<Scalars['String']>
  appointmentType: IShipmentStopAppointmentTypes
  confirmationReference?: Maybe<Scalars['String']>
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']>
  confirmedBy?: Maybe<IUser>
  /** @deprecated Use start_at */
  date?: Maybe<Scalars['String']>
  ediAppointmentReasonCode?: Maybe<Scalars['String']>
  endAt?: Maybe<Scalars['ISO8601DateTime']>
  endAtHasTime: Scalars['Boolean']
  id: Scalars['ID']
  isWorkIn: Scalars['Boolean']
  recommendedStartAt?: Maybe<Scalars['ISO8601DateTime']>
  rescheduleReason?: Maybe<IReadOnlyRescheduleReasons>
  startAt?: Maybe<Scalars['ISO8601DateTime']>
  startAtHasTime: Scalars['Boolean']
  status?: Maybe<IShipmentStopAppointmentStatuses>
  stop: IShipmentStop
  /** @deprecated Use start_at if start_at_has_time? is true */
  time?: Maybe<Scalars['String']>
  timeUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  timeUpdatedBy?: Maybe<IUser>
  timezone: Scalars['String']
  /** @deprecated Use the iso time above. It includes timezone */
  timezoneShort: Scalars['String']
}

/** The connection type for ShipmentStopAppointment. */
export type IShipmentStopAppointmentConnection = {
  __typename?: 'ShipmentStopAppointmentConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IShipmentStopAppointmentEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IShipmentStopAppointment>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IShipmentStopAppointmentEdge = {
  __typename?: 'ShipmentStopAppointmentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IShipmentStopAppointment>
}

export enum IShipmentStopAppointmentStatuses {
  /** Confirmed */
  confirmed = 'confirmed',
  /** Predicted */
  predicted = 'predicted',
  /** Unconfirmed */
  unconfirmed = 'unconfirmed',
}

export enum IShipmentStopAppointmentTypes {
  /** Appointment */
  appointment = 'appointment',
  /** Range */
  range = 'range',
}

export type IShipmentStopArrivalDepartureInput = {
  /** Arrival date for the stop in its local timezone. */
  arrivedAtDate?: Maybe<Scalars['ISO8601Date']>
  /** Arrival time for the stop in its local timezone. */
  arrivedAtTime?: Maybe<Scalars['ISO8601Time']>
  /** Departure date for the stop in its local timezone. */
  leftAtDate?: Maybe<Scalars['ISO8601Date']>
  /** Departure time for the stop in its local timezone. */
  leftAtTime?: Maybe<Scalars['ISO8601Time']>
  shipmentStopId?: Maybe<Scalars['ID']>
  /** Trailer arrival date for the stop in its local timezone. */
  trailerArrivedAtDate?: Maybe<Scalars['ISO8601Date']>
  /** Trailer arrival time for the stop in its local timezone. */
  trailerArrivedAtTime?: Maybe<Scalars['ISO8601Time']>
  /** Trailer empty date for the stop in its local timezone. */
  trailerEmptiedAtDate?: Maybe<Scalars['ISO8601Date']>
  /** Trailer empty time for the stop in its local timezone. */
  trailerEmptiedAtTime?: Maybe<Scalars['ISO8601Time']>
}

export enum IShipmentStopRegionTypes {
  /** Coastal */
  C = 'C',
  /** Midwest */
  MW = 'MW',
  /** Midwestcentral */
  MWC = 'MWC',
  /** Midwesteast */
  MWE = 'MWE',
  /** Northeast */
  N = 'N',
  /** South */
  S = 'S',
  /** Southeast */
  SE = 'SE',
  /** West */
  W = 'W',
}

export enum IShipmentStopRelayedByTypes {
  dispatcher = 'dispatcher',
  driver = 'driver',
}

export enum IShipmentStopRelayedViaTypes {
  /** Email */
  email = 'email',
  /** Inbound call */
  inbound_call = 'inbound_call',
  /** Outbound call */
  outbound_call = 'outbound_call',
  /** Sms */
  sms = 'sms',
}

export type IShipmentStopSequenceInput = {
  sequenceNumber: Scalars['Int']
  shipmentStopId: Scalars['ID']
}

export enum IShipmentStopTypes {
  /** Delivery */
  delivery = 'delivery',
  /** Pickup */
  pickup = 'pickup',
}

export type IShipmentStopsListInput = {
  appointmentInput?: Maybe<IUpdateShipmentStopAppointmentInput>
  billOfLadingReference?: Maybe<Scalars['String']>
  commodity?: Maybe<Scalars['String']>
  dropTrailer?: Maybe<Scalars['Boolean']>
  ediAppointmentReasonCode?: Maybe<Scalars['String']>
  ediStatusReasonCode?: Maybe<Scalars['String']>
  facilityContactUuid?: Maybe<Scalars['ID']>
  genericCommodityId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  palletCount?: Maybe<Scalars['Int']>
  poReference?: Maybe<Scalars['String']>
  shipperFacilityUuid?: Maybe<Scalars['ID']>
  specialInstruction?: Maybe<Scalars['String']>
  vendorId?: Maybe<Scalars['ID']>
  weight?: Maybe<Scalars['Int']>
}

export type IShipmentTaskCap = {
  __typename?: 'ShipmentTaskCap'
  cap: Scalars['Int']
  taskNamespace: ITaskNamespaces
}

export type IShipperApplication = {
  __typename?: 'ShipperApplication'
  accessorialContactEmail?: Maybe<Scalars['String']>
  accessorialPolicies: Array<IShipperApplicationAccessorialPolicy>
  accountManager?: Maybe<IUser>
  accountingEmail?: Maybe<Scalars['String']>
  appointmentConfirmationRules: Array<IAppointmentConfirmationRule>
  appointmentPreference?: Maybe<IShipperAppointmentPreference>
  brokerPod?: Maybe<IBrokerPod>
  carrierInstructions?: Maybe<Scalars['String']>
  carrierManager?: Maybe<IUser>
  cohortQuarter?: Maybe<Scalars['Int']>
  cohortYear?: Maybe<Scalars['Int']>
  contacts: Array<IShipperApplicationContact>
  createdBy?: Maybe<IUser>
  ediReasonCodes: Array<IEdiReasonCode>
  financeRep?: Maybe<IUser>
  groups: Array<IGroup>
  hasCustomAccessorialRates: Scalars['Boolean']
  headquarter?: Maybe<ILocation>
  id: Scalars['ID']
  inboundEdiMapperConnectionConfigs?: Maybe<Array<IInboundConnectionConfig>>
  isFsmaApproved: Scalars['Boolean']
  name: Scalars['String']
  onboardingEdiConfig?: Maybe<IShipperOnboardingEdiConfig>
  opsCustomerEmail?: Maybe<Scalars['String']>
  outboundEdiMapperConnectionConfigs?: Maybe<Array<IOutboundConnectionConfig>>
  podId?: Maybe<Scalars['ID']>
  podRequiredToInvoice: Scalars['Boolean']
  requireBtf?: Maybe<Scalars['Boolean']>
  schedulingInstructions?: Maybe<Scalars['String']>
  secondaryAccountingEmail?: Maybe<Scalars['String']>
  segment?: Maybe<Scalars['String']>
  shipmentEmail: Scalars['String']
  shipperBtfCalculationDetails?: Maybe<IShipperBtfCalculationDetails>
  shipperRelationships: Array<IShipperRelationship>
  shipperTrackingSegment?: Maybe<IShipperTrackingSegment>
  spfIntegrations?: Maybe<Array<ISpfIntegration>>
  state: IShipperApplicationStates
  trackingFees?: Maybe<Scalars['Float']>
  trackingNotes?: Maybe<Scalars['String']>
}

export enum IShipperApplicationAccessorialBillingMethods {
  /** Edi */
  edi = 'edi',
  /** Mail */
  mail = 'mail',
  /** Pdf */
  pdf = 'pdf',
  /** Tms */
  tms = 'tms',
}

export type IShipperApplicationAccessorialPolicy = {
  __typename?: 'ShipperApplicationAccessorialPolicy'
  approvalEmail?: Maybe<Scalars['String']>
  approvalMinutesLimit?: Maybe<Scalars['Int']>
  authNumberRequired: Scalars['Boolean']
  billingMethod?: Maybe<IShipperApplicationAccessorialBillingMethods>
  createdAt: Scalars['ISO8601DateTime']
  customerApprovalRequired: Scalars['Boolean']
  customerNotificationRequired: Scalars['Boolean']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  equipment?: Maybe<IEquipment>
  id: Scalars['ID']
  inOutTimesRequired: Scalars['Boolean']
  isStandardRate: Scalars['Boolean']
  maxAmount?: Maybe<Scalars['Float']>
  minAmount?: Maybe<Scalars['Float']>
  minutesThreshold?: Maybe<Scalars['Int']>
  notes?: Maybe<Scalars['String']>
  notificationEmail?: Maybe<Scalars['String']>
  podRequired: Scalars['Boolean']
  rate?: Maybe<Scalars['Float']>
  rateInterval?: Maybe<Scalars['String']>
  rateType: IShipperApplicationAccessorialRateTypes
  receiptRequired: Scalars['Boolean']
  shipmentAccessorialName: IShipmentAccessorialNames
  shipperApplication: IShipperApplication
  taxIdRequired: Scalars['Boolean']
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IShipperApplicationAccessorialRateTypes {
  /** Daily */
  daily = 'daily',
  /** Flat rate */
  flat_rate = 'flat_rate',
  /** Hourly */
  hourly = 'hourly',
}

/** The connection type for ShipperApplication. */
export type IShipperApplicationConnection = {
  __typename?: 'ShipperApplicationConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IShipperApplicationEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IShipperApplication>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

export type IShipperApplicationContact = {
  __typename?: 'ShipperApplicationContact'
  email?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  phoneExtension?: Maybe<Scalars['String']>
  role: IShipperApplicationContactRoles
  secondaryEmail?: Maybe<Scalars['String']>
}

export enum IShipperApplicationContactRoles {
  /** Edi */
  EDI = 'EDI',
  /** Edi invoicing */
  EDI_invoicing = 'EDI_invoicing',
  /** Accessorials */
  accessorials = 'accessorials',
  /** Accounting */
  accounting = 'accounting',
  /** After hours */
  after_hours = 'after_hours',
  /** Escalations */
  escalations = 'escalations',
  /** General */
  general = 'general',
  /** Other */
  other = 'other',
  /** Scheduling */
  scheduling = 'scheduling',
}

/** An edge in a connection. */
export type IShipperApplicationEdge = {
  __typename?: 'ShipperApplicationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IShipperApplication>
}

/** Config describing shipper's EDI settings/configurations. */
export type IShipperApplicationEdiConfig = {
  __typename?: 'ShipperApplicationEdiConfig'
  /** Whether or not EDI is enabled for this shipper */
  ediEnabled: Scalars['Boolean']
  /** Whether or not EDI invoicing is enabled for this shipper */
  ediInvoicing: Scalars['Boolean']
  id: Scalars['ID']
  /** Whether or not to send appointment messages only when confirmed */
  sendsAppointmentMessagesOnlyWhenConfirmed: Scalars['Boolean']
  /** Whether or not to send appointment times on shipment creation */
  sendsAppointmentTimesOnShipmentCreation: Scalars['Boolean']
  /** ShipperApplication ID */
  shipperApplicationId: Scalars['ID']
  /** when in the shipment lifecycle will we accept rate updates from a shipper or not */
  shipperRateUpdatesAllowed: IShipperRateUpdatesAllowed
  /** Timezone scheme to use when sending status messages */
  statusTimezoneScheme: IStatusTimezoneScheme
}

export enum IShipperApplicationStates {
  /** Canceled */
  canceled = 'canceled',
  /** Active */
  confirmed = 'confirmed',
  /** Limited */
  limited = 'limited',
  /** Pending */
  pending = 'pending',
  /** Rejected */
  rejected = 'rejected',
  /** Suspended */
  suspended = 'suspended',
}

export type IShipperAppointmentPreference = ICreatedByUser & {
  __typename?: 'ShipperAppointmentPreference'
  allowAutotender: Scalars['Boolean']
  beginBeforeAfter?: Maybe<IShipperBeginBeforeAfter>
  beginDate?: Maybe<IShipperBeginDateOptions>
  beginDays?: Maybe<Scalars['Int']>
  beginEnabled: Scalars['Boolean']
  bufferStopType?: Maybe<IShipperBufferStopTypes>
  bufferTimeMin?: Maybe<Scalars['Int']>
  buffersEnabled: Scalars['Boolean']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  deliveryAutoScheduleEnabled: Scalars['Boolean']
  id?: Maybe<Scalars['ID']>
  orderEnabled: Scalars['Boolean']
  orderStopType?: Maybe<IShipmentStopTypes>
  pickupAutoScheduleEnabled: Scalars['Boolean']
  schedulingInstructions?: Maybe<Scalars['String']>
  shipperApplicationId: Scalars['ID']
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>
}

export enum IShipperAppointmentTypes {
  /** Delivery */
  delivery = 'delivery',
  /** Fcfs window */
  fcfs_window = 'fcfs_window',
  /** Pickup */
  pickup = 'pickup',
}

/** Autogenerated input type of ShipperApproveShipmentAccessorial */
export type IShipperApproveShipmentAccessorialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentAccessorialId: Scalars['ID']
}

/** Autogenerated return type of ShipperApproveShipmentAccessorial */
export type IShipperApproveShipmentAccessorialPayload = {
  __typename?: 'ShipperApproveShipmentAccessorialPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

export type IShipperAutoAcceptRejectConfiguration = {
  __typename?: 'ShipperAutoAcceptRejectConfiguration'
  acceptState: Scalars['String']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  createdById?: Maybe<Scalars['ID']>
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  enqueueTimeInMinutes: Scalars['Int']
  id: Scalars['ID']
  rejectState: Scalars['String']
  respondToTender: Scalars['Boolean']
  shipmentType: Scalars['String']
  shipperApplicationId: Scalars['ID']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IShipperAutoAcceptRejectConfigurationInput = {
  acceptState: Scalars['String']
  createdById: Scalars['ID']
  enqueueTimeInMinutes: Scalars['Int']
  rejectState: Scalars['String']
  respondToTender: Scalars['Boolean']
  shipmentType: Scalars['String']
  shipperApplicationId: Scalars['ID']
}

export type IShipperAutoAcceptRejectResult = {
  __typename?: 'ShipperAutoAcceptRejectResult'
  configurationId?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  decision?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  isFinal?: Maybe<Scalars['Boolean']>
  referencedData?: Maybe<Scalars['JSON']>
  rulesApplied?: Maybe<Scalars['JSON']>
  shipmentId: Scalars['ID']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IShipperAutoAcceptRejectRule = {
  __typename?: 'ShipperAutoAcceptRejectRule'
  chainRuleOnFalse?: Maybe<Scalars['ID']>
  chainRuleOnTrue?: Maybe<Scalars['ID']>
  configurationId?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  createdById?: Maybe<Scalars['ID']>
  decisionOnFalse?: Maybe<Scalars['String']>
  decisionOnTrue?: Maybe<Scalars['String']>
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  isStart?: Maybe<Scalars['Boolean']>
  parameters?: Maybe<Scalars['JSON']>
  previousConfigurationId?: Maybe<Scalars['String']>
  rule: IAutoAcceptRejectRule
  shipmentType: Scalars['String']
  shipperApplicationId: Scalars['ID']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IShipperAwardEstimationConfiguration = {
  __typename?: 'ShipperAwardEstimationConfiguration'
  annualLtl?: Maybe<Scalars['Float']>
  annualRevenue?: Maybe<Scalars['Float']>
  contractMarginPercentage?: Maybe<Scalars['Float']>
  contractMarginUsd?: Maybe<Scalars['Float']>
  contractNumberOfLoads?: Maybe<Scalars['Int']>
  contractSpend?: Maybe<Scalars['Float']>
  createdAt: Scalars['ISO8601DateTime']
  customerAnnualFtl?: Maybe<Scalars['Float']>
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  directions?: Maybe<Array<ICarrierBidDirectionTypes>>
  endDate?: Maybe<Scalars['ISO8601Date']>
  id: Scalars['ID']
  shipperApplicationId: Scalars['ID']
  spotMarginPercentage?: Maybe<Scalars['Float']>
  spotMarginUsd?: Maybe<Scalars['Float']>
  spotNumberOfLoads?: Maybe<Scalars['Int']>
  spotSpend?: Maybe<Scalars['Float']>
  startDate?: Maybe<Scalars['ISO8601Date']>
  thirdPartyLogisticsSpend?: Maybe<Scalars['Float']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type IShipperAwardEstimationConfigurationInput = {
  annualLtl?: Maybe<Scalars['Float']>
  annualRevenue?: Maybe<Scalars['Float']>
  contractMarginPercentage?: Maybe<Scalars['Float']>
  contractMarginUsd?: Maybe<Scalars['Float']>
  contractNumberOfLoads?: Maybe<Scalars['Int']>
  contractSpend?: Maybe<Scalars['Float']>
  customerAnnualFtl?: Maybe<Scalars['Float']>
  directions?: Maybe<Array<ICarrierBidDirectionTypes>>
  endDate?: Maybe<Scalars['ISO8601Date']>
  spotMarginPercentage?: Maybe<Scalars['Float']>
  spotMarginUsd?: Maybe<Scalars['Float']>
  spotNumberOfLoads?: Maybe<Scalars['Int']>
  spotSpend?: Maybe<Scalars['Float']>
  startDate?: Maybe<Scalars['ISO8601Date']>
  thirdPartyLogisticsSpend?: Maybe<Scalars['Float']>
}

export enum IShipperBeginBeforeAfter {
  /** After */
  after = 'after',
  /** Before */
  before = 'before',
}

export enum IShipperBeginDateOptions {
  /** Date we accepted the tender */
  date_we_accepted_the_tender = 'date_we_accepted_the_tender',
  /** Tendered delivery date */
  tendered_delivery_date = 'tendered_delivery_date',
  /** Tendered pickup date */
  tendered_pickup_date = 'tendered_pickup_date',
}

export type IShipperBtfCalculationDetails = {
  __typename?: 'ShipperBtfCalculationDetails'
  btfBaseRate: Scalars['Float']
  btfMpg: Scalars['Float']
  btfRequired: Scalars['Boolean']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  shipper: IShipperApplication
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy?: Maybe<IUser>
}

export enum IShipperBufferStopTypes {
  /** Delivery */
  delivery = 'delivery',
  /** Pickup */
  pickup = 'pickup',
  /** Pickup and delivery */
  pickup_and_delivery = 'pickup_and_delivery',
}

export type IShipperContactInput = {
  email?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  phoneExtension?: Maybe<Scalars['String']>
  role: IShipperApplicationContactRoles
  secondaryEmail?: Maybe<Scalars['String']>
}

export type IShipperDropTrailersConfiguration = {
  __typename?: 'ShipperDropTrailersConfiguration'
  canFlipDropsToLive?: Maybe<Scalars['Boolean']>
  canSplitLanesBetweenCarriers?: Maybe<Scalars['Boolean']>
  createdAt: Scalars['ISO8601DateTime']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  deliveryDropWindowNumber?: Maybe<Scalars['Int']>
  deliveryDropWindowUnit?: Maybe<ITimeUnitsEnum>
  id: Scalars['ID']
  minimumDropTimeframeNumber?: Maybe<Scalars['Int']>
  minimumDropTimeframeUnit?: Maybe<ITimeUnitsEnum>
  notes?: Maybe<Scalars['String']>
  shipperApplicationId: Scalars['ID']
  tenderingProcessLeadTimeNumber?: Maybe<Scalars['Int']>
  tenderingProcessLeadTimeUnit?: Maybe<ITimeUnitsEnum>
  trailerPoolRatio?: Maybe<Scalars['Int']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type IShipperDropTrailersConfigurationInput = {
  canFlipDropsToLive?: Maybe<Scalars['Boolean']>
  canSplitLanesBetweenCarriers?: Maybe<Scalars['Boolean']>
  deliveryDropWindowNumber?: Maybe<Scalars['Int']>
  deliveryDropWindowUnit?: Maybe<ITimeUnitsEnum>
  minimumDropTimeframeNumber?: Maybe<Scalars['Int']>
  minimumDropTimeframeUnit?: Maybe<ITimeUnitsEnum>
  notes?: Maybe<Scalars['String']>
  tenderingProcessLeadTimeNumber?: Maybe<Scalars['Int']>
  tenderingProcessLeadTimeUnit?: Maybe<ITimeUnitsEnum>
  trailerPoolRatio?: Maybe<Scalars['Int']>
}

export type IShipperEquipmentAttributeInput = {
  id: Scalars['ID']
  value: Scalars['String']
}

export type IShipperFacility = {
  __typename?: 'ShipperFacility'
  contacts: Array<IFacilityContact>
  endShipperFacilityLanes: Array<IShipperFacilityLane>
  facility: IFacility
  /** @deprecated Shipper facilities now have multiple codes. Access through `identifiers` instead. */
  facilityCode?: Maybe<Scalars['String']>
  hours: Array<IFacilityScheduleHour>
  id: Scalars['ID']
  identifiers: Array<IFacilityIdentifier>
  latestShipmentDelivery?: Maybe<Scalars['ISO8601DateTime']>
  metadata?: Maybe<IFacilityMetadata>
  note?: Maybe<Scalars['String']>
  schedule?: Maybe<IFacilitySchedule>
  shipperApplication: IShipperApplication
  shipperApplicationId: Scalars['ID']
  startShipperFacilityLanes: Array<IShipperFacilityLane>
  totalShipmentsLastYear: Scalars['Int']
  totalTrailers: Scalars['Int']
  trailerPools?: Maybe<Array<IShipperFacilityTrailerPool>>
  uuid: Scalars['ID']
}

/** The connection type for ShipperFacility. */
export type IShipperFacilityConnection = {
  __typename?: 'ShipperFacilityConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IShipperFacilityEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IShipperFacility>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IShipperFacilityEdge = {
  __typename?: 'ShipperFacilityEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IShipperFacility>
}

export type IShipperFacilityHourValue = {
  __typename?: 'ShipperFacilityHourValue'
  open247: Scalars['Boolean']
  sameHoursMonFri: Scalars['Boolean']
  shifts?: Maybe<Array<IFacilityScheduleHour>>
  stopType?: Maybe<IShipmentStopTypes>
  unloadType?: Maybe<IFacilityScheduleRulesUnloadTypes>
}

export type IShipperFacilityHourValueInput = {
  open247?: Maybe<Scalars['Boolean']>
  sameHoursMonFri?: Maybe<Scalars['Boolean']>
  shifts: Array<IFacilityScheduleHourInput>
  stopType: IShipmentStopTypes
  unloadType: IFacilityScheduleRulesUnloadTypes
}

export type IShipperFacilityHours = {
  __typename?: 'ShipperFacilityHours'
  overridden: Scalars['Boolean']
  value: IShipperFacilityHourValue
}

export type IShipperFacilityInput = {
  identifiers?: Maybe<Array<IFacilityIdentifierInput>>
  metadata?: Maybe<IFacilityMetadataInput>
  uuid: Scalars['ID']
}

export type IShipperFacilityLane = {
  __typename?: 'ShipperFacilityLane'
  endNote?: Maybe<Scalars['String']>
  endShipperFacility: IShipperFacility
  hours?: Maybe<Array<IShipperFacilityHours>>
  id: Scalars['ID']
  startNote?: Maybe<Scalars['String']>
  startShipperFacility: IShipperFacility
}

export type IShipperFacilityTrailerPool = {
  __typename?: 'ShipperFacilityTrailerPool'
  carrier?: Maybe<ICarrierApplication>
  carrierApplicationId?: Maybe<Scalars['ID']>
  id: Scalars['Int']
  presentTrailers: Scalars['Int']
  trailerRequirement: Scalars['Int']
  trailers?: Maybe<Array<ITrailer>>
}

export type IShipperFuelMatrix = ICreatedByUser & {
  __typename?: 'ShipperFuelMatrix'
  createdAt: Scalars['ISO8601DateTime']
  /** The transfix child user that triggered the creation of this object */
  createdBy: IUser
  createdById: Scalars['Int']
  fuelMatrixData?: Maybe<Scalars['JSON']>
  id: Scalars['ID']
  shipperApplicationId: Scalars['ID']
  sourceFile?: Maybe<Scalars['String']>
  sourceFileName?: Maybe<Scalars['String']>
  useDateBasedRate: Scalars['Boolean']
}

export type IShipperFuelPaddMapping = {
  __typename?: 'ShipperFuelPaddMapping'
  createdAt: Scalars['ISO8601DateTime']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  paddRegion: Scalars['String']
  shipperApplicationId: Scalars['ID']
  stateCodes: Scalars['JSON']
  stopType: Scalars['String']
  updatedAt: Scalars['ISO8601DateTime']
  updatedById?: Maybe<Scalars['ID']>
}

export enum IShipperFuelRateAt {
  creation = 'creation',
  pickup = 'pickup',
}

export type IShipperFuelRateConfig = {
  __typename?: 'ShipperFuelRateConfig'
  automateCalculation: Scalars['Boolean']
  eiaRateWeekOffset?: Maybe<Scalars['Int']>
  equipmentTypes?: Maybe<Array<IEquipment>>
  fuelSource: IShipperFuelSource
  overrideAtCreation: Scalars['Boolean']
  rateAt?: Maybe<IShipperFuelRateAt>
  rateTypes?: Maybe<Array<IShipperRateTypes>>
  samePickupAndDeliveryZipcode: Scalars['Boolean']
  shipperApplication: IShipperApplication
}

export enum IShipperFuelSource {
  /** Btf */
  btf = 'btf',
  /** Fuel schedule */
  fuel_schedule = 'fuel_schedule',
}

export type IShipperInsuranceRequirement = {
  __typename?: 'ShipperInsuranceRequirement'
  automotiveRequirements: Array<Scalars['String']>
  cargoCoverageRequirements: Array<Scalars['String']>
  shipmentSpecificRequirements: Array<Scalars['String']>
}

export type IShipperKpiTrackingConfiguration = {
  __typename?: 'ShipperKpiTrackingConfiguration'
  createdAt: Scalars['ISO8601DateTime']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  parameters?: Maybe<Scalars['JSON']>
  shipperApplicationId: Scalars['ID']
  trackingType: Scalars['String']
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IShipperLinkTypes {
  /** Kpi */
  kpi = 'kpi',
  /** Sop */
  sop = 'sop',
}

export enum IShipperLoadTypes {
  /** Bulk loading */
  bulk_loading = 'bulk_loading',
  /** Floor load */
  floor_load = 'floor_load',
  /** Palletized */
  palletized = 'palletized',
}

export type IShipperOnboardingEdiConfig = {
  __typename?: 'ShipperOnboardingEdiConfig'
  onboardingEdiFileTypesSupported?: Maybe<Array<ITransactionSetTypes>>
  onboardingEdiFilesRequiredByDate?: Maybe<Scalars['ISO8601Date']>
  onboardingRequiresEdi?: Maybe<Scalars['Boolean']>
  onboardingRequiresLateReasonCodes?: Maybe<Scalars['Boolean']>
}

export type IShipperOnboardingEdiConfigInput = {
  onboardingEdiFileTypesSupported?: Maybe<Array<ITransactionSetTypes>>
  onboardingEdiFilesRequiredByDate?: Maybe<Scalars['ISO8601Date']>
  onboardingRequiresEdi?: Maybe<Scalars['Boolean']>
  onboardingRequiresLateReasonCodes?: Maybe<Scalars['Boolean']>
}

export type IShipperOnboardingKpiConfiguration = {
  __typename?: 'ShipperOnboardingKpiConfiguration'
  createdAt: Scalars['ISO8601DateTime']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  ediPerformancePercentage?: Maybe<Scalars['Float']>
  id: Scalars['ID']
  onTimeDeliveryMeasure?: Maybe<IOnTimeDeliveryMeasures>
  onTimeDeliveryMeasurementFrequencyNumber?: Maybe<Scalars['Int']>
  onTimeDeliveryMeasurementFrequencyUnit?: Maybe<ITimeUnitsEnum>
  onTimeDeliveryPercentage?: Maybe<Scalars['Float']>
  onTimePickUpMeasure?: Maybe<IOnTimePickUpMeasures>
  onTimePickUpMeasurementFrequencyNumber?: Maybe<Scalars['Int']>
  onTimePickUpMeasurementFrequencyUnit?: Maybe<ITimeUnitsEnum>
  onTimePickUpPercentage?: Maybe<Scalars['Float']>
  otherKpis?: Maybe<Scalars['String']>
  scorecard?: Maybe<Scalars['Boolean']>
  scorecardFrequencyNumber?: Maybe<Scalars['Int']>
  scorecardFrequencyUnit?: Maybe<ITimeUnitsEnum>
  shipperApplicationId: Scalars['ID']
  trackingConsistencyPercentage?: Maybe<Scalars['Float']>
  trackingPercentage?: Maybe<Scalars['Float']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type IShipperOnboardingKpiConfigurationInput = {
  ediPerformancePercentage?: Maybe<Scalars['Float']>
  onTimeDeliveryMeasure?: Maybe<IOnTimeDeliveryMeasures>
  onTimeDeliveryMeasurementFrequencyNumber?: Maybe<Scalars['Int']>
  onTimeDeliveryMeasurementFrequencyUnit?: Maybe<ITimeUnitsEnum>
  onTimeDeliveryPercentage?: Maybe<Scalars['Float']>
  onTimePickUpMeasure?: Maybe<IOnTimePickUpMeasures>
  onTimePickUpMeasurementFrequencyNumber?: Maybe<Scalars['Int']>
  onTimePickUpMeasurementFrequencyUnit?: Maybe<ITimeUnitsEnum>
  onTimePickUpPercentage?: Maybe<Scalars['Float']>
  otherKpis?: Maybe<Scalars['String']>
  scorecard?: Maybe<Scalars['Boolean']>
  scorecardFrequencyNumber?: Maybe<Scalars['Int']>
  scorecardFrequencyUnit?: Maybe<ITimeUnitsEnum>
  trackingConsistencyPercentage?: Maybe<Scalars['Float']>
  trackingPercentage?: Maybe<Scalars['Float']>
}

export type IShipperProofOfTonu = {
  __typename?: 'ShipperProofOfTonu'
  createdAt?: Maybe<Scalars['ISO8601DateTime']>
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  document?: Maybe<IDownloadable>
  id: Scalars['ID']
  type: Scalars['String']
}

export type IShipperRate = {
  __typename?: 'ShipperRate'
  /** Describes whether this is a primary or backup rate. */
  awardType: IShipperRateAwardTypeEnum
  carrierMarketRate?: Maybe<Scalars['Float']>
  carrierSalesRep?: Maybe<IUser>
  createdAt: Scalars['ISO8601DateTime']
  createdBy: IUser
  datMiles?: Maybe<Scalars['Float']>
  deliveryCity?: Maybe<Scalars['String']>
  deliveryIsoCountryCode?: Maybe<ICountries>
  deliveryLocation?: Maybe<ILocation>
  deliveryPostalCode?: Maybe<Scalars['String']>
  deliveryRegion?: Maybe<IShipmentStopRegionTypes>
  deliveryStateCode?: Maybe<IFederatedStateCodes>
  /** The rate for this lane is no longer in effect after this day. */
  endDate?: Maybe<Scalars['ISO8601DateTime']>
  equipment?: Maybe<IEquipment>
  geocodedMiles?: Maybe<Scalars['Float']>
  geocoderSource?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isDeliveryDropTrailer?: Maybe<Scalars['Boolean']>
  isPickupDropTrailer?: Maybe<Scalars['Boolean']>
  listingDetails?: Maybe<IShipperRateListingDetails>
  notes: Array<INote>
  pickupCity?: Maybe<Scalars['String']>
  pickupIsoCountryCode?: Maybe<ICountries>
  pickupLocation?: Maybe<ILocation>
  pickupPostalCode?: Maybe<Scalars['String']>
  pickupRegion?: Maybe<IShipmentStopRegionTypes>
  pickupStateCode?: Maybe<IFederatedStateCodes>
  rate?: Maybe<IRate>
  requestForProposalLaneFeedback?: Maybe<IRequestForProposalLaneFeedback>
  shipperApplication: IShipperApplication
  /** The shipper-provided reference for this lane. */
  shipperLaneId?: Maybe<Scalars['String']>
  shipperMiles?: Maybe<Scalars['Float']>
  shipperRateShipperFacilities: Array<IShipperRateShipperFacility>
  /**
   * Tracks whether a shipper rate is a candidate for sourcing. This value is based
   * on business logic (award type, drop type, volume), and is orthogonal to if the
   * lane is already sourced or not.
   */
  shouldSource?: Maybe<Scalars['Boolean']>
  /** Carrier sales' concept of the status of a lane: if it needs sourcing or not. */
  sourceStatus: IShipperRateSourceStatusEnum
  sourcedCarrierRates: Array<ISourcedCarrierRate>
  sourcedCarrierRatesCount: Scalars['Int']
  /** The rate for this lane is valid from this day. */
  startDate: Scalars['ISO8601DateTime']
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy: IUser
  volume?: Maybe<Scalars['Int']>
  /** Cadence of the volume commitment. */
  volumeType?: Maybe<IShipperRateVolumeTypeEnum>
  /** Standardized weekly volume conversion. */
  weeklyVolume?: Maybe<Scalars['Float']>
}

export type IShipperRateNotesArgs = {
  noteType?: Maybe<INoteTypes>
}

export enum IShipperRateAwardTypeEnum {
  /** Backup */
  backup = 'backup',
  /** Primary */
  primary = 'primary',
  /** Published */
  published = 'published',
}

/** The connection type for ShipperRate. */
export type IShipperRateConnection = {
  __typename?: 'ShipperRateConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IShipperRateEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IShipperRate>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IShipperRateEdge = {
  __typename?: 'ShipperRateEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IShipperRate>
}

export type IShipperRateListingDetails = {
  __typename?: 'ShipperRateListingDetails'
  commodity?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  maxWeight?: Maybe<Scalars['Int']>
  minWeight?: Maybe<Scalars['Int']>
  /** Contextual information displayed to external users. */
  note?: Maybe<Scalars['String']>
  /** The offer lead time as a number of days. */
  offerLeadTime?: Maybe<Scalars['Int']>
  shipperRate: IShipperRate
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IShipperRateListingDetailsInput = {
  commodity?: Maybe<Scalars['String']>
  maxWeight?: Maybe<Scalars['Int']>
  minWeight?: Maybe<Scalars['Int']>
  note?: Maybe<Scalars['String']>
  offerLeadTime?: Maybe<Scalars['Int']>
}

export type IShipperRateShipperFacility = {
  __typename?: 'ShipperRateShipperFacility'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  shipperFacility: IShipperFacility
  shipperRate: IShipperRate
  stopType: IShipmentStopTypes
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IShipperRateShipperFacilityInput = {
  shipperFacilityUuid: Scalars['String']
  stopType: IShipmentStopTypes
}

export enum IShipperRateSourceStatusEnum {
  /** Cancelled */
  cancelled = 'cancelled',
  /** Deving */
  deving = 'deving',
  /** Done */
  done = 'done',
  /** Pending volume */
  pending_volume = 'pending_volume',
  /** Redev */
  redev = 'redev',
}

export enum IShipperRateTypes {
  /** Contract Backup */
  contract_backup = 'contract_backup',
  /** Contract Primary */
  contract_primary = 'contract_primary',
  /** Spot */
  spot = 'spot',
}

export enum IShipperRateUpdatesAllowed {
  after_delivery = 'after_delivery',
  never = 'never',
  until_delivery = 'until_delivery',
}

export enum IShipperRateVolumeTypeEnum {
  /** Annual */
  annual = 'annual',
  /** Gross */
  gross = 'gross',
  /** Monthly */
  monthly = 'monthly',
  /** Quarterly */
  quarterly = 'quarterly',
  /** Weekly */
  weekly = 'weekly',
}

export enum IShipperRatesSortByEnum {
  /** End date of rate validity. */
  end_date = 'end_date',
  /** AKA weekly volume. */
  normalized_volume = 'normalized_volume',
  /** Start date of rate validity. */
  start_date = 'start_date',
}

/** Autogenerated input type of ShipperRejectShipmentAccessorial */
export type IShipperRejectShipmentAccessorialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentAccessorialId: Scalars['ID']
  shipperRejectionReason: Scalars['String']
}

/** Autogenerated return type of ShipperRejectShipmentAccessorial */
export type IShipperRejectShipmentAccessorialPayload = {
  __typename?: 'ShipperRejectShipmentAccessorialPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

export type IShipperRelationship = {
  __typename?: 'ShipperRelationship'
  createdAt: Scalars['ISO8601DateTime']
  createdBy: IUser
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  deletedBy?: Maybe<IUser>
  id: Scalars['ID']
  relationshipLevel: IApplicationRelationshipLevels
  relationshipType: IShipperRelationshipTypes
  shipperApplication: IShipperApplication
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy: IUser
  user: IUser
}

export type IShipperRelationshipInput = {
  /** Destroy this relationship if it exists. */
  destroy?: Maybe<Scalars['Boolean']>
  relationshipLevel: IApplicationRelationshipLevels
  relationshipType: IShipperRelationshipTypes
  userId: Scalars['ID']
}

export enum IShipperRelationshipTypes {
  /** Account manager */
  account_manager = 'account_manager',
  /** Account ops */
  account_ops = 'account_ops',
  /** Carrier experience rep */
  carrier_experience_rep_id = 'carrier_experience_rep_id',
  /** Carrier ops */
  carrier_ops = 'carrier_ops',
  /** Contact referer */
  contact_referer = 'contact_referer',
  /** Exec sponsor */
  exec_sponsor = 'exec_sponsor',
  /** Finance rep */
  finance_rep = 'finance_rep',
  /** Sales dev rep */
  sales_dev_rep = 'sales_dev_rep',
  /** Sales rep */
  sales_rep = 'sales_rep',
}

export type IShipperTenderAppointmentConfiguration = {
  __typename?: 'ShipperTenderAppointmentConfiguration'
  appointmentGracePeriodNumber?: Maybe<Scalars['Int']>
  appointmentGracePeriodUnit?: Maybe<ITimeUnitsEnum>
  appointmentType?: Maybe<Array<IShipperAppointmentTypes>>
  carrierInstructions?: Maybe<Scalars['String']>
  contractLeadTimeNumber?: Maybe<Scalars['Int']>
  contractLeadTimeUnit?: Maybe<ITimeUnitsEnum>
  createdAt: Scalars['ISO8601DateTime']
  daysOfTender?: Maybe<Array<IWeekDaysEnum>>
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  driverRequirements?: Maybe<Scalars['String']>
  equipmentAttributes?: Maybe<Array<IShipmentEquipmentAttribute>>
  equipments?: Maybe<Array<IEquipment>>
  id: Scalars['ID']
  isPenaltyCharge?: Maybe<Scalars['Boolean']>
  liveDrop?: Maybe<Array<IFacilityScheduleRulesUnloadTypes>>
  loadType?: Maybe<Array<IShipperLoadTypes>>
  penaltyCharge?: Maybe<Scalars['Float']>
  sealRequirements?: Maybe<Scalars['String']>
  shipperApplicationId: Scalars['ID']
  spotLeadTimeNumber?: Maybe<Scalars['Int']>
  spotLeadTimeUnit?: Maybe<ITimeUnitsEnum>
  typicalWeight?: Maybe<Scalars['Int']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type IShipperTenderAppointmentConfigurationInput = {
  appointmentGracePeriodNumber?: Maybe<Scalars['Int']>
  appointmentGracePeriodUnit?: Maybe<ITimeUnitsEnum>
  appointmentType?: Maybe<Array<IShipperAppointmentTypes>>
  carrierInstructions?: Maybe<Scalars['String']>
  contractLeadTimeNumber?: Maybe<Scalars['Int']>
  contractLeadTimeUnit?: Maybe<ITimeUnitsEnum>
  daysOfTender?: Maybe<Array<IWeekDaysEnum>>
  driverRequirements?: Maybe<Scalars['String']>
  equipmentAttributes?: Maybe<Array<IShipperEquipmentAttributeInput>>
  equipmentIds?: Maybe<Array<Scalars['ID']>>
  isPenaltyCharge?: Maybe<Scalars['Boolean']>
  liveDrop?: Maybe<Array<IFacilityScheduleRulesUnloadTypes>>
  loadType?: Maybe<Array<IShipperLoadTypes>>
  penaltyCharge?: Maybe<Scalars['Float']>
  sealRequirements?: Maybe<Scalars['String']>
  spotLeadTimeNumber?: Maybe<Scalars['Int']>
  spotLeadTimeUnit?: Maybe<ITimeUnitsEnum>
  typicalWeight?: Maybe<Scalars['Int']>
}

export type IShipperTrackingSegment = {
  __typename?: 'ShipperTrackingSegment'
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  level: Scalars['Int']
}

export type IShipperTrueRateConfiguration = {
  __typename?: 'ShipperTrueRateConfiguration'
  beatTargetSharePercent: Scalars['Float']
  configEndTime?: Maybe<Scalars['String']>
  configStartTime?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  endDate?: Maybe<Scalars['ISO8601Date']>
  fuelSource: Scalars['String']
  hasFuelSchedule?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  maxMarginPercent?: Maybe<Scalars['Float']>
  minMarginAmount?: Maybe<Scalars['Float']>
  minMarginPercent?: Maybe<Scalars['Float']>
  missTargetSharePercent: Scalars['Float']
  rateTypeKey: Scalars['String']
  shipperApplicationId: Scalars['ID']
  startDate?: Maybe<Scalars['ISO8601Date']>
  targetMarginPercent: Scalars['Float']
  updatedAt: Scalars['ISO8601DateTime']
  volumeCommitment: IVolumeCommitmentTypes
}

export type IShouldTrackNow = {
  __typename?: 'ShouldTrackNow'
  trackNow: Scalars['Boolean']
}

/** Autogenerated input type of SignRateConfirmation */
export type ISignRateConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of SignRateConfirmation */
export type ISignRateConfirmationPayload = {
  __typename?: 'SignRateConfirmationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of SkipShipmentWaterfallCarrier */
export type ISkipShipmentWaterfallCarrierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contractLaneMatchId: Scalars['ID']
  skipReason: IContractLaneMatchUserSkipReasons
}

/** Autogenerated return type of SkipShipmentWaterfallCarrier */
export type ISkipShipmentWaterfallCarrierPayload = {
  __typename?: 'SkipShipmentWaterfallCarrierPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contractLaneMatch?: Maybe<IContractLaneMatch>
  errors: Array<IError>
}

export type ISmsMessage = {
  __typename?: 'SmsMessage'
  conversation?: Maybe<IConversation>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  fromPhone?: Maybe<Scalars['String']>
  fromUser?: Maybe<IUser>
  id: Scalars['ID']
  intent?: Maybe<ISmsMessageIntents>
  languageDetected?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  resolvedAt?: Maybe<Scalars['ISO8601DateTime']>
  resolvedBy?: Maybe<IUser>
  sendError?: Maybe<Scalars['String']>
  sendErrorReason?: Maybe<Scalars['String']>
  source?: Maybe<Scalars['String']>
  toPhone?: Maybe<Scalars['String']>
  toUser?: Maybe<IUser>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum ISmsMessageIntents {
  /** App download instruction */
  app_download_instruction = 'app_download_instruction',
  /** Complete app setup */
  complete_app_setup = 'complete_app_setup',
  /** Confirm mt eta */
  confirm_mt_eta = 'confirm_mt_eta',
  /** Delivery confirm in */
  delivery_confirm_in = 'delivery_confirm_in',
  /** Delivery confirm out */
  delivery_confirm_out = 'delivery_confirm_out',
  /** Driver feedback survey */
  driver_feedback_survey = 'driver_feedback_survey',
  /** Facility checkin reminder */
  facility_checkin_reminder = 'facility_checkin_reminder',
  /** Internal bid notification */
  internal_bid_notification = 'internal_bid_notification',
  /** Must track warning */
  must_track_warning = 'must_track_warning',
  /** Nudge for location ping */
  nudge_for_location_ping = 'nudge_for_location_ping',
  /** Pickup confirm in */
  pickup_confirm_in = 'pickup_confirm_in',
  /** Pickup confirm out */
  pickup_confirm_out = 'pickup_confirm_out',
  /** Pod request */
  pod_request = 'pod_request',
  /** Prebook request app download */
  prebook_request_app_download = 'prebook_request_app_download',
  /** Request app download */
  request_app_download = 'request_app_download',
  /** Resume tracking reminder */
  resume_tracking_reminder = 'resume_tracking_reminder',
}

/** Autogenerated input type of SnoozeShipmentActiveTasks */
export type ISnoozeShipmentActiveTasksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** Optional text to add to the end of the created note on the `Shipment` */
  note?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
  snoozePeriodUnit: ITimeUnitsEnum
  snoozePeriodValue: Scalars['Int']
  snoozeReason: ITaskSnoozeReasons
  taskNamespace: ITaskNamespaces
}

/** Autogenerated return type of SnoozeShipmentActiveTasks */
export type ISnoozeShipmentActiveTasksPayload = {
  __typename?: 'SnoozeShipmentActiveTasksPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  tasks?: Maybe<Array<ITask>>
}

/** Autogenerated input type of SoftDeleteRelayPaymentsCode */
export type ISoftDeleteRelayPaymentsCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** the relay_payments_code record id to be soft deleted */
  relayPaymentsCodeId: Scalars['ID']
}

/** Autogenerated return type of SoftDeleteRelayPaymentsCode */
export type ISoftDeleteRelayPaymentsCodePayload = {
  __typename?: 'SoftDeleteRelayPaymentsCodePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  result: Scalars['Boolean']
}

export enum ISortOrderEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type ISourcedCarrierRate = {
  __typename?: 'SourcedCarrierRate'
  canDoWeekends?: Maybe<Scalars['Boolean']>
  carrierApplication: ICarrierApplication
  confirmed?: Maybe<Scalars['Boolean']>
  createdAt: Scalars['ISO8601DateTime']
  createdBy?: Maybe<IUser>
  id: Scalars['ID']
  latestLaneAgreement?: Maybe<IAttachedDocument>
  maxCapacity?: Maybe<Scalars['Int']>
  minCapacity?: Maybe<Scalars['Int']>
  rate: IRate
  /** System of origin for this sourced rate. */
  rateSource?: Maybe<ISourcedCarrierRateRateSourceEnum>
  shipperRate?: Maybe<IShipperRate>
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy?: Maybe<IUser>
}

/** The connection type for SourcedCarrierRate. */
export type ISourcedCarrierRateConnection = {
  __typename?: 'SourcedCarrierRateConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ISourcedCarrierRateEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ISourcedCarrierRate>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type ISourcedCarrierRateEdge = {
  __typename?: 'SourcedCarrierRateEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<ISourcedCarrierRate>
}

export enum ISourcedCarrierRateRateSourceEnum {
  /** Award */
  Award = 'Award',
  /** Bid */
  Bid = 'Bid',
  /** Fms */
  FMS = 'FMS',
}

export enum ISpfAvailableIntegrationTypes {
  /** Custom */
  custom = 'custom',
  /** Standard */
  standard = 'standard',
}

export enum ISpfAvailableProviderNames {
  /** Fourkites */
  fourkites = 'fourkites',
  /** Macropoint */
  macropoint = 'macropoint',
  /** Project44 */
  project44 = 'project44',
  /** Trimble */
  trimble = 'trimble',
}

export type ISpfIntegration = ICreatedByUser & {
  __typename?: 'SpfIntegration'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  createdBy: IUser
  createdById: Scalars['Int']
  id: Scalars['ID']
  integrationType: ISpfAvailableIntegrationTypes
  notes?: Maybe<Scalars['String']>
  providerName: ISpfAvailableProviderNames
  scac?: Maybe<Scalars['String']>
  shipperApplication: IShipperApplication
  shipperSpecificKey?: Maybe<Scalars['String']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy?: Maybe<IUser>
}

export type ISpotBiddingConfig = {
  __typename?: 'SpotBiddingConfig'
  configName?: Maybe<Scalars['String']>
  configType?: Maybe<Scalars['String']>
  fuelRpm?: Maybe<Scalars['Float']>
  id: Scalars['ID']
  modifyPastPickupType?: Maybe<Scalars['String']>
  namespace?: Maybe<Scalars['String']>
  rateType?: Maybe<Scalars['String']>
  shipperApplicationId?: Maybe<Scalars['ID']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type ISpotBiddingRule = {
  __typename?: 'SpotBiddingRule'
  appointmentTimeCriteria?: Maybe<IAppointmentTimeCriteria>
  carrierWaitTimeCriteria?: Maybe<ICarrierWaitTimeCriteria>
  contractCriteria?: Maybe<IContractCriteria>
  countLoadsQuotedCriteria?: Maybe<ICountLoadsQuotedCriteria>
  createdAt: Scalars['ISO8601DateTime']
  dateCriteria?: Maybe<IDateCriteria>
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  distanceToMarketCenterCriteria?: Maybe<IDistanceToMarketCenterCriteria>
  geographicCriteria?: Maybe<IGeographicCriteria>
  id: Scalars['ID']
  isBaseline: Scalars['Boolean']
  isDrop?: Maybe<Scalars['Boolean']>
  isMultiStop: Scalars['Boolean']
  isSameDay: Scalars['Boolean']
  isWeekend: Scalars['Boolean']
  laneGeographicCriteria?: Maybe<ILaneGeographicCriteria>
  laneTierCriteria?: Maybe<ILaneTierCriteria>
  mileageCriteria?: Maybe<IMileageCriteria>
  parentEquipmentKey?: Maybe<Scalars['String']>
  proximalHourCriteria?: Maybe<IProximalHourCriteria>
  reason?: Maybe<Scalars['String']>
  ruleAction: Scalars['String']
  ruleStartTimeCriteria?: Maybe<IRuleStartTimeCriteria>
  shipperApplicationId?: Maybe<Scalars['ID']>
  spotBiddingConfig?: Maybe<ISpotBiddingConfig>
  spotBiddingConfigId: Scalars['ID']
  spotPremium?: Maybe<ISpotPremium>
  stopSpecificDropCriteria?: Maybe<IStopSpecificDropCriteria>
  transitDifferenceCriteria?: Maybe<ITransitDifferenceCriteria>
  updatedAt: Scalars['ISO8601DateTime']
}

export type ISpotPremium = {
  __typename?: 'SpotPremium'
  amount?: Maybe<Scalars['Float']>
  id: Scalars['ID']
  premiumType?: Maybe<Scalars['String']>
  rateMultiplierType?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

/** Autogenerated input type of StartPhoneCall */
export type IStartPhoneCallInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** The phone number for the recipient of the phone call. */
  toPhoneNumber: Scalars['String']
}

/** Autogenerated return type of StartPhoneCall */
export type IStartPhoneCallPayload = {
  __typename?: 'StartPhoneCallPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

export enum IStates {
  /** Alberta */
  AB = 'AB',
  /** Alaska */
  AK = 'AK',
  /** Alabama */
  AL = 'AL',
  /** Arkansas */
  AR = 'AR',
  /** American Samoa */
  AS = 'AS',
  /** Arizona */
  AZ = 'AZ',
  /** British Columbia */
  BC = 'BC',
  /** California */
  CA = 'CA',
  /** Colorado */
  CO = 'CO',
  /** Connecticut */
  CT = 'CT',
  /** District Of Columbia */
  DC = 'DC',
  /** Delaware */
  DE = 'DE',
  /** Florida */
  FL = 'FL',
  /** Georgia */
  GA = 'GA',
  /** Guam */
  GU = 'GU',
  /** Hawaii */
  HI = 'HI',
  /** Iowa */
  IA = 'IA',
  /** Idaho */
  ID = 'ID',
  /** Illinois */
  IL = 'IL',
  /** Indiana */
  IN = 'IN',
  /** Kansas */
  KS = 'KS',
  /** Kentucky */
  KY = 'KY',
  /** Louisiana */
  LA = 'LA',
  /** Massachusetts */
  MA = 'MA',
  /** Manitoba */
  MB = 'MB',
  /** Maryland */
  MD = 'MD',
  /** Maine */
  ME = 'ME',
  /** Marshall Islands */
  MH = 'MH',
  /** Michigan */
  MI = 'MI',
  /** Minnesota */
  MN = 'MN',
  /** Missouri */
  MO = 'MO',
  /** Northern Mariana Islands */
  MP = 'MP',
  /** Mississippi */
  MS = 'MS',
  /** Montana */
  MT = 'MT',
  /** New Brunswick */
  NB = 'NB',
  /** North Carolina */
  NC = 'NC',
  /** North Dakota */
  ND = 'ND',
  /** Nebraska */
  NE = 'NE',
  /** New Hampshire */
  NH = 'NH',
  /** New Jersey */
  NJ = 'NJ',
  /** Newfoundland and Labrador */
  NL = 'NL',
  /** New Mexico */
  NM = 'NM',
  /** Nova Scotia */
  NS = 'NS',
  /** Northwest Territories */
  NT = 'NT',
  /** Nunavut */
  NU = 'NU',
  /** Nevada */
  NV = 'NV',
  /** New York */
  NY = 'NY',
  /** Ohio */
  OH = 'OH',
  /** Oklahoma */
  OK = 'OK',
  /** Ontario */
  ON = 'ON',
  /** Oregon */
  OR = 'OR',
  /** Pennsylvania */
  PA = 'PA',
  /** Prince Edward Island */
  PE = 'PE',
  /** Puerto Rico */
  PR = 'PR',
  /** Quebec */
  QC = 'QC',
  /** Rhode Island */
  RI = 'RI',
  /** South Carolina */
  SC = 'SC',
  /** South Dakota */
  SD = 'SD',
  /** Saskatchewan */
  SK = 'SK',
  /** Tennessee */
  TN = 'TN',
  /** Texas */
  TX = 'TX',
  /** Utah */
  UT = 'UT',
  /** Virginia */
  VA = 'VA',
  /** Virgin Islands */
  VI = 'VI',
  /** Vermont */
  VT = 'VT',
  /** Washington */
  WA = 'WA',
  /** Wisconsin */
  WI = 'WI',
  /** West Virginia */
  WV = 'WV',
  /** Wyoming */
  WY = 'WY',
  /** Yukon Territory */
  YT = 'YT',
}

export enum IStatusTimezoneScheme {
  eastern = 'eastern',
  local = 'local',
  local_with_lt = 'local_with_lt',
  utc = 'utc',
}

export type IStopSpecificDropCriteria = {
  __typename?: 'StopSpecificDropCriteria'
  deliveryDropTrailer: Scalars['Boolean']
  id: Scalars['ID']
  pickupDropTrailer: Scalars['Boolean']
  showStopSpecificCheckbox?: Maybe<Scalars['Boolean']>
}

export enum IStupidEdiConfigs {
  ALBERTSONS = 'ALBERTSONS',
  ALDI = 'ALDI',
  ANHEUSER_BUSCH_3040 = 'ANHEUSER_BUSCH_3040',
  BLUJAY_210 = 'BLUJAY_210',
  CELANESE = 'CELANESE',
  COTY = 'COTY',
  CVS = 'CVS',
  DEFAULT = 'DEFAULT',
  FIJI = 'FIJI',
  GE = 'GE',
  HEB = 'HEB',
  HOME_DEPOT = 'HOME_DEPOT',
  HUB_GROUP = 'HUB_GROUP',
  PG = 'PG',
  UPFIELD = 'UPFIELD',
}

/** Autogenerated input type of SyncBillWithTriumphpay */
export type ISyncBillWithTriumphpayInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of SyncBillWithTriumphpay */
export type ISyncBillWithTriumphpayPayload = {
  __typename?: 'SyncBillWithTriumphpayPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of SyncHighwayDataIntoCarrier */
export type ISyncHighwayDataIntoCarrierInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shouldSyncContactEmail?: Maybe<Scalars['Boolean']>
  shouldSyncContactName?: Maybe<Scalars['Boolean']>
  shouldSyncContactPhone?: Maybe<Scalars['Boolean']>
  shouldSyncDbaName?: Maybe<Scalars['Boolean']>
  shouldSyncEin?: Maybe<Scalars['Boolean']>
  shouldSyncLegalName?: Maybe<Scalars['Boolean']>
  shouldSyncMcNumber?: Maybe<Scalars['Boolean']>
  shouldSyncPhysicalAddress?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of SyncHighwayDataIntoCarrier */
export type ISyncHighwayDataIntoCarrierPayload = {
  __typename?: 'SyncHighwayDataIntoCarrierPayload'
  carrierApplication?: Maybe<ICarrierApplication>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** A polymorphic table capable of storing flexible resource metadata */
export type ITag = {
  __typename?: 'Tag'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  domain?: Maybe<ITaggableDomainsEnum>
  id: Scalars['ID']
  metadata?: Maybe<Scalars['JSON']>
  taggableId: Scalars['ID']
  taggableType: ITaggableTypesEnum
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  variant?: Maybe<ITaggableVariantsEnum>
}

export enum ITaggableDomainsEnum {
  fms = 'fms',
  mobile = 'mobile',
  tms = 'tms',
}

export enum ITaggableTypesEnum {
  Shipment = 'Shipment',
}

export enum ITaggableVariantsEnum {
  customer_detail = 'customer_detail',
  great_rate_shipment = 'great_rate_shipment',
  popular_shipment = 'popular_shipment',
}

export type ITask = {
  __typename?: 'Task'
  assignedAt?: Maybe<Scalars['ISO8601DateTime']>
  assignedBy?: Maybe<IUser>
  assignedTo?: Maybe<IUser>
  canceledAt?: Maybe<Scalars['ISO8601DateTime']>
  completedAt?: Maybe<Scalars['ISO8601DateTime']>
  completedAutomatically: Scalars['Boolean']
  completedBy?: Maybe<IUser>
  dueAt: Scalars['ISO8601DateTime']
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  name: Scalars['String']
  namespace: ITaskNamespaces
  snoozeCanceledAt?: Maybe<Scalars['ISO8601DateTime']>
  snoozeCount: Scalars['Int']
  snoozeReason?: Maybe<ITaskSnoozeReasons>
  snoozeUpdatedBy?: Maybe<IUser>
  snoozed: Scalars['Boolean']
  snoozedAt?: Maybe<Scalars['ISO8601DateTime']>
  snoozedUntil?: Maybe<Scalars['ISO8601DateTime']>
  taskable: ITaskable
  taskableId: Scalars['ID']
  taskableType: ITaskableTypes
}

/** The connection type for Task. */
export type ITaskConnection = {
  __typename?: 'TaskConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ITaskEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ITask>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type ITaskEdge = {
  __typename?: 'TaskEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<ITask>
}

export enum ITaskNamespaces {
  CE = 'CE',
  CX = 'CX',
}

export enum ITaskSnoozeReasons {
  /** Arrived Early */
  ARRIVED_EARLY = 'ARRIVED_EARLY',
  /** Bounce Requested */
  BOUNCE_REQUESTED = 'BOUNCE_REQUESTED',
  /** Carrier Not Answering */
  CARRIER_NOT_ANSWERING = 'CARRIER_NOT_ANSWERING',
  /** Customer Requested */
  CUSTOMER_REQUESTED = 'CUSTOMER_REQUESTED',
  /** Delaying Due to Automation */
  DELAYING_DUE_TO_AUTOMATION = 'DELAYING_DUE_TO_AUTOMATION',
  /** Detention Requested at Facility */
  DETENTION_REQUESTED_AT_FACILITY = 'DETENTION_REQUESTED_AT_FACILITY',
  /** Driver Lost */
  DRIVER_LOST = 'DRIVER_LOST',
  /** Drop Trailer */
  DROP_TRAILER = 'DROP_TRAILER',
  /** Escalated Accessorial */
  ESCALATED_ACCESSORIAL = 'ESCALATED_ACCESSORIAL',
  /** Escalated Externally */
  ESCALATED_EXTERNALLY = 'ESCALATED_EXTERNALLY',
  /** Escalated Internally */
  ESCALATED_INTERNALLY = 'ESCALATED_INTERNALLY',
  /** GPS Integration Pending */
  GPS_INTEGRATION_PENDING = 'GPS_INTEGRATION_PENDING',
  /** Missing Carrier Info */
  MISSING_CARRIER_INFO = 'MISSING_CARRIER_INFO',
  /** Receiver Requested */
  RECEIVER_REQUESTED = 'RECEIVER_REQUESTED',
  /** Reschedule */
  RESCHEDULE = 'RESCHEDULE',
  /** Shipper Requested */
  SHIPPER_REQUESTED = 'SHIPPER_REQUESTED',
  /** Too early to schedule */
  TOO_EARLY_TO_SCHEDULE = 'TOO_EARLY_TO_SCHEDULE',
}

/** Objects which may have tasks assigned to them */
export type ITaskable = IShipment | IShipmentStop

export enum ITaskableTypes {
  Shipment = 'Shipment',
  ShipmentStop = 'ShipmentStop',
}

export type ITaskedShipment = {
  __typename?: 'TaskedShipment'
  shipment: IShipment
  taskNamespace: ITaskNamespaces
}

/** The connection type for TaskedShipment. */
export type ITaskedShipmentConnection = {
  __typename?: 'TaskedShipmentConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ITaskedShipmentEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ITaskedShipment>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type ITaskedShipmentEdge = {
  __typename?: 'TaskedShipmentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<ITaskedShipment>
}

export type ITaskedShipmentFilterPreferences = {
  __typename?: 'TaskedShipmentFilterPreferences'
  amPodIds?: Maybe<Array<Scalars['ID']>>
  carrierIds?: Maybe<Array<Scalars['ID']>>
  deliveryDate?: Maybe<Scalars['ISO8601Date']>
  endDeliveryDate?: Maybe<Scalars['ISO8601Date']>
  endPickupDate?: Maybe<Scalars['ISO8601Date']>
  excludeIds?: Maybe<Array<Scalars['ID']>>
  hot?: Maybe<Scalars['Boolean']>
  ids?: Maybe<Array<Scalars['ID']>>
  /** Filters by shipments whose shippers are assigned to no groups. Can be used in conjunction with `shipperGroupIds` */
  inNoOpsGroup?: Maybe<Scalars['Boolean']>
  mustGo?: Maybe<Scalars['Boolean']>
  pickupDate?: Maybe<Scalars['ISO8601Date']>
  /**
   * Filters shipments by ID, BOL, PO reference, shipper shipment reference,
   * appointment reference or confirmation reference, or other edi shipper shipment identifiers.
   */
  searchTerm?: Maybe<Scalars['String']>
  /**
   * Only include shipments whose shipper is assigned to one of the passed group
   * IDs. Can be used in combination with `inNoOpsGroup`
   */
  shipperGroupIds?: Maybe<Array<Scalars['ID']>>
  shipperIds?: Maybe<Array<Scalars['ID']>>
  /** If `true`, only include shipments where all tasks are snoozed. If `false`, exclude shipments where all tasks are snoozed */
  snoozed?: Maybe<Scalars['Boolean']>
  /**
   * Only return shipments in the passed states. Only states between On Hold
   * (inclusive) and Delivered (exclusive) will be considered
   */
  states?: Maybe<Array<IShipmentStates>>
  /** Filter by shipments with tasked assigned to passed user IDs */
  taskAssignedToIds?: Maybe<Array<Scalars['ID']>>
  taskNamespaces?: Maybe<Array<ITaskNamespaces>>
  /** If `true`, only return shipments with past due tasks. If `false` or missing this parameter is ignored. */
  tasksPastDue?: Maybe<Scalars['Boolean']>
  /**
   * If true returns only shipments where all tasks for the namespace are
   * unassigned. If false returns shipments where at least one task for the
   * namespace is assigned.
   */
  tasksUnassigned?: Maybe<Scalars['Boolean']>
}

export type ITaskedShipmentFilterPreferencesInput = {
  amPodIds?: Maybe<Array<Scalars['ID']>>
  carrierIds?: Maybe<Array<Scalars['ID']>>
  deliveryDate?: Maybe<Scalars['ISO8601Date']>
  endDeliveryDate?: Maybe<Scalars['ISO8601Date']>
  endPickupDate?: Maybe<Scalars['ISO8601Date']>
  excludeIds?: Maybe<Array<Scalars['ID']>>
  hot?: Maybe<Scalars['Boolean']>
  ids?: Maybe<Array<Scalars['ID']>>
  inNoOpsGroup?: Maybe<Scalars['Boolean']>
  mustGo?: Maybe<Scalars['Boolean']>
  pickupDate?: Maybe<Scalars['ISO8601Date']>
  searchTerm?: Maybe<Scalars['String']>
  shipperGroupIds?: Maybe<Array<Scalars['ID']>>
  shipperIds?: Maybe<Array<Scalars['ID']>>
  snoozed?: Maybe<Scalars['Boolean']>
  states?: Maybe<Array<IShipmentStates>>
  taskAssignedToIds?: Maybe<Array<Scalars['ID']>>
  taskNamespaces?: Maybe<Array<ITaskNamespaces>>
  tasksPastDue?: Maybe<Scalars['Boolean']>
  tasksUnassigned?: Maybe<Scalars['Boolean']>
}

export type ITaskedShipmentsCount = {
  __typename?: 'TaskedShipmentsCount'
  count: Scalars['Int']
  taskNamespace: ITaskNamespaces
  userId: Scalars['ID']
}

export enum ITcmEquipmentKeyTypes {
  dry_van = 'dry_van',
  reefer = 'reefer',
}

export type ITcmPricingStrategy = {
  __typename?: 'TcmPricingStrategy'
  keyValue?: Maybe<Scalars['String']>
  values?: Maybe<ITcmPricingStrategyValues>
}

export type ITcmPricingStrategyValues = {
  __typename?: 'TcmPricingStrategyValues'
  TCM10?: Maybe<Scalars['Float']>
  TCM15?: Maybe<Scalars['Float']>
  TCM20?: Maybe<Scalars['Float']>
  TCM25?: Maybe<Scalars['Float']>
  TCM30?: Maybe<Scalars['Float']>
  TCM35?: Maybe<Scalars['Float']>
  TCM40?: Maybe<Scalars['Float']>
  TCM45?: Maybe<Scalars['Float']>
  TCM50?: Maybe<Scalars['Float']>
  TCM55?: Maybe<Scalars['Float']>
  TCM60?: Maybe<Scalars['Float']>
  TCM65?: Maybe<Scalars['Float']>
  TCM70?: Maybe<Scalars['Float']>
  TCM75?: Maybe<Scalars['Float']>
  TCM80?: Maybe<Scalars['Float']>
  TCM85?: Maybe<Scalars['Float']>
  TCM90?: Maybe<Scalars['Float']>
}

/** Autogenerated input type of TenderShipment */
export type ITenderShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of TenderShipment */
export type ITenderShipmentPayload = {
  __typename?: 'TenderShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of TestAs2ConnectionConfigOutbound */
export type ITestAs2ConnectionConfigOutboundInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** the connection config to test */
  id?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of TestAs2ConnectionConfigOutbound */
export type ITestAs2ConnectionConfigOutboundPayload = {
  __typename?: 'TestAs2ConnectionConfigOutboundPayload'
  as2ConnectionConfigOutboundTestReport: IAs2ConnectionConfigOutboundTestReport
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of TestFtpConnectionConfig */
export type ITestFtpConnectionConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediMapperConnectionConfigId: Scalars['ID']
  ediMapperConnectionConfigType: IConnectionConfigTypes
}

/** Autogenerated return type of TestFtpConnectionConfig */
export type ITestFtpConnectionConfigPayload = {
  __typename?: 'TestFtpConnectionConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  ftpConnectionConfigTestReport: IFtpConnectionConfigTestReport
}

export enum ITimeUnitsEnum {
  /** Day */
  day = 'day',
  /** Hour */
  hour = 'hour',
  /** Min */
  min = 'min',
}

export type ITodo = {
  __typename?: 'Todo'
  carrierDot?: Maybe<Scalars['String']>
  externalId: Scalars['ID']
  firstPickupStartAt?: Maybe<Scalars['ISO8601DateTime']>
  missingDriver?: Maybe<Scalars['Boolean']>
  missingTruckNumber?: Maybe<Scalars['Boolean']>
  missingVin?: Maybe<Scalars['Boolean']>
  podMissing?: Maybe<Scalars['Boolean']>
  podRejected?: Maybe<Scalars['Boolean']>
}

export type ITopMarket = {
  __typename?: 'TopMarket'
  cityState: Scalars['String']
  count: Scalars['Int']
}

export type ITrackingCapabilities = {
  __typename?: 'TrackingCapabilities'
  keepTruckin: Scalars['Boolean']
  mobile: Scalars['Boolean']
  project44: Scalars['Boolean']
}

export type ITrackingOverview = {
  __typename?: 'TrackingOverview'
  calculatedTrackingMethod: Scalars['String']
  calculatedTrackingMethodLatestPing?: Maybe<IDriverLocation>
  carrierApplicationId?: Maybe<Scalars['ID']>
  carrierAssignment?: Maybe<ICarrierAssignment>
  dispatcher?: Maybe<IUser>
  driver?: Maybe<IUser>
  driverLatestPing?: Maybe<IDriverLocation>
  eldTruckNumber?: Maybe<IEldTruckNumber>
  trackingCapabilities: ITrackingCapabilities
  trackingRequirement: Scalars['String']
  trackingState: ITrackingStateEnum
}

export enum ITrackingStateEnum {
  currently_tracking = 'currently_tracking',
  not_tracking_not_required = 'not_tracking_not_required',
  not_tracking_required = 'not_tracking_required',
  was_tracking = 'was_tracking',
}

export type ITrackingSummary = {
  __typename?: 'TrackingSummary'
  isTracking: Scalars['Boolean']
  shouldBeTracking: Scalars['Boolean']
}

export type ITrailer = {
  __typename?: 'Trailer'
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']>
  carrier: ICarrierApplication
  carrierAssignments: Array<ICarrierAssignment>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  createdBy?: Maybe<IUser>
  id: Scalars['ID']
  length?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  number: Scalars['String']
  shipment?: Maybe<IShipment>
  shipperFacility?: Maybe<IShipperFacility>
  state: Scalars['String']
  trailerType?: Maybe<Scalars['String']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  updatedBy?: Maybe<IUser>
}

/** The connection type for Trailer. */
export type ITrailerConnection = {
  __typename?: 'TrailerConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ITrailerEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ITrailer>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type ITrailerEdge = {
  __typename?: 'TrailerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<ITrailer>
}

export type ITrailerPoolInput = {
  carrierApplicationId?: Maybe<Scalars['ID']>
  id?: Maybe<Scalars['ID']>
  shipperApplicationId?: Maybe<Scalars['ID']>
  shipperFacilityUuid?: Maybe<Scalars['String']>
  trailerRequirement?: Maybe<Scalars['Int']>
}

export enum ITrailerStatesEnum {
  /** Assigned to facility */
  assigned_to_facility = 'assigned_to_facility',
  /** Assigned to shipment */
  assigned_to_shipment = 'assigned_to_shipment',
  /** Empty at delivery */
  empty_at_delivery = 'empty_at_delivery',
  /** Inactive */
  inactive = 'inactive',
  /** Unassigned */
  unassigned = 'unassigned',
}

export enum ITransactionSetSubtypes {
  BOOKING = 'BOOKING',
  SCHEDULED_TRACKING = 'SCHEDULED_TRACKING',
}

export enum ITransactionSetTypes {
  _204 = '_204',
  _210 = '_210',
  _214 = '_214',
  _816 = '_816',
  _824 = '_824',
  _864 = '_864',
  _990 = '_990',
  _997 = '_997',
}

export type ITransactionSetWithSubtype = {
  __typename?: 'TransactionSetWithSubtype'
  transactionSet: ITransactionSetTypes
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
}

export type ITransfixHighwayInsurancePolicyFlag = {
  __typename?: 'TransfixHighwayInsurancePolicyFlag'
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  transfixAdditionalInsured: Scalars['Boolean']
  transfixAdditionalInsuredUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  transfixAdditionalInsuredUpdatedBy?: Maybe<Scalars['String']>
  transfixAdditionalInsuredUpdatedById?: Maybe<Scalars['ID']>
  transfixHolder: Scalars['Boolean']
  transfixHolderUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  transfixHolderUpdatedBy?: Maybe<Scalars['String']>
  transfixHolderUpdatedById?: Maybe<Scalars['ID']>
  transfixLossPayee: Scalars['Boolean']
  transfixLossPayeeUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  transfixLossPayeeUpdatedBy?: Maybe<Scalars['String']>
  transfixLossPayeeUpdatedById?: Maybe<Scalars['ID']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type ITransitDifferenceCriteria = {
  __typename?: 'TransitDifferenceCriteria'
  id: Scalars['ID']
  timeRangeEnd?: Maybe<Scalars['String']>
  timeRangeStart: Scalars['String']
  timeUnit: Scalars['String']
}

export type ITranslation = {
  __typename?: 'Translation'
  fromLanguage: Scalars['String']
  fromLanguageDetected: Scalars['Boolean']
  originalText: Scalars['String']
  toLanguage: Scalars['String']
  translatedText?: Maybe<Scalars['String']>
}

export type ITransportationManagementSystem = {
  __typename?: 'TransportationManagementSystem'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  name: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type ITrueRates = {
  __typename?: 'TrueRates'
  actualMargin?: Maybe<Scalars['Float']>
  carrierRate?: Maybe<Scalars['Float']>
  marketRate?: Maybe<Scalars['Float']>
  projectedMargin?: Maybe<Scalars['Float']>
  trueRateTotal?: Maybe<Scalars['Float']>
}

/** Autogenerated input type of UnassignAllShipmentActiveTasks */
export type IUnassignAllShipmentActiveTasksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  taskNamespace: ITaskNamespaces
}

/** Autogenerated return type of UnassignAllShipmentActiveTasks */
export type IUnassignAllShipmentActiveTasksPayload = {
  __typename?: 'UnassignAllShipmentActiveTasksPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  tasks?: Maybe<Array<ITask>>
}

/** Autogenerated input type of UnassignFacilityVendor */
export type IUnassignFacilityVendorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  facilityUuid: Scalars['ID']
  vendorId: Scalars['ID']
}

/** Autogenerated return type of UnassignFacilityVendor */
export type IUnassignFacilityVendorPayload = {
  __typename?: 'UnassignFacilityVendorPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  vendor?: Maybe<IVendor>
}

/** Autogenerated input type of UnassignTrailerFromShipment */
export type IUnassignTrailerFromShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of UnassignTrailerFromShipment */
export type IUnassignTrailerFromShipmentPayload = {
  __typename?: 'UnassignTrailerFromShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  trailer?: Maybe<ITrailer>
}

/** Autogenerated input type of UncancelShipment */
export type IUncancelShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of UncancelShipment */
export type IUncancelShipmentPayload = {
  __typename?: 'UncancelShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of UndeliverShipment */
export type IUndeliverShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of UndeliverShipment */
export type IUndeliverShipmentPayload = {
  __typename?: 'UndeliverShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of UnmarkFacilityPrimary */
export type IUnmarkFacilityPrimaryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  facilityUuid: Scalars['ID']
}

/** Autogenerated return type of UnmarkFacilityPrimary */
export type IUnmarkFacilityPrimaryPayload = {
  __typename?: 'UnmarkFacilityPrimaryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  facility?: Maybe<IFacility>
}

/** Autogenerated input type of UnmarkShipmentRolled */
export type IUnmarkShipmentRolledInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  rescheduleReason: IRescheduleReasons
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of UnmarkShipmentRolled */
export type IUnmarkShipmentRolledPayload = {
  __typename?: 'UnmarkShipmentRolledPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of UnsnoozeShipmentActiveTasks */
export type IUnsnoozeShipmentActiveTasksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
  taskNamespace: ITaskNamespaces
}

/** Autogenerated return type of UnsnoozeShipmentActiveTasks */
export type IUnsnoozeShipmentActiveTasksPayload = {
  __typename?: 'UnsnoozeShipmentActiveTasksPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  tasks?: Maybe<Array<ITask>>
}

/** Autogenerated input type of UpdateAs2Certificate */
export type IUpdateAs2CertificateInput = {
  /** PEM-encoded certificate body */
  body: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of UpdateAs2Certificate */
export type IUpdateAs2CertificatePayload = {
  __typename?: 'UpdateAs2CertificatePayload'
  as2Certificate?: Maybe<IAs2Certificate>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateAssignedFacilityVendor */
export type IUpdateAssignedFacilityVendorInput = {
  addressLine2?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  facilityUuid: Scalars['ID']
  industry?: Maybe<IVendorIndustries>
  name?: Maybe<Scalars['String']>
  shipperFacilities?: Maybe<Array<IShipperFacilityInput>>
  vendorId: Scalars['ID']
}

/** Autogenerated return type of UpdateAssignedFacilityVendor */
export type IUpdateAssignedFacilityVendorPayload = {
  __typename?: 'UpdateAssignedFacilityVendorPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  vendor?: Maybe<IVendor>
}

export type IUpdateBid = {
  amount: Scalars['Float']
  carrierAvailableTruck?: Maybe<IAvailableTruckInput>
  carrierContactName?: Maybe<Scalars['String']>
  carrierContactPhone: Scalars['String']
  carrierContactPhoneExt?: Maybe<Scalars['String']>
  carrierContactUserId?: Maybe<Scalars['ID']>
  counterBidAmount?: Maybe<Scalars['Float']>
  driverId?: Maybe<Scalars['ID']>
  note?: Maybe<Scalars['String']>
  removeCounterBid?: Maybe<Scalars['Boolean']>
  shipmentId: Scalars['ID']
}

/** Autogenerated input type of UpdateBidApprovalState */
export type IUpdateBidApprovalStateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  comment?: Maybe<Scalars['String']>
  id: Scalars['ID']
  state: IBidApprovalStateEnum
}

/** Autogenerated return type of UpdateBidApprovalState */
export type IUpdateBidApprovalStatePayload = {
  __typename?: 'UpdateBidApprovalStatePayload'
  bidApproval?: Maybe<IBidApproval>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateBid */
export type IUpdateBidInput = {
  bid: IUpdateBid
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of UpdateBid */
export type IUpdateBidPayload = {
  __typename?: 'UpdateBidPayload'
  bid?: Maybe<IBid>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateCarrierApplicationState */
export type IUpdateCarrierApplicationStateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  dotNumber?: Maybe<Scalars['String']>
  mcNumber?: Maybe<Scalars['String']>
  state: Scalars['String']
}

/** Autogenerated return type of UpdateCarrierApplicationState */
export type IUpdateCarrierApplicationStatePayload = {
  __typename?: 'UpdateCarrierApplicationStatePayload'
  carrier?: Maybe<ICarrierApplication>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateCarrierAssignment */
export type IUpdateCarrierAssignmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  trackingMethod?: Maybe<IPreferredTrackingMethods>
}

/** Autogenerated return type of UpdateCarrierAssignment */
export type IUpdateCarrierAssignmentPayload = {
  __typename?: 'UpdateCarrierAssignmentPayload'
  carrierAssignment?: Maybe<ICarrierAssignment>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateCarrierCertification */
export type IUpdateCarrierCertificationInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  code: Scalars['String']
  isVerified?: Maybe<Scalars['Boolean']>
  issuingOrganization?: Maybe<Scalars['String']>
  renewalDate?: Maybe<Scalars['ISO8601Date']>
}

/** Autogenerated return type of UpdateCarrierCertification */
export type IUpdateCarrierCertificationPayload = {
  __typename?: 'UpdateCarrierCertificationPayload'
  certification?: Maybe<ICarrierCertification>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateCarrierCompanyInformation */
export type IUpdateCarrierCompanyInformationInput = {
  carrierApplicationId?: Maybe<Scalars['ID']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ein?: Maybe<Scalars['String']>
  entityType?: Maybe<ICarrierApplicationEntityTypes>
  fleetPlannerMotorCarrierId?: Maybe<Scalars['ID']>
  location?: Maybe<ILocationInput>
}

/** Autogenerated return type of UpdateCarrierCompanyInformation */
export type IUpdateCarrierCompanyInformationPayload = {
  __typename?: 'UpdateCarrierCompanyInformationPayload'
  carrierApplication?: Maybe<ICarrierApplication>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateCarrierDedicatedLaneRatePreference */
export type IUpdateCarrierDedicatedLaneRatePreferenceInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  isInterestedInDedicatedLanes?: Maybe<Scalars['Boolean']>
  minimumRatePerMile?: Maybe<Scalars['Float']>
}

/** Autogenerated return type of UpdateCarrierDedicatedLaneRatePreference */
export type IUpdateCarrierDedicatedLaneRatePreferencePayload = {
  __typename?: 'UpdateCarrierDedicatedLaneRatePreferencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  dedicatedLaneRatePreference?: Maybe<ICarrierDedicatedLaneRatePreference>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateCarrierEndorsements */
export type IUpdateCarrierEndorsementsInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  endorsements: Array<Scalars['String']>
}

/** Autogenerated return type of UpdateCarrierEndorsements */
export type IUpdateCarrierEndorsementsPayload = {
  __typename?: 'UpdateCarrierEndorsementsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  endorsements: Array<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateCarrierEquipmentCapability */
export type IUpdateCarrierEquipmentCapabilityInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  isDryVanCapable?: Maybe<Scalars['Boolean']>
  isFlatbedCapable?: Maybe<Scalars['Boolean']>
  isReeferCapable?: Maybe<Scalars['Boolean']>
  isTrailerOnly?: Maybe<Scalars['Boolean']>
  powerUnitCount?: Maybe<Scalars['Int']>
  trailerCount?: Maybe<Scalars['Int']>
}

/** Autogenerated return type of UpdateCarrierEquipmentCapability */
export type IUpdateCarrierEquipmentCapabilityPayload = {
  __typename?: 'UpdateCarrierEquipmentCapabilityPayload'
  carrierEquipmentCapability?: Maybe<ICarrierEquipmentCapability>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateCarrierExcludedCommodities */
export type IUpdateCarrierExcludedCommoditiesInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  excludedCommodities: Array<Scalars['String']>
}

/** Autogenerated return type of UpdateCarrierExcludedCommodities */
export type IUpdateCarrierExcludedCommoditiesPayload = {
  __typename?: 'UpdateCarrierExcludedCommoditiesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  excludedCommodities: Array<Scalars['String']>
}

/** Autogenerated input type of UpdateCarrierFreightCapability */
export type IUpdateCarrierFreightCapabilityInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  isDrayageCapable?: Maybe<Scalars['Boolean']>
  isFtlCapable?: Maybe<Scalars['Boolean']>
  isIntermodalCapable?: Maybe<Scalars['Boolean']>
  isLtlCapable?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of UpdateCarrierFreightCapability */
export type IUpdateCarrierFreightCapabilityPayload = {
  __typename?: 'UpdateCarrierFreightCapabilityPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  freightCapability?: Maybe<ICarrierFreightCapability>
}

/** Autogenerated input type of UpdateCarrierLoadingCapability */
export type IUpdateCarrierLoadingCapabilityInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  isDropCapable?: Maybe<Scalars['Boolean']>
  isHeavyLoadCapable?: Maybe<Scalars['Boolean']>
  isLiveCapable?: Maybe<Scalars['Boolean']>
  isPowerOnly?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of UpdateCarrierLoadingCapability */
export type IUpdateCarrierLoadingCapabilityPayload = {
  __typename?: 'UpdateCarrierLoadingCapabilityPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  loadingCapability?: Maybe<ICarrierLoadingCapability>
}

/** Autogenerated input type of UpdateCarrierRateTypePreference */
export type IUpdateCarrierRateTypePreferenceInput = {
  allowsAllIn?: Maybe<Scalars['Boolean']>
  allowsDayRate?: Maybe<Scalars['Boolean']>
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  hasLineHaulFuelSurcharge?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of UpdateCarrierRateTypePreference */
export type IUpdateCarrierRateTypePreferencePayload = {
  __typename?: 'UpdateCarrierRateTypePreferencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  rateTypePreference?: Maybe<ICarrierRateTypePreference>
}

/** Autogenerated input type of UpdateCarrierSmartWayRegistration */
export type IUpdateCarrierSmartWayRegistrationInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  isRegistered: Scalars['Boolean']
  renewalDate?: Maybe<Scalars['ISO8601Date']>
}

/** Autogenerated return type of UpdateCarrierSmartWayRegistration */
export type IUpdateCarrierSmartWayRegistrationPayload = {
  __typename?: 'UpdateCarrierSmartWayRegistrationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  smartWayRegistration?: Maybe<ICarrierSmartWayRegistration>
}

/** Autogenerated input type of UpdateCarrierTonu */
export type IUpdateCarrierTonuInput = {
  carrierFee?: Maybe<Scalars['Float']>
  carrierTonuId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  internalNotesDescription?: Maybe<Scalars['String']>
  isApproved?: Maybe<Scalars['Boolean']>
  isCustomerRequest?: Maybe<Scalars['Boolean']>
  isOutOfPocket?: Maybe<Scalars['Boolean']>
  outOfPocketReason?: Maybe<Scalars['String']>
  proofOfTonu?: Maybe<IDocumentInput>
  shipperApprovalState?: Maybe<Scalars['String']>
  shipperFee?: Maybe<Scalars['Float']>
  shipperRejectionReason?: Maybe<Scalars['String']>
}

/** Autogenerated return type of UpdateCarrierTonu */
export type IUpdateCarrierTonuPayload = {
  __typename?: 'UpdateCarrierTonuPayload'
  carrierTonu?: Maybe<ICarrierTonu>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateConfigGroup */
export type IUpdateConfigGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
}

/** Autogenerated input type of UpdateConfigGroupMapping */
export type IUpdateConfigGroupMappingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isaSenderId: Scalars['String']
}

/** Autogenerated return type of UpdateConfigGroupMapping */
export type IUpdateConfigGroupMappingPayload = {
  __typename?: 'UpdateConfigGroupMappingPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configGroupMapping?: Maybe<IConfigGroupMapping>
  errors: Array<IError>
}

/** Autogenerated return type of UpdateConfigGroup */
export type IUpdateConfigGroupPayload = {
  __typename?: 'UpdateConfigGroupPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configGroup?: Maybe<IConfigGroup>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateConfigurableBuilder */
export type IUpdateConfigurableBuilderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** the inbound connection config to update */
  id: Scalars['ID']
  isLive?: Maybe<Scalars['Boolean']>
  name?: Maybe<Scalars['String']>
  transactionSet?: Maybe<ITransactionSetTypes>
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
}

/** Autogenerated return type of UpdateConfigurableBuilder */
export type IUpdateConfigurableBuilderPayload = {
  __typename?: 'UpdateConfigurableBuilderPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configurableBuilder?: Maybe<IConfigurableBuilder>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateConfigurableBuilderTest */
export type IUpdateConfigurableBuilderTestInput = {
  accountingInvoiceId?: Maybe<Scalars['Int']>
  changedField?: Maybe<Scalars['String']>
  changedShipperStopSequence?: Maybe<Scalars['Int']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  expectedOutput?: Maybe<Scalars['JSON']>
  /** the configurable builder to update */
  id: Scalars['ID']
  isLive?: Maybe<Scalars['Boolean']>
  name?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  shipmentId?: Maybe<Scalars['Int']>
}

/** Autogenerated return type of UpdateConfigurableBuilderTest */
export type IUpdateConfigurableBuilderTestPayload = {
  __typename?: 'UpdateConfigurableBuilderTestPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configurableBuilderTest?: Maybe<IConfigurableBuilderTest>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateConfigurableBuilderVersion */
export type IUpdateConfigurableBuilderVersionInput = {
  builderLibrary?: Maybe<IBuilderLibraries>
  canBuildBalanceDues?: Maybe<Scalars['Boolean']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  extractionTemplate?: Maybe<Scalars['String']>
  /** the configurable builder version to update */
  id: Scalars['ID']
  stupidediConfig?: Maybe<IStupidEdiConfigs>
  tfx12DefinitionId?: Maybe<Scalars['ID']>
}

/** Autogenerated return type of UpdateConfigurableBuilderVersion */
export type IUpdateConfigurableBuilderVersionPayload = {
  __typename?: 'UpdateConfigurableBuilderVersionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configurableBuilderVersion?: Maybe<IConfigurableBuilderVersion>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateDispatcher */
export type IUpdateDispatcherInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  dispatcherId: Scalars['ID']
  id: Scalars['ID']
}

/** Autogenerated return type of UpdateDispatcher */
export type IUpdateDispatcherPayload = {
  __typename?: 'UpdateDispatcherPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of UpdateDriver */
export type IUpdateDriverInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  driverId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
}

/** Autogenerated return type of UpdateDriver */
export type IUpdateDriverPayload = {
  __typename?: 'UpdateDriverPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of UpdateEdiChargeCode */
export type IUpdateEdiChargeCodeInput = {
  chargeCode?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lineItemTitle?: Maybe<ILineItemTitles>
  stopType?: Maybe<Scalars['String']>
}

/** Autogenerated return type of UpdateEdiChargeCode */
export type IUpdateEdiChargeCodePayload = {
  __typename?: 'UpdateEdiChargeCodePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediChargeCode?: Maybe<IEdiChargeCode>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateGlobalRfpStrategies */
export type IUpdateGlobalRfpStrategiesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  strategies?: Maybe<Array<IUpdateRfpStrategyInput>>
}

/** Autogenerated return type of UpdateGlobalRfpStrategies */
export type IUpdateGlobalRfpStrategiesPayload = {
  __typename?: 'UpdateGlobalRfpStrategiesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of UpdateGroup */
export type IUpdateGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  deletedMembersIds?: Maybe<Array<Scalars['ID']>>
  deletedShipperIds?: Maybe<Array<Scalars['ID']>>
  group: IEditGroupInput
  newMembersIds?: Maybe<Array<Scalars['ID']>>
  newShipperIds?: Maybe<Array<Scalars['ID']>>
}

/** Autogenerated return type of UpdateGroup */
export type IUpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  group?: Maybe<IGroup>
}

/** Autogenerated input type of UpdateHeadquarter */
export type IUpdateHeadquarterInput = {
  carrierApplicationId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  headquarter: ILocationInput
}

/** Autogenerated return type of UpdateHeadquarter */
export type IUpdateHeadquarterPayload = {
  __typename?: 'UpdateHeadquarterPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  headquarter?: Maybe<ILocation>
}

/** Autogenerated input type of UpdateInboundAs2ConnectionConfig */
export type IUpdateInboundAs2ConnectionConfigInput = {
  /** The connection config this connection will receive files from */
  as2ConnectionConfigId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  disabled: Scalars['Boolean']
  environment?: Maybe<IConnectionConfigEnvironment>
  /** only process files matching this pattern */
  filenameGlob: Scalars['String']
  /** the inbound connection config to update */
  id: Scalars['ID']
  /** shipper or carrier id */
  partnerApplicationId: Scalars['ID']
  partnerApplicationType: IPartnerApplicationTypes
  send997s?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of UpdateInboundAs2ConnectionConfig */
export type IUpdateInboundAs2ConnectionConfigPayload = {
  __typename?: 'UpdateInboundAs2ConnectionConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediInboundConnectionConfig?: Maybe<IInboundConnectionConfig>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateInboundEdiMessage */
export type IUpdateInboundEdiMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediMapperConfigurableParserId?: Maybe<Scalars['ID']>
  /** the edi message type to update */
  id: Scalars['ID']
  /** the inbound config to add the message type to */
  inboundEdiMapperConnectionConfigId?: Maybe<Scalars['ID']>
  legacyParserClass?: Maybe<ILegacyParserClassTypes>
  transactionSet?: Maybe<ITransactionSetTypes>
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
}

/** Autogenerated return type of UpdateInboundEdiMessage */
export type IUpdateInboundEdiMessagePayload = {
  __typename?: 'UpdateInboundEdiMessagePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediMessageType?: Maybe<IEdiMessage>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateInboundFileRouterConfig */
export type IUpdateInboundFileRouterConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  connectionType: IFtpConnectionTypes
  /** should config be disabled? */
  disabled: Scalars['Boolean']
  environment: IConnectionConfigEnvironment
  /** hostname */
  host: Scalars['String']
  /** the inbound file router config to update */
  id: Scalars['ID']
  /** directory to check for incoming files */
  pathPrefix: Scalars['String']
  /** tcp port */
  port: Scalars['Int']
  /**
   * Either an ENV variable name, or a string consisting of 'secretsmanager:'
   * followed by a secretsmanager id. This should resolve to a password or SSH
   * private key, depending on the connection type.
   */
  secretKey: Scalars['String']
  /** JSON config to get the shipper code from EDI */
  shipperCodeJson: Scalars['JSON']
  /** TMS name */
  tmsName: Scalars['String']
  /** username to use for login */
  username: Scalars['String']
}

/** Autogenerated return type of UpdateInboundFileRouterConfig */
export type IUpdateInboundFileRouterConfigPayload = {
  __typename?: 'UpdateInboundFileRouterConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  inboundFileRouterConfig?: Maybe<IInboundFileRouterConfig>
}

/** Autogenerated input type of UpdateInboundFtpConnectionConfig */
export type IUpdateInboundFtpConnectionConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  connectionType: IFtpConnectionTypes
  /** should config be disabled? */
  disabled: Scalars['Boolean']
  environment?: Maybe<IConnectionConfigEnvironment>
  /** only fetch files matching this pattern */
  filenameGlob?: Maybe<Scalars['String']>
  /** hostname */
  host: Scalars['String']
  /** the inbound connection config to update */
  id: Scalars['ID']
  /** shipper or carrier id */
  partnerApplicationId: Scalars['ID']
  partnerApplicationType: IPartnerApplicationTypes
  /** directory to check for incoming files */
  pathPrefix: Scalars['String']
  /** tcp port */
  port: Scalars['Int']
  /**
   * Either an ENV variable name, or a string consisting of 'secretsmanager:'
   * followed by a secretsmanager id. This should resolve to a password or SSH
   * private key, depending on the connection type.
   */
  secretKey: Scalars['String']
  send997s?: Maybe<Scalars['Boolean']>
  /** username to use for login */
  username: Scalars['String']
}

/** Autogenerated return type of UpdateInboundFtpConnectionConfig */
export type IUpdateInboundFtpConnectionConfigPayload = {
  __typename?: 'UpdateInboundFtpConnectionConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediInboundConnectionConfig?: Maybe<IInboundConnectionConfig>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateIssueAutomationRule */
export type IUpdateIssueAutomationRuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  issueAutomationRuleNodes?: Maybe<Array<IIssueAutomationRuleNodeInput>>
  name?: Maybe<Scalars['String']>
}

/** Autogenerated return type of UpdateIssueAutomationRule */
export type IUpdateIssueAutomationRulePayload = {
  __typename?: 'UpdateIssueAutomationRulePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  issueAutomationRule?: Maybe<IIssueAutomationRule>
}

/** Autogenerated input type of UpdateLocalRfpStrategies */
export type IUpdateLocalRfpStrategiesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  rfpId: Scalars['ID']
  strategies?: Maybe<Array<IUpdateRfpStrategyInput>>
}

/** Autogenerated return type of UpdateLocalRfpStrategies */
export type IUpdateLocalRfpStrategiesPayload = {
  __typename?: 'UpdateLocalRfpStrategiesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

export type IUpdateNormFileGeneratorRowStatusInput = {
  customerVendorName?: Maybe<Scalars['String']>
  deliveryCity?: Maybe<Scalars['String']>
  deliveryDropTrailer?: Maybe<Scalars['Boolean']>
  deliveryIsoCountryCode?: Maybe<Scalars['String']>
  deliveryState?: Maybe<Scalars['String']>
  deliveryZip?: Maybe<Scalars['String']>
  deliveryZone?: Maybe<Scalars['String']>
  deliveryZoneType?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['ISO8601Date']>
  equipMapped?: Maybe<Scalars['String']>
  id: Scalars['ID']
  pickupCity?: Maybe<Scalars['String']>
  pickupDropTrailer?: Maybe<Scalars['Boolean']>
  pickupIsoCountryCode?: Maybe<Scalars['String']>
  pickupState?: Maybe<Scalars['String']>
  pickupZip?: Maybe<Scalars['String']>
  pickupZone?: Maybe<Scalars['String']>
  pickupZoneType?: Maybe<Scalars['String']>
  pricingDoNotQuote?: Maybe<Scalars['String']>
  shipperMiles?: Maybe<Scalars['Int']>
  startDate?: Maybe<Scalars['ISO8601Date']>
  volumeRelevant?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of UpdateNormFileGeneratorRowStatuses */
export type IUpdateNormFileGeneratorRowStatusesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  enqueueRowJob?: Maybe<Scalars['Boolean']>
  normFileGeneratorRowStatuses: Array<IUpdateNormFileGeneratorRowStatusInput>
}

/** Autogenerated return type of UpdateNormFileGeneratorRowStatuses */
export type IUpdateNormFileGeneratorRowStatusesPayload = {
  __typename?: 'UpdateNormFileGeneratorRowStatusesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of UpdateNormFile */
export type IUpdateNormFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  rfpId: Scalars['ID']
}

/** Autogenerated return type of UpdateNormFile */
export type IUpdateNormFilePayload = {
  __typename?: 'UpdateNormFilePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateNote */
export type IUpdateNoteInput = {
  body?: Maybe<Scalars['String']>
  callBackAt?: Maybe<Scalars['ISO8601DateTime']>
  calledBackAt?: Maybe<Scalars['ISO8601DateTime']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Autogenerated return type of UpdateNote */
export type IUpdateNotePayload = {
  __typename?: 'UpdateNotePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  note?: Maybe<INote>
}

/** Autogenerated input type of UpdateOutboundAs2ConnectionConfig */
export type IUpdateOutboundAs2ConnectionConfigInput = {
  /** The connection config this connection will receive files from */
  as2ConnectionConfigId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  componentSeparator: Scalars['String']
  /** Used to differentiate multiple outbound configs associated with a single partner. */
  destinationOverride: Scalars['String']
  disabled: Scalars['Boolean']
  elementSeparator: Scalars['String']
  environment?: Maybe<IConnectionConfigEnvironment>
  expect997s?: Maybe<Scalars['Boolean']>
  groupVersionStr: Scalars['String']
  gsReceiverId?: Maybe<Scalars['String']>
  gsSenderId?: Maybe<Scalars['String']>
  /** the outbound connection config to update */
  id: Scalars['ID']
  interchangeVersionStr: Scalars['String']
  isaReceiverId?: Maybe<Scalars['String']>
  isaReceiverIdQualifier?: Maybe<Scalars['String']>
  isaSenderId?: Maybe<Scalars['String']>
  isaSenderIdQualifier?: Maybe<Scalars['String']>
  /** shipper or carrier id */
  partnerApplicationId: Scalars['ID']
  partnerApplicationType: IPartnerApplicationTypes
  repetitionSeparator: Scalars['String']
  segmentSeparator: Scalars['String']
  testIndicator: IUsageIndicators
}

/** Autogenerated return type of UpdateOutboundAs2ConnectionConfig */
export type IUpdateOutboundAs2ConnectionConfigPayload = {
  __typename?: 'UpdateOutboundAs2ConnectionConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediOutboundConnectionConfig?: Maybe<IOutboundConnectionConfig>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateOutboundEdiMessage */
export type IUpdateOutboundEdiMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediMapperConfigurableBuilderId?: Maybe<Scalars['ID']>
  /** the edi message type to update */
  id: Scalars['ID']
  legacyBuilderClass?: Maybe<ILegacyBuilderClassTypes>
  /** the outbound config to add the message type to */
  outboundEdiMapperConnectionConfigId?: Maybe<Scalars['ID']>
  transactionSet?: Maybe<ITransactionSetTypes>
  transactionSetSubtype?: Maybe<ITransactionSetSubtypes>
}

/** Autogenerated return type of UpdateOutboundEdiMessage */
export type IUpdateOutboundEdiMessagePayload = {
  __typename?: 'UpdateOutboundEdiMessagePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediMessageType?: Maybe<IEdiMessage>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateOutboundFtpConnectionConfig */
export type IUpdateOutboundFtpConnectionConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  componentSeparator: Scalars['String']
  connectionType: IFtpConnectionTypes
  /** Used to differentiate multiple outbound configs associated with a single partner. */
  destinationOverride: Scalars['String']
  /** should config be disabled? */
  disabled: Scalars['Boolean']
  elementSeparator: Scalars['String']
  environment?: Maybe<IConnectionConfigEnvironment>
  expect997s?: Maybe<Scalars['Boolean']>
  groupVersionStr: Scalars['String']
  gsReceiverId?: Maybe<Scalars['String']>
  gsSenderId?: Maybe<Scalars['String']>
  /** hostname */
  host: Scalars['String']
  /** the outbound connection config to update */
  id: Scalars['ID']
  interchangeVersionStr: Scalars['String']
  isaReceiverId?: Maybe<Scalars['String']>
  isaReceiverIdQualifier?: Maybe<Scalars['String']>
  isaSenderId?: Maybe<Scalars['String']>
  isaSenderIdQualifier?: Maybe<Scalars['String']>
  /** shipper or carrier id */
  partnerApplicationId: Scalars['ID']
  partnerApplicationType: IPartnerApplicationTypes
  /** directory to check for incoming files */
  pathPrefix: Scalars['String']
  /** tcp port */
  port: Scalars['Int']
  repetitionSeparator: Scalars['String']
  /**
   * Either an ENV variable name, or a string consisting of 'secretsmanager:'
   * followed by a secretsmanager id. This should resolve to a password or SSH
   * private key, depending on the connection type.
   */
  secretKey: Scalars['String']
  segmentSeparator: Scalars['String']
  testIndicator: IUsageIndicators
  /** username to use for login */
  username: Scalars['String']
}

/** Autogenerated return type of UpdateOutboundFtpConnectionConfig */
export type IUpdateOutboundFtpConnectionConfigPayload = {
  __typename?: 'UpdateOutboundFtpConnectionConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediOutboundConnectionConfig?: Maybe<IOutboundConnectionConfig>
  errors: Array<IError>
}

/** Autogenerated input type of UpdatePriceRequestQuote */
export type IUpdatePriceRequestQuoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  customerQuote: Scalars['Float']
  customerQuoteType: Scalars['String']
  id: Scalars['ID']
  manualQuoteOverrideReason: Scalars['String']
}

/** Autogenerated return type of UpdatePriceRequestQuote */
export type IUpdatePriceRequestQuotePayload = {
  __typename?: 'UpdatePriceRequestQuotePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  quotes?: Maybe<IPriceRequest>
  success: Scalars['Boolean']
}

/** Autogenerated input type of UpdateProofOfTonu */
export type IUpdateProofOfTonuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  proofOfTonu?: Maybe<IDocumentInput>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of UpdateProofOfTonu */
export type IUpdateProofOfTonuPayload = {
  __typename?: 'UpdateProofOfTonuPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  proofOfTonu?: Maybe<IProofOfTonu>
}

/** Autogenerated input type of UpdateRates */
export type IUpdateRatesInput = {
  backhaulRevenueShareAgreementId?: Maybe<Scalars['ID']>
  btfRequired?: Maybe<Scalars['Boolean']>
  carrierPerMileFuelRate?: Maybe<Scalars['Float']>
  carrierRate?: Maybe<Scalars['Float']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  disallowAutoShipperFuelComputation?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  pricingType?: Maybe<IPricingTypes>
  shipperPerMileFuelRate?: Maybe<Scalars['Float']>
  shipperRate?: Maybe<Scalars['Float']>
  shipperRateType?: Maybe<IShipperRateTypes>
  shipperTotalFuelSurcharge?: Maybe<Scalars['Float']>
}

/** Autogenerated return type of UpdateRates */
export type IUpdateRatesPayload = {
  __typename?: 'UpdateRatesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of UpdateRfpLaneData */
export type IUpdateRfpLaneDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  filters: IRfpLaneFilters
  laneFeedbackUpdate?: Maybe<IRfpLaneFeedbackUpdateInput>
  lanePriceUpdate?: Maybe<IRfpLanePriceUpdateInput>
  laneUpdate?: Maybe<IRfpLaneUpdateInput>
}

/** Autogenerated return type of UpdateRfpLaneData */
export type IUpdateRfpLaneDataPayload = {
  __typename?: 'UpdateRfpLaneDataPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
  updatedLanes?: Maybe<Array<IRequestForProposalLane>>
}

export type IUpdateRfpLaneFeedbackInput = {
  awardStatus?: Maybe<Scalars['String']>
  id: Scalars['ID']
  tttAtAward?: Maybe<Scalars['Float']>
}

export type IUpdateRfpLaneInput = {
  auditStatus?: Maybe<Scalars['String']>
  id: Scalars['ID']
}

export type IUpdateRfpLanePriceInput = {
  allInOverride?: Maybe<Scalars['Float']>
  allInTcmValueOverride?: Maybe<Scalars['String']>
  dollarPremium?: Maybe<Scalars['Float']>
  id: Scalars['ID']
  linehaulOverride?: Maybe<Scalars['Float']>
  liveAuditRiskLevel?: Maybe<Scalars['String']>
  marginAdjustment1?: Maybe<Scalars['Float']>
  marginAdjustmentDollar?: Maybe<Scalars['Float']>
  p2dAdjustmentPct?: Maybe<Scalars['Float']>
  premiumPct?: Maybe<Scalars['Float']>
  roundAuditStatus?: Maybe<Scalars['String']>
  setAllInToTtt?: Maybe<Scalars['Boolean']>
  strategyUpdate?: Maybe<IRequestForProposalStrategyUpdateTypes>
  tcmUsed?: Maybe<Scalars['String']>
  tttAdjustmentDollar?: Maybe<Scalars['Float']>
  tttAdjustmentPct?: Maybe<Scalars['Float']>
  tttOverride?: Maybe<Scalars['Float']>
}

/** Autogenerated input type of UpdateRfpLanesAndPrices */
export type IUpdateRfpLanesAndPricesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  laneFeedbackUpdates?: Maybe<Array<IUpdateRfpLaneFeedbackInput>>
  lanePriceUpdates?: Maybe<Array<IUpdateRfpLanePriceInput>>
  laneUpdates?: Maybe<Array<IUpdateRfpLaneInput>>
}

/** Autogenerated return type of UpdateRfpLanesAndPrices */
export type IUpdateRfpLanesAndPricesPayload = {
  __typename?: 'UpdateRfpLanesAndPricesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
  updatedLanes?: Maybe<Array<IRequestForProposalLane>>
}

export type IUpdateRfpStrategyInput = {
  name: Scalars['String']
  strategyMatrix: Scalars['JSON']
}

export type IUpdateRulesAssessmentOverride = {
  result: IRulesAssessmentOverrideResultEnum
  rulesAssessmentId: Scalars['ID']
  rulesAssessmentType: IRulesAssessmentOverrideTypeEnum
}

/** Autogenerated input type of UpdateScraperJobConfigurations */
export type IUpdateScraperJobConfigurationsInput = {
  applyToTms?: Maybe<Scalars['Boolean']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  comment?: Maybe<Scalars['String']>
  demoMode?: Maybe<Scalars['Boolean']>
  enabled?: Maybe<Scalars['Boolean']>
  jobQueueName?: Maybe<Scalars['String']>
  jobUuid: Scalars['String']
  updatedById?: Maybe<Scalars['ID']>
  waitTime?: Maybe<Scalars['Int']>
}

/** Autogenerated return type of UpdateScraperJobConfigurations */
export type IUpdateScraperJobConfigurationsPayload = {
  __typename?: 'UpdateScraperJobConfigurationsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
  updatedScraperJobConfigurationsAndHistories?: Maybe<Array<IScraperJobConfigurationAndHistory>>
}

/** Autogenerated input type of UpdateShipmentAccessorial */
export type IUpdateShipmentAccessorialInput = {
  amount?: Maybe<Scalars['Float']>
  autoSendSms?: Maybe<Scalars['Boolean']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  constraintAmount?: Maybe<Scalars['Float']>
  description?: Maybe<Scalars['String']>
  document?: Maybe<IDocumentInput>
  endAt?: Maybe<Scalars['ISO8601DateTime']>
  escortServiceName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  internalNotesDescription?: Maybe<Scalars['String']>
  isCustomerRequest?: Maybe<Scalars['Boolean']>
  isOutOfPocket?: Maybe<Scalars['Boolean']>
  lumperServiceName?: Maybe<Scalars['String']>
  oopOwnerId?: Maybe<Scalars['ID']>
  oopOwnerType?: Maybe<IShipmentIssueFollowerTypes>
  oopReason?: Maybe<Scalars['String']>
  rejectionReason?: Maybe<Scalars['String']>
  shipperApprovalState?: Maybe<Scalars['String']>
  shipperCharge?: Maybe<Scalars['Float']>
  shipperFacilityUuid?: Maybe<Scalars['String']>
  shipperRejectionReason?: Maybe<Scalars['String']>
  source?: Maybe<IShipmentAccessorialSources>
  startAt?: Maybe<Scalars['ISO8601DateTime']>
  state?: Maybe<Scalars['String']>
  taxId?: Maybe<Scalars['String']>
  trailerControlRecord?: Maybe<Scalars['String']>
  /**
   * Will update the accessorial on behalf of this user. Requires permission
   * stark.can_create_or_modify_accessorial_on_behalf. updated_by_id must be a parent user id
   */
  updatedById?: Maybe<Scalars['ID']>
  useRelayPayments?: Maybe<Scalars['Boolean']>
  withComcheck?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of UpdateShipmentAccessorial */
export type IUpdateShipmentAccessorialPayload = {
  __typename?: 'UpdateShipmentAccessorialPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipmentAccessorial?: Maybe<IShipmentAccessorial>
}

/** Autogenerated input type of UpdateShipmentCmTarget */
export type IUpdateShipmentCmTargetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  cmTarget: Scalars['Float']
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of UpdateShipmentCmTarget */
export type IUpdateShipmentCmTargetPayload = {
  __typename?: 'UpdateShipmentCmTargetPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of UpdateShipmentContactPreferenceCarrierContactInstructions */
export type IUpdateShipmentContactPreferenceCarrierContactInstructionsInput = {
  carrierContactInstructions: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of UpdateShipmentContactPreferenceCarrierContactInstructions */
export type IUpdateShipmentContactPreferenceCarrierContactInstructionsPayload = {
  __typename?: 'UpdateShipmentContactPreferenceCarrierContactInstructionsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contactPreferences?: Maybe<IContactPreference>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateShipmentContactPreference */
export type IUpdateShipmentContactPreferenceInput = {
  autoSmsDisabled: Scalars['Boolean']
  autoSmsDisabledReason?: Maybe<Scalars['String']>
  carrierContactInstructions?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of UpdateShipmentContactPreference */
export type IUpdateShipmentContactPreferencePayload = {
  __typename?: 'UpdateShipmentContactPreferencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contactPreferences?: Maybe<IContactPreference>
  errors: Array<IError>
}

/** Autogenerated input type of UpdateShipmentEquipment */
export type IUpdateShipmentEquipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  equipmentAttributes: Array<IShipmentEquipmentAttributeInput>
  equipmentType: IEquipmentTypes
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of UpdateShipmentEquipment */
export type IUpdateShipmentEquipmentPayload = {
  __typename?: 'UpdateShipmentEquipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of UpdateShipment */
export type IUpdateShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  declaredValue?: Maybe<Scalars['Float']>
  fraudValidation?: Maybe<Scalars['Boolean']>
  hasClaims?: Maybe<Scalars['Boolean']>
  hasOsd?: Maybe<Scalars['Boolean']>
  hot?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  isBackhaul?: Maybe<Scalars['Boolean']>
  isHighRisk?: Maybe<Scalars['Boolean']>
  loadingType?: Maybe<IShipperLoadTypes>
  mustGo?: Maybe<Scalars['Boolean']>
  originalShipmentId?: Maybe<Scalars['ID']>
  shipperMiles?: Maybe<Scalars['Float']>
  specialInstruction?: Maybe<Scalars['String']>
  team?: Maybe<Scalars['Boolean']>
  totalPalletCount?: Maybe<Scalars['Int']>
  totalWeight?: Maybe<Scalars['Int']>
  trailerNumber?: Maybe<Scalars['String']>
  truckNumber?: Maybe<Scalars['String']>
  vin?: Maybe<Scalars['String']>
}

/** Autogenerated input type of UpdateShipmentIssue */
export type IUpdateShipmentIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  dueAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  issueResolutionSteps?: Maybe<Array<IIssueResolutionStepInput>>
  owner?: Maybe<IShipmentIssueFollowerInput>
  priority?: Maybe<Scalars['Int']>
  shipmentIssueFaultId?: Maybe<Scalars['ID']>
  shipmentIssueReasonId?: Maybe<Scalars['ID']>
  shipmentIssueTypeId?: Maybe<Scalars['ID']>
  state?: Maybe<IShipmentIssueStates>
  subscribers?: Maybe<Array<IShipmentIssueFollowerInput>>
  summary?: Maybe<Scalars['String']>
}

/** Autogenerated return type of UpdateShipmentIssue */
export type IUpdateShipmentIssuePayload = {
  __typename?: 'UpdateShipmentIssuePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipmentIssue?: Maybe<IShipmentIssue>
}

/** Autogenerated input type of UpdateShipmentListPrice */
export type IUpdateShipmentListPriceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  newListPrice: Scalars['Float']
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of UpdateShipmentListPrice */
export type IUpdateShipmentListPricePayload = {
  __typename?: 'UpdateShipmentListPricePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of UpdateShipmentOpsRep */
export type IUpdateShipmentOpsRepInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  opsRepId: Scalars['ID']
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of UpdateShipmentOpsRep */
export type IUpdateShipmentOpsRepPayload = {
  __typename?: 'UpdateShipmentOpsRepPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated return type of UpdateShipment */
export type IUpdateShipmentPayload = {
  __typename?: 'UpdateShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export type IUpdateShipmentStopAppointmentInput = {
  appointmentReference?: Maybe<Scalars['String']>
  appointmentType?: Maybe<IShipmentStopAppointmentTypes>
  confirmationReference?: Maybe<Scalars['String']>
  /** End at date for the appointment in its local timezone. */
  endAtDate?: Maybe<Scalars['ISO8601Date']>
  /** End at time for the appointment in its local timezone. */
  endAtTime?: Maybe<Scalars['ISO8601Time']>
  isWorkIn?: Maybe<Scalars['Boolean']>
  rescheduleReason?: Maybe<IRescheduleReasons>
  /** Start at date for the appointment in its local timezone. */
  startAtDate?: Maybe<Scalars['ISO8601Date']>
  /** Start at time for the appointment in its local timezone. */
  startAtTime?: Maybe<Scalars['ISO8601Time']>
  status?: Maybe<IShipmentStopAppointmentStatuses>
}

/** Autogenerated input type of UpdateShipmentStop */
export type IUpdateShipmentStopInput = {
  appointmentInput?: Maybe<IUpdateShipmentStopAppointmentInput>
  billOfLadingReference?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  commodity?: Maybe<Scalars['String']>
  dropTrailer?: Maybe<Scalars['Boolean']>
  ediAppointmentReasonCode?: Maybe<Scalars['String']>
  ediStatusReasonCode?: Maybe<Scalars['String']>
  facilityContactUuid?: Maybe<Scalars['ID']>
  genericCommodityId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  palletCount?: Maybe<Scalars['Int']>
  poReference?: Maybe<Scalars['String']>
  shipperFacilityUuid?: Maybe<Scalars['ID']>
  specialInstruction?: Maybe<Scalars['String']>
  vendorId?: Maybe<Scalars['ID']>
  weight?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of UpdateShipmentStopManualEta */
export type IUpdateShipmentStopManualEtaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  lateReason?: Maybe<Scalars['String']>
  /** ETA in timezone of stop */
  manualEtaDate: Scalars['ISO8601Date']
  /** ETA in timezone of stop */
  manualEtaTime: Scalars['ISO8601Time']
  shipmentStopId: Scalars['ID']
}

/** Autogenerated return type of UpdateShipmentStopManualEta */
export type IUpdateShipmentStopManualEtaPayload = {
  __typename?: 'UpdateShipmentStopManualEtaPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipmentStop?: Maybe<IShipmentStop>
}

/** Autogenerated return type of UpdateShipmentStop */
export type IUpdateShipmentStopPayload = {
  __typename?: 'UpdateShipmentStopPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipmentStop?: Maybe<IShipmentStop>
}

/** Autogenerated input type of UpdateShipmentStopsArrivalDeparture */
export type IUpdateShipmentStopsArrivalDepartureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  relayedBy?: Maybe<IShipmentStopRelayedByTypes>
  relayedVia?: Maybe<IShipmentStopRelayedViaTypes>
  updates: Array<IShipmentStopArrivalDepartureInput>
}

/** Autogenerated return type of UpdateShipmentStopsArrivalDeparture */
export type IUpdateShipmentStopsArrivalDeparturePayload = {
  __typename?: 'UpdateShipmentStopsArrivalDeparturePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of UpdateShipmentStops */
export type IUpdateShipmentStopsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipmentStops: Array<IShipmentStopsListInput>
}

/** Autogenerated return type of UpdateShipmentStops */
export type IUpdateShipmentStopsPayload = {
  __typename?: 'UpdateShipmentStopsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

/** Autogenerated input type of UpdateShipperApplicationEdiConfig */
export type IUpdateShipperApplicationEdiConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ediEnabled?: Maybe<Scalars['Boolean']>
  ediInvoicing?: Maybe<Scalars['Boolean']>
  /** the shipper application edi config to update */
  id: Scalars['ID']
  sendBalanceDuesViaEdi?: Maybe<Scalars['Boolean']>
  sendsAppointmentMessagesOnlyWhenConfirmed?: Maybe<Scalars['Boolean']>
  sendsAppointmentTimesOnShipmentCreation?: Maybe<Scalars['Boolean']>
  shipperRateUpdatesAllowed?: Maybe<IShipperRateUpdatesAllowed>
  statusTimezoneScheme?: Maybe<IStatusTimezoneScheme>
}

/** Autogenerated return type of UpdateShipperApplicationEdiConfig */
export type IUpdateShipperApplicationEdiConfigPayload = {
  __typename?: 'UpdateShipperApplicationEdiConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperApplicationEdiConfig?: Maybe<IShipperApplicationEdiConfig>
}

/** Autogenerated input type of UpdateShipperApplicationTracking */
export type IUpdateShipperApplicationTrackingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipperApplicationId: Scalars['ID']
  shipperTrackingSegmentId?: Maybe<Scalars['ID']>
  trackingFees?: Maybe<Scalars['Float']>
  trackingNotes?: Maybe<Scalars['String']>
}

/** Autogenerated return type of UpdateShipperApplicationTracking */
export type IUpdateShipperApplicationTrackingPayload = {
  __typename?: 'UpdateShipperApplicationTrackingPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperApplication?: Maybe<IShipperApplication>
}

/** Autogenerated input type of UpdateShipperBrokerPod */
export type IUpdateShipperBrokerPodInput = {
  brokerPodId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipperApplicationId: Scalars['ID']
}

/** Autogenerated return type of UpdateShipperBrokerPod */
export type IUpdateShipperBrokerPodPayload = {
  __typename?: 'UpdateShipperBrokerPodPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperApplication?: Maybe<IShipperApplication>
}

/** Autogenerated input type of UpdateShipperFacilityLane */
export type IUpdateShipperFacilityLaneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  endShipperFacilityNote?: Maybe<Scalars['String']>
  endShipperFacilityUuid?: Maybe<Scalars['String']>
  hours?: Maybe<Array<IShipperFacilityHourValueInput>>
  id: Scalars['ID']
  startShipperFacilityNote?: Maybe<Scalars['String']>
  startShipperFacilityUuid?: Maybe<Scalars['String']>
}

/** Autogenerated return type of UpdateShipperFacilityLane */
export type IUpdateShipperFacilityLanePayload = {
  __typename?: 'UpdateShipperFacilityLanePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperFacilityLane?: Maybe<IShipperFacilityLane>
}

/** Autogenerated input type of UpdateShipperFacilityTrailerPool */
export type IUpdateShipperFacilityTrailerPoolInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  trailerPools: Array<ITrailerPoolInput>
}

/** Autogenerated return type of UpdateShipperFacilityTrailerPool */
export type IUpdateShipperFacilityTrailerPoolPayload = {
  __typename?: 'UpdateShipperFacilityTrailerPoolPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  trailerPools?: Maybe<Array<IShipperFacilityTrailerPool>>
}

/** Autogenerated input type of UpdateShipperOnboardingEdiConfiguration */
export type IUpdateShipperOnboardingEdiConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  onboardingEdiConfig: IShipperOnboardingEdiConfigInput
  shipperApplicationId: Scalars['ID']
}

/** Autogenerated return type of UpdateShipperOnboardingEdiConfiguration */
export type IUpdateShipperOnboardingEdiConfigurationPayload = {
  __typename?: 'UpdateShipperOnboardingEdiConfigurationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  onboardingEdiConfig: IShipperOnboardingEdiConfig
}

/** Autogenerated input type of UpdateShipperRate */
export type IUpdateShipperRateInput = {
  addShipperRateShipperFacilities?: Maybe<Array<IShipperRateShipperFacilityInput>>
  carrierSalesRepId?: Maybe<Scalars['ID']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  listingDetails?: Maybe<IShipperRateListingDetailsInput>
  removeShipperRateShipperFacilities?: Maybe<Array<Scalars['ID']>>
  sourceStatus?: Maybe<IShipperRateSourceStatusEnum>
}

/** Autogenerated return type of UpdateShipperRate */
export type IUpdateShipperRatePayload = {
  __typename?: 'UpdateShipperRatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperRate?: Maybe<IShipperRate>
}

/** Autogenerated input type of UpdateSourcedCarrierRate */
export type IUpdateSourcedCarrierRateInput = {
  canDoWeekends?: Maybe<Scalars['Boolean']>
  carrierApplicationId?: Maybe<Scalars['ID']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  confirmed?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  laneAgreement?: Maybe<IDocumentInput>
  maxCapacity?: Maybe<Scalars['Int']>
  minCapacity?: Maybe<Scalars['Int']>
  rate?: Maybe<IRateInput>
}

/** Autogenerated return type of UpdateSourcedCarrierRate */
export type IUpdateSourcedCarrierRatePayload = {
  __typename?: 'UpdateSourcedCarrierRatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  sourcedCarrierRate?: Maybe<ISourcedCarrierRate>
}

/** Autogenerated input type of UpdateSpfIntegration */
export type IUpdateSpfIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  integrationType?: ISpfAvailableIntegrationTypes
  notes?: Maybe<Scalars['String']>
  providerName: ISpfAvailableProviderNames
  scac?: Maybe<Scalars['String']>
  shipperApplicationId: Scalars['ID']
  shipperSpecificKey?: Maybe<Scalars['String']>
}

/** Autogenerated return type of UpdateSpfIntegration */
export type IUpdateSpfIntegrationPayload = {
  __typename?: 'UpdateSpfIntegrationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors?: Maybe<Array<IError>>
  spfIntegration?: Maybe<ISpfIntegration>
}

export type IUpdateTaskInput = {
  assignedToId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
}

/** Autogenerated input type of UpdateTasks */
export type IUpdateTasksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  updates: Array<IUpdateTaskInput>
}

/** Autogenerated return type of UpdateTasks */
export type IUpdateTasksPayload = {
  __typename?: 'UpdateTasksPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  tasks?: Maybe<Array<ITask>>
}

/** Autogenerated input type of UpdateTrailer */
export type IUpdateTrailerInput = {
  carrierId?: Maybe<Scalars['ID']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** Trailer emptied at date in timezone of facility */
  emptiedAtDate?: Maybe<Scalars['ISO8601Date']>
  /** Trailer emptied at time in timezone of facility */
  emptiedAtTime?: Maybe<Scalars['ISO8601Time']>
  /** Trailer arrived at date in timezone of facility */
  facilityArrivedAtDate?: Maybe<Scalars['ISO8601Date']>
  /** Trailer arrived at time in timezone of facility */
  facilityArrivedAtTime?: Maybe<Scalars['ISO8601Time']>
  id: Scalars['ID']
  length?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  number?: Maybe<Scalars['String']>
  shipmentId?: Maybe<Scalars['ID']>
  shipperFacilityUuid?: Maybe<Scalars['String']>
  state?: Maybe<ITrailerStatesEnum>
  type?: Maybe<Scalars['String']>
}

/** Autogenerated return type of UpdateTrailer */
export type IUpdateTrailerPayload = {
  __typename?: 'UpdateTrailerPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  trailer?: Maybe<ITrailer>
}

/** Autogenerated input type of UpdateTransfixHighwayInsurancePolicyFlag */
export type IUpdateTransfixHighwayInsurancePolicyFlagInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  highwayInsurancePolicyId: Scalars['ID']
  transfixAdditionalInsured?: Maybe<Scalars['Boolean']>
  transfixHolder?: Maybe<Scalars['Boolean']>
  transfixLossPayee?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of UpdateTransfixHighwayInsurancePolicyFlag */
export type IUpdateTransfixHighwayInsurancePolicyFlagPayload = {
  __typename?: 'UpdateTransfixHighwayInsurancePolicyFlagPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  highwayInsurancePolicy?: Maybe<IHighwayInsurancePolicy>
}

/** Autogenerated input type of UpdateUserAvailability */
export type IUpdateUserAvailabilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  userAvailabilitiesToUpdate: Array<ISetUserAvailabilityInput>
}

/** Autogenerated return type of UpdateUserAvailability */
export type IUpdateUserAvailabilityPayload = {
  __typename?: 'UpdateUserAvailabilityPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  updatedAvailabilities?: Maybe<Array<IUserAvailability>>
}

export type IUpdateVendorKeywordInput = {
  id?: Maybe<Scalars['ID']>
  value: Scalars['String']
}

/** Autogenerated input type of UploadAward */
export type IUploadAwardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  csv: Scalars['String']
  rfpId: Scalars['ID']
}

/** Autogenerated return type of UploadAward */
export type IUploadAwardPayload = {
  __typename?: 'UploadAwardPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of UploadOutboundFiles */
export type IUploadOutboundFilesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  outboundConnectionConfigId: Scalars['ID']
  outboundRawEdiFileIds?: Maybe<Array<Scalars['ID']>>
}

/** Autogenerated return type of UploadOutboundFiles */
export type IUploadOutboundFilesPayload = {
  __typename?: 'UploadOutboundFilesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  uploadOutboundFilesReport: IUploadOutboundFilesReport
}

/** Contains information on the results of uploading test files for staging testing. */
export type IUploadOutboundFilesReport = {
  __typename?: 'UploadOutboundFilesReport'
  errorBacktrace?: Maybe<Scalars['String']>
  errorMessage?: Maybe<Scalars['String']>
  /** IDs for the outbound files uploaded */
  outboundRawEdiFileIds: Array<Scalars['ID']>
  /** Remote paths for the outbound files uploaded */
  remotePaths: Array<Scalars['String']>
  success: Scalars['Boolean']
}

/** Autogenerated input type of UploadW9Form */
export type IUploadW9FormInput = {
  carrierApplicationId?: Maybe<Scalars['ID']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  fleetPlannerMotorCarrierId?: Maybe<Scalars['ID']>
  w9FormParams: IDocumentInput
}

/** Autogenerated return type of UploadW9Form */
export type IUploadW9FormPayload = {
  __typename?: 'UploadW9FormPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  didUpload: Scalars['Boolean']
  errors: Array<IError>
}

/** Autogenerated input type of UpsertAs2ConnectionConfig */
export type IUpsertAs2ConnectionConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  identifier: Scalars['String']
  outboundUrl: Scalars['String']
  serverInfoCredentialsIdentifier: Scalars['String']
  transfixIdentifier: Scalars['String']
}

/** Autogenerated return type of UpsertAs2ConnectionConfig */
export type IUpsertAs2ConnectionConfigPayload = {
  __typename?: 'UpsertAs2ConnectionConfigPayload'
  as2ConnectionConfig?: Maybe<IAs2ConnectionConfig>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpsertFuelRateConfig */
export type IUpsertFuelRateConfigInput = {
  automateCalculation: Scalars['Boolean']
  btfBaseRate?: Maybe<Scalars['Float']>
  btfMpg?: Maybe<Scalars['Float']>
  btfRequired?: Maybe<Scalars['Boolean']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  eiaRateWeekOffset?: Maybe<Scalars['Int']>
  equipmentTypes: Array<IParentEquipmentTypes>
  fuelSource: IShipperFuelSource
  overrideAtCreation: Scalars['Boolean']
  rateAt?: Maybe<IShipperFuelRateAt>
  rateTypes: Array<IShipperRateTypes>
  samePickupAndDeliveryZipcode?: Maybe<Scalars['Boolean']>
  shipperApplicationId: Scalars['ID']
}

/** Autogenerated return type of UpsertFuelRateConfig */
export type IUpsertFuelRateConfigPayload = {
  __typename?: 'UpsertFuelRateConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperFuelRateConfig?: Maybe<IShipperFuelRateConfig>
}

/** Autogenerated input type of UpsertShipperAutoAcceptRejectConfiguration */
export type IUpsertShipperAutoAcceptRejectConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipperAutoAcceptRejectConfigurationBup: IShipperAutoAcceptRejectConfigurationInput
  shipperAutoAcceptRejectConfigurationContract: IShipperAutoAcceptRejectConfigurationInput
  shipperAutoAcceptRejectConfigurationSpot: IShipperAutoAcceptRejectConfigurationInput
  shipperAutoAcceptRejectRules: Array<ICreateShipperAutoAcceptRejectRuleInput>
}

/** Autogenerated return type of UpsertShipperAutoAcceptRejectConfiguration */
export type IUpsertShipperAutoAcceptRejectConfigurationPayload = {
  __typename?: 'UpsertShipperAutoAcceptRejectConfigurationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperAutoAcceptRejectConfigurationBup?: Maybe<IShipperAutoAcceptRejectConfiguration>
  shipperAutoAcceptRejectConfigurationContract?: Maybe<IShipperAutoAcceptRejectConfiguration>
  shipperAutoAcceptRejectConfigurationSpot?: Maybe<IShipperAutoAcceptRejectConfiguration>
  shipperAutoAcceptRejectRules?: Maybe<Array<IShipperAutoAcceptRejectRule>>
}

/** Autogenerated input type of UpsertShipperAwardEstimationConfiguration */
export type IUpsertShipperAwardEstimationConfigurationInput = {
  awardEstimationConfig: IShipperAwardEstimationConfigurationInput
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  shipperApplicationId: Scalars['ID']
}

/** Autogenerated return type of UpsertShipperAwardEstimationConfiguration */
export type IUpsertShipperAwardEstimationConfigurationPayload = {
  __typename?: 'UpsertShipperAwardEstimationConfigurationPayload'
  awardEstimationConfig?: Maybe<IShipperAwardEstimationConfiguration>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
}

/** Autogenerated input type of UpsertShipperContacts */
export type IUpsertShipperContactsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contacts: Array<IShipperContactInput>
  shipperApplicationId: Scalars['ID']
}

/** Autogenerated return type of UpsertShipperContacts */
export type IUpsertShipperContactsPayload = {
  __typename?: 'UpsertShipperContactsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contacts: Array<IShipperApplicationContact>
  errors: Array<IError>
}

/** Autogenerated input type of UpsertShipperDropTrailersConfiguration */
export type IUpsertShipperDropTrailersConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  dropTrailerConfiguration: IShipperDropTrailersConfigurationInput
  shipperApplicationId: Scalars['ID']
}

/** Autogenerated return type of UpsertShipperDropTrailersConfiguration */
export type IUpsertShipperDropTrailersConfigurationPayload = {
  __typename?: 'UpsertShipperDropTrailersConfigurationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  dropTrailerConfiguration?: Maybe<IShipperDropTrailersConfiguration>
  errors: Array<IError>
}

/** Autogenerated input type of UpsertShipperFuelMatrix */
export type IUpsertShipperFuelMatrixInput = {
  autoExtend?: Maybe<Scalars['Boolean']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  fuelMatrixCsv?: Maybe<Scalars['String']>
  fuelMatrixJson?: Maybe<Scalars['JSON']>
  shipperApplicationId: Scalars['ID']
  sourceFile?: Maybe<Scalars['String']>
  sourceFileName?: Maybe<Scalars['String']>
  useDateBasedRate?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of UpsertShipperFuelMatrix */
export type IUpsertShipperFuelMatrixPayload = {
  __typename?: 'UpsertShipperFuelMatrixPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperFuelMatrix?: Maybe<IShipperFuelMatrix>
  warningMessage?: Maybe<Scalars['String']>
}

/** Autogenerated input type of UpsertShipperFuelPaddMapping */
export type IUpsertShipperFuelPaddMappingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  paddRegion?: Maybe<Scalars['String']>
  shipperApplicationId?: Maybe<Scalars['ID']>
  shipperFuelPaddMappingId?: Maybe<Scalars['ID']>
  stateCodes?: Maybe<Scalars['JSON']>
  stopType?: Maybe<Scalars['String']>
}

/** Autogenerated return type of UpsertShipperFuelPaddMapping */
export type IUpsertShipperFuelPaddMappingPayload = {
  __typename?: 'UpsertShipperFuelPaddMappingPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperFuelPaddMapping?: Maybe<IShipperFuelPaddMapping>
}

/** Autogenerated input type of UpsertShipperKpiLinks */
export type IUpsertShipperKpiLinksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  deletedIds?: Maybe<Array<Scalars['ID']>>
  linkType?: Maybe<IShipperLinkTypes>
  newLinks?: Maybe<Array<ILinkInput>>
  shipperApplicationId: Scalars['ID']
}

/** Autogenerated return type of UpsertShipperKpiLinks */
export type IUpsertShipperKpiLinksPayload = {
  __typename?: 'UpsertShipperKpiLinksPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperKpiLinks?: Maybe<Array<ILink>>
}

/** Autogenerated input type of UpsertShipperKpiTrackingConfiguration */
export type IUpsertShipperKpiTrackingConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  parameters?: Maybe<Scalars['JSON']>
  shipperApplicationId: Scalars['ID']
  shipperKpiTrackingConfigurationId?: Maybe<Scalars['ID']>
  trackingType?: Maybe<Scalars['String']>
}

/** Autogenerated return type of UpsertShipperKpiTrackingConfiguration */
export type IUpsertShipperKpiTrackingConfigurationPayload = {
  __typename?: 'UpsertShipperKpiTrackingConfigurationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperKpiTrackingConfiguration?: Maybe<IShipperKpiTrackingConfiguration>
}

/** Autogenerated input type of UpsertShipperOnboardingKpiConfiguration */
export type IUpsertShipperOnboardingKpiConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  onboardingKpiConfig: IShipperOnboardingKpiConfigurationInput
  shipperApplicationId: Scalars['ID']
}

/** Autogenerated return type of UpsertShipperOnboardingKpiConfiguration */
export type IUpsertShipperOnboardingKpiConfigurationPayload = {
  __typename?: 'UpsertShipperOnboardingKpiConfigurationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  onboardingKpiConfig: IShipperOnboardingKpiConfiguration
}

/** Autogenerated input type of UpsertShipperTrueRateConfiguration */
export type IUpsertShipperTrueRateConfigurationInput = {
  beatTargetSharePercent?: Maybe<Scalars['Float']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  configEndTime?: Maybe<Scalars['String']>
  configStartTime?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['ISO8601Date']>
  fuelSource?: Maybe<Scalars['String']>
  maxMarginPercent?: Maybe<Scalars['Float']>
  minMarginAmount?: Maybe<Scalars['Float']>
  minMarginPercent?: Maybe<Scalars['Float']>
  missTargetSharePercent?: Maybe<Scalars['Float']>
  rateTypeKey?: Maybe<Scalars['String']>
  shipperApplicationId: Scalars['ID']
  shipperTrueRateConfigurationId?: Maybe<Scalars['ID']>
  startDate?: Maybe<Scalars['ISO8601Date']>
  targetMarginPercent?: Maybe<Scalars['Float']>
  volumeCommitment?: Maybe<IVolumeCommitmentTypes>
}

/** Autogenerated return type of UpsertShipperTrueRateConfiguration */
export type IUpsertShipperTrueRateConfigurationPayload = {
  __typename?: 'UpsertShipperTrueRateConfigurationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipperTrueRateConfiguration?: Maybe<IShipperTrueRateConfiguration>
}

export enum IUsageIndicators {
  /** Production Data */
  PRODUCTION = 'PRODUCTION',
  /** Test Data */
  TEST = 'TEST',
}

export type IUser = {
  __typename?: 'User'
  activeCeTasks: ITaskConnection
  activeCxTasks: ITaskConnection
  appIsTurnedOn: Scalars['Boolean']
  applicationId?: Maybe<Scalars['ID']>
  applicationType?: Maybe<IApplicationTypes>
  /** Returns the number of shipments with active tasks assigned to this user in each task namespace */
  assignedTasksCounts: Array<ITaskedShipmentsCount>
  carrierRelationships: Array<ICarrierRelationship>
  ceTaskAssignmentAvailability?: Maybe<IUserAvailability>
  cellPhone?: Maybe<Scalars['String']>
  cmLoadAssignmentAvailability?: Maybe<IUserAvailability>
  cxTaskAssignmentAvailability?: Maybe<IUserAvailability>
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  fullName?: Maybe<Scalars['String']>
  groups: Array<IGroup>
  id: Scalars['ID']
  isSubscribedToSms: Scalars['Boolean']
  lastMobileHeartbeat?: Maybe<Scalars['ISO8601DateTime']>
  lastName?: Maybe<Scalars['String']>
  locationEnabled: Scalars['Boolean']
  mobileAppNotificationToken?: Maybe<Scalars['String']>
  parentUserId: Scalars['ID']
  phone?: Maybe<Scalars['String']>
  phoneExt?: Maybe<Scalars['String']>
  phoneModel?: Maybe<Scalars['String']>
  phoneOs?: Maybe<Scalars['String']>
  transfixAppVersion?: Maybe<Scalars['String']>
  userAvailabilities: IUserAvailabilityConnection
  /** @deprecated Use cmLoadAssignmentAvailability instead */
  userAvailability?: Maybe<IUserAvailability>
  userType?: Maybe<IUserTypeTypes>
}

export type IUserActiveCeTasksArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  onlyPastDue?: Maybe<Scalars['Boolean']>
  onlyTaskableShipments?: Maybe<Scalars['Boolean']>
}

export type IUserActiveCxTasksArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  onlyPastDue?: Maybe<Scalars['Boolean']>
  onlyTaskableShipments?: Maybe<Scalars['Boolean']>
}

export type IUserAssignedTasksCountsArgs = {
  taskNamespaces?: Maybe<Array<ITaskNamespaces>>
}

export type IUserGroupsArgs = {
  search?: Maybe<Scalars['String']>
}

export type IUserUserAvailabilitiesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type IUserAvailability = {
  __typename?: 'UserAvailability'
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  endAt?: Maybe<Scalars['ISO8601DateTime']>
  isAvailable: Scalars['Boolean']
  startAt: Scalars['ISO8601DateTime']
  type: IUserAvailabilityTypes
  updatedAt: Scalars['ISO8601DateTime']
  updatedById: Scalars['ID']
  user: IUser
  userId: Scalars['ID']
}

/** The connection type for UserAvailability. */
export type IUserAvailabilityConnection = {
  __typename?: 'UserAvailabilityConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IUserAvailabilityEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IUserAvailability>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IUserAvailabilityEdge = {
  __typename?: 'UserAvailabilityEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IUserAvailability>
}

export enum IUserAvailabilityTypes {
  CeTaskAssignmentAvailability = 'CeTaskAssignmentAvailability',
  CmLoadAssignmentAvailability = 'CmLoadAssignmentAvailability',
  CxTaskAssignmentAvailability = 'CxTaskAssignmentAvailability',
}

/** The connection type for User. */
export type IUserConnection = {
  __typename?: 'UserConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IUserEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IUser>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IUserEdge = {
  __typename?: 'UserEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IUser>
}

export type IUserFilterPreferences = {
  __typename?: 'UserFilterPreferences'
  filterName: Scalars['String']
  filters: IFilterPreferences
  id: Scalars['ID']
}

export enum IUserFilterTypes {
  /** Latest user availabilities */
  LATEST_USER_AVAILABILITIES = 'LATEST_USER_AVAILABILITIES',
  /** Shipment issues */
  SHIPMENT_ISSUES = 'SHIPMENT_ISSUES',
  /** Tasked shipments */
  TASKED_SHIPMENTS = 'TASKED_SHIPMENTS',
}

export enum IUserTypeTypes {
  /** Admin */
  admin = 'admin',
  /** Contract Admin */
  contract_admin = 'contract_admin',
  /** Dispatcher */
  dispatcher = 'dispatcher',
  /** Driver */
  driver = 'driver',
  /** Owner Operator */
  owner_operator = 'owner_operator',
  /** Sales Rep */
  sales_rep = 'sales_rep',
  /** Shipper */
  shipper = 'shipper',
  /** Bot */
  system = 'system',
}

export type IVendor = {
  __typename?: 'Vendor'
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  deletedBy?: Maybe<IUser>
  id: Scalars['ID']
  industry?: Maybe<IVendorIndustries>
  name: Scalars['String']
  vendorFacilities?: Maybe<Array<IVendorFacility>>
  vendorKeywords?: Maybe<Array<IVendorKeyword>>
  vendorShipperFacilities?: Maybe<Array<IVendorShipperFacility>>
}

export type IVendorVendorFacilitiesArgs = {
  facilityUuid?: Maybe<Scalars['ID']>
}

export type IVendorVendorShipperFacilitiesArgs = {
  facilityUuid?: Maybe<Scalars['ID']>
  shipperFacilityUuid?: Maybe<Scalars['ID']>
}

/** The connection type for Vendor. */
export type IVendorConnection = {
  __typename?: 'VendorConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IVendorEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IVendor>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IVendorEdge = {
  __typename?: 'VendorEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IVendor>
}

export type IVendorFacility = {
  __typename?: 'VendorFacility'
  facilityUuid?: Maybe<Scalars['ID']>
  id?: Maybe<Scalars['ID']>
  metadata?: Maybe<IFacilityMetadata>
  uuid?: Maybe<Scalars['ID']>
  vendor?: Maybe<IVendor>
  vendorId?: Maybe<Scalars['ID']>
}

export enum IVendorIndustries {
  COMMERCIAL_INDUSTRIAL_AUTOMOTIVE = 'COMMERCIAL_INDUSTRIAL_AUTOMOTIVE',
  CPG = 'CPG',
  FOOD_AND_BEV = 'FOOD_AND_BEV',
  RETAIL = 'RETAIL',
}

export type IVendorKeyword = {
  __typename?: 'VendorKeyword'
  id: Scalars['ID']
  value: Scalars['String']
  vendorId: Scalars['ID']
}

export type IVendorShipperDetails = {
  __typename?: 'VendorShipperDetails'
  facilityCount?: Maybe<Scalars['Int']>
  shipper?: Maybe<IShipperApplication>
}

/** The connection type for VendorShipperDetails. */
export type IVendorShipperDetailsConnection = {
  __typename?: 'VendorShipperDetailsConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IVendorShipperDetailsEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IVendorShipperDetails>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IVendorShipperDetailsEdge = {
  __typename?: 'VendorShipperDetailsEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IVendorShipperDetails>
}

export type IVendorShipperFacility = {
  __typename?: 'VendorShipperFacility'
  id: Scalars['ID']
  identifiers?: Maybe<Array<IFacilityIdentifier>>
  metadata?: Maybe<IFacilityMetadata>
  shipperFacility: IShipperFacility
  uuid: Scalars['ID']
  vendorId: Scalars['ID']
}

/** Autogenerated input type of VerifyParentUser */
export type IVerifyParentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  parentUserId: Scalars['ID']
  password?: Maybe<Scalars['String']>
  phoneCode?: Maybe<Scalars['String']>
}

/** Autogenerated return type of VerifyParentUser */
export type IVerifyParentUserPayload = {
  __typename?: 'VerifyParentUserPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  parentUser?: Maybe<IParentUser>
}

export enum IVolumeCommitmentTypes {
  /** All shipments */
  all_shipments = 'all_shipments',
  /** Lane specific */
  lane_specific = 'lane_specific',
}

export type IWaterfallOfferSequence = {
  __typename?: 'WaterfallOfferSequence'
  sequenceNumber: Scalars['ID']
}

export type IWaterfallSkipReason = {
  __typename?: 'WaterfallSkipReason'
  description: Scalars['String']
  key: IContractLaneMatchUserSkipReasons
}

export enum IWaterfallStatusTypes {
  /** Waterfall Ended */
  waterfall_ended = 'waterfall_ended',
  /** Waterfall in progress */
  waterfall_in_progress = 'waterfall_in_progress',
  /** Waterfall not started on load */
  waterfall_not_started = 'waterfall_not_started',
}

export enum IWeekDaysEnum {
  /** Friday */
  friday = 'friday',
  /** Monday */
  monday = 'monday',
  /** Saturday */
  saturday = 'saturday',
  /** Sunday */
  sunday = 'sunday',
  /** Thursday */
  thursday = 'thursday',
  /** Tuesday */
  tuesday = 'tuesday',
  /** Wednesday */
  wednesday = 'wednesday',
}

export type IWithShipmentIssueInput = {
  dueAt?: Maybe<Scalars['ISO8601DateTime']>
  owner: IShipmentIssueFollowerInput
  priority?: Maybe<Scalars['Int']>
  shipmentIssueFaultId?: Maybe<Scalars['ID']>
  shipmentIssueReasonId?: Maybe<Scalars['ID']>
  subscribers?: Maybe<Array<IShipmentIssueFollowerInput>>
  summary?: Maybe<Scalars['String']>
}
